const de = {
  // MCP self-service token UI (LEA-269)
  'mcp.live': 'Live',
  'mcp.tok.generate': 'Token erstellen',
  'mcp.tok.title': 'KI-Client verbinden',
  'mcp.tok.intro':
    'Erstelle einen persönlichen Token, um Claude, Cursor oder deinen eigenen Agenten mit deinem Leadscraper-Konto zu verbinden. Der Token wird nur einmal angezeigt.',
  'mcp.tok.name': 'Token-Name',
  'mcp.tok.generating': 'Wird erstellt…',
  'mcp.tok.once': 'Kopiere den Token jetzt: Aus Sicherheitsgründen wird er nie wieder angezeigt.',
  'mcp.tok.yourToken': 'Dein Token',
  'mcp.tok.copy': 'Kopieren',
  'mcp.tok.copied': 'Kopiert',
  'mcp.tok.claudeConfig': 'Claude-Desktop-Konfiguration',
  'mcp.tok.copyConfig': 'Konfiguration kopieren',
  'mcp.tok.done': 'Fertig',
  'mcp.tok.limit': 'Token-Limit erreicht. Widerrufe zuerst einen alten.',
  'mcp.tok.mintFailed': 'Token konnte nicht erstellt werden. Bitte versuche es erneut.',
  'mcp.tok.revoked': 'Token „{name}“ widerrufen',
  'mcp.tok.revokeFailed': 'Token konnte nicht widerrufen werden.',
  'mcp.tok.expires': 'läuft ab',
  'mcp.tok.lastUsed': 'zuletzt verwendet',
  'mcp.tok.neverUsed': 'nie verwendet',
  'mcp.tok.revoke': 'Widerrufen',
  // LEA-349 Phase 3: Claude.ai (Web) OAuth-Connect-Pfad
  'mcp.claude.connect': 'Mit Claude verbinden',
  'mcp.claude.cardHint':
    'Claude.ai (Web) verbindet sich mit einem Klick per OAuth, kein Token nötig.',
  'mcp.claude.intro':
    'Füge Leadscraper in Claude.ai als Custom Connector hinzu. Du bestätigst den Zugriff einmal, kein Token zum Kopieren oder Einfügen.',
  'mcp.claude.cta': 'Claude-Connectors öffnen',
  'mcp.claude.urlLabel': 'Deine MCP-Server-URL',
  'mcp.claude.step1':
    'Klicke auf "Claude-Connectors öffnen", dann auf "Custom Connector hinzufügen".',
  'mcp.claude.step2': 'Füge die obige URL ein und fahre fort.',
  'mcp.claude.step3': 'Bestätige den Zugriff ("Erlauben"). Claude kann jetzt deine Leads nutzen.',
  'mcp.claude.desktopNote': 'Nutzt du Claude Desktop, Cursor oder deinen eigenen Agenten?',
  'mcp.claude.desktopCta': 'Stattdessen Token generieren',
  // nav
  'nav.dashboard': 'Dashboard',
  'nav.leads': 'Leads',
  'nav.cortex': 'Zielgruppe',
  'nav.credits': 'Verfügbare Credits',
  'nav.buyLeads': 'Leads jetzt kaufen',
  'nav.credits.label': 'Kontostand',
  'nav.credits.total': 'Gesamt',
  'nav.credits.remaining': 'Verbleibend',
  'nav.credits.available': 'Verfügbar',
  'nav.credits.upgrade': 'Upgrade',
  // Account / Profil screen
  'acct.title': 'Profil',
  'acct.sub':
    'Verwalte Profileinstellungen, ändere Zahlungsmethoden und lade Rechnungen für vergangene Transaktionen herunter.',
  'acct.tab.profile': 'Profil',
  'acct.tab.billing': 'Abrechnung',
  'acct.prof.title': 'Profil Information',
  'acct.prof.save': 'Speichern',
  'acct.prof.upload': 'Bild hochladen',
  'acct.prof.uploadHint': 'JPG, PNG oder WebP. Max. 2 MB.',
  'acct.prof.avatarUpdated': 'Profilbild aktualisiert.',
  'acct.prof.avatarErr': 'Bild konnte nicht hochgeladen werden. Bitte erneut versuchen.',
  'acct.prof.avatarMime': 'Bitte JPG-, PNG- oder WebP-Datei wählen.',
  'acct.prof.avatarSize': 'Datei zu groß (max. 2 MB).',
  'acct.prof.first': 'Vorname',
  'acct.prof.last': 'Nachname',
  'acct.prof.email': 'E-Mail-Adresse',
  'acct.prof.lang': 'Sprache',
  'acct.sec.title': 'Sicherheitseinstellungen',
  'acct.sec.pw': 'Passwort ändern',
  'acct.sec.pwSub': 'Ändere hier dein Account-Passwort',
  'acct.sec.change': 'Ändern',
  'acct.sec.twofa': 'Zwei-Faktor-Authentifizierung',
  'acct.sec.twofaSub':
    'Authentifizierung ist deaktiviert. Aktiviere sie, um deinem Konto eine zusätzliche Sicherheitsebene hinzuzufügen.',
  'acct.sec.active': 'Aktiv',
  'acct.sec.inactive': 'Inaktiv',
  'acct.sec.twofaActivate': '2FA aktivieren',
  'acct.sec.twofaDeactivate': '2FA deaktivieren',
  'acct.bill.methods': 'Zahlungsmethoden',
  'acct.bill.manageCards': 'Karten verwalten',
  'acct.bill.noMethods': 'Keine Zahlungsmethoden gefunden',
  'acct.bill.addMethod': 'Zahlungsmethode hinzufügen',
  'acct.bill.history': 'Transaktionsverlauf',
  'acct.bill.filter.all': 'Gesamter Zeitraum',
  'acct.bill.filter.30': 'Letzte 30 Tage',
  'acct.bill.filter.90': 'Letzte 90 Tage',
  'acct.bill.col.date': 'Datum',
  'acct.bill.col.desc': 'Beschreibung',
  'acct.bill.col.amount': 'Betrag',
  'acct.bill.col.credits': 'Credits',
  'acct.bill.col.status': 'Status',
  'acct.bill.col.invoice': 'Rechnung',
  'acct.bill.paid': 'Bezahlt',
  'acct.bill.pdfUnavailable': 'Diese Rechnung lässt sich hier gerade nicht als PDF laden. Bei Stripe kannst du sie öffnen und herunterladen.',
  'acct.bill.pdfOpenStripe': 'Rechnung bei Stripe öffnen',
  'acct.bill.empty': 'Keine Transaktionen gefunden',
  'acct.bill.emptySub': 'Dein Zahlungsverlauf erscheint hier nach deinem ersten Kauf.',
  'acct.plan.your': 'Dein Plan',
  'acct.plan.trial': 'Testphase',
  'acct.plan.active': 'Aktiv',
  'acct.plan.canceled': 'Gekündigt',
  'acct.plan.refundedEnded': 'Abo erstattet, Plan beendet. Wähle einen Plan, um fortzufahren.',
  'acct.plan.perMonth': '/ Monat',
  'acct.plan.afterTrial': 'Nach Testphase',
  'acct.plan.nextBill': 'Nächste Abrechnung am {date} · {leads} Leads/Monat',
  'acct.plan.cancelsOn': 'Endet am {date}',
  'acct.plan.cancelNote': 'Keine weitere Abbuchung, aktiv bis {date}.',
  // LEA-561: Abbuchungsdatum + Ein-Klick-Kuendigung im Trial. Bewusst OHNE
  // Erinnerungs-Versprechen — die Reminder-Mail ist gebaut, aber noch von
  // keinem Scheduler aufgerufen; eine Zusage, die das System nicht halten
  // kann, ist genau der Vertrauensbruch, den LEA-553 abstellen soll.
  'acct.plan.trialFirstCharge': 'Erste Abbuchung am {date}. Kündigen jederzeit mit einem Klick.',
  'acct.plan.daysLeft': 'Noch {n} Tage kostenlos testen. Danach läuft dein Abo automatisch weiter.',
  'acct.plan.dayLeft': 'Noch 1 Tag kostenlos testen. Danach läuft dein Abo automatisch weiter.',
  'acct.plan.endsToday': 'Testphase endet heute. Dein Abo startet automatisch.',
  'acct.plan.switch': 'Plan wechseln',
  'acct.plan.downgradeScheduled': 'Tarifwechsel geplant',
  'acct.plan.downgradeScheduledDetail':
    'Du wechselst am {date} zu {plan}. Bis dahin behältst du deinen aktuellen Tarif, und deine Credits bleiben erhalten.',
  'acct.plan.downgradeCancel': 'Wechsel abbrechen',
  'acct.plan.downgradeCanceling': 'Wird abgebrochen …',
  'acct.plan.secureSub': 'Abo starten',
  'acct.plan.trialUsage': 'Test-Leads diese Phase',
  'acct.plan.monthUsage': 'Leads diesen Monat',
  'acct.plan.leftOf': 'von {total} übrig',
  'acct.plan.bonusCredits': 'Paket-Credits',
  'acct.plan.bonusCreditsTip':
    'Bezahlte Credits aus Einmalpaketen werden zusätzlich zum monatlichen Kontingent gutgeschrieben und verfallen nicht.',
  'acct.plan.trialCredits': 'Trial-Credits',
  'acct.plan.trialCreditsTip':
    'Geschenkte Test-Credits aus deiner Anmeldung werden zusätzlich zum monatlichen Kontingent gutgeschrieben und verfallen nicht.',
  // LEA-704: surplus of a migrated account = the balance carried over, not trial credits.
  'acct.plan.carriedOverCredits': 'übernommene Credits',
  'acct.plan.carriedOverCreditsTip':
    'Dein Guthaben von vor dem Wechsel zur Abrechnung pro Kontakt – zusätzlich zum monatlichen Kontingent und ohne Ablaufdatum',
  'acct.plan.addOneOff': 'Einmalpaket dazuladen',
  'acct.plan.usedThisMonth': '{used} / {total} diesen Monat genutzt · Reset am {date}',

  // LEA-333: Inline-Kündigung + Churn-Feedback (config-driven, §312k).
  // LEA-557 — retention discount (30% x 3 Monate).
  'acct.cancel.save.discountTitle': '30 % Rabatt für die nächsten 3 Monate',
  'acct.cancel.save.discountBody':
    'Bleib dabei und zahle drei Monate lang 30 % weniger — der Rabatt liegt direkt auf deinem Abo, deine Karte bleibt wie sie ist, kein neuer Checkout.',
  'acct.cancel.save.discountCta': '30 % Rabatt aktivieren',
  'acct.cancel.save.discounting': 'Wird aktiviert …',
  'acct.cancel.save.discountDoneTitle': 'Rabatt ist aktiv',
  'acct.cancel.save.discountDoneBody':
    'Deine nächsten drei Monatsrechnungen sind um 30 % reduziert. Danach läuft dein Abo zum normalen Preis weiter — kündigen kannst du weiterhin jederzeit mit einem Klick.',

  'acct.cancel.trigger': 'Abo kündigen',
  'acct.cancel.manageHint': 'Abo verwalten',
  'acct.cancel.scheduledTitle': 'Kündigung geplant',
  'acct.cancel.scheduledDetail': 'Dein Abo endet am {date}. Bis dahin behältst du vollen Zugriff.',
  'acct.cancel.reactivate': 'Kündigung rückgängig machen',
  'acct.cancel.reactivating': 'Wird rückgängig gemacht …',
  'acct.cancel.restored': 'Abo wiederhergestellt – dein Plan läuft weiter.',
  'acct.cancel.title': 'Abo kündigen',
  'acct.cancel.stepOf': 'Schritt {n} von {total}',
  'acct.cancel.reasonTitle': 'Warum möchtest du kündigen?',
  'acct.cancel.reasonSub': 'Optional: Deine Antwort hilft uns, Leadscraper besser zu machen.',
  'acct.cancel.reason.too_expensive': 'Zu teuer',
  'acct.cancel.reason.too_few_leads': 'Zu wenige (gute) Leads',
  'acct.cancel.reason.wrong_contacts': 'Falsche Ansprechpartner',
  'acct.cancel.reason.unreliable_data': 'Mails/Kontaktdaten unzuverlässig',
  'acct.cancel.reason.too_complicated': 'Zu kompliziert',
  'acct.cancel.reason.missing_feature': 'Ein Feature fehlt',
  'acct.cancel.reason.temporary_only': 'Nur vorübergehend gebraucht',
  'acct.cancel.reason.switched_tool': 'Wechsel zu anderem Tool',
  'acct.cancel.reason.other': 'Sonstiges',
  'acct.cancel.freeTextPlaceholder': 'Erzähl uns mehr (optional) …',
  'acct.cancel.save.downgradeTitle': 'Vielleicht passt ein kleinerer Plan?',
  'acct.cancel.save.downgradeBody':
    'Statt zu kündigen kannst du zu einem günstigeren Plan wechseln: Du behältst deine Credits und zahlst ab dem nächsten Zyklus weniger.',
  'acct.cancel.save.downgradeCta': 'Günstigeren Plan ansehen',
  // LEA-333 Phase 5: Inline-Downgrade-Angebot (konkreter nächst-kleinerer Plan).
  'acct.cancel.save.downgradeOffer':
    'Wechsle zu {plan}: {price}\u00A0€/Monat · {leads} Leads/Monat. Du behältst deine Credits und zahlst ab dem nächsten Zyklus weniger.',
  'acct.cancel.save.downgradeCtaPlan': 'Zu {plan} wechseln',
  'acct.cancel.save.downgrading': 'Wird gewechselt …',
  'acct.cancel.save.seeAllPlans': 'Alle Pläne ansehen',
  'acct.cancel.save.helpTitle': 'Lass es uns in Ordnung bringen',
  'acct.cancel.save.helpBody':
    'Vieles davon verbessern wir gerade aktiv. Schreib uns kurz, was gefehlt hat: Oft können wir deine Suche schnell nachjustieren.',
  'acct.cancel.confirm.accessUntil': 'Du behältst vollen Zugriff bis zum {date}.',
  'acct.cancel.confirm.noCharge': 'Danach werden dir keine weiteren Beträge berechnet.',
  'acct.cancel.confirm.reactivate': 'Du kannst die Kündigung jederzeit vorher rückgängig machen.',
  'acct.cancel.audit.title': 'Eine letzte Bitte (optional)',
  'acct.cancel.audit.sub': 'Was hat gepasst, was nicht? Das fließt direkt in Verbesserungen.',
  'acct.cancel.audit.rightCompanies': 'Die richtigen Unternehmen?',
  'acct.cancel.audit.rightContacts': 'Die richtigen Ansprechpartner?',
  'acct.cancel.audit.contactDataUsable': 'E-Mail/Telefon/LinkedIn nutzbar?',
  'acct.cancel.audit.enoughLeads': 'Genügend Leads?',
  'acct.cancel.audit.helpedWin': 'Hat es dir geholfen, Kunden zu gewinnen?',
  'acct.cancel.audit.good': 'Gut',
  'acct.cancel.audit.bad': 'Schlecht',
  // LEA-333 Phase 7: "welcher Lead hat enttäuscht?" Picker (crown jewel).
  'acct.cancel.lead.title': 'Welcher Lead hat enttäuscht? (optional)',
  'acct.cancel.lead.sub':
    'Wenn ein bestimmter Lead nicht gepasst hat, hilfst du uns am meisten, wenn du ihn nennst.',
  'acct.cancel.lead.pick': 'Lead auswählen',
  'acct.cancel.lead.loading': 'Wird geladen …',
  'acct.cancel.lead.none': 'Keine gelieferten Leads gefunden.',
  // LEA-333: counterfactual + competitive (point C) — last, optional.
  'acct.cancel.cf.title': 'Hilf uns, besser zu werden (optional)',
  'acct.cancel.cf.gapPlaceholder': 'Was hätten wir liefern müssen, das wir nicht konnten?',
  'acct.cancel.cf.toolPlaceholder': 'Wechselst du zu einem anderen Tool? Zu welchem?',
  'acct.cancel.cf.betterPlaceholder': 'Was macht es besser?',
  'acct.cancel.justCancel': 'Jetzt kündigen',
  'acct.cancel.keep': 'Doch behalten',
  'acct.cancel.next': 'Weiter',
  'acct.cancel.back': 'Zurück',
  'acct.cancel.stillCancel': 'Trotzdem kündigen',
  'acct.cancel.confirmBtn': 'Kündigung bestätigen',
  'acct.cancel.confirming': 'Wird gekündigt …',
  'acct.cancel.done.title': 'Kündigung bestätigt',
  'acct.cancel.done.body':
    'Dein Abo endet am {date}. Bis dahin hast du vollen Zugriff, und du kannst die Kündigung jederzeit vorher rückgängig machen.',
  'acct.cancel.done.close': 'Schließen',

  // LEA-555 — Trial-Intercept. Ersetzt im Trial den grund-gekoppelten
  // Save-Schritt. Ton: nicht verkaufen, sondern die Angst wegnehmen. Diese
  // Nutzer kündigen im Median ~20 Minuten nach Signup, meist ohne einen Lead
  // gesehen zu haben — sie fürchten, das Kündigen zu vergessen.
  'acct.cancel.trial.interceptTitle': 'Warte — dein Test läuft noch bis zum {date}.',
  'acct.cancel.trial.interceptTitleNoDate': 'Warte — dein Test läuft noch.',
  'acct.cancel.trial.interceptSub': 'Bis dahin wird dir nichts berechnet.',
  'acct.cancel.trial.reminderTitle': 'Wir erinnern dich rechtzeitig',
  'acct.cancel.trial.reminderBody':
    'Du musst dir nichts notieren und nichts im Kopf behalten. Wir melden uns 24 Stunden vor Ablauf — falls du dann nicht weitermachen willst, kündigst du direkt aus der E-Mail heraus.',
  'acct.cancel.trial.reminderPointMail': 'Der Kündigen-Link steht direkt in der E-Mail.',
  'acct.cancel.trial.reminderPointNoCharge': 'Vorher wird dir nichts abgebucht.',
  'acct.cancel.trial.reminderCta': 'Weiter testen & erinnern',
  'acct.cancel.trial.keepTestingCta': 'Weiter testen',
  'acct.cancel.trial.reminderSaving': 'Wird aktiviert …',
  'acct.cancel.trial.reminderDoneTitle': 'Erinnerung ist aktiv',
  'acct.cancel.trial.reminderDoneBody':
    'Wir schreiben dir am {date} — 24 Stunden vor Ablauf deines Tests, mit dem Kündigen-Link direkt in der E-Mail.',
  'acct.cancel.trial.reminderDoneBodyNoDate':
    'Wir schreiben dir 24 Stunden vor Ablauf deines Tests, mit dem Kündigen-Link direkt in der E-Mail.',
  // LEA-558 (Janik 04.09.): 990 € ist VERGLEICHSGROESSE ('im Gegenwert
  // von'), nie 'regulaer' — es gibt keinen kaufbaren 990-€-SKU, und die
  // Copy darf keinen erfinden.
  'acct.cancel.trial.vipTitle': 'Janik richtet deinen Account persönlich ein',
  'acct.cancel.trial.vipBody':
    'Zielgruppen, Suchprofile, erste Suchen — der Gründer setzt deinen Account persönlich mit dir auf. Eine Leistung im Gegenwert von 990 € — für dich kostenlos, wenn du den Test weiterführst.',
  'acct.cancel.trial.vipCta': 'Persönliche Einrichtung anfragen',
  'acct.cancel.trial.vipRequesting': 'Wird angefragt …',
  'acct.cancel.trial.vipDoneTitle': 'Anfrage ist raus',
  'acct.cancel.trial.vipDoneBody':
    'Janik meldet sich innerhalb von 24 Stunden persönlich bei dir. Dein Test läuft ganz normal weiter — es wurde nichts gekündigt und nichts berechnet.',
  'acct.cancel.trial.cancelNowLink': 'Jetzt endgültig kündigen',
  // Bewusst schonungslos: im Trial endet der Zugang SOFORT (LEA-554), nicht zum
  // Periodenende. Wer das hier nicht klar sagt, produziert genau den
  // Vertrauensbruch, den dieses Projekt abstellen soll.
  'acct.cancel.trial.confirm.endsNow': 'Dein Testzugang endet sofort — nicht erst am Ablaufdatum.',
  'acct.cancel.trial.confirm.forfeits': 'Deine Suchprofile und übrigen Credits verfallen.',
  'acct.cancel.trial.confirm.noCharge': 'Es wird dir nichts berechnet.',
  'acct.cancel.trial.done.title': 'Testzugang beendet',
  'acct.cancel.trial.done.body':
    'Dein Test ist beendet und dir wurde nichts berechnet. Wenn du es dir anders überlegst, kannst du jederzeit ein Abo starten.',
  // LEA-333 Phase 4: Pause als Save-Lever + eigenständige Aktion.
  // LEA-559: Ueberschrift des Angebots-Schritts. Er zeigt jetzt jeden
  // verfuegbaren Hebel statt genau einen grund-gekoppelten, braucht also
  // eine Rahmung — und eine, die nicht draengt (Leitplanke: keine Huerden).
  'acct.cancel.save.offerTitle': 'Bevor du kündigst — vielleicht passt eines davon besser',
  'acct.cancel.save.offerSub': 'Kein Druck. Kündigen bleibt einen Klick entfernt.',
  'acct.cancel.save.pauseTitle': 'Lieber pausieren statt kündigen?',
  'acct.cancel.save.pauseBody':
    'Friere dein Abo ein statt zu kündigen: Keine Abbuchung, deine Credits und Daten bleiben erhalten, und du setzt jederzeit mit einem Klick fort.',
  'acct.cancel.save.pauseCta': 'Abo pausieren',
  'acct.cancel.save.pausing': 'Wird pausiert …',
  'acct.cancel.pauseTrigger': 'Pausieren',
  'acct.cancel.pausing': 'Wird pausiert …',
  'acct.cancel.pausedBadge': 'Pausiert',
  'acct.cancel.pausedNote': 'Abo pausiert, keine Abbuchung. Deine Credits bleiben nutzbar.',
  'acct.cancel.pauseMonthsLabel': 'Pausieren für',
  'acct.cancel.pauseMonths1': '1 Monat',
  'acct.cancel.pauseMonths': '{n} Monate',
  'acct.cancel.pauseResumeHint':
    'Dein Abo läuft am {date} automatisch weiter — ab dann wird wieder abgebucht.',
  'acct.cancel.pausedDetailUntil':
    'Es werden keine Beträge abgebucht. Du behältst Zugriff und deine verbleibenden Credits. Am {date} läuft dein Abo automatisch weiter; du kannst jederzeit früher fortsetzen.',
  'acct.cancel.pausedNoteUntil':
    'Abo pausiert bis {date}, keine Abbuchung. Deine Credits bleiben nutzbar.',
  'acct.cancel.pausedTitle': 'Abo pausiert',
  'acct.cancel.pausedDetail':
    'Es werden keine Beträge abgebucht. Du behältst Zugriff und deine verbleibenden Credits. Setze jederzeit fort.',
  'acct.cancel.resume': 'Abo fortsetzen',
  'acct.cancel.resuming': 'Wird fortgesetzt …',
  'acct.bill.methodAutoAdded': 'Wird automatisch nach Testphasen-Start hinzugefügt.',
  'acct.bill.cardEnds': 'Visa endet auf •• 4242',
  'acct.bill.cardExpHolder': 'Ablauf 08/2028 · Janik Deimann',
  'acct.bill.primary': 'Primär',
  'acct.bill.descSub': '{plan}-Abo · {month} {year}',
  'acct.menu.settings': 'Account-Einstellungen',
  'acct.menu.logout': 'Abmelden',
  // Integrations
  'acct.tab.integrations': 'Integrationen',
  'acct.int.title': 'CRM-Integrationen',
  'acct.founder.title': 'Direkter Draht zum Gründer',
  'acct.founder.body':
    'Feedback, Frage oder Problem? Deine Nachricht landet direkt bei Janik, nicht in einem Ticket-System.',
  'acct.founder.cta': 'Schreib Janik',
  'acct.int.sub': 'Verbinde dein CRM und pushe passende Leads automatisch – oder manuell pro Lead.',
  // LEA-334: Webhook-Signing-Secret
  'acct.int.whsec.title': 'Webhook-Signatur-Schlüssel',
  'acct.int.whsec.sub':
    'Wir signieren jede Webhook-Zustellung mit HMAC-SHA256, damit dein Endpunkt prüfen kann, dass sie wirklich von Leadscraper stammt.',
  'acct.int.whsec.revealed': 'Jetzt kopieren – wird nur einmal angezeigt.',
  'acct.int.whsec.copy': 'Kopieren',
  'acct.int.whsec.copied': 'Kopiert',
  'acct.int.whsec.rotate': 'Schlüssel neu erzeugen & anzeigen',
  'acct.int.whsec.rotating': 'Wird erzeugt…',
  'acct.int.whsec.rotateHint':
    'Beim Neu-Erzeugen entsteht ein neuer Schlüssel, der einmalig angezeigt wird – danach deinen Endpunkt aktualisieren.',
  'acct.int.whsec.fail': 'Schlüssel konnte nicht neu erzeugt werden.',
  'acct.int.whsec.docs':
    'Prüfen: Header X-Leadscraper-Signature: t=<unix>,v1=<hex>, wobei hex = HMAC-SHA256(secret, "<t>.<rawBody>"). Anfrage ablehnen, wenn sie nicht übereinstimmt oder der Zeitstempel veraltet ist.',
  // LEA-334: Webhook-Connect-Modal-Texte
  'acct.int.webhookUrl': 'Webhook-URL',
  'acct.int.webhookUrlP': 'https://dein-endpunkt.example.com/leadscraper',
  'acct.int.autoPushSubWebhook':
    'Neue Leads werden automatisch an deinen Webhook gesendet, sobald ihre Kontakte angereichert sind.',
  // LEA-334: Webhook-Verifizierung
  'acct.int.whverify.title': 'Endpunkt verifizieren',
  'acct.int.whverify.sub':
    'Ein erreichbarer Endpunkt (liefert 2xx) ist nicht dasselbe wie ein verifizierter. Bestätige einen Einmal-Code, damit wir wissen, dass Leads wirklich ankommen. Bis dahin wird nichts zugestellt.',
  'acct.int.whverify.verified': '✓ Verifiziert',
  'acct.int.whverify.unverified': 'Nicht verifiziert',
  'acct.int.whverify.send': 'Test-Event senden',
  'acct.int.whverify.sending': 'Wird gesendet…',
  'acct.int.whverify.resend': 'Test-Event erneut senden',
  'acct.int.whverify.sent': 'Test-Event gesendet. Prüfe deinen Endpunkt auf den Code.',
  'acct.int.whverify.sendFail': 'Test-Event konnte nicht gesendet werden.',
  'acct.int.whverify.enter': 'Gib den Code (LSWH-…) ein, der an deinem Endpunkt angekommen ist:',
  'acct.int.whverify.confirm': 'Bestätigen',
  'acct.int.whverify.ok': 'Webhook verifiziert. Leads können jetzt zugestellt werden.',
  'acct.int.whverify.mismatch':
    'Dieser Code stimmt nicht. Prüfe deinen Endpunkt und versuche es erneut.',
  'acct.int.whverify.expired': 'Dieser Code ist abgelaufen. Sende ein neues Test-Event.',
  'acct.int.connected': 'Verbunden',
  'acct.int.notConnected': 'Nicht verbunden',
  'acct.int.connect': 'Verbinden',
  // LEA-317: freundlicher Free/Expired-Hinweis (ersetzt das rohe 402-JSON,
  // das der OAuth-Connect-Tab vorher angezeigt hat).
  'acct.int.subRequired':
    'CRM-Integrationen sind nur in kostenpflichtigen Tarifen verfügbar. Mach ein Upgrade, um dein CRM zu verbinden.',
  'acct.int.upgradeTitle': 'Upgrade, um dein CRM zu verbinden',
  'acct.int.upgradeCta': 'Upgrade',
  'acct.int.manage': 'Verwalten',
  'acct.int.disconnect': 'Trennen',
  'acct.int.autoPush': 'Auto-Push bei „Passt"',
  'acct.int.autoPushSub': 'Leads werden automatisch ins CRM geschoben, sobald du sie bestätigst.',
  'acct.int.apiKey': 'API-Schlüssel',
  'acct.int.apiKeyP': 'Aus den Entwicklereinstellungen deines CRM',
  'acct.int.pipeline': 'Pipeline',
  'acct.int.stage': 'Stage für neue Leads',
  'acct.int.owner': 'Zuständig (Owner)',
  'acct.int.object': 'Objekt-Typ',
  'acct.int.mapping': 'Feld-Mapping',
  'acct.int.mappingSub': 'Leadscraper-Felder → CRM-Felder',
  'acct.int.save': 'Verbindung speichern',
  'acct.int.cancel': 'Abbrechen',
  'acct.int.testing': 'Teste Verbindung …',
  'acct.int.connectSuccess': 'Verbunden mit {name}',
  'acct.int.disconnectSuccess': 'Verbindung zu {name} getrennt',
  'acct.int.pushSuccess': '{n} Lead(s) an {name} gesendet',
  'acct.int.pushToCRM': 'An CRM senden',
  'acct.int.pushedTo': 'In {name}',
  'acct.int.openInCRM': 'In {name} öffnen',
  'acct.int.none': 'Kein CRM verbunden',
  'acct.int.connectFirst':
    'Verbinde dein CRM in den Account-Einstellungen, um Leads automatisch zu pushen.',
  'acct.int.sectionLead': 'CRM-Status',
  'acct.int.notPushedYet': 'Noch nicht gepusht',
  'acct.int.pushedAt': 'Gepusht {when}',
  'acct.int.bulkPush': '{n} an CRM senden',
  // LEA-282: HubSpot OAuth strings (Wave 2) — restored after a rebase dropped them
  'acct.int.oauthFail': 'OAuth-Verbindung fehlgeschlagen',
  'acct.int.reconnect': 'Neu verbinden',
  'acct.int.reconnectRequired': 'Neu verbinden nötig',
  'acct.int.connectedVia': 'Via OAuth verbunden',
  // LEA-268 backfill: CRM-button strings missing from the initial deploy
  // (Om bug-report 2026-05-26 — keys rendered as bracketed [det.crmOpenRecord]).
  'det.crmPushing': 'Wird gepusht…',
  'det.crmPushFail': 'CRM-Push fehlgeschlagen',
  'det.crmSubRequired': 'Für CRM-Push ist ein bezahlter Plan erforderlich.',
  'det.crmDuplicate': 'Bereits im CRM',
  'det.crmNotConnected': 'Kein CRM verbunden. Richte eines unter Konto → Integrationen ein',
  'det.crmOpenRecord': 'Datensatz öffnen',
  'acct.int.pushFail': 'CRM-Push fehlgeschlagen',
  'acct.int.pushDuplicate': 'Bereits im CRM',
  'acct.int.pushSubRequired': 'Für CRM-Push ist ein bezahlter Plan erforderlich.',
  'acct.int.bulkSummary': '{pushed} gesendet · {skipped} übersprungen · {failed} fehlgeschlagen',
  'leads.bulkPushBtn': '{n} an {crm} senden',
  'leads.bulkPushPickBtn': '{n} an CRM senden ▾',
  'leads.bulkPushTitle': 'Sende die aktuell sichtbaren Leads (max. 50) an dein CRM',
  'nav.activeProfile': 'Aktive Zielgruppe',
  'nav.feedbacks': 'Feedbacks',
  'nav.matchRate': 'Trefferquote',
  'nav.matchRateMin': 'Trefferquote wird ab 5 Bewertungen angezeigt',
  'nav.rated': 'bewertet',
  'nav.open': 'offen',
  'nav.rateNudge.title': 'Springe zu den noch nicht bewerteten Leads',
  'nav.allRated': 'Alle bewertet',
  'nav.switchProfiles': 'Zwischen Zielgruppen wechseln',
  'nav.newProfile': 'Neue Zielgruppe anlegen',

  // new profile wizard
  'np.title': 'Neue Zielgruppe anlegen',
  'np.stepOf': 'Schritt {n} von 2',
  'np.step1Title': 'Für wen oder was suchst du?',
  'np.step1Sub':
    'Gib deinem Profil einen klaren Namen. Leadscraper nutzt diese Beschreibung als Startpunkt, bevor dein Feedback das Muster schärft.',
  'np.name': 'Name der Zielgruppe',
  'np.nameP': 'z.B. Faltschachtelhersteller NRW',
  'np.audience': 'Zielgruppe beschreiben',
  'np.audienceHint':
    'Je konkreter, desto besser der erste Sortierlauf. Du kannst das später jederzeit anpassen.',
  'np.step2Title': 'Erste Parameter',
  'np.step2Sub':
    'Optional: Leadscraper nutzt diese Angaben als Seed. Das Profil lernt dazu, sobald du Leads bewertest.',
  'np.optional': 'Optional',
  'np.industry': 'Branche',
  'np.industryP': 'z.B. Verpackung, Faltschachtel',
  'np.region': 'Region / Bundesland',
  'np.regionP': 'z.B. NRW, DACH, ganz Deutschland',
  'np.companySize': 'Unternehmensgröße',
  'np.companySizeP': 'z.B. 50–250 Mitarbeiter',
  'np.notes': 'Weitere Hinweise',
  'np.notesP': 'Ausschlüsse, Kundentypen, Signalwörter …',
  'np.coldStart': 'Kaltstart, keine Seed-Parameter',
  'np.coldStartDesc':
    'Das Profil startet komplett leer. Nach ~20 Feedbacks stehen die ersten Klartext-Aussagen in Leadscraper.',
  'np.back': 'Zurück',
  'np.skip': 'Überspringen',
  'np.continue': 'Weiter',
  'np.create': 'Zielgruppe anlegen',
  'np.creating': 'Wird angelegt …',
  'np.abort': 'Abbrechen',
  'np.created': 'Zielgruppe angelegt. Leadscraper ist bereit.',
  'np.summaryTitle': 'Leadscraper startet mit',
  'np.nothingYet': ': nichts Vorgegebenes. Leadscraper wird durch dein Feedback geformt.',
  'np.header': 'Neue Zielgruppe',
  'np.headline': 'Vertriebsbriefing anlegen',
  'np.suggHeading': 'Vorschläge für deine Zielgruppe',
  'np.suggHint':
    'Click übernimmt den Vorschlag: Du kannst durchswitchen, eigenen Text tippen oder direkt anlegen.',
  'np.draftWriting': 'Leadscraper schreibt dein Briefing …',
  'np.draftErrorLabel': 'Hinweis:',
  'np.draftErrorFallback':
    'Briefing-Draft konnte nicht erzeugt werden. Du kannst manuell weiterschreiben.',
  'np.audienceLabel': 'Vertriebsbriefing',
  'np.audienceP':
    'Beispiel: Wir möchten mittelständische Steuerkanzleien für unsere Recruiting-Lösung gewinnen. Ziel ist ein Erstgespräch mit der Kanzleileitung.',
  'np.audienceHintLong':
    'Schreib das wie du es einem neuen Vertriebsmitarbeiter erklären würdest. Leadscraper extrahiert daraus deine Ziele, Kanäle, Argumente und Hooks, und nutzt das pro Lead für den Akquise-Plan.',
  'np.briefingHelpTitle': 'Hilfreich für Leadscraper',
  'np.briefingHelp.q1': 'Was ist dein Ziel mit dieser Zielgruppe?',
  'np.briefingHelp.q2': 'Was bietest du an?',
  'np.briefingHelp.q3': 'Warum ist dein Angebot für diese Zielgruppe relevant?',
  'np.briefingHelp.q4': 'Was ist dein stärkster USP?',
  'np.briefingHelp.q5': 'Welche Probleme löst du?',
  'np.briefingHelp.q6': 'Wen möchtest du zuerst ansprechen?',
  'np.briefingHelp.q7': 'Welcher Kanal funktioniert für dich: E-Mail, Telefon, LinkedIn?',
  'np.briefingHelp.q8': 'Was soll der nächste Schritt sein: Antwort, Termin, Demo, Angebot?',
  'np.briefingHelp.q9': 'Was soll in der Ansprache vermieden werden?',
  'np.briefingHelpFooter': 'Das sind keine Pflichtfelder, nur Orientierung für den Freitext.',
  'np.whatHappens': 'Was passiert dann?',
  'np.whatHappensBody':
    'Im Dashboard startest du die <b>Suchanfrage</b> und legst Branche, Region und Größe fest. Leadscraper findet passende Firmen samt Ansprechpartnern und baut pro Lead einen Akquise-Plan aus diesem Briefing.',

  // dashboard
  // leads table
  'leads.title': 'Deine Leads',
  'leads.sub':
    '{n} Leads · nach deinen Profilen gruppiert. Ein Klick öffnet den 360°-Blick auf die Firma.',
  'leads.allProfiles': 'Alle Zielgruppen',
  'leads.filterBy': 'Nach Zielgruppe filtern',
  'leads.tableView': 'Tabelle',
  'leads.cardView': 'Karten',
  'leads.col.company': 'Firma',
  'leads.col.phase': 'Phase',
  'leads.col.profile': 'Zielgruppe',
  'leads.col.nace': 'Branche',
  'leads.col.sector': 'Sub-Branche',
  'leads.col.legalForm': 'Rechtsform',
  'leads.col.city': 'Standort',
  'leads.col.size': 'MA',
  'leads.col.founded': 'Gründung',
  'leads.col.match': 'Match',
  'leads.col.status': 'Status',
  'leads.col.decider': 'Entscheider',
  'leads.col.centralEmail': 'E-Mail',
  'leads.col.centralPhone': 'Telefon',
  'leads.col.website': 'Website',
  'leads.status.unseen': 'Ungesehen',
  'leads.status.accepted': 'Passt',
  'leads.status.rejected': 'Passt nicht',
  'leads.empty':
    'Keine Leads für dieses Profil. Starte einen neuen Suchlauf über „Neue Leads finden".',
  'leads.chip.edge': 'Grenzfall · Urteil?',
  'leads.chip.pattern': 'Prägt ein Muster',
  'leads.col.phone': 'Telefon',
  'leads.col.revenue': 'Umsatz',
  'leads.col.lastActivity': 'Letzte Aktivität',
  'leads.col.crm': 'CRM',
  'leads.crm.push': 'Senden',
  'leads.crm.notSynced': 'Nicht synchronisiert',
  'leads.crm.syncedTo': 'Synchronisiert mit {crm}',
  'leads.crm.pushFailed': 'Push fehlgeschlagen',
  'leads.col.actions': 'Aktionen',
  'leads.searchP': 'Firma, Branche, Standort, Entscheider …',
  'leads.count': '{shown} von {total} Leads',
  'leads.export': 'Export',
  'leads.cols.btn': 'Spalten',
  'leads.cols.title': 'Spalten anzeigen',
  'leads.cols.sub': 'Zeige nur, was du brauchst.',
  'leads.cols.fixed': 'Fix',
  'leads.cols.reset': 'Zurücksetzen',
  'leads.daysAgo': 'vor {n} Tagen',
  'leads.footerHint':
    'Klick auf eine Zeile zeigt den Kurz-Gedanken. Der Button „Details" öffnet den 360°-Blick.',
  'leads.exp.whyShown': 'Warum Leadscraper dir diesen Lead zeigt',
  'leads.exp.uncertain': 'Leadscraper ist hier {score}: {note}.',
  'leads.exp.memoryRefs': 'Aus deinem Gedächtnis',
  'leads.act.fits': 'Passt',
  'leads.act.fitsNot': 'Passt nicht',
  'leads.act.fitsDone': 'Als Passt gespeichert',
  'leads.act.fitsNotDone': 'Als Passt nicht gespeichert',
  'leads.act.reason': 'Grund wählen',
  'leads.act.cancel': 'Abbrechen',
  'leads.act.details': 'Details',
  'leads.toast.accepted': '„{c}" als Passt gespeichert. Leadscraper lernt daraus.',
  'leads.toast.rejected':
    '„{c}" abgelehnt · Grund: {r}. Leadscraper lernt daraus für nächste Runs.',
  'leads.toast.export': 'Export-Funktion kommt bald.',

  // notifications
  'notif.title': 'Hinweise',
  'notif.sub': 'Hinweise, mit denen deine Suchen präziser werden.',
  'notif.empty.title': 'Alles im Fluss.',
  'notif.empty.sub': 'Leadscraper lernt.',
  'notif.dismiss': 'Ausblenden',
  'notif.kind.review': 'Bewerten',
  'notif.kind.pattern': 'Muster',
  'notif.kind.edge': 'Grenzfall',
  'notif.review.title': 'Neue Leads bewerten',
  'notif.review.body': 'Du hast noch {n} unbewertete Leads.',
  'notif.review.bodyAll': '{n} unbewertete Leads in {m} Zielgruppen.',
  'notif.review.cta': 'Jetzt reviewen',
  'notif.edge.title': 'Grenzfälle brauchen dein Urteil',
  'notif.edge.body':
    '{n} unsichere Leads bei {profile}: Dein Urteil schärft Leadscraper am stärksten.',
  'notif.act.review': 'Zu den Leads',
  'notif.act.pattern': 'In Leadscraper bestätigen',
  'notif.act.edge': 'Grenzfälle ansehen',
  'notif.pattern.title': 'Muster erkannt',
  'notif.pattern.badge': 'Gelerntes Muster',
  'notif.pattern.needsConfirm': 'Stimmt das?',
  'notif.pattern.yes': 'Ja, stimmt',
  'notif.pattern.no': 'Nein, ablehnen',
  'notif.pattern.stage2': 'Gespeichert',
  'notif.pattern.whyLabel': 'Warum? (optional)',
  'notif.pattern.whyPlaceholder': 'Hilft Leadscraper, die Nuance zu lernen, aber kein Muss.',
  'notif.pattern.back': 'Zurück',
  'notif.pattern.saveAndClose': 'Speichern',

  'dash.roi': 'ROI-Rechner',
  'dash.simulation': 'Simulation',
  'dash.leads': 'Leads',
  'dash.winRate': 'Gewinnquote',
  'dash.avgOrder': 'Ø Bestellvolumen',
  'dash.projectedRevenue': 'Progn. Umsatz',
  'dash.roiShort': 'ROI',
  'dash.newCustomers': 'Neue Kunden',
  'dash.timeline': 'Kennzahlenentwicklung im Zeitverlauf',
  'dash.lastYear': 'Letztes Jahr',
  'dash.totalLeads': 'Gesamtzahl der Leads',
  'dash.leadsGenerated': 'Lead generiert',
  'dash.newCust': 'Neukunden',
  'dash.projRevenue': 'Prognostizierter Umsatz',
  'dash.yourLeads': 'Deine Leads',
  'dash.yourProfiles': 'Deine Zielgruppen',
  'dash.yourProfilesSub':
    'Alle Zielgruppen, die du trainierst. Klick öffnet die Leads dieser Zielgruppe.',
  'dash.profiles': 'aktiv',
  'hero.eyebrow': 'Leadscraper lernt dich kennen',
  'hero.title': 'Über alle Zielgruppen hinweg wird Leadscraper präziser, mit jedem Feedback.',
  'hero.sub':
    'Jedes „Passt / Passt nicht" schärft, welche Leads morgen oben stehen. Das hier sind deine aktuellen Kennzahlen.',
  'hero.stat.feedbacks': 'Feedbacks insgesamt',
  'hero.stat.matchrate': '⌀ Trefferquote',
  'hero.stat.profiles': 'aktive Zielgruppen',
  'dash.col.profile': 'Zielgruppe',
  'dash.col.query': 'Zielgruppe',
  'dash.col.leads': 'Leads',
  'dash.col.trained': 'Trainiert',
  'dash.col.matchrate': 'Trefferquote',
  'dash.col.lastRun': 'Letzter Lauf',
  'dash.newBadge': 'neu',
  'dash.openProfile': 'Leads öffnen',
  'dash.startRun': 'Suchlauf starten',
  'dash.nextUp': 'Als nächstes',
  'dash.actNow': 'Öffnen',
  'dash.onlyFavorites': 'Nur Favoriten',
  'dash.date': 'Datum',
  'dash.queryId': 'Query ID',
  'dash.status': 'Status',
  'dash.progress': 'Fortschritt',
  'dash.leadsGen': 'Leads generiert',
  'dash.action': 'Aktion',
  'dash.openLeads': 'Leads öffnen →',
  'dash.done': 'Fertig',
  'dash.inProgress': 'In Bearbeitung',

  // find-leads form
  'find.title': 'Neue Leads finden',
  'find.forProfile': 'Für welche Zielgruppe?',
  'find.forProfileHint': 'Deine Bewertungen trainieren Leadscraper dieser Zielgruppe.',
  'find.businessType': 'Unternehmensart',
  'find.businessTypeP': 'z.B. Restaurant, Anwalt, Steuerberater',
  'find.location': 'Standort',
  'find.locationP': 'z.B. Berlin, Hamburg, München',
  'find.contact': 'Ansprechpartner',
  'find.contactP': 'z.B. Inhaber, Vertriebsmitarbeiter, Geschäftsführer',
  'find.amount': 'Anzahl der Leads',
  'find.creditNote': '(1 Lead = 1 Credit)',
  'find.amountHint': 'Der Wert muss zwischen 1 und 1000 liegen',
  'find.extras': 'Zusätzliche Einschränkungen',
  'find.extrasP': 'Definiere deine Zielgruppe noch genauer',
  'find.start': 'Leadscraper starten',
  'find.trainsProfile': 'Trainiert',

  // cortex
  'cortex.title': 'Memory',
  'cortex.heroEmpty':
    'Noch leer. Leadscraper beginnt zu lernen, sobald du die ersten Leads bewertest.',
  'cortex.heroEmptySub':
    'Leadscraper ist das Gedächtnis deines Profils: was du bevorzugst, was du ablehnst und wo das System noch unsicher ist.',
  'cortex.step': 'Schritt',
  'cortex.step1': 'Leads öffnen',
  'cortex.step1d': 'Schau dir die ersten Karten in deiner Liste an.',
  'cortex.step2': 'Passt / Passt nicht',
  'cortex.step2d': 'Bewerte jeden Lead. Gib beim Ablehnen kurz einen Grund.',
  'cortex.step3': 'Hier nachlesen',
  'cortex.step3d': 'Nach ~20 Feedbacks stehen hier die ersten Klartext-Aussagen.',
  'cortex.ctaRate': 'Jetzt erste Leads bewerten',
  'cortex.activeSince': 'Zielgruppe aktiv seit',
  'cortex.hero': 'Das hat Leadscraper aus deinen {n} Bewertungen gelernt.',
  'cortex.heroSub':
    'Jede Aussage kannst du bestätigen, korrigieren oder vergessen lassen. Änderungen greifen ab dem nächsten Sortierlauf.',
  'cortex.matchRate': 'Trefferquote',
  'cortex.sinceStart': 'seit Start',
  'cortex.feedbacks': 'Feedbacks',
  'cortex.fits': 'Passt',
  'cortex.fitsNot': 'Passt nicht',
  'cortex.perWeek': 'pro Woche',
  'cortex.runs.title': 'Suchläufe',
  'cortex.runs.sub': 'Alle Abfragen, die du für diese Zielgruppe gestartet hast.',
  'cortex.runs.count': 'Läufe',
  'cortex.runs.col.date': 'Datum',
  'cortex.runs.col.params': 'Suchparameter',
  'cortex.runs.col.leads': 'Leads',
  'cortex.runs.col.matchrate': 'Trefferquote',
  'cortex.runs.col.action': 'Aktion',
  'cortex.runs.repeat': 'Wiederholen',
  'repeat.title': 'Suchlauf wiederholen',
  'repeat.sub': 'Parameter sind vorbelegt. Pass sie an oder starte direkt neu.',
  'repeat.paramsLabel': 'Parameter dieses Laufs',
  'repeat.amountLabel': 'Wie viele Leads möchtest du?',
  'repeat.amountHint': 'Mehr Leads = breitere Abdeckung, weniger Leads = höhere Qualität pro Lead.',
  'repeat.preset': 'Vorschläge',
  'repeat.prediction.title': 'Erwartetes Ergebnis',
  'repeat.prediction.matches': 'erwartete Treffer',
  'repeat.prediction.basedOn': 'basierend auf deiner aktuellen Match-Rate',
  'repeat.prediction.time': 'geschätzte Laufzeit',
  'repeat.prediction.credits': 'Credits',
  'repeat.cancel': 'Abbrechen',
  'repeat.start': 'Suchlauf starten',
  'repeat.toast': 'Suchlauf gestartet, Ergebnisse in wenigen Minuten.',

  // Scheduling
  'sched.section': 'Wiederholung',
  'sched.sectionSub': 'Lass Leadscraper diesen Suchlauf regelmäßig automatisch durchführen.',
  'sched.once': 'Einmalig',
  'sched.onceSub': 'Jetzt einmal ausführen',
  'sched.daily': 'Täglich',
  'sched.dailySub': 'Jeden Tag um dieselbe Uhrzeit',
  'sched.weekly': 'Wöchentlich',
  'sched.weeklySub': 'Jede Woche am gewählten Tag',
  'sched.monthly': 'Monatlich',
  'sched.monthlySub': 'Jeden Monat am gewählten Datum',
  'sched.time': 'Startzeit',
  'sched.weekday': 'Wochentag',
  'sched.dayOfMonth': 'Tag im Monat',
  'sched.autoPush': 'Neue Leads automatisch ins CRM pushen',
  'sched.autoPushSub':
    'Sobald Leadscraper einen geplanten Lauf abschließt, werden alle gefundenen Leads automatisch an dein verbundenes CRM gesendet.',
  'sched.autoPushNoCRM':
    'Du musst zuerst ein CRM in den Account-Einstellungen verbinden, um Auto-Push zu nutzen.',
  'sched.nextRun': 'Nächster Lauf',
  'sched.toast.created': 'Geplanter Suchlauf angelegt, läuft automatisch weiter.',
  'sched.toast.paused': 'Geplanter Lauf pausiert.',
  'sched.toast.resumed': 'Geplanter Lauf reaktiviert.',
  'sched.toast.deleted': 'Geplanter Lauf gelöscht.',
  // Days
  'sched.day.mon': 'Montag',
  'sched.day.tue': 'Dienstag',
  'sched.day.wed': 'Mittwoch',
  'sched.day.thu': 'Donnerstag',
  'sched.day.fri': 'Freitag',
  'sched.day.sat': 'Samstag',
  'sched.day.sun': 'Sonntag',
  'sched.day.mon.short': 'Mo',
  'sched.day.tue.short': 'Di',
  'sched.day.wed.short': 'Mi',
  'sched.day.thu.short': 'Do',
  'sched.day.fri.short': 'Fr',
  'sched.day.sat.short': 'Sa',
  'sched.day.sun.short': 'So',
  // Scheduled runs section
  'schedRuns.title': 'Geplante Suchläufe',
  'schedRuns.sub': 'Regelmäßige Läufe, die automatisch neue Leads in diese Zielgruppe holen.',
  'schedRuns.count': 'aktiv',
  'schedRuns.col.frequency': 'Frequenz',
  'schedRuns.col.params': 'Parameter',
  'schedRuns.col.leads': 'Leads/Lauf',
  'schedRuns.col.crm': 'CRM-Push',
  'schedRuns.col.nextRun': 'Nächster Lauf',
  'schedRuns.col.action': '',
  'schedRuns.crm.yes': 'Aktiv',
  'schedRuns.crm.no': 'Aus',
  'schedRuns.status.paused': 'Pausiert',
  'schedRuns.pause': 'Pausieren',
  'schedRuns.resume': 'Fortsetzen',
  'schedRuns.delete': 'Löschen',
  'schedRuns.empty.title': 'Noch keine geplanten Läufe',
  'schedRuns.empty.sub':
    'Aktiviere „Wiederholung" beim nächsten Suchlauf, um regelmäßig neue Leads zu erhalten.',
  'schedRuns.freq.daily': 'Täglich · {time}',
  'schedRuns.freq.weekly': '{day} · {time}',
  'schedRuns.freq.monthly': '{day}. des Monats · {time}',
  // Dashboard inbox hint
  'inbox.sched.title': '{n} geplante Läufe aktiv',
  'inbox.sched.body': 'Nächster Lauf {rel}. Neue Leads landen automatisch {where}.',
  'inbox.sched.cta': 'Ansehen',
  'inbox.sched.inCRM': 'im CRM',
  'inbox.sched.inList': 'in deiner Liste',

  'cortex.roi.title': 'ROI-Schätzung',
  'cortex.roi.sub': 'Was dein aktueller Stand wert sein könnte.',
  'cortex.roi.leads': 'Leads',
  'cortex.roi.winRate': 'Gewinnquote',
  'cortex.roi.avgOrder': 'Ø Bestellvolumen',
  'cortex.roi.expectedFits': 'Erwartete Passt-Leads',
  'cortex.roi.viaRate': 'Ø Trefferquote',
  'cortex.roi.newCustomers': 'Neue Kunden',
  'cortex.roi.winLabel': 'Gewinnquote',
  'cortex.roi.revenue': 'Progn. Umsatz',
  'cortex.roi.revenueSub': 'bei aktuellem Stand',
  'cortex.roi.disclaimer':
    'Rechenwert, basiert auf deiner aktuellen Trefferquote. Ist Leadscraper reifer, werden die Zahlen realistischer.',
  'cortex.patterns': 'Gelernte Muster',
  'cortex.strong': 'stark',
  'cortex.medium': 'mittel',
  'cortex.weak': 'schwach',
  'cortex.learned': 'Was Leadscraper gelernt hat',
  'cortex.plain': 'In Klartext, so wie du es lesen würdest.',
  'cortex.tierStrong': 'Stark',
  'cortex.tierMedium': 'Mittel',
  'cortex.tierWeak': 'Schwach',
  'cortex.strongNote': 'belastbare Muster',
  'cortex.mediumNote': 'weiter beobachtet',
  'cortex.weakNote': 'Leadscraper ist hier unsicher',
  'cortex.confirmed': 'von dir bestätigt',
  'cortex.uncertain': 'Leadscraper ist hier unsicher',
  'cortex.patternsPending': 'Noch zu bestätigen',
  'cortex.confirm': 'Bestätigen',
  'cortex.correct': 'Korrigieren',
  'cortex.forget': 'Vergessen',
  'cortex.footer':
    'Wenn du eine Aussage korrigierst oder vergisst, wird sie ab sofort nicht mehr zum Sortieren deiner Leads verwendet.',

  // detail — transparency
  'det.back': 'Zurück zu den Suchergebnissen',
  'det.fits': 'Passt',
  'det.fitsNot': 'Passt nicht',
  'det.markedFit': '✓ Als Passt markiert',
  'det.rejectAnyway': '↩ Doch nicht passend?',
  'det.markedNotFit': '× Als Passt nicht markiert',
  'det.whyFits': 'Warum passt das zu dir',
  'det.whyFitsSub': 'aus dem, was Leadscraper über dich gelernt hat',
  'det.patterns': 'Gelernte Muster, die hier greifen',
  'det.similar': 'Ähnlich zu Leads, die du vorher akzeptiert hast',
  'det.accepted': 'Angenommen',
  'det.companyProfile': 'Firmenprofil',
  'det.sector': 'Branche',
  'det.city': 'Standort',
  'det.size': 'Mitarbeiter',
  'det.founded': 'Gründung',
  'det.website': 'Website',
  'det.shortProfile': 'Kurzprofil',
  'det.webExcerpts': 'Website-Auszüge',
  'det.sourcesTitle': 'Woher diese Informationen stammen',
  'det.trail.searched': 'Cortex durchsuchte {n} öffentliche Quellen',
  'det.trail.website': 'Firmen-Website',
  'det.trail.register': 'Handelsregister',
  'det.trail.google': 'Google-Recherche',
  'det.trail.press': 'Presse',
  'det.trail.pages': '{n} Seiten',
  'det.trail.profiles': '{n} Profile',
  'det.capturedAt': 'erfasst',
  'det.derivedAt': 'abgeleitet',
  'det.sourcePage': 'Ausgangsseite',
  'det.sourcesBelegtCount': '{n} belegt',
  'det.sourcesTagline': 'Wo jede Angabe herkommt, offen und nachprüfbar.',
  'det.sourcesBelegt': '{n} von {total} belegt',
  'det.sourcesFieldCount': '{n} Felder',
  'det.lastChecked': 'zuletzt geprüft',
  'det.sourcesUnsourced': 'Noch nicht belegt',
  'det.sourcesHonesty':
    'Amtliche und öffentliche Angaben sind direkt belegt, KI-Schätzungen klar als solche markiert. Leadscraper nutzt keine bezahlpflichtigen Datenbanken.',
  'det.sourcesFlex':
    'Andere verstecken, woher ihre Daten kommen. Wir legen jede Quelle offen, nachprüfbar.',
  'ld.tier.officialName': 'Amtlich belegt',
  'ld.tier.officialSub': 'Amtliches Register und gesetzliche Pflichtangaben',
  'ld.tier.publicName': 'Öffentlich belegt',
  'ld.tier.publicSub': 'Öffentlich einsehbar im Web',
  'ld.tier.inferredName': 'Von Cortex abgeleitet',
  'ld.tier.inferredSub': 'Schätzung, vor dem Senden prüfen',
  'ld.tier.officialFallback': 'Amtliche Quelle',
  'ld.tier.publicFallback': 'Öffentliche Quelle',
  'ld.tier.inferredFallback': 'Von Cortex abgeleitet',
  'ld.tier.legendOfficial': 'amtlich',
  'ld.tier.legendPublic': 'öffentlich',
  'ld.tier.legendInferred': 'abgeleitet · prüfen',
  'ld.tier.legendUnsourced': 'noch offen',
  'ld.srcLabel.dork': 'Öffentliche Web-Suche',
  'ld.srcLabel.icypeas_finder': 'Abgeleitete E-Mail',
  'ld.srcLabel.role_match': 'Rollen-Abgleich',
  'ld.srcLabel.cortexNace': 'Cortex-Branchenanalyse',
  'ld.field.vatId': 'USt-IdNr.',
  'ld.field.facebook': 'Facebook',
  'ld.field.instagram': 'Instagram',
  'ld.field.country': 'Land',
  'ld.field.contactPhone': 'Telefon (Ansprechpartner)',
  'det.sourcesSub':
    'Jedes Feld in diesem Lead kannst du auf eine konkrete öffentliche Quelle zurückführen.',
  'det.sourcesCount': 'Quellen',
  'det.sourcesPending':
    'Die Quellen-Belege für diesen Lead werden noch zusammengestellt. Sie erscheinen hier, sobald sie verifiziert sind.',
  'det.fetched': 'abgerufen',
  'det.delivers': 'Liefert:',
  'det.open': 'Öffnen',
  'det.publicOnly':
    'Alle Quellen sind öffentlich zugänglich. Leadscraper speichert niemals Daten, die aus nicht-öffentlichen oder bezahlpflichtigen Verzeichnissen stammen.',
  'det.decider': 'Entscheider',
  'det.contact': 'Kontakt',
  'det.draftMail': 'E-Mail-Entwurf vorbereiten',
  'det.toCRM': 'In CRM übernehmen',
  'det.draftMailSoonToast': 'E-Mail-Entwürfe aus dem Lead heraus sind noch nicht verfügbar. Bald.',
  'det.crmSoonTitle':
    'CRM-Integration kommt bald. Du wirst benachrichtigt sobald HubSpot, Pipedrive & Co. angeschlossen sind.',
  'det.research.label': 'Recherche-Weg',
  'det.research.summaryFallback':
    '{n} Suchwege probiert, keine spezifische Rolle gefunden, Geschäftsführer als Fallback',
  'det.research.summaryFound': 'Kontakt gefunden auf Stufe {stage}: {label}',
  'det.research.summaryNoHit': '{n} Suchwege ohne Treffer',
  'det.research.hit': '✓ Treffer',
  'det.research.noHit': '○ kein Treffer',
  'det.research.resultOne': 'Ergebnis',
  'det.research.resultMany': 'Ergebnisse',
  'det.research.footer':
    'Leadscraper probiert verschiedene Suchwege (LinkedIn, Firmen-Website, Presse, Xing), bevor es zum Geschäftsführer-Fallback greift. So ist transparent, warum genau dieser Kontakt angezeigt wird.',
  'det.contactsEmpty':
    'Noch keine Ansprechpartner extrahiert. Leadscraper sucht in Impressum + LinkedIn.',
  'det.memoryHint': 'Hinweis für dein Gedächtnis',
  'det.memoryHintText':
    'Wenn du diesen Lead akzeptierst oder ablehnst, beeinflusst das ähnliche Leads in „{profile}", aber nicht deine anderen Profile.',

  // source kinds
  'src.official': 'Amtlich',
  'src.web': 'Firmen-Website',
  'src.directory': 'Verzeichnis',
  'src.news': 'Fachpresse',
  'src.derived': 'Von Leadscraper',

  // --- Profile-Detail (360°) ---
  'pd.screenLabel': 'Zielgruppen-Details',
  'pd.activeSince': 'Aktiv seit {date}',
  'pd.ratings': '{n} Bewertungen',
  'pd.runs': '{n} Suchläufe',
  'pd.openLeads': 'Leads öffnen',
  'pd.curve.title': 'Lernkurve',
  'pd.curve.sub': 'Wie sich die Trefferquote mit jeder Bewertung entwickelt hat.',
  'pd.curve.noData': 'Noch zu wenig Daten.',
  'pd.curve.liftLabel': 'Verbesserung seit Start',
  'pd.curve.liftSub': 'absolute Trefferquote',
  'pd.curve.inWeeks': 'in {n} Wochen',
  'pd.curve.start': 'Start',
  'pd.curve.coldSub': 'Cold',
  'pd.curve.milestone50': '50 Bewertungen',
  'pd.curve.milestone50Sub': 'erste Patterns',
  'pd.curve.milestone200': '200 Bewertungen',
  'pd.curve.milestone200Sub': 'Modell stabilisiert',
  'pd.curve.today': 'Heute',
  'pd.curve.todaySub': '{n} Bewertungen',
  'pd.patterns.title': 'Was Leadscraper gelernt hat',
  'pd.patterns.sub': 'Deine Präferenzen, extrahiert aus jeder Passt / Passt-nicht-Bewertung.',
  'pd.patterns.strong': 'Stark, verlässliche Regeln',
  'pd.patterns.medium': 'Mittel, plausibel, wird beobachtet',
  'pd.patterns.weak': 'Schwach, frühe Signale',
  'pd.leads.title': 'Letzte Leads',
  'pd.leads.sub': 'Vorschau. Die vollständige Liste findest du im Tab Leads.',
  'pd.leads.viewAll': 'Alle ansehen',
  'pd.side.focus': 'Suchfokus',
  'pd.side.reasons': 'Häufige Ablehnungsgründe',
  'pd.side.recommended': 'Empfohlen',
  'pd.side.next1.t': 'Suchlauf starten',
  'pd.side.next1.d': 'Bei {pct} % Trefferquote lohnen sich 50–100 neue Leads.',
  'pd.side.next2.t': 'Unbestätigte Patterns prüfen',
  'pd.side.next2.d': 'So lernt Leadscraper schneller.',
  'pd.side.next3.t': 'Feedback weiter geben',
  'pd.side.next3.d': 'Je mehr Bewertungen, desto präziser.',
  'pd.side.snapshot': 'Auf einen Blick',
  'pd.side.matchRate': 'Trefferquote',
  'pd.side.leadsTotal': 'Leads total',
  'pd.side.accepted': '({n} passend)',
  'pd.side.patterns': 'Patterns',
  'pd.side.patternsSub': '{strong} stark · {medium} mittel',
  'pd.side.lastRun': 'Letzter Lauf',
  'pd.side.lastRunLeads': '{n} Leads',
  'pd.side.firstRun': 'Erster Lauf',
  'pd.side.feedbacks': 'Bewertungen',
  'pd.side.matchMiss': 'Passend / Nicht',
  'pd.pat.confirm': 'Bestätigen',
  'pd.pat.confirmT': 'Bestätigen, als Regel übernehmen',
  'pd.pat.reject': 'Verwerfen',
  'pd.pat.rejectT': 'Verwerfen, Pattern löschen',
  'pd.pat.weaken': 'Abschwächen',
  'pd.pat.remove': 'Entfernen',
  'pd.pat.actions': 'Aktionen',
  'pd.toast.confirmed': 'Pattern bestätigt, wird ab sofort als verlässliche Regel angewendet',
  'pd.toast.rejected': 'Pattern verworfen',
  'pd.toast.weakened': 'Pattern abgeschwächt, wird neu beobachtet',
  'pd.toast.removed': 'Pattern entfernt',

  // --- Search results screen ---
  'res.new': 'Neu',
  'res.uncertainty': 'Leadscraper ist hier {score}: {text}.',
  'res.fromMem': 'aus deinem Gedächtnis: „{text}"',
  'res.fit': 'Passt',
  'res.notFit': 'Passt nicht',
  'res.openDetails': 'Details öffnen →',
  'res.pickReason': 'Grund wählen →',
  'res.acceptedNote': 'Leadscraper lernt aus dieser Annahme.',
  'res.rejectedNote': 'Grund gespeichert. Das schärft dein Gedächtnis.',
  'res.whyNotTitle': 'Warum passt dieser Lead nicht?',
  'res.cancel': 'Abbrechen',
  'res.reasonHint': 'Ein Click reicht. Dein Grund schärft, was du morgen siehst.',
  'res.toast.accepted': '„{company}" als Passt gespeichert. Leadscraper schärft deine Zielgruppe.',
  'res.toast.rejected': 'Grund „{reason}" gespeichert. Ähnliche Leads werden seltener.',
  'res.breadcrumb': 'Suchergebnisse · {profile}',
  'res.title': 'Leads · {profile}',
  'res.summary':
    '{count} Leads aus 412 gesichtet. Jeder kommt mit einem Satz, warum er zu dir passt. Dein „Passt / Passt nicht" schärft, was du morgen siehst.',
  'res.density.comfortable': 'Komfortabel',
  'res.density.compact': 'Kompakt',
  'res.filter': 'Filter',
  'res.fb.status': 'Feedback-Status',
  'res.fb.all': 'Alle',
  'res.fb.new': 'Neu für dich',
  'res.sector': 'Branche',
  'res.employees': 'Mitarbeiter',
  'res.location': 'Standort',
  'res.learning.title': 'Was Leadscraper gerade lernt',
  'res.learning.body':
    'Neues Signal über die letzten zwei Wochen: du akzeptierst Betriebe mit eigener Druck- oder Stanztechnik öfter als reine Konfektionierer.',
  'res.footer':
    'Leadscraper hat weitere 406 Einträge gesichtet. Die hier gezeigten {count} sind diejenigen, die am besten zu deinem bisherigen Feedback passen.',

  'dash.close': 'Schließen',
  'dash.months': 'Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez,Jan,Feb,Mär,Apr',

  // --- Onboarding gate ---
  'og.later': 'Später entscheiden →',
  'og.ready': 'Dein Konto ist bereit',
  'og.welcome': 'Willkommen, Janik.',
  'og.sub1': 'Wähle dein Abo, um Leadscraper',
  'og.sub1b': '3 Tage kostenlos zu testen',
  'og.sub2': 'Keine Zahlung jetzt. Du kannst während der Testphase jederzeit kündigen.',
  'og.moneyBack': '14-Tage-Geld-zurück',
  'og.dsgvo': 'DSGVO-konform · Server DE',
  'og.cancelAny': 'Jederzeit kündbar',
  'og.cta': '3 Tage kostenlos testen: {plan}',
  'og.ctaSub':
    'Keine Zahlung in den ersten 3 Tagen · Danach {price},00 € / Monat · {leads} Test-Leads inklusive',
  'og.ctaPlain': 'Weiter mit {plan}',
  'og.ctaSubPlain': '{price},00 € / Monat · sofortige Aktivierung',
  'og.recommended': 'Empfohlen',
  'og.plan': 'Abo',
  'og.perMonth': '€ / Monat',
  'og.leadsIncl': '{n} Leads pro Monat inklusive',
  'og.trial': '3 Tage kostenlos testen',
  'og.trialIncl': 'inkl.',
  'og.trialLeadsN': '{n} Test-Leads',
  'og.ctaBeta': 'Beta-Zugang sichern: {price} € / Monat',
  'pricing.beta.headline': 'Dein Beta-Zugang zu Leadscraper',
  'pricing.beta.subText': 'Growth-Plan im ersten Monat mit 55 % Rabatt, exklusiv für Beta-Tester.',
  'offer.beta.pricing.intro': 'Beta-Einladung · 55 % Rabatt im 1. Monat',
  // `pricing.trial50.{headline,subText}` siehe LEA-261-Block weiter unten —
  // LEA-241-Werte ersetzt durch die Redesign-Copy aus Janiks Mockup.

  // --- Onboarding gate v2 (LEA-241): 1:1 mit Janiks Cloud-Design Mockups
  //     unter apps/web/public/prototype/sandbox/pricing-{default,
  //     50credits-trial,beta}.html. Headlines split into lead/grad/tail
  //     so der Gradient-span im React-JSX i18n-bar bleibt. Plan-Detail/
  //     Feature-Copy ist hier neu — bewusst getrennt von price.plan.* das
  //     in der älteren PricingModal-Version weitergenutzt wird.
  'og.step.created': 'Account erstellt',
  'og.step.pickPlan': 'Plan wählen',
  'og.step.start': 'Loslegen',
  'og.step.startTrial': '3 Tage gratis testen',
  'og.step.activateBeta': 'Beta-Paket aktivieren',

  'og.title.default.lead': 'Wähle deinen Plan und ',
  'og.title.default.grad': 'starte in 60 Sekunden',
  'og.title.default.tail': '.',
  'og.subtitle.default':
    'Drei Pläne, dieselbe Datenqualität. Wähle, wie viele Leads du pro Monat brauchst. Wechseln und kündigen kannst du jederzeit mit einem Klick.',

  'og.eyebrow.trial50': '50 Credits geschenkt',
  // `og.title.trial50.{lead,grad,tail}` + `og.subtitle.trial50` siehe LEA-261-Block.
  'og.hlBanner.trial50.title': 'So funktioniert dein Trial:',
  'og.hlBanner.trial50.body':
    'Nach Plan-Auswahl bekommst du sofort {credits} auf dein Konto. Verbrauche sie in den nächsten 3 Tagen. Wenn du nicht kündigst, wechselst du automatisch in den gewählten Plan.',
  'og.hlBanner.trial50.credits': '{n} Credits',

  'og.eyebrow.beta': 'Persönliche Beta-Einladung',
  'og.title.beta.lead': 'Du wurdest ',
  'og.title.beta.grad': 'handverlesen',
  'og.title.beta.tail': ' für die Beta.',
  // Ehrlichkeits-Fix (Janik 21.07.): der Stripe-Coupon BETA55 gilt nur für die
  // ERSTE Rechnung (duration=once) — die Copy darf keinen dauerhaften Rabatt
  // versprechen. Alle „dauerhaft"-Claims → Erstmonats-Framing.
  'og.subtitle.beta':
    'Als Beta-Tester bekommst du unser stärkstes Paket (500 Leads pro Monat) zum Sonderpreis: Dein erster Monat kostet 220 € statt 490 €. Keine Mindestlaufzeit, jederzeit kündbar.',

  'og.beta.narrativeTitle': 'Warum dieses Angebot?',
  'og.beta.narrativeBody':
    'Wir suchen {profis}, die unser System früh nutzen, ehrlich Feedback geben und mitbestimmen, wie sich Leadscraper entwickelt. Im Gegenzug zahlst du im ersten Monat {price} für unser Growth-Paket, statt regulär 490 € — danach regulärer Preis, jederzeit kündbar.',
  'og.beta.narrativeProfis': '30 aktive Vertriebsprofis',
  'og.beta.narrativePrice': 'nur 220 €',
  'og.beta.feature.1.lead': '',
  'og.beta.feature.1.bold': '500 Leads',
  'og.beta.feature.1.tail': ' pro Monat, verifizierte E-Mails & Telefonnummern',
  'og.beta.feature.2': 'KI-Targeting in natürlicher Sprache',
  'og.beta.feature.3': 'CRM-Integrationen + CSV/Excel-Export',
  'og.beta.feature.4': 'DSGVO-konform · Daten in der EU',
  'og.beta.feature.5.lead': 'Direkter ',
  'og.beta.feature.5.bold': 'WhatsApp-Zugang zu Janik',
  'og.beta.feature.5.tail': ' bei Fragen',
  'og.beta.savings': 'Du sparst {n} € im ersten Monat',
  'og.beta.cardName': 'Dein Beta-Paket',
  'og.beta.priceOld': '{n} € / Monat regulär',
  'og.beta.priceNowSuffix': '/ 1. Monat',
  'og.beta.priceFootnote': 'danach {n} €/Monat · jederzeit kündbar',
  'og.beta.cardFeature.1': '500 Leads / Monat im Growth-Umfang',
  'og.beta.cardFeature.2': 'Sofortige Aktivierung. Kein Trial',
  'og.beta.cardFeature.3': 'Jederzeit mit 1 Klick kündbar',
  'og.beta.cardCta': 'Beta-Paket aktivieren',
  'og.beta.cardFoot': 'Karte erforderlich · sichere Zahlung über Stripe',

  'og.planLeadsUnit': 'Leads / Monat',
  'og.planDetail.basic': 'Für kleine Vertriebsteams, die gezielt nachfassen.',
  'og.planDetail.starter': 'Bestes Preis-Leistungs-Verhältnis für aktive Teams.',
  'og.planDetail.growth': 'Für Teams, die Outbound skalieren wollen.',
  'og.planFeature.basic.1': 'Verifizierte E-Mails & Telefonnummern',
  'og.planFeature.basic.2': 'KI-Targeting in natürlicher Sprache',
  'og.planFeature.basic.3': 'CRM-Integrationen + CSV/Excel-Export',
  'og.planFeature.basic.4': 'DSGVO-konform · Daten in der EU',
  'og.planFeature.starter.1': 'Alles aus Basic',
  'og.planFeature.starter.2': '2,5× mehr Leads pro Monat',
  'og.planFeature.starter.3': 'Priorisierte Lead-Queue',
  'og.planFeature.starter.4': 'E-Mail-Support < 4 h',
  'og.planFeature.growth.1': 'Alles aus Starter',
  'og.planFeature.growth.2': '5× mehr Leads pro Monat',
  'og.planFeature.growth.3': 'Persönlicher Onboarding-Call',
  'og.planFeature.growth.4': 'Premium-Support direkt mit Janik',

  'og.planPriceSuffix.default': '/ Monat',
  'og.planPriceSuffix.trial': '/ Monat nach Trial',
  // Trial-Reframe (Janik 20.07.): großer Kartenpreis = „0 € heute", der echte
  // Monatspreis steht in der planPriceNote ({price} kommt aus PlanCard).
  'og.planPriceSuffix.trialToday': 'heute',
  'og.planPriceNote.basic.default': 'Entspricht 1,90 € pro Lead',
  'og.planPriceNote.starter.default': 'Entspricht 1,16 € pro Lead. Spare 39 %',
  'og.planPriceNote.growth.default': 'Entspricht 0,98 € pro Lead. Spare 48 %',
  'og.planPriceNote.basic.trial': 'Danach {price} €/Monat · 100 Credits inklusive',
  'og.planPriceNote.starter.trial': 'Danach {price} €/Monat · 250 Credits inklusive · Spare 39 %',
  'og.planPriceNote.growth.trial': 'Danach {price} €/Monat · 500 Credits inklusive · Spare 48 %',

  'og.planCta.pick.basic': 'Basic auswählen',
  'og.planCta.pick.starter': 'Starter auswählen',
  'og.planCta.pick.growth': 'Growth auswählen',
  // Janik 20.07.: EIN CTA-Text auf allen drei Karten — die Plan-Wahl trägt
  // die Karte selbst, der Button verkauft nur noch den kostenlosen Test.
  'og.planCta.trial.basic': '3 Tage kostenlos testen',
  'og.planCta.trial.starter': '3 Tage kostenlos testen',
  'og.planCta.trial.growth': '3 Tage kostenlos testen',
  'og.planCta.loading': 'Weiter zur Zahlung …',
  'og.planBadge.recommended': 'Empfohlen',

  'og.trust.card.title.default': 'Karte erforderlich',
  'og.trust.card.body.default': 'Sichere Zahlung über Stripe',
  'og.trust.card.title.trial': 'Karte zur Aktivierung',
  'og.trust.card.body.trial': 'Erst nach 3 Tagen wird abgebucht',
  'og.trust.cancel.title.default': '1-Klick kündbar',
  'og.trust.cancel.body.default': 'Keine Mindestlaufzeit',
  'og.trust.cancel.body.trial': 'Während des Trials kostenlos',
  'og.trust.gdpr.title': 'DSGVO-konform',
  'og.trust.gdpr.body': 'Server in der EU · nur öffentliche Quellen',
  'og.trust.beta.lock.title': 'Beta-Sonderpreis im 1. Monat',
  'og.trust.beta.lock.body': 'keine versteckten Aufschläge',

  // --- LEA-261 Split-Testimonials Layout (mai-offer + 50credits-trial v2)
  //     Visual-Quelle: mai-offer-pricing-wall.html und
  //     50credits-trial-pricing-wall.html (Linear-Attachments LEA-261).
  //     Headlines wieder lead/grad/tail-split damit der Gradient-span
  //     im JSX i18n-fest bleibt. trial50-Werte ersetzen die LEA-241-Copy.
  'pricing.trial50.headline': '50 B2B Leads im Wert von 100 €, jetzt geschenkt.',
  'pricing.trial50.subText': '50 Leads geschenkt, 3 Tage testen, jederzeit kündbar.',
  'og.title.trial50.lead': '50 B2B Leads im Wert von 100 €, ',
  'og.title.trial50.grad': 'jetzt geschenkt',
  'og.title.trial50.tail': '.',
  'og.subtitle.trial50': '50 Leads geschenkt, 3 Tage testen, jederzeit kündbar.',
  'pricing.mai.headline': 'Dein unfairer Wettbewerbsvorteil startet hier.',
  'pricing.mai.subText':
    'Im ersten Monat 74 % sparen, danach jederzeit mit 1 Klick wechseln oder kündigen.',
  'og.title.mai.lead': 'Dein ',
  'og.title.mai.grad': 'unfairer Wettbewerbsvorteil',
  'og.title.mai.tail': ' startet hier.',
  'og.subtitle.mai':
    'Im ersten Monat 74 % sparen, danach jederzeit mit 1 Klick wechseln oder kündigen.',

  'og.split.badge.start': 'Perfekt für den Start',
  'og.split.rating.score': '4.8 / 5.0',
  'og.split.rating.note': '· Exzellentes Nutzerfeedback',
  'og.split.trust.cancel': '1-Klick kündbar',
  'og.split.trust.gdpr': 'DSGVO-konform',

  'og.trial50v2.planName': 'Trial',
  'og.trial50v2.leadsNum': '50',
  'og.trial50v2.leadsUnit': 'Leads in 3 Tagen',
  'og.trial50v2.detail': 'Genug Credits, um Leadscraper komplett zu testen.',
  'og.trial50v2.price': 'Gratis',
  'og.trial50v2.priceNote': 'Endet nach 3 Tagen oder läuft weiter, 1-Klick kündbar.',
  'og.trial50v2.feature.1': 'Verifizierte E-Mails & Telefonnummern',
  'og.trial50v2.feature.2': 'KI-Targeting in natürlicher Sprache',
  'og.trial50v2.feature.3': 'CRM-Integrationen + CSV/Excel-Export',
  'og.trial50v2.feature.4': 'DSGVO-konform · Daten in der EU',
  'og.trial50v2.feature.5': 'Läuft nach 3 Tagen weiter, 1-Klick kündbar',
  'og.trial50v2.cta': '50 Credits gratis sichern',

  'og.maiOffer.planName': 'Basic',
  'og.maiOffer.leadsNum': '100',
  'og.maiOffer.leadsUnit': 'Leads / Monat',
  'og.maiOffer.detail': 'Perfekt zum Reinschnuppern, ohne Bindung.',
  'og.maiOffer.price': '49 €',
  'og.maiOffer.priceSuffix': '/ Monat',
  'og.maiOffer.priceOriginal': 'Statt 190 € / Monat',
  'og.maiOffer.priceNote': '0,49 € statt 1,90 € pro Lead, nur diesen Monat.',
  'og.maiOffer.feature.1': 'Verifizierte E-Mails & Telefonnummern',
  'og.maiOffer.feature.2': 'KI-Targeting in natürlicher Sprache',
  'og.maiOffer.feature.3': 'CRM-Integrationen + CSV/Excel-Export',
  'og.maiOffer.feature.4': 'DSGVO-konform · Daten in der EU',
  'og.maiOffer.feature.5': 'Ab Monat 2: 190 €/Monat, 1-Klick kündbar',
  'og.maiOffer.cta': 'Mai-Deal: 100 B2B Leads für 49 € sichern',

  // --- LEA-319 Trust-Redesign (variant '50credits-trust'). Pixel-Quelle:
  //     sandbox/pricing-trust-50credits{,-en}.html (approved Janik 2026-06-10).
  //     Timeline-Bodies nutzen {s} als Platzhalter für das gebold-te Segment
  //     (gleiche Split-Mechanik wie og.hlBanner / og.beta.narrative).
  'og.title.trust.lead': 'Teste Leadscraper ',
  'og.title.trust.grad': '3 Tage gratis',
  'og.title.trust.tail': ' mit 50 echten Leads.',
  'og.subtitle.trust':
    'Heute wird nichts abgebucht. Du testest mit echten Leads aus deiner Zielgruppe, und wenn es nicht passt, beendest du den Test mit einem Klick. Ohne Anruf, ohne Frist.',

  'og.trust.demo.tag': 'Live-Demo · kein Marketing-Video',
  'og.trust.demo.title': 'Sieh dir an, wie Leadscraper deine Leads findet',
  'og.trust.demo.body':
    'Echte Suche, echtes Dashboard, echte Ergebnisse. Gründer Janik zeigt dir den kompletten Ablauf von der Zielgruppen-Eingabe bis zur fertigen Lead-Liste.',
  'og.trust.demo.play': 'Demo-Video abspielen',
  'og.trust.demo.close': 'Schließen',

  'og.trust.timeline.1.when': 'Heute',
  'og.trust.timeline.1.body':
    'Plan wählen, Zahlungsmethode hinterlegen. {s}: Deine 50 Credits sind sofort nutzbar.',
  'og.trust.timeline.1.strong': '0 € Abbuchung',
  'og.trust.timeline.2.when': 'Tag 1–3',
  'og.trust.timeline.2.body':
    'Du testest mit echten Leads. Nicht überzeugt? {s} beendet den Test sofort, ohne Kontakt, ohne Begründung.',
  'og.trust.timeline.2.strong': 'Ein Klick im Konto',
  'og.trust.timeline.3.when': 'Ab Tag 3',
  'og.trust.timeline.3.body':
    'Erst jetzt startet dein Abo im gewählten Plan. {s}, keine Mindestlaufzeit.',
  'og.trust.timeline.3.strong': 'Monatlich kündbar',

  'og.trust.ctaNote': 'Heute 0 € · Beenden = 1 Klick',

  'og.trust.proof.head': 'Vertriebsteams, die schon umgestiegen sind',
  // Nachfolger des geloeschten og.trust.proof.pill (behauptete Google & OMR ohne Beleg; LEA-619). Nur aus
  // lib/verifiedReviews gerendert, {platform} = Plattformen der gezeigten Bewertungen.
  'og.trust.proof.pillVerified': 'Bewertungen auf {platform}',

  'og.trust.bar.card.title': '0 € heute',
  'og.trust.bar.card.body': 'Karte, PayPal oder SEPA-Lastschrift, sicher über Stripe',
  'og.trust.bar.cancel.title': 'In 5 Sekunden gekündigt',
  'og.trust.bar.cancel.body': '1 Klick im Konto, ohne Kontakt, sofort wirksam',
  'og.trust.bar.gdpr.title': 'Nur öffentliche Daten',
  'og.trust.bar.gdpr.body': 'DSGVO by design · Server in der EU · nur öffentliche Quellen',

  'og.trust.founderLine.title': 'Inhabergeführt aus Hamburg',
  'og.trust.founderLine.name': ' · Janik Deimann, Gründer',
  'og.trust.founderLine.sub':
    'Deimann Com GmbH · Du erreichst bei uns Menschen, keine Ticket-Warteschlange.',
  'og.trust.founderLine.ask':
    'Noch unsicher? Schreib uns: support@leadscraper.eu. Es antwortet ein Mensch.',

  // --- Paywall Revision 19 (Janik-Freigabe 11.09.2026) ---
  // Deutsche Texte 1:1 aus dem freigegebenen Entwurf (Design-Commit 22a435e7).
  // Nicht umformulieren — die Formulierungen sind abgestimmt, insbesondere das
  // qualifizierte „bis zu 50" und der Zusatz zu den Credit-Kosten.
  'og.r19.accountReady': 'Konto erstellt · Jetzt Test aktivieren',
  'og.r19.headline.lead': 'Finde bis zu',
  'og.r19.headline.grad': '50 kostenlose Leads.',
  'og.r19.lead':
    'Starte heute mit Firmen, die zu deinem Angebot passen. Dein Test enthält {credits} Credits für bis zu {credits} Firmen-Leads.',
  'og.r19.offerNote':
    'Kontakte und Firmenwissen kosten zusätzliche Credits. Dafür eingesetzte Credits reduzieren die Anzahl der Firmen.',
  'og.r19.rating.value': '4,8 / 5',
  'og.r19.rating.caption': 'Exzellentes Nutzerfeedback',
  'og.r19.rating.aria': 'Kundenbewertung: 4,8 von 5 Sternen',
  'og.r19.product.footnote': 'Du entscheidest, bei welchen Firmen du tiefer recherchierst.',
  'og.r19.picker.title': 'Starte jetzt kostenlos.',
  'og.r19.picker.trialCredits': '{credits} Credits Testguthaben',
  'og.r19.picker.trialPlan': '{plan} · {days} Tage 0 €, danach {renewal}, monatlich kündbar',
  'og.r19.picker.trialPlanAll': '{plan} · Test 0 €, danach {renewal}, monatlich kündbar',
  'og.r19.picker.today': '0 €',
  'og.r19.picker.todayLabel': 'heute',
  'og.r19.picker.description': 'Wähle dein Paket für die Zeit nach dem Test.',
  'og.r19.credits.title': '1 Firma finden',
  'og.r19.credits.equals': '=',
  'og.r19.credits.unit': '1 Credit',
  'og.r19.credits.note': 'Kontakte & Firmenwissen kosten zusätzliche Credits.',
  'og.r19.credits.info': 'Credit-Verbrauch am Beispiel ansehen',
  'og.r19.credits.example':
    'Beispiel: Du findest 20 Firmen und ergänzt bei 10 davon Kontakte und Firmenwissen. Das sind 40 Credits.',
  'og.r19.credits.exampleRest': 'Von deinen {credits} Test-Credits bleiben {rest} übrig.',
  'og.r19.credits.disclaimer':
    '{credits} Credits sind nicht automatisch {credits} vollständig recherchierte Kontakte.',
  'og.r19.plans.legend': 'Paket nach dem Test wählen',
  'og.r19.plans.creditsPerMonth': '{credits} Credits / Monat',
  'og.r19.plans.perMonth': '/ Monat',
  'og.r19.plans.caption.basic': 'Für deinen Einstieg',
  'og.r19.plans.caption.starter': 'Für die regelmäßige Akquise',
  'og.r19.plans.caption.growth': 'Für einen größeren Vertrieb',
  'og.r19.cta': 'Jetzt kostenlos starten',
  'og.r19.renewal': 'Danach {s} für {credits} Credits.',
  'og.r19.renewal.strong': '{price} € / Monat',
  'og.r19.renewal.cancel': 'Kündige vor Testende, damit keine Zahlung anfällt.',
  'og.r19.security': 'Zahlungsmittel im nächsten Schritt',
  'og.r19.help.faq': 'Test & Kündigung',
  'og.r19.help.features': 'Pakete im Detail',

  // --- Memory editor modal + extras ---
  'mem.editKicker': 'Gelernte Annahme korrigieren',
  'mem.editTitle': 'Wie soll Leadscraper das lernen?',
  'mem.editHint': 'Leadscraper nutzt diese Aussage ab dem nächsten Sortierlauf.',
  'mem.cancel': 'Abbrechen',
  'mem.save': 'Annahme speichern',
  'mem.toast.confirmed': 'Annahme bestätigt.',
  'mem.toast.forgotten': 'Annahme vergessen.',
  'mem.toast.corrected': 'Korrektur gespeichert.',
  'mem.screenLabelEmpty': 'Memory · leer',
  'mem.screenLabel': 'Memory',
  'mem.today': 'Heute',
  'mem.param.sector': 'Branche',
  'mem.param.location': 'Standort',
  'mem.param.contact': 'Ansprechpartner',
  'mem.param.extras': 'Extras',
  'mem.param.leads': 'Leads',
  'mem.profile': 'Zielgruppe',

  // --- Notifications / patterns ---
  'notif.pattern.confirmedLabel': 'Pattern bestätigt.',
  'notif.pattern.rejectedLabel': 'Pattern abgelehnt.',

  // --- Pricing ---
  'price.heroTrial': 'Wähle deinen Plan. Die ersten 3 Tage sind kostenlos.',
  'price.heroSub': 'Mehr Leads. Genau dann, wenn du sie brauchst.',
  'price.subTrialDesc':
    'Mit echten Leads, deinen Zielgruppen und deinem eigenen Leadscraper-Memory. Unbrauchbare Leads bekommst du zurück, ohne Rückfragen.',
  'price.subOneoffDesc':
    'Zusätzliche Leads als Einmalpaket, keine Laufzeit, keine Bindung. Credits laufen nicht ab.',
  'price.tab.sub': 'Abonnements',
  'price.tab.oneoff': 'Einmalpakete',
  'price.tab.afterSub': '(nach Abo)',
  'price.tab.lockNote': 'Verfügbar nach Abo-Start',
  'price.trust.refund.t': 'Unbrauchbare Leads? Zurück.',
  'price.trust.refund.s': 'Wenn ein Lead nicht passt, bekommst du den Credit sofort zurück.',
  'price.trust.gdpr.t': 'DSGVO-konform',
  'price.trust.gdpr.s': 'Alle Daten EU-gehostet, verschlüsselt, keine Drittweitergabe.',
  'price.trust.cancel.t': 'Jederzeit kündbar',
  'price.trust.cancel.s': 'Monatlich kündbar, keine versteckten Gebühren, keine Mindestlaufzeit.',
  'price.selected': 'Gewählt:',
  'price.trial3days': '3 Tage kostenlos',
  'price.testLeads': 'Test-Leads',
  'price.then': 'danach',
  'price.perMonth': '/Monat',
  'price.perMonthLong': '/ Monat',
  'price.leads': 'Leads',
  'price.oneTime': 'einmalig',
  'price.perLead': '€ / Lead',
  'price.ctaStartTrial': '3 Tage kostenlos starten',
  'price.ctaSwitchPlan': 'Abo wechseln',
  'price.ctaDowngradeScheduled': 'Wechsel bereits geplant',
  'price.ctaCurrentPlan': 'Aktueller Plan',
  'price.ctaTopUp': 'Jetzt aufladen',
  'price.badge.recommended': 'Empfohlen',
  'price.badge.popular': 'Beliebt',
  'price.badge.yourPlan': 'Dein Plan',
  'price.monthlyCancelable': 'monatlich kündbar',
  'price.afterThen': 'Danach {price} / Monat · jederzeit kündbar',
  'price.trialIncl': 'inkl.',
  // Plan taglines
  'price.plan.basic.tag': 'Für den Einstieg mit einer Zielgruppe',
  'price.plan.starter.tag': 'Bestes Preis-Leistungs-Verhältnis',
  'price.plan.growth.tag': 'Für skalierende Vertriebsteams',
  'price.plan.basic.f1': '100 qualifizierte Leads pro Monat',
  'price.plan.basic.f2': '1 aktive Zielgruppe',
  'price.plan.basic.f3': 'Leadscraper-KI mit kontinuierlichem Lernen',
  'price.plan.basic.f4': 'CRM-Integrationen (HubSpot, Pipedrive, Salesforce …)',
  'price.plan.basic.f5': 'E-Mail-Support',
  'price.plan.starter.f1': '250 qualifizierte Leads pro Monat',
  'price.plan.starter.f2': '3 aktive Zielgruppen',
  'price.plan.starter.f3': 'Leadscraper-KI mit priorisiertem Lernen',
  'price.plan.starter.f4': 'Alle CRM-Integrationen',
  'price.plan.starter.f5': 'Priorisierter Support',
  'price.plan.starter.f6': 'Export in CSV, XLSX, JSON',
  'price.plan.growth.f1': '500 qualifizierte Leads pro Monat',
  'price.plan.growth.f2': 'Unbegrenzte Zielgruppen',
  'price.plan.growth.f3': 'Leadscraper-KI mit Team-Memory',
  'price.plan.growth.f4': 'Alle CRM-Integrationen + Webhooks',
  'price.plan.growth.f5': 'Dedizierter Account Manager',
  'price.plan.growth.f6': 'API-Zugang',
  'price.pack.1000.tag': 'Perfekt für den Einstieg',
  'price.pack.5000.tag': 'Für erste skalierte Kampagnen',
  'price.pack.10000.tag': 'Für kontinuierliche Leadgenerierung',
  'price.pack.50000.tag': 'Für hohe Volumen und Teams',
  // Trial banner
  'trial.phase': 'Testphase',
  'trial.day1': 'Noch 1 Tag',
  'trial.daysN': 'Noch {n} Tage',
  'trial.freeTest': 'kostenlos testen.',
  'trial.afterNote': 'Danach läuft dein {plan}-Abo automatisch weiter, jederzeit kündbar.',
  'trial.leadsLeft': '{left} / {total} Test-Leads übrig',
  'trial.secureSub': 'Abo starten',
  // LEA-324: SEPA-Abo "Zahlung wird verarbeitet"-Banner (finale Copy von Janik ausstehend).
  'bill.sepaProcessing.badge': 'Zahlung wird verarbeitet',
  'bill.sepaProcessing.title':
    'Deine SEPA-Zahlung wird verarbeitet. Dein Zugang ist bereits freigeschaltet.',
  'bill.sepaProcessing.note':
    'Die Lastschrift kann 2–5 Werktage dauern. Du kannst Leadscraper schon jetzt voll nutzen.',

  // --- Leadscraper AI chat ---
  'ai.onlinePrefix': 'Online · kennt deine {n} Zielgruppen',
  'ai.collapse': 'Einklappen',
  'ai.intro':
    'Ich überwache deine Profile rund um die Uhr und helfe dir, schärfere Suchläufe und sichere Lernsignale zu formulieren.',
  'ai.cortex': 'Leadscraper',
  'ai.now': 'jetzt',
  'ai.greeting':
    'Hey 👋 Ich bin dein Leadscraper-Assistent. Ich sehe dein aktives Profil "{profile}" und alle Muster, die das System gelernt hat. Worum geht’s?',
  'ai.thinkingAbout': 'Woran ich gerade denke',
  'ai.quickStart': 'Schnellstart',
  'ai.openChat': 'Chat öffnen',
  'ai.moreN': '+{n} weitere',
  'ai.dismiss': 'Verbergen',
  'ai.inputP': 'Frag den Assistenten etwas …',
  'ai.send': 'Senden',
  'ai.footer': 'Leadscraper kennt nur deine Zielgruppen und Feedbacks, keine externen Daten.',
  'ai.errorReply':
    'Ich komme gerade nicht an meine Daten ran. Versuch es gleich noch einmal, oder formulier die Frage kürzer.',
  // Insights
  'ai.ins.pattern.title': 'Neues Muster in "{profile}"',
  'ai.ins.pattern.cta': 'Muster prüfen',
  'ai.ins.tune.title': '"{profile}" ist noch im Training',
  'ai.ins.tune.body':
    'Match-Rate bei {rate} %. Ich kann dir helfen, den nächsten Suchlauf gezielter zu formulieren.',
  'ai.ins.tune.cta': 'Suchlauf schärfen',
  'ai.ins.edge.title': 'Grenzfall: {company}',
  'ai.ins.edge.fallback':
    'Leadscraper ist hier unsicher. Dein Urteil hilft, das Muster zu schärfen.',
  'ai.ins.edge.cta': 'Lead anschauen',
  // Starter prompts (labels + prompts)
  'ai.sp1.label': 'Wo steht meine aktive Zielgruppe?',
  'ai.sp1.prompt':
    'Fass mir in 3 Sätzen zusammen, wie gut Leadscraper mein aktives Profil bereits verstanden hat, was ist gelernt, was nicht?',
  'ai.sp2.label': 'Welche Muster sollte ich bestätigen?',
  'ai.sp2.prompt':
    'Welche gelernten Muster sollte ich als nächstes bestätigen oder ablehnen, damit das System schneller lernt?',
  'ai.sp3.label': 'Suchlauf vorschlagen',
  'ai.sp3.prompt':
    'Schlag mir basierend auf meinem aktiven Profil einen präzisen nächsten Suchlauf vor, mit Branche, Standort, Größe und Extras.',
  'ai.sp4.label': 'Wo verliere ich Qualität?',
  'ai.sp4.prompt':
    'Wo in meinen Profilen siehst du Potenzial für höhere Match-Raten? Was sollte ich anpassen?',
  'ai.seedRefine': 'Schlag mir für meine Zielgruppe "{profile}" einen verfeinerten Suchlauf vor.',
  // System prompt language hint (used inside context)
  'ai.langHint':
    'Antworte auf Deutsch. Maximal 3-4 kurze Sätze pro Antwort, außer bei konkreten Anleitungen.',

  // --- LEA-230 (Om's bug): strings that were previously hardcoded in JSX ---
  // Common (reused across screens)
  'common.cancel': 'Abbrechen',
  'common.save': 'Speichern',
  'common.saving': 'Wird gespeichert …',
  'common.loading': 'Lädt …',
  'common.refresh': 'Aktualisieren',
  'common.edit': 'Ändern',
  'common.collapse': 'Einklappen',
  'common.hide': 'Ausblenden',

  // Account / Profile danger zone
  'acct.dataAccount': 'Daten & Konto',
  'acct.export.title': 'Daten exportieren',
  'acct.export.sub': 'DSGVO Art. 20: Alle deine Daten als JSON-Download.',
  'acct.export.btn': 'Exportieren',
  'acct.export.preparing': 'Export wird vorbereitet, kann bei vielen Daten etwas dauern.',
  'acct.export.ready': 'Download gestartet.',
  'acct.export.failed': 'Export fehlgeschlagen. Bitte erneut versuchen.',
  'acct.sec.twofaSoon':
    'Zwei-Faktor-Authentifizierung (Authenticator-App) ist hier noch nicht angebunden. Der Schalter war bisher nur lokal. Echte 2FA kommt als nächstes.',
  'acct.deleteAccount.title': 'Konto löschen',
  'acct.deleteAccount.warn':
    'Dein Konto wird in 30 Tagen endgültig gelöscht. Du kannst es in dieser Zeit reaktivieren.',
  'acct.deleteAccount.btn': 'Konto löschen',
  'acct.deleteAccount.modalTitle': 'Konto löschen',
  'acct.deleteAccount.modalBody':
    'Dein Konto wird deaktiviert und nach 30 Tagen endgültig gelöscht. Innerhalb dieser Frist kannst du es per E-Mail + Passwort reaktivieren. Alle deine Leads, Profile und Bewertungen werden dann unwiderruflich gelöscht.',
  'acct.deleteAccount.confirmPwLabel': 'Zur Bestätigung dein Passwort eingeben',
  'acct.deleteAccount.deleting': 'Wird gelöscht …',
  'acct.deleteAccount.confirmBtn': 'Konto endgültig löschen',
  'acct.deleteAccount.errPwRequired': 'Bitte Passwort eingeben.',
  'acct.deleteAccount.errFailed': 'Löschen fehlgeschlagen.',

  // Account / Password change modal
  'acct.pw.title': 'Passwort ändern',
  'acct.pw.current': 'Aktuelles Passwort',
  'acct.pw.new': 'Neues Passwort',
  'acct.pw.confirm': 'Neues Passwort bestätigen',
  'acct.pw.minHint': 'Mindestens 8 Zeichen',
  'acct.pw.minErr': 'Mindestens 8 Zeichen.',
  'acct.pw.mismatch': 'Passwörter stimmen nicht überein.',
  'acct.pw.failed': 'Passwort konnte nicht geändert werden.',
  'acct.pw.wrongCurrent': 'Aktuelles Passwort ist falsch.',
  'acct.pw.complexity':
    'Neues Passwort muss mindestens 8 Zeichen, Groß- und Kleinbuchstaben, Ziffer und Sonderzeichen (@$!%*?&) enthalten.',
  'acct.pw.sameAsCurrent': 'Neues Passwort muss anders sein als das aktuelle.',
  'acct.pw.success': 'Passwort geändert ✓',
  'acct.pw.changing': 'Wird geändert …',
  'acct.pw.cta': 'Passwort ändern',
  'acct.toast.saved': 'Profil gespeichert.',
  'acct.toast.failed': 'Speichern fehlgeschlagen. Bitte erneut versuchen.',

  // CRM Integrations
  'crm.comingSoon': 'Bald verfügbar',
  'crm.bald': 'BALD',
  'crm.mcpTitle': 'Leadscraper als MCP-Server',
  'crm.mcpSub':
    'Verbinde Leadscraper direkt mit Claude, ChatGPT, Cursor oder deinem eigenen Agenten via Model Context Protocol. Deine Leads, Profile & Memory werden nativ als Tools verfügbar.',
  'crm.mcpComingSoon': 'Verfügbar sobald MCP-Server live geht.',
  'crm.tooltipComingSoon':
    '{name}-Integration kommt bald. Du wirst benachrichtigt sobald sie verfügbar ist.',
  'crm.customAgent': 'Eigener Agent',

  // --- CRM sections + push preview + history (LEA-267 / LEA-268) ---
  'crm.section.connected': 'Verbunden',
  'crm.section.available': 'Verfügbar',
  'crm.section.comingNext': 'Demnächst',
  'crm.section.comingNextLabel': 'Bald',
  'crm.section.morePlanned': 'Weitere Integrationen geplant',
  'crm.preview.title': 'Vorschau: Push an {crm}',
  'crm.preview.bulkSub': '{n} Leads werden an dein CRM gepusht',
  'crm.preview.singleSub': 'Das wird in deinem CRM angelegt',
  'crm.preview.bulkBody':
    'Erstellt {n} Organisations-Einträge (und Personen für Leads mit Kontaktdaten). Duplikate, die bereits in deinem CRM sind, werden übersprungen. Deine bestehenden Einträge bleiben erhalten.',
  'crm.preview.withContact': 'Org + Person',
  'crm.preview.noContact': 'Nur Org',
  'crm.preview.plusMore': '+ {n} weitere …',
  'crm.preview.willCreate': 'Wird erstellt',
  'crm.preview.willCreatePerson': ': primärer Kontakt mit E-Mail/Telefon',
  'crm.preview.skipPerson': ': übersprungen (keine E-Mail oder Telefon bei diesem Lead)',
  'crm.preview.dedupNote':
    'Wenn dieser Lead bereits in deinem CRM ist (Abgleich über Domain), wird der Push protokolliert, aber kein neuer Eintrag erstellt. Du behältst was du hast.',
  'crm.preview.pushing': 'Wird gepusht…',
  'crm.preview.pushNBtn': '{n} jetzt pushen',
  'crm.preview.pushBtn': 'Jetzt pushen',
  'crm.history.title': 'Push-Verlauf',
  'crm.history.sub': 'Die letzten 50 Leads, die an dein CRM gepusht wurden, neueste zuerst.',
  'crm.history.loading': 'Laden…',
  'crm.history.empty': 'Noch keine Pushes. Nutze „An CRM senden" bei einem Lead, um loszulegen.',
  'crm.history.sent': 'Gesendet',
  'crm.history.duplicate': 'Bereits im CRM',
  'crm.history.failed': 'Fehlgeschlagen',
  'crm.picker.title': 'An welches CRM?',
  'crm.picker.subtitle':
    'Wähle, wohin dieser Lead gepusht werden soll. Du kannst jederzeit wechseln.',

  // Leads table — review filter chips + cross-profile header
  'leads.allProfilesShow': 'Alle Zielgruppen anzeigen',
  'leads.backToActive': '← zurück zur aktiven Zielgruppe',
  'leads.allProfilesHeader': 'Alle Zielgruppen',
  'leads.crossOverview.one': '{n} Lead · Zielgruppen-übergreifend',
  'leads.crossOverview.many': '{n} Leads · Zielgruppen-übergreifend',
  'leads.filter.unrated': 'Unbewertet',
  'leads.filter.fits': 'Passt',
  'leads.filter.fitsNot': 'Passt nicht',
  'leads.filter.all': 'Alle',

  // Dashboard — query filter tabs
  'dash.filter.all': 'Alle',
  'dash.filter.scheduled': 'Geplant',
  'dash.filter.oneshot': 'Einmalig',
  'dash.filter.running': 'Läuft',
  'dash.run.notBackendProfile':
    'Diese Zielgruppe ist noch nicht im Backend registriert. Lege eine echte über',
  'dash.run.notBackendProfileCta': '+ Neue Zielgruppe',
  'dash.run.notBackendProfileEnd': 'an. Dann läuft der Scraper.',

  // Dashboard — status chips
  'dash.status.running': 'Läuft',
  'dash.status.runningEllipsis': 'Läuft…',
  'dash.status.runningPrefix': 'Läuft · ',
  'dash.status.done': 'Fertig',
  'dash.status.delivered.one': '{n} Lead geliefert',
  'dash.status.delivered.many': '{n} Leads geliefert',
  'dash.status.deliveredSuffix.one': 'Lead geliefert',
  'dash.status.deliveredSuffix.many': 'Leads geliefert',
  'dash.status.empty': 'Keine Treffer',
  'dash.status.failed': 'Fehlgeschlagen',
  'dash.status.unfeasible': 'Nicht machbar',

  // Dashboard — last queries section
  'dash.lastQueries.title': 'Letzte Lead-Queries',
  'dash.lastQueries.subForProfile':
    'Deine zuletzt gestarteten Suchen für "{profile}". Klick öffnet die Details und lässt dich die Suche wiederholen.',
  'dash.lastQueries.subAll':
    'Deine zuletzt gestarteten Suchen über alle Profile. Klick öffnet die Details und lässt dich die Suche wiederholen.',

  // Dashboard — buttons / CTAs
  'dash.newProfile': 'Neue Zielgruppe',
  'dash.startRunDisabledHint': 'Erst eine Zielgruppe anlegen, dann Suchlauf starten',
  'dash.queryHint': 'Hinweis zum Suchlauf',
  'dash.renameQuery': 'Query umbenennen',

  // Dashboard — empty states
  'dash.empty.noProfile': 'Noch keine Zielgruppe angelegt.',
  'dash.empty.defineAudience': '+ Jetzt Zielgruppe definieren',
  'dash.empty.noQueryStartedForProfile': 'Noch keine Lead-Query gestartet für "{profile}".',
  'dash.empty.noQueryStartedAll': 'Noch keine Lead-Query gestartet über alle Zielgruppen.',
  'dash.empty.startHint':
    'Klick „Suchlauf starten" um eine Query (Unternehmensart, Region, Rolle, …) zu definieren.',
  'dash.empty.noFiltered': 'Keine Queries in diesem Filter.',
  'dash.empty.showAll': 'Alle anzeigen ({n})',

  // Dashboard — table headers (overrides where Status/Profil/Wann/Query are hardcoded)
  'dash.col.queryName': 'Query',
  'dash.col.statusH': 'Status',
  'dash.col.profileH': 'Zielgruppe',
  'dash.col.whenH': 'Wann',

  // Dashboard — Cortex company-context panel
  'dash.cortex.title': 'Was Leadscraper über dein Unternehmen weiß',
  'dash.cortex.reanalyze': 'Erneut analysieren. Leadscraper schaut sich die Seite frisch an',
  'dash.cortex.reanalyzeKeepTitle': 'Deine manuellen Änderungen behalten?',
  'dash.cortex.reanalyzeKeepBody':
    'Du hast dieses Firmen-Profil von Hand angepasst. Beim erneuten Analysieren können deine Änderungen erhalten bleiben und nur der Rest wird aktualisiert – oder alles wird auf die frischen KI-Vorschläge zurückgesetzt.',
  'dash.cortex.reanalyzeKeepCta': 'Meine Änderungen behalten',
  'dash.cortex.reanalyzeResetCta': 'Auf KI-Vorschläge zurücksetzen',
  'dash.cortex.sells': 'Was du verkaufst',
  'dash.cortex.toWhom': 'An wen',
  'dash.cortex.valueProps': 'Warum Kunden dich wählen',

  // Dashboard — maturity badge popover
  'dash.maturity.label': 'Reifegrad: {label}',
  'dash.maturity.next.one': 'Noch {n} Feedback bis {stage}.',
  'dash.maturity.next.many': 'Noch {n} Feedbacks bis {stage}.',
  'dash.maturity.stage.early': 'Einlernend',
  'dash.maturity.stage.calibrated': 'Kalibriert',
  'dash.maturity.stage.mature': 'Ausgereift',
  'dash.maturity.usage':
    'Leadscraper nutzt dein Feedback je nach Reifegrad unterschiedlich stark im nächsten Suchlauf.',

  // NavHeader — profile rename modal
  'nav.renameProfile': 'Zielgruppe umbenennen',
  'nav.renameProfileSub': 'Wähle einen neuen Namen für diese Zielgruppe.',
  'nav.profileName': 'Name der Zielgruppe',
  'nav.profileNameP': 'z. B. IT-Dienstleister DACH',
  'nav.openSettings': 'Einstellungen & Learnings von "{name}" öffnen',
  'nav.deleteProfile': 'Zielgruppe löschen',
  'nav.deleteProfileTitle': 'Zielgruppe löschen?',
  'nav.deleteProfileBody':
    'Alle Leads, Bewertungen und gelernten Muster für „{name}" werden unwiderruflich gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
  'nav.deleteProfileCta': 'Endgültig löschen',
  'nav.deleteProfileBusy': 'Wird gelöscht …',
  'nav.deleteProfileSuccess': 'Zielgruppe gelöscht.',
  'nav.deleteProfileError': 'Zielgruppe konnte nicht gelöscht werden. Bitte erneut versuchen.',
  'nav.deleteProfileInFlight':
    'Ein Suchlauf läuft gerade für diese Zielgruppe. Bitte warte, bis er fertig ist.',
  'nav.startSubscription': 'Abo starten',
  'nav.apiStatus.ok': 'API erreichbar',
  'nav.apiStatus.slow': 'API antwortet langsam',
  'nav.apiStatus.down': 'API nicht erreichbar. Bitte Page reloaden',
  'nav.apiStatus.checking': 'API-Status wird geprüft …',

  // ProfileDetail — Learning curve + Cortex-Profil hexagon section
  'pd.curve.subShort': 'Wie sich die Trefferquote mit jeder Bewertung entwickelt',
  'pd.cortex.title': 'Leadscraper-Zielgruppe',
  'pd.cortex.sub': 'Wo Leadscraper über dein Targeting am schärfsten ist',

  // Mobile-App (LEA-230 follow-up: Om's i18n bug)
  'mobile.empty.noProfileSelected': 'Keine Zielgruppe ausgewählt.',
  'mobile.empty.noProfileShort': 'Keine Zielgruppe.',
  'mobile.empty.noOpenLeads': 'Keine offenen Leads.',
  'mobile.empty.nothingFound': 'Nichts gefunden.',
  'mobile.empty.noContactData': 'Keine Kontaktdaten verfügbar.',
  'mobile.tip.label': 'Tipp:',
  'mobile.tip.profilesDesktop':
    'Mehrere Zielgruppen (z.B. nach Branche oder Region) legst du am Desktop an.',
  'mobile.note.label': 'Hinweis:',
  'mobile.note.scheduleDesktop': 'Zeitpläne und Zielgruppen-Memory bearbeitest du auf Desktop.',

  // Dashboard — last search status pill (LEA-230 follow-up)
  'dash.lastSearch': 'Letzte Suche: {result}',
  'dash.lastSearch.error': 'Fehler',
  'dash.lastSearch.zero': '0 Leads',

  // --- Comprehensive i18n sweep (LEA-230 Om: "check this everywhere") ---

  // Relative time helper
  'rel.now': 'gerade',
  'rel.minAgo': 'vor {n} min',
  'rel.hAgo': 'vor {n} h',
  'rel.yesterday': 'gestern',
  'rel.daysAgo': 'vor {n} Tagen',
  'rel.weeksAgo': 'vor {n} Wochen',

  // NextRunHint
  'dash.nextRun.autoPaused': 'Auto-pausiert · 3 leere Runs',
  'dash.nextRun.pausedCredits': 'Pausiert · Credits aufgebraucht',
  'dash.nextRun.paused': 'Pausiert',
  'dash.nextRun.manual': 'Manuell · kein Zeitplan',
  'dash.nextRun.soon': 'Gleich',
  'dash.nextRun.in': 'Nächster Lauf in {time}',

  // SchedulePicker
  'dash.sched.title': 'Query timen',
  'dash.sched.sub': 'Leadscraper zieht regelmäßig 10 frische Leads für diese Zielgruppe.',
  'dash.sched.daily': 'Täglich',
  'dash.sched.dailySub': 'Jeden Tag 10 frische Leads',
  'dash.sched.twiceWeekly': 'Mo / Do',
  'dash.sched.twiceWeeklySub': '2× pro Woche, ~20 Leads/Woche',
  'dash.sched.weekly': 'Wöchentlich',
  'dash.sched.weeklySub': 'Einmal pro Woche 10 Leads',
  'dash.sched.manual': 'Manuell',
  'dash.sched.manualSub': 'Kein Schedule, nur auf Klick',
  'dash.sched.resume': '▶ Fortsetzen',
  'dash.sched.pause': '⏸ Pausieren',
  'dash.sched.toast.paused': 'Zielgruppe pausiert, keine automatischen Runs.',
  'dash.sched.toast.manual': 'Schedule aufgehoben. Zielgruppe läuft nur manuell.',
  'dash.sched.toast.set': 'Schedule gesetzt. Leadscraper läuft automatisch ({cadence}).',
  'dash.sched.toast.error': 'Schedule konnte nicht gespeichert werden: {err}',
  'dash.sched.change': 'ändern',
  'dash.sched.time': 'Query timen',
  'dash.schedInd.nextRun': 'nächster Lauf',
  'dash.whenCell.next': 'nächster {label}',

  // cadenceLabel
  'dash.cadence.hourly': 'stündlich',
  'dash.cadence.daily': 'täglich',
  'dash.cadence.weekly': 'wöchentlich',
  'dash.cadence.monthly': 'monatlich',
  'dash.cadence.manual': 'manuell',

  // getScheduleInfo
  'dash.schedInfo.paused': 'pausiert',
  'dash.schedInfo.oneshot': 'einmalig',
  'dash.schedInfo.hourly': 'stündlich',
  'dash.schedInfo.everyNh': 'alle {n} h',

  // formatNextRunCompact
  'dash.fmtNext.soon': 'startet gleich',
  'dash.fmtNext.inMin': 'in {n}m',
  'dash.fmtNext.inH': 'in {n}h',
  'dash.fmtNext.tomorrow': 'morgen',
  'dash.fmtNext.inDays': 'in {n}d',

  // ProfileDropdown empty
  'dash.profileDrop.create': 'Erste Zielgruppe anlegen',
  'dash.profileDrop.createSub': "Zielgruppe definieren, dann kann's losgehen",

  // ActiveRunsPanel
  'dash.activeRuns.title': 'Leadscraper arbeitet gerade für dich',
  'dash.activeRuns.run': 'Suchlauf',
  'dash.activeRuns.runs': 'Suchläufe',

  // ActiveRunCard steps
  'dash.step.planning': 'Leadscraper erinnert sich',
  'dash.step.discovery': 'Firmen identifizieren',
  'dash.step.hydration': 'Firmen tiefgehend analysieren',
  'dash.step.reasoning': 'Leadscraper bewertet',
  'dash.step.delivery': 'Leads zusammenstellen',
  'dash.step.done': 'Fertig',
  'dash.step.starting': 'Starte…',
  'dash.step.fallbackProfile': 'Zielgruppe',

  // Funnel labels
  'dash.funnel.identified': 'Identifiziert',
  'dash.funnel.deepened': 'Vertieft',
  'dash.funnel.evaluated': 'Bewertet',
  'dash.funnel.ready': 'Bereit',

  // RunModal
  'dash.run.title': 'Leadabfrage starten',
  'dash.run.sub': '10 Credits · 10 Leads · typisch 5–12 min',
  'dash.run.forWhich': 'Für welche Zielgruppe?',
  'dash.run.audience': 'Zielgruppe:',
  'dash.run.suggHeading': 'Beispiel-Suchen für dein Unternehmen',
  'dash.run.intent.broad': 'Klassisch',
  'dash.run.intent.growth': 'Wachstums-Signal',
  'dash.run.intent.tool': 'Tool-Signal',
  'dash.run.intent.default': 'Vorschlag',
  'dash.run.pastQueries': 'Letzte Lead-Queries',
  'dash.run.pastQueriesHint': 'Klick übernimmt die Werte',
  'dash.run.businessType': 'Unternehmensart',
  'dash.run.businessTypeP': 'z.B. Faltschachtelhersteller mit eigener Stanze',
  'dash.run.region': 'Region / Standort',
  'dash.run.regionP': 'z.B. Köln, NRW, Großraum Hamburg, oder bundesweit',
  'dash.run.regionHint':
    'Stadt, Bundesland, Region oder „bundesweit". Schreib\'s so wie du suchen würdest.',
  'dash.run.contact': 'Ansprechpartner',
  'dash.run.contactP': 'z.B. Geschäftsführung, Einkaufsleitung',
  'dash.run.extras': 'Zusätzliche Einschränkungen',
  'dash.run.extrasP':
    'z.B. kein Konzern, gerne familiengeführt, FSC-zertifiziert bevorzugt, 50–250 MA',
  'dash.run.optional': '(optional)',
  'dash.run.cancel': 'Abbrechen',
  'dash.run.minField': 'Mindestens Unternehmensart angeben',
  'dash.run.searchBtn': '10 Leads suchen',
  // LEA-338 Part A / LEA-355 — "Ansprechpartner anreichern" Toggle. Slimmed copy
  // (LEA-355): Label nutzt "anreichern" statt "verbinden", Kosten als dezente Sub-Zeile.
  'dash.run.withContact.label': 'Ansprechpartner automatisch anreichern',
  'dash.run.withContact.hint':
    'Jeder neue Lead wird direkt mit passenden Ansprechpartnern und Kontaktdaten angereichert. Alternativ kannst du die Leads erst prüfen und einzeln anreichern – gerade am Anfang empfehlenswert.',
  'dash.run.withContact.cost': 'Bis zu {n} Credits – nur bei erfolgreicher Anreicherung berechnet.',
  // LEA-418: per-phase credit-cost transparency
  'dash.run.cost.base': 'Kosten: {n} Leads = {n} Credits (1 pro geliefertem Lead).',
  'dash.run.cost.extras': 'Ansprechpartner & Voll-Insights: je +1 Credit/Lead, nur auf Anfrage.',
  'lt.next.connectCostHint': 'Nur 1 Credit bei erreichbarem Kontakt – sonst gratis.',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'lt.next.connectFreeHint':
    'Kostenlos – bezahlt wird erst das Freischalten eines Ansprechpartners',
  // LEA-356 — cascading Phase-3 "Akquiseplan automatisch erstellen" toggle.
  'dash.run.withPlan.label': 'Akquiseplan automatisch erstellen',
  'dash.run.withPlan.hint':
    'Für jeden angereicherten Lead wird ein individueller Akquiseplan erstellt – eine konkrete Ansprache auf Basis der gefundenen Kontakte.',
  'dash.run.withPlan.cost': 'Bis zu {n} Credits – nur bei erfolgreicher Plan-Erstellung berechnet.',
  'dash.run.costPreview': 'bis zu {n} Credits',

  // QueryDetailOverlay
  'dash.query.unnamed': 'Unbenannte Query',
  'dash.query.header': 'Lead-Query',
  'dash.query.profile': 'Zielgruppe: {name}',
  'dash.query.businessType': 'Unternehmensart',
  'dash.query.region': 'Region / Standort',
  'dash.query.contact': 'Ansprechpartner',
  'dash.query.extras': 'Zusatzkriterien',
  'dash.query.howWorked': 'Wie Leadscraper gearbeitet hat',
  'dash.query.loading': 'nachgeladen…',
  // LEA-498: "X companies skipped because you already know them" — turns the invisible saving visible.
  'dash.query.alreadyKnown': '{n} bereits bekannte Firmen übersprungen',
  'dash.query.alreadyKnownTip':
    'Firmen, die du bereits kennst (Ausschlussliste / CRM-Import), wurden vor der Lieferung übersprungen — du zahlst nicht dafür.',
  'dash.query.dashExplain':
    '"—" heißt: Leadscraper hat den Wert nicht getrackt (kommt mit V1.13 als vollständiger Run-Trace).',
  'dash.query.identified': 'Identifiziert',
  'dash.query.identifiedHint': 'Firmen aus Web-Suche + Verzeichnissen gefunden',
  'dash.query.deepAnalysis': 'Tiefenanalyse',
  'dash.query.deepAnalysisHint': 'Website + Impressum durchgelesen',
  'dash.query.evaluated': 'Bewertet',
  'dash.query.evaluatedHint': 'Leadscraper-Reasoning angewandt',
  'dash.query.delivered': 'Geliefert',
  'dash.query.deliveredHint': 'Tatsächliche Treffer',
  'dash.query.whenRuns': 'Wann läuft diese Suche?',
  'dash.query.runHistory': 'Verlauf der letzten Läufe',
  'dash.query.failedTitle': 'Suchlauf fehlgeschlagen',
  'dash.query.unfeasibleTitle': 'Leadscraper hält die Query für nicht erfüllbar',
  'dash.query.suggestions': 'Leadscraper-Vorschläge',
  'dash.query.startedAt': 'Gestartet: {date}',
  'dash.query.restart': 'Neu starten',
  'dash.query.rerun': 'Erneut starten',
  'dash.query.rerunTitle':
    'Diese Query erneut durch Leadscraper jagen (z.B. nach Zielgruppen-Updates)',
  'dash.query.leadsSoFar': '{n} Leads bisher · läuft noch',
  'dash.query.runningNoLeads': 'Läuft noch. Gleich kommen Leads',
  'dash.query.noLeads': 'Keine Leads gefunden',
  'dash.query.showLeads': '{n} Leads anzeigen',
  'dash.query.rerunRow': 'Wiederholen',
  'dash.query.rerunCta': 'Suche wiederholen',
  'dash.query.searchedLabel': 'Das hast du gesucht',
  'dash.query.autoRepeat': 'Automatisch wiederholen',
  'dash.query.openSettings': 'Einstellungen öffnen',
  'dash.query.technicalDetails': 'Technische Details',

  // EmptyStateLearningHint
  'dash.learning.title': 'Leadscraper wartet auf dein erstes Feedback',
  'dash.learning.body':
    'Mit jedem ✓ „passt" oder ✗ „passt nicht" {scope} schärft Leadscraper sein Verständnis für deinen idealen Lead, und filtert die nächsten Treffer entsprechend.',
  'dash.learning.scopeProfile': 'für „{name}"',
  'dash.learning.scopeAll': 'in deinen Zielgruppen',
  'dash.learning.cta': '{n} Leads bewerten',
  'dash.learning.hint': 'Starte oben einen Suchlauf. Sobald Leads da sind, kannst du sie bewerten.',

  // UserCompanyDashboardCard
  'dash.company.collapsed':
    'Leadscraper kennt dein Unternehmen. Alle Justifications werden auf dich zugeschnitten.',
  'dash.company.emptyTitle': 'Leadscraper kennt dich noch nicht',
  'dash.company.editTitle': 'Damit Leadscraper deine Pitches schärft. Sag uns was du verkaufst',
  'dash.company.setupBadge': 'Setup notwendig',
  'dash.company.emptyBody':
    'Trag deine Firmen-Website ein und Leadscraper versteht in 10 Sekunden was du verkaufst. Ab dann erklärt jede Lead-Justification konkret warum DEIN Angebot zu DIESEM Lead passt, statt nur "passt zur Branche". Das ist der Aha-Moment.',
  'dash.company.editBody':
    'Trag deine Firmen-Website ein. Leadscraper liest sie und merkt sich dauerhaft was du anbietest, an wen du verkaufst, und welche Argumente du nutzt, damit jede Justification bei deinen Leads zu einer maßgeschneiderten Pitch-Strategie wird statt nur "passt zur Branche".',
  'dash.company.urlPlaceholder': 'https://meine-firma.de',
  'dash.company.urlHint':
    'Trag deine Website ein. Sobald die URL steht, kannst du Leadscraper anlernen.',
  'dash.company.analyzing': 'Leadscraper liest…',
  'dash.company.analyzeFresh': '✨ Leadscraper anlernen',
  'dash.company.analyzeBtn': 'Analysieren',
  'dash.company.cachedToast': 'Profil aus Speicher geladen.',
  'dash.company.doneToast': '✓ Leadscraper kennt dich jetzt.',
  'dash.company.errorFallback': 'Analyse fehlgeschlagen. Bitte nochmal probieren.',
  'dash.company.stage1': 'Lade deine Website…',
  'dash.company.stage2': 'Verstehe was du anbietest…',
  'dash.company.stage3': 'Identifiziere deine Zielgruppe…',
  'dash.company.stage4': 'Verbinde alles mit deinem Wert…',
  'dash.company.stage5': 'Fast fertig…',

  // ActionInbox
  'dash.inbox.title': 'Heute zu erledigen',
  'dash.inbox.less': 'Weniger zeigen',
  'dash.inbox.showAll': 'Alle {n} zeigen',
  'dash.inbox.more': '+ {n} weitere',
  'dash.inbox.profileWord': 'Zielgruppe',
  'dash.inbox.profilesWord': 'Zielgruppen',
  'dash.inbox.leadsFrom': '{leads} Leads aus {profiles} {profileWord}',
  'dash.inbox.edge': 'Grenzfall',
  'dash.inbox.edges': 'Grenzfälle',
  'dash.inbox.hint': 'Hinweis',

  // NavHeader — active runs
  'nav.runs.one': '1 Suchlauf läuft',
  'nav.runs.many': '{n} Suchläufe laufen',
  'nav.runs.title': 'Laufende Suchläufe',
  'nav.runs.leadsReady': '{n} Lead{s} bereit',
  'nav.runs.footer':
    'Klick auf eine Zielgruppe, um Fortschritt anzuzeigen. Du kannst weiter arbeiten.',

  // LeadDetail
  'ld.match.excellent': 'exzellent',
  'ld.match.strong': 'starker Match',
  'ld.match.solid': 'solider Match',
  'ld.match.borderline': 'Grenzfall',
  'ld.email.notFound': 'Keine direkte E-Mail für diesen Kontakt gefunden.',
  'ld.email.confLikely': 'wahrscheinlich',
  'ld.email.confPlausible': 'plausibel',
  'ld.email.confGuessed': 'vermutet',
  'ld.email.copied': 'Vermutete Email in Zwischenablage kopiert.',
  'ld.contact.emailCopied': 'E-Mail-Adresse kopiert.',
  'ld.contact.phoneCopied': 'Telefonnummer kopiert.',
  'ld.contact.copy': 'Kopieren',
  'ld.contact.copied': 'Kopiert.',
  'ld.contact.tagCentral': 'Zentrale',
  'ld.contact.tagUnconfirmed': 'unbestätigt',
  'ld.contact.tagPattern': 'Muster',
  'ld.contact.centralTooltip': 'Direktwahl nicht öffentlich. Anrufen und nach {name} fragen.',
  'ld.contact.centralTooltipNoName': 'Direktwahl nicht öffentlich. Sie erreichen die Zentrale.',
  'ld.contact.verifiedSmtp': 'E-Mail-Postfach bestätigt (SMTP).',
  'ld.contact.unverifiedHint': 'Aus öffentlicher Quelle übernommen, noch nicht SMTP-geprüft.',
  'ld.contact.patternTooltip':
    'Wahrscheinliche Adresse nach dem Firmen-E-Mail-Muster, unbestätigt.',
  'ld.contact.derivePattern': 'E-Mail nach Firmen-Muster ableiten',
  'ld.contact.bestRoute': 'Bester Weg:',
  'ld.contact.route.central': 'Anruf über die Zentrale',
  'ld.contact.route.centralEmail': 'E-Mail an die Zentrale',
  'ld.contact.route.linkedin': 'LinkedIn-Nachricht',
  'ld.contact.route.xing': 'Xing-Nachricht',
  'ld.contact.route.phone': 'Anruf (Direktwahl)',
  'ld.contact.route.email': 'E-Mail',
  'ld.contact.route.pattern': 'E-Mail nach Firmen-Muster',
  'ld.contact.provMailbox': 'Postfach bestätigt',
  'ld.contact.provImpressum': 'Im Impressum genannt',
  'ld.contact.provFound': 'In öffentlichen Quellen gefunden',
  'ld.contact.provVia': 'belegt via',
  'ld.contact.confHigh': 'Hoch',
  'ld.contact.confMid': 'Mittel',
  'ld.contact.confLow': 'Niedrig',
  'ld.contact.photoVia': 'Foto: {src} ↗',
  'ld.contact.roleProof': 'Rolle öffentlich belegt ↗',
  'ld.section.roleFallback':
    'Wunschrolle ({roles}) ist nicht öffentlich belegt. Wir zeigen die nächstbesten Ansprechpartner.',
  'ld.section.noDirect': 'Direktkontakte sind hier nicht öffentlich, erreichbar über die Zentrale.',
  'ld.email.apply': 'Pattern anwenden',
  'ld.email.derivedFrom':
    'Abgeleitet aus {n} Email{s} auf der Firmen-Website. {conf}. Prüfe selbst bevor du mailst.',
  'ld.email.noDirectExplain':
    'Die direkte Email für {first} {last} fanden wir nicht. Wir haben aber das Email-Schema der Firma erkannt. Auf Klick zeigen wir dir die wahrscheinliche Adresse. Du trägst Verantwortung.',
  'ld.srcLabel.impressum': 'Impressum',
  'ld.srcLabel.handelsregister': 'Handelsregister',
  'ld.srcLabel.kontakt': 'Kontakt-Seite',
  'ld.srcLabel.ueber_uns': 'Über-uns Seite',
  'ld.srcLabel.team': 'Team-Seite',
  'ld.srcLabel.karriere': 'Karriere-Seite',
  'ld.srcLabel.news': 'Presse / News',
  'ld.srcLabel.footer': 'Website-Footer',
  'ld.srcLabel.json_ld': 'Strukturierte Daten (Schema.org)',
  'ld.srcLabel.firecrawl': 'Firmen-Website (Hauptseite)',
  'ld.srcLabel.serp': 'Google-Suche',
  'ld.srcLabel.regex_derived': 'Pattern-Ableitung',
  'ld.srcLabel.haiku_extracted': 'KI-Extraktion',
  'ld.srcLabel.llm_haiku': 'KI-Extraktion',
  'ld.srcLabel.llm_sonnet': 'KI-Bewertung',
  'ld.srcLabel.user_feedback': 'Dein Feedback',
  'ld.srcDesc.impressum':
    'Pflichtangaben-Seite mit Firmenname, Rechtsform, Anschrift, Geschäftsführung. Wird gefetched + parsed.',
  'ld.srcDesc.handelsregister':
    'Offizielles deutsches Unternehmensregister: HRB-Nummer, Sitz, Eintragungs-Datum.',
  'ld.srcDesc.kontakt':
    'Kontakt-/Standort-Seite: Telefonnummern, Email-Adressen, ggf. Ansprechpartner.',
  'ld.srcDesc.ueber_uns':
    'Selbst-Beschreibung der Firma: Geschichte, Eigentümer, Werte, Kunden-Referenzen.',
  'ld.srcDesc.team': 'Team-/Mitarbeiter-Seite: Personen + Rollen.',
  'ld.srcDesc.karriere':
    'Karriere-Seite: offene Stellen, gesuchte Profile (Trigger-Signal für Wachstum).',
  'ld.srcDesc.news': 'Presse-/Aktuelles-Seite: letzte Events, Werks-Erweiterungen, Awards.',
  'ld.srcDesc.footer': 'Website-Footer: Standorte, Zertifikate, alternative Kontaktwege.',
  'ld.srcDesc.json_ld': 'Maschinenlesbare Schema.org-Metadaten der Website (Org-Profil).',
  'ld.srcDesc.firecrawl': 'Hauptseite der Firmen-Website (gecached).',
  'ld.srcDesc.serp': 'Google-Treffer für gezielte Domain- oder Personen-Suche.',
  'ld.srcDesc.regex_derived':
    'Aus anderen Daten abgeleitet: z.B. Email-Pattern aus bekannter Firmen-Email + Name.',
  'ld.srcDesc.haiku_extracted':
    'Leadscraper hat aus dem hydratisierten Website-Inhalt strukturierte Felder extrahiert (Beschreibung, Kunden, Trigger-Events).',
  'ld.srcDesc.llm_haiku':
    'Leadscraper hat aus dem hydratisierten Website-Inhalt strukturierte Felder extrahiert (Beschreibung, Kunden, Trigger-Events).',
  'ld.srcDesc.llm_sonnet': 'Leadscraper hat den Lead gegen deine Zielgruppe + Memory bewertet.',
  'ld.srcDesc.user_feedback':
    'Du hast diesen Lead manuell bestätigt oder verworfen, höchstes Trust-Level.',
  'ld.field.companyName': 'Firmenname',
  'ld.field.legalForm': 'Rechtsform',
  'ld.field.foundedYear': 'Gründungsjahr',
  'ld.field.description': 'Kurzprofil',
  'ld.field.hrNumber': 'Handelsregister-Nummer',
  'ld.field.nace': 'NACE-Branche',
  'ld.field.website': 'Website-URL',
  'ld.field.centralPhone': 'Zentral-Telefon',
  'ld.field.centralEmail': 'Zentral-Email',
  'ld.field.city': 'Stadt',
  'ld.field.zip': 'PLZ',
  'ld.field.street': 'Straße',
  'ld.field.employees': 'Mitarbeiterzahl',
  'ld.field.sizeClass': 'Größenklasse',
  'ld.field.revenueRange': 'Umsatz-Range',
  'ld.field.firstName': 'Vorname (Entscheider)',
  'ld.field.lastName': 'Nachname (Entscheider)',
  'ld.field.role': 'Rolle (Entscheider)',
  'ld.field.email': 'Email (Entscheider)',
  'ld.field.linkedin': 'LinkedIn (Entscheider)',
  'ld.field.xing': 'XING (Entscheider)',
  'ld.field.deciderProfile': 'Entscheider-Profil',
  'ld.field.acquisitionHook': 'Leadscraper-Akquise-Hook',
  'ld.field.triggerEvent': 'Trigger-Event',
  'ld.field.jobSnapshot': 'Offene Stellen',
  'ld.field.customerRefs': 'Kunden-Referenzen',
  'ld.field.ownership': 'Eigentümer / Geschichte',
  'ld.field.locations': 'Standorte',
  'ld.field.certs': 'Zertifikate',
  'ld.fetchedThisWeek': 'diese Woche',
  'ld.linkedinPublic': 'LinkedIn · öffentlich',
  'ld.xingPublic': 'XING · öffentlich',
  'ld.companySite': 'Firmen-Website',
  'ld.websiteExcerpt': 'Website-Auszug',
  'ld.trust.official': '🛡 Offiziell',
  'ld.trust.inferred': '🔵 AI-abgeleitet',
  'ld.trust.public': '🟡 Öffentlich',
  'ld.trust.officialTitle': 'Rechtlich-authoritative Quelle (Handelsregister/Impressum).',
  'ld.trust.inferredTitle': 'Von Leadscraper-KI abgeleitet, nicht offizielle Quelle.',
  'ld.trust.publicTitle': 'Öffentlich einsehbar auf der Firmen-Website.',
  'ld.sparkle.title': 'Live-Signale',
  'ld.sparkle.sub': '· was Leadscraper gerade gefunden hat',
  'ld.sparkle.hookLabel': 'Leadscraper Akquise-Hook',
  'ld.sparkle.locked': '· gesperrt',
  'ld.sparkle.hookFake':
    'Hier kannst du andocken weil {company} klassisches Mittelstands-Profil mit konkretem Bedarf zeigt, passt direkt zu deinem Angebot.',
  'ld.sparkle.hookUnlockPre': 'Trag oben im Dashboard ',
  'ld.sparkle.hookUnlockLink': 'deine Firmen-Website',
  'ld.sparkle.hookUnlockPost':
    ' ein. Leadscraper generiert dann pro Lead einen personalisierten Hook.',
  'ld.sparkle.waitLabel': '· wartet auf Re-Run',
  'ld.sparkle.staleMsg':
    'Dieser Lead wurde generiert bevor dein Firmen-Profil bei Leadscraper hinterlegt war.',
  'ld.sparkle.staleAction':
    'Starte die Query im Dashboard erneut. Dann generieren wir für DIESEN Lead einen personalisierten Akquise-Hook plus alle Sales-Signale (Trigger-Events, offene Stellen, Kunden, …).',
  'ld.sparkle.trigger': 'Trigger-Event',
  'ld.sparkle.jobs': 'Stellen-Snapshot',
  'ld.sparkle.jobsBadge': '{n} offene Stellen',
  'ld.sparkle.customers': 'Kunden-Referenzen',
  'ld.sparkle.ownership': 'Inhaberstruktur',
  'ld.sparkle.ownerSince': 'seit {year}',
  'ld.sparkle.locations': 'Standorte',
  'ld.sparkle.certs': 'Zertifikate & Awards',
  'ld.toast.accepted': '„{company}" als Passt gespeichert.',
  'ld.toast.rejected': '„{company}" als Passt nicht markiert.',
  'ld.toast.feedbackErr': 'Feedback konnte nicht gespeichert werden. Versuche es nochmal.',
  'ld.unverified.title': '„{token}" konnte Leadscraper auf dieser Firma nicht verifizieren',
  'ld.unverified.body':
    'Generischer Branchen-Match. Die Spezialisierung wurde im Website-Content nicht erwähnt. Falls strikt nötig, präzisiere die Query (z.B. „{token}-Fachgeschäft").',
  'ld.uncertainty': 'Leadscraper ist hier {score}: {text}.',
  'ld.company': 'Unternehmen',
  'ld.aggregatorWarn':
    'Eigene Firmen-Website wird noch ermittelt. Bis dahin zeigen wir die Quell-URL (Verzeichnis/Presse) aus der diese Firma stammt.',
  'ld.emailPattern': 'E-Mail-Muster',
  'ld.emailPattern.confHigh': 'hoch',
  'ld.emailPattern.confMid': 'mittel',
  'ld.emailPattern.confLow': 'niedrig',
  'ld.emailPattern.sourceOne': 'Quelle',
  'ld.emailPattern.sourceMany': 'Quellen',
  'ld.emailPattern.hint': 'Alle Ansprechpartner dieser Firma folgen vermutlich diesem Muster.',
  'ld.emailPattern.noSamples': 'Keine Mitarbeiter-Emails auf der Webseite gefunden.',
  'ld.emailPattern.noPattern': 'Gefundene Emails ({n}) folgen keinem klaren Muster.',
  'ld.emailPattern.notRecognized': 'nicht erkannt',
  'ld.emailPattern.notFound': 'Kein Muster gefunden',
  'ld.contacts': 'Ansprechpartner',
  'ld.decisionMaker': '· Entscheider',
  'ld.comingSoon': '· bald',
  // V1.27.x (Janik 2026-05-19, Vanessa Sonders Phone-Coverage-Report):
  // Klarstellung wenn ein Personen-Kontakt KEINE Direktwahl hat. Personen-
  // Direktwahlen sind systemisch selten öffentlich (nicht im Impressum, nicht
  // auf LinkedIn). Statt leeres Feld zeigt das UI explizit den Status + die
  // Zentrale als Erreichbarkeits-Pfad.
  'ld.contactPhoneUnknown': 'Direktwahl nicht öffentlich',
  'ld.viaCentralPhone': 'Über Zentrale',
  // V1.27.1 hotfix: ld.demo.quote{1,2,3} entfernt zusammen mit der fake
  // "Website-Auszüge"-Section in LeadDetail.jsx (Niklas-Bug-1).
  'ld.emailLabel': 'E-Mail',
  'ld.specialization': 'Spezialisierung',

  // LeadsTable — NACE full
  'lt.naceF.A': 'Land- und Forstwirtschaft, Fischerei',
  'lt.naceF.B': 'Bergbau und Gewinnung von Steinen und Erden',
  'lt.naceF.C': 'Verarbeitendes Gewerbe',
  'lt.naceF.D': 'Energieversorgung',
  'lt.naceF.E': 'Wasserversorgung; Abwasser- und Abfallentsorgung',
  'lt.naceF.F': 'Baugewerbe',
  'lt.naceF.G': 'Handel; Instandhaltung und Reparatur von Kraftfahrzeugen',
  'lt.naceF.H': 'Verkehr und Lagerei',
  'lt.naceF.I': 'Gastgewerbe',
  'lt.naceF.J': 'Information und Kommunikation',
  'lt.naceF.K': 'Erbringung von Finanz- und Versicherungsdienstleistungen',
  'lt.naceF.L': 'Grundstücks- und Wohnungswesen',
  'lt.naceF.M':
    'Erbringung von freiberuflichen, wissenschaftlichen und technischen Dienstleistungen',
  'lt.naceF.N': 'Erbringung von sonstigen wirtschaftlichen Dienstleistungen',
  'lt.naceF.O': 'Öffentliche Verwaltung, Verteidigung; Sozialversicherung',
  'lt.naceF.P': 'Erziehung und Unterricht',
  'lt.naceF.Q': 'Gesundheits- und Sozialwesen',
  'lt.naceF.R': 'Kunst, Unterhaltung und Erholung',
  'lt.naceF.S': 'Erbringung von sonstigen Dienstleistungen',
  'lt.naceF.T': 'Private Haushalte',
  'lt.naceF.U': 'Exterritoriale Organisationen und Körperschaften',
  // LeadsTable — NACE short
  'lt.naceS.A': 'Land/Forst',
  'lt.naceS.B': 'Bergbau',
  'lt.naceS.C': 'Verarbeit. Gewerbe',
  'lt.naceS.D': 'Energie',
  'lt.naceS.E': 'Wasser/Abfall',
  'lt.naceS.F': 'Bau',
  'lt.naceS.G': 'Handel',
  'lt.naceS.H': 'Verkehr/Lagerei',
  'lt.naceS.I': 'Gastgewerbe',
  'lt.naceS.J': 'IT/Medien',
  'lt.naceS.K': 'Finanz/Versich.',
  'lt.naceS.L': 'Immobilien',
  'lt.naceS.M': 'Freiberuflich',
  'lt.naceS.N': 'Sonst. Dienstl.',
  'lt.naceS.O': 'Öff. Verwaltung',
  'lt.naceS.P': 'Bildung',
  'lt.naceS.Q': 'Gesundheit',
  'lt.naceS.R': 'Kunst/Unterh.',
  'lt.naceS.S': 'Sonst. Dienstl.',
  'lt.naceS.T': 'Priv. Haushalte',
  'lt.naceS.U': 'Exterritorial',
  // LeadsTable — reject reasons
  'lt.rr.wrong_industry': 'Falsche Branche',
  'lt.rr.wrong_industry.hint': 'Leadscraper hat das Geschäftsfeld falsch erkannt',
  'lt.rr.wrong_size': 'Falsche Unternehmensgröße',
  'lt.rr.wrong_size.hint': 'Zu klein, zu groß oder Konzern statt Mittelstand',
  'lt.rr.wrong_region': 'Falscher Standort',
  'lt.rr.wrong_region.hint': 'Sitz / Bundesland passt nicht zur Suche',
  'lt.rr.wrong_role': 'Falscher Ansprechpartner',
  'lt.rr.wrong_role.hint': 'Person oder Rolle ist nicht der Entscheider',
  'lt.rr.not_operator': 'Kein Operator',
  'lt.rr.not_operator.hint': 'Agentur, Vermittler oder Bauträger statt operativer Anbieter',
  'lt.rr.wrong_ownership': 'Falsche Eigentümer-Struktur',
  'lt.rr.wrong_ownership.hint':
    'Konzern-Tochter statt Familienunternehmen, falsche Rechtsform o.ä.',
  'lt.rr.no_buying_signal': 'Kein erkennbarer Bedarf',
  'lt.rr.no_buying_signal.hint':
    'Keine Trigger-Events, keine offenen Stellen, kein Wachstumssignal',
  'lt.rr.already_known': 'Kennen wir schon',
  'lt.rr.already_known.hint': 'Bereits im CRM oder schon einmal kontaktiert (kein Lern-Signal)',
  'lt.rr.bad_data': 'Falsche Daten',
  'lt.rr.bad_data.hint': 'Adresse, Name oder Kontaktinfo stimmt nicht',
  'lt.rr.other': 'Anderer Grund',
  'lt.rr.other.hint': 'Schreib unten kurz warum (Freitext)',
  // LeadsTable — MatchRing
  'lt.ring.rejected': 'Abgelehnt, als 0 gewertet',
  'lt.ring.match': 'Match {pct}%',
  // LeadsTable — RejectModal
  'lt.rm.header': 'Lead verwerfen',
  'lt.rm.sub': 'Sag uns warum. Leadscraper lernt daraus und liefert nächstes Mal besser.',
  'lt.rm.noteRequired': 'Bitte kurz beschreiben (Pflicht)',
  'lt.rm.noteOptional': 'Notiz für Leadscraper (optional)',
  'lt.rm.placeholderReq': 'Z.B. „Konkurrent, verkaufen ähnliche Lösung"',
  'lt.rm.placeholderOpt':
    'Was hat Leadscraper übersehen oder falsch gewertet? (Je konkreter, desto besser lernt das System.)',
  'lt.rm.cancel': 'Abbrechen',
  'lt.rm.submit': 'Lead verwerfen',
  // LeadsTable — misc
  'lt.feedbackFail': 'Feedback konnte nicht gespeichert werden. Versuche es nochmal.',
  'lt.payoff.avoided': 'Das Dossier meidet ab jetzt:',
  'lt.payoff.flowsIn': 'Fließt in die nächste Analyse ein.',
  // LEA-287: Kanban / Funnel-View (LeadsFunnel.tsx + LeadsTable.jsx)
  'lt.filter.all': 'Alle',
  'lt.filter.torate': 'Zu bewerten',
  'lt.filter.identified': 'Unternehmen angelegt',
  'lt.filter.connected': 'Mit Ansprechpartnern',
  'lt.filter.planned': 'Plan bereit',
  'lt.filter.archived': 'Archiviert',
  'lt.view.list': 'Liste',
  'lt.view.listSubheader': 'Tabelle, alle Spalten sichtbar',
  'lt.funnel.subheader': 'Funnel, Leads gruppiert nach Phase',
  'lt.funnel.addCompany': 'Unternehmen anlegen',
  'lt.funnel.add': 'Anlegen',
  'lt.funnel.addTooltip': 'Unternehmen per URL hinzufügen · 1 Credit',
  'lt.funnel.pullAllContacts': 'Alle Kontakte ziehen',
  'lt.funnel.empty': 'Noch keine Leads in dieser Phase',
  'lt.funnel.dropHint': 'Hier ablegen, um Phase zu starten',
  'lt.col.planned': 'Akquiseplan bereit',
  'lt.card.new': 'Neu',
  'lt.card.viewPlan': 'Plan ansehen',
  'lt.card.findContacts': 'Ansprechpartner finden',
  'lt.card.createPlan': 'Akquiseplan erstellen',
  'lt.card.contactsCount': '{n} Ansprechpartner',
  'lt.card.fitTooltip': 'Passung {score} %: wie gut diese Firma zu deiner Zielgruppe passt',
  'lt.card.noContacts': 'Noch keine Ansprechpartner',
  'lt.card.noJustification':
    'Noch keine Cortex-Begründung. Lead wird beim nächsten Run angereichert.',
  'lt.card.rejectTitle': 'Als nicht passend markieren',
  'lt.card.rejectAria': '{company} als nicht passend markieren',
  'lt.card.openWebsite': '{website} öffnen',
  'lt.next.title': 'Nächste Schritte',
  'lt.next.verifyContacts': 'Ansprechpartner verifizieren',
  'lt.next.verifyingContacts': 'Verifiziere Ansprechpartner …',
  'lt.next.contactsVerified': '{n} Ansprechpartner verifiziert',
  'lt.next.contactVerified': 'Ansprechpartner verifiziert',
  'lt.next.openPlan': 'Plan öffnen',
  'lt.next.generatingPlan': 'Generiere Akquiseplan …',
  'lt.next.credit': '1 Credit',
  'lt.next.retry': 'Erneut versuchen',
  'lt.next.verifyFirst': 'Erst Ansprechpartner verifizieren',
  'lt.next.failedHint': 'Letzter Versuch fehlgeschlagen. Du kannst nochmal probieren.',
  'lt.loading.connecting': 'Ansprechpartner werden recherchiert …',
  'lt.loading.planning': 'Akquiseplan wird generiert …',
  'lt.loading.adding': 'Wird angelegt …',
  'lt.loading.verifying': 'Wird verifiziert …',
  'lt.loading.connectingLive': 'Ansprechpartner werden verifiziert …',
  'lt.loading.planningLive': 'Akquiseplan wird erstellt …',
  'lt.manual.verifyingDesc': 'Website wird verifiziert, Basisdaten werden extrahiert …',
  'lt.manual.addedDesc':
    'Per URL angelegt. Branche, Adresse und Kontaktdaten werden bei der Verifikation ergänzt.',
  // AddCompanyManualModal — manuelles Anlegen per URL
  'lt.manual.modal.eyebrow': 'Pipeline · manuell',
  'lt.manual.modal.title': 'Unternehmen hinzufügen',
  'lt.manual.modal.desc':
    'Leadscraper verifiziert die Website + extrahiert Basisdaten zum Unternehmen. Danach landet der Lead in {phase} und du kannst von dort Ansprechpartner + Akquise-Plan ziehen.',
  'lt.manual.modal.phase': '„Unternehmen angelegt"',
  'lt.manual.modal.websiteLabel': 'Website',
  'lt.manual.modal.placeholder': 'z.B. heuerlogistics.de',
  'lt.manual.modal.hint':
    'Wir versuchen die Website zu erreichen. Bei Fehler wird kein Credit verbraucht.',
  'lt.manual.modal.cancel': 'Abbrechen',
  'lt.manual.modal.close': 'Schließen',
  'lt.manual.modal.submit': 'Hinzufügen',
  'lt.manual.modal.submitting': 'Lege an …',
  'lt.manual.modal.creditOne': '{n} Credit',
  'lt.manual.modal.creditMany': '{n} Credits',
  'lt.manual.modal.errEmpty': 'Bitte eine Website angeben.',
  'lt.manual.modal.errInvalid':
    'Das sieht nicht wie eine gültige Website aus (z.B. heuerlogistics.de).',
  'lt.phaseChip.identified': 'Angelegt',
  'lt.phaseChip.connected': 'Kontakte',
  'lt.phaseChip.planned': 'Plan bereit',
  'lt.resetToast': 'Bewertung für {c} zurückgesetzt',
  'lt.queryLabel': 'Gefiltert auf Query:',
  'lt.queryClear': 'Filter aufheben',
  'lt.profileLeads': 'Leads · {name}',
  'lt.profileSubOne': '1 Lead · alle Queries dieser Zielgruppe landen hier',
  'lt.profileSub': '{n} Leads · alle Queries dieser Zielgruppe landen hier',
  'lt.dashHint1': 'Im Dashboard findest du einen Hinweis dazu (Symbol',
  'lt.dashHint2': 'neben dem Status).',
  // LeadsTable — tooltips
  'lt.tip.accepted': 'Akzeptiert, Klick zum Aufheben',
  'lt.tip.rejected': 'Verworfen, Klick zum Aufheben',
  'lt.tip.unseen': 'Noch ungesehen',
  'lt.tip.softKeep':
    'Möglicherweise relevant. Leadscraper hat hier eine Unsicherheit, siehe Detail',
  'lt.badge.soft': 'möglich',
  'lt.tip.contacts': '{n} Ansprechpartner anzeigen',
  'lt.tip.openLead': 'Lead-Details öffnen',
  'lt.tip.openCompany': 'Unternehmens-Details öffnen',
  'lt.tip.dragCol': 'Spaltenbreite ziehen',
  // LeadsTable — export
  'lt.exp.tipNoLeads': 'Nur Leads mit Ansprechpartnern oder fertigem Plan sind exportierbar',
  'lt.exp.tipWrongFilter':
    'Nur Leads mit Ansprechpartnern oder fertigem Akquiseplan können exportiert werden.',
  'lt.exp.tipReady': '{n} Leads exportieren',
  'lt.exp.toastNoLeads':
    'Nur Leads mit Ansprechpartnern oder fertigem Akquiseplan lassen sich exportieren.',
  'lt.exp.noRows': 'Keine Leads zum Export gefunden.',
  'lt.exp.success': '{n} Zeilen als {fmt} exportiert.',
  'lt.exp.fail': 'Export fehlgeschlagen: {err}',
  // LEA-482: Rating-Nudges gegen die Feedback-Starvation (88 gelieferte Leads, 0 bewertet).
  'rateNudge.viewToast':
    'Du hast {n} Leads angesehen, aber noch keinen bewertet. Ein Tap auf ✓ oder ✕ genügt — und die nächste Runde wird treffsicherer.',
  'rateNudge.exportToast':
    'Exportiert. Bewerte kurz ein paar Leads mit ✓ oder ✕ — deine nächste Runde sitzt dann besser.',
  'lt.exp.unknownErr': 'Unbekannter Fehler',
  'lt.exp.ing': 'Exportiere…',
  'lt.exp.btn': 'Export',
  'lt.exp.csvHint': '.csv (Komma-getrennt)',
  // LeadsTable — export headers
  'lt.expH.company': 'Firma',
  'lt.expH.profile': 'Zielgruppe',
  'lt.expH.sector': 'Branche',
  'lt.expH.legalForm': 'Rechtsform',
  'lt.expH.street': 'Straße',
  'lt.expH.zip': 'PLZ',
  'lt.expH.city': 'Standort',
  'lt.expH.website': 'Website',
  'lt.expH.companyEmail': 'Firmen-E-Mail',
  'lt.expH.companyPhone': 'Firmen-Telefon',
  'lt.expH.vatId': 'USt-IdNr',
  'lt.expH.hr': 'Handelsregister',
  'lt.expH.founded': 'Gegründet',
  'lt.expH.size': 'Mitarbeiter',
  'lt.expH.revenue': 'Umsatzbereich',
  'lt.expH.description': 'Beschreibung',
  'lt.expH.techStack': 'Tech-Stack',
  'lt.expH.triggers': 'Signale/Trigger',
  'lt.expH.scoreCompany': 'Firmen-Fit-Score',
  'lt.expH.scoreData': 'Daten-Qualität',
  'lt.expH.contact': 'Ansprechpartner',
  'lt.expH.role': 'Rolle',
  'lt.expH.seniority': 'Seniorität',
  'lt.expH.department': 'Abteilung',
  'lt.expH.email': 'E-Mail',
  'lt.expH.emailSource': 'Quelle E-Mail',
  'lt.expH.phone': 'Telefon',
  'lt.expH.linkedin': 'LinkedIn',
  'lt.expH.xing': 'Xing',
  'lt.expH.qualification': 'Qualifikation',
  'lt.expH.confidence': 'Konfidenz',
  'lt.expH.channel': 'Empfohlener Kanal',
  'lt.expH.direct': 'direkt',
  'lt.expH.guessed': 'vermutet ({n}%)',

  // ScheduleCard
  // MobileApp
  'mob.wizardHint':
    'Lege dein erstes Profil auf einem Desktop an. Der Wizard ist mobil noch nicht verfügbar.',
  'mob.back': '← Zurück',
  'mob.queryPlaceholder': 'z.B. Bäckereien, Steuerberater, Schuhgeschäft',
  'mob.changePassword': 'Passwort ändern',
  'mob.onDesktop': 'Auf Desktop',
  'mob.logout': 'Abmelden',
  'mob.logoutConfirm': 'Wirklich abmelden?',
  'mob.abo': 'Abo & Credits',
  'mob.trialLeads': 'Test-Leads übrig',
  'mob.active': 'Aktiv',
  'mob.upgrade': 'Auf Pro upgraden',
  'mob.changePlan': 'Plan ändern',
  'mob.upgradeHint': 'Mehr Leads + Schedule',
  // MobileApp — V1.25 i18n cleanup (Shashank 2026-05-04, LEA-230 Om-feedback)
  'mob.acct.aria': 'Mein Konto',
  'mob.toast.accepted': '✓ Als passend markiert',
  'mob.toast.rejected': '✗ Abgelehnt',
  'mob.toast.runStarted': 'Suchlauf gestartet, kommt in ~2 Min',
  'mob.fb.fits': '✓ Passt',
  'mob.fb.rejected': '✗ Abgelehnt',
  'mob.detail.fits': '✓ Passt',
  'mob.detail.rejected': '✗ Abgelehnt',
  'mob.detail.notFitting': '✗ Passt nicht',
  'mob.home.activeProfile': 'Aktive Zielgruppe',
  'mob.home.stat.leads': 'Leads',
  'mob.home.stat.fits': 'Passt',
  'mob.home.stat.matchRate': 'Match-Rate',
  'mob.home.cta.newSearch': 'Neue Suchanfrage starten',
  'mob.home.newLeads': 'Neue Leads',
  'mob.home.viewAll': 'Alle ansehen →',
  'mob.home.emptyHint': 'Starte eine neue Suche oder wechsle die Zielgruppe.',
  'mob.leads.title': 'Leads',
  'mob.leads.new': '＋ Neu',
  'mob.leads.filter.open': 'Offen',
  'mob.leads.filter.fits': 'Passt',
  'mob.leads.filter.rejected': 'Abgelehnt',
  'mob.leads.filter.all': 'Alle',
  'mob.leads.cta.newSearch': 'Neue Suche starten',
  'mob.detail.section.company': 'Unternehmen',
  'mob.detail.label.website': 'Website',
  'mob.detail.label.email': 'E-Mail',
  'mob.detail.label.phone': 'Telefon',
  'mob.detail.contacts': 'Ansprechpartner ({n})',
  'mob.search.title': 'Neue Suchanfrage',
  'mob.search.profileLabel': 'Zielgruppe: {name}',
  'mob.search.askWho': 'Wen suchst du?',
  'mob.search.region': 'Region (optional)',
  'mob.search.regionPlaceholder': 'z.B. Bayern, Hamburg, NRW',
  'mob.search.start': 'Suchlauf starten',
  'mob.search.cancel': 'Abbrechen',
  'mob.profile.title': 'Zielgruppen',
  'mob.profile.active': 'Aktiv',
  'mob.profile.stat.match': 'Match',
  'mob.profile.switchTo': 'Wechseln zu',
  'mob.profile.leadsCount': '{n} Leads',
  'mob.profile.newCount': '{n} neu',
  'mob.more.title': 'Mehr',
  'mob.more.section.account': 'Mein Konto',
  'mob.more.label.email': 'E-Mail',
  'mob.more.plan.trial': 'Trial',
  'mob.more.plan.monthly': 'Monats-Abo',
  'mob.more.invoices': 'Rechnungen',
  'mob.more.section.help': 'Hilfe & App',
  'mob.more.toDesktop': 'Auf Desktop wechseln',
  'mob.more.toDesktop.value': 'Voller Funktionsumfang',
  'mob.more.help': 'Hilfe & Kontakt',
  'mob.nav.home': 'Home',
  'mob.nav.leads': 'Leads',
  'mob.nav.profile': 'Zielgruppen',
  'mob.nav.account': 'Konto',

  // FeasibilityBlockerModal
  'fb.field.unternehmensart': 'Unternehmensart',
  'fb.field.region': 'Region',
  'fb.field.ort': 'Ort',
  'fb.field.ansprechpartner': 'Ansprechpartner',
  'fb.field.zusatz': 'Zusatzkriterien',
  'fb.field.rawQuery': 'Freitext',
  'fb.blocked.headline': 'Die Query ist zu breit',
  'fb.blocked.subline':
    'Leadscraper würde damit hauptsächlich Portale, Verbände oder Beratungen finden, keine echten Einzelfirmen.',
  'fb.warning.headline': 'Diese Query ist sehr spezifisch',
  'fb.warning.subline':
    'Mit dieser Kombination an Filtern findet Leadscraper möglicherweise nur wenige oder keine Treffer. Du kannst trotzdem starten oder die Query etwas öffnen.',
  'fb.cta.adjust': 'Query anpassen',
  'fb.cta.sharpen': 'Zurück & schärfen',
  'fb.cta.bypass': 'Trotzdem starten',
  'fb.cta.bypassTitle': 'Die Query durchläuft Leadscraper trotzdem, auf eigene Verantwortung',
  'fb.fieldWarnings': 'Felder mit Hinweisen',
  'fb.suggestions': 'Konkretere Formulierungen',
  'fb.suggestionsHint':
    'Kopiere einen der Vorschläge zurück ins Feld oder formuliere selbst. Das erhöht die Trefferquote messbar.',

  // SearchOverlay
  'so.step.planning.title': 'Leadscraper erinnert sich',
  'so.step.planning.sub': 'Deine Learnings analysieren + Suchstrategien planen',
  'so.step.discovery.title': 'Firmen identifizieren',
  // V1.28.0 (Janik 2026-05-21): "deutschen Web-Quellen" → "Web + Branchenverzeichnisse"
  // (Discovery ist nicht country-gelockt im Frontend-Sinn — der Customer-Report
  // mit Italien-Anfrage hat gezeigt dass solche Restriktionen falsch sind.
  // Backend-Internationalisation kommt mit Phase 1, aber UI darf schon ehrlich
  // sein: wir suchen über Google + Branchenverzeichnisse, primär DACH, aber
  // nicht nur).
  'so.step.discovery.sub': 'Top-Kandidaten aus Web-Suche + Branchenverzeichnissen',
  'so.step.hydration.title': 'Firmen tiefgehend analysieren',
  'so.step.hydration.sub': 'Websites + Impressum + Karriere + Team + News',
  'so.step.reasoning.title': 'Leadscraper bewertet',
  'so.step.reasoning.sub': 'Leadscraper prüft jeden Kandidaten gegen deine Zielgruppe',
  'so.step.delivery.title': 'Leads zusammenstellen',
  'so.step.delivery.sub': 'Top-Matches werden für dich sortiert + ausgeliefert',
  // V1.28.0 (Janik 2026-05-21, Bug R): 'enriching' = Stream-Delivery durch
  // (10 Leads sind in der Datenbank), aber Akquiseplan + Scores + Person-
  // Deep-Research laufen noch im Hintergrund. UI markiert das als
  // quasi-fertig — User kann schon arbeiten, Reload bringt die enriched
  // Daten nach.
  'so.step.enriching.title': 'Cortex enriched noch',
  'so.step.enriching.sub': 'Akquiseplan, Scores + Tiefen-Recherche zu den 10 Leads',
  // Janik 2026-05-25 (Round 4+++): Light-Path-Mode Labels. Welle-B nutzt
  // KI-Researcher statt Web-Suche + skipped Hydration/Reasoning/Delivery
  // → Phase-Liste hat nur planning → discovery → enriching.
  'so.step.discovery.title.light': 'Firmen identifizieren',
  'so.step.discovery.sub.light': 'KI-Researcher schlägt passende Firmen vor (Google-validiert)',
  'so.step.enriching.title.light': 'Grunddaten verifizieren',
  'so.step.enriching.sub.light':
    'Adresse, Größe, Tech-Stack pro Firma, sichtbar in der Kanban-Liste',
  'so.step.done.title': 'Fertig',
  'so.step.done.sub': 'Suchlauf abgeschlossen',
  'so.hero.reflecting': 'Leadscraper überlegt sich einen neuen Plan',
  'so.hero.round': '(Runde {n})',
  'so.hero.searching': 'Leadscraper sucht für dich',
  'so.hero.preparing': 'Leadscraper prüft deine Anfrage',
  'so.hero.elapsed': 'Zeit seit Start:',
  'so.hero.inFocus': 'Firmen im Fokus',
  'so.reflector.title': 'Leadscraper hat den ersten Ansatz verworfen',
  'so.query.title': 'Deine Suchanfrage',
  'so.funnel.identified': 'Identifiziert',
  'so.funnel.analyzed': 'Vertieft analysiert',
  'so.funnel.evaluated': 'Bewertet',
  'so.funnel.ready': 'Bereit',
  'so.live.title': 'Leadscraper arbeitet live',
  'so.close.btn': 'Im Hintergrund weiterlaufen lassen',
  'so.close.hint': 'Du kannst weiterarbeiten. Leadscraper meldet sich wenn neue Leads bereit sind.',
  'so.close.trust': 'Nur öffentliche Quellen · jede Angabe wird im Lead belegt.',

  // Auth — Login
  'auth.login.title': 'Willkommen zurück',
  'auth.login.sub': 'Melden Sie sich bei Ihrem Konto an, um auf Ihr Konto zuzugreifen.',
  'auth.login.email': 'E-Mail',
  'auth.login.password': 'Passwort',
  'auth.login.remember': 'Eingeloggt bleiben',
  'auth.login.submit': 'Anmelden',
  'auth.login.submitting': 'Anmelden …',
  'auth.login.forgot': 'Passwort vergessen?',
  'auth.login.noAccount': 'Noch kein Konto?',
  'auth.login.signUp': 'Registrieren',
  'auth.login.or': 'Oder',
  'auth.login.google': 'Mit Google anmelden',
  'auth.login.googleBusy': 'Anmeldung mit Google …',
  'auth.login.microsoft': 'Mit Microsoft anmelden',
  'auth.login.microsoftBusy': 'Anmeldung mit Microsoft …',
  'auth.login.errEmpty': 'Bitte fülle alle Felder aus.',
  'auth.login.errEmail': 'Ungültige E-Mail-Adresse.',
  'auth.login.errUnverified': 'Bitte bestätige zuerst deine E-Mail-Adresse.',
  'auth.login.errCredentials': 'E-Mail oder Passwort ist falsch.',
  'auth.login.errGeneric': 'Login fehlgeschlagen. Bitte versuche es erneut.',
  'auth.login.hidePassword': 'Passwort verbergen',
  'auth.login.showPassword': 'Passwort anzeigen',
  'auth.login.docTitle': 'Anmelden · Leadscraper',

  // Auth — Register
  'auth.register.title': 'Kostenlosen Account erstellen',
  'auth.register.sub':
    'Teste wie einfach präzise Leadlisten heute dank KI-Agenten generiert werden können.',
  'auth.register.firstName': 'Vorname',
  'auth.register.lastName': 'Nachname',
  'auth.register.email': 'E-Mail',
  'auth.register.password': 'Passwort',
  'auth.register.passwordConfirm': 'Passwort bestätigen',
  'auth.register.submit': 'Konto erstellen',
  'auth.register.submitting': 'Wird erstellt …',
  'auth.register.haveAccount': 'Bereits ein Konto?',
  'auth.register.signIn': 'Anmelden',
  'auth.register.or': 'Oder',
  'auth.register.google': 'Mit Google registrieren',
  'auth.register.googleBusy': 'Registrierung mit Google …',
  'auth.register.microsoft': 'Mit Microsoft registrieren',
  'auth.register.microsoftBusy': 'Registrierung mit Microsoft …',
  'auth.register.errEmpty': 'Bitte fülle alle Felder aus.',
  'auth.register.errBotCheck': 'Bitte schließe die Bot-Prüfung ab.',
  'auth.register.errEmail': 'Ungültige E-Mail-Adresse.',
  'auth.register.errPwShort': 'Passwort muss mindestens 8 Zeichen lang sein.',
  'auth.register.errPwMismatch': 'Passwörter stimmen nicht überein.',
  'auth.register.hidePassword': 'Passwort verbergen',
  'auth.register.showPassword': 'Passwort anzeigen',
  'auth.register.docTitle': 'Registrieren · Leadscraper',

  // Auth — Reset Password
  'auth.reset.docTitle': 'Passwort zurücksetzen · Leadscraper',
  'auth.reset.title': 'Passwort zurücksetzen',
  'auth.reset.sub':
    'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.',
  'auth.reset.emailLabel': 'E-Mail*',
  'auth.reset.emailPlaceholder': 'Geben Sie Ihre E-Mail-Adresse ein',
  'auth.reset.errInvalidEmail': 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  'auth.reset.errRequest': 'Anfrage fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'auth.reset.sending': 'Wird gesendet …',
  'auth.reset.send': 'Link senden',
  'auth.reset.haveAccount': 'Sie haben bereits ein Konto?',
  'auth.reset.signIn': 'Anmelden',
  'auth.reset.sentTitle': 'E-Mail gesendet',
  'auth.reset.sentSub':
    'Falls ein Konto mit dieser E-Mail existiert, haben wir Ihnen einen Link zum Zurücksetzen gesendet. Prüfen Sie Ihren Posteingang (und ggf. Spam).',
  'auth.reset.backToLogin': 'Zurück zur Anmeldung',
  'auth.reset.newPwTitle': 'Neues Passwort festlegen',
  'auth.reset.newPwSub': 'Wählen Sie ein neues Passwort für Ihr Konto.',
  'auth.reset.newPwLabel': 'Neues Passwort*',
  'auth.reset.newPwPlaceholder': 'Mindestens 8 Zeichen',
  'auth.reset.confirmLabel': 'Passwort bestätigen*',
  'auth.reset.confirmPlaceholder': 'Passwort erneut eingeben',
  'diag.failed': 'Die letzte Suche ist fehlgeschlagen. Bitte starte sie einfach erneut.',
  'diag.interrupted': 'Die letzte Suche wurde unterbrochen — {n} Leads wurden trotzdem geliefert.',
  'diag.qualifierDown':
    'Unser Qualitäts-Check war bei der letzten Suche nicht erreichbar — an deinen Kriterien liegt es nicht. Einfach erneut starten.',
  'auth.reset.errPwShort': 'Das Passwort muss mindestens 8 Zeichen lang sein.',
  'auth.reset.errPwWeak':
    'Das Passwort muss Groß- und Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten.',
  'auth.reset.pwRules':
    'Mindestens 8 Zeichen, mit Groß- und Kleinbuchstaben, einer Zahl und einem Sonderzeichen.',
  'auth.reset.errPwMismatch': 'Passwörter stimmen nicht überein.',
  'auth.reset.saving': 'Wird gespeichert …',
  'auth.reset.resetBtn': 'Passwort zurücksetzen',
  'auth.reset.hidePassword': 'Passwort verbergen',
  'auth.reset.showPassword': 'Passwort anzeigen',
  'auth.reset.doneTitle': 'Passwort erfolgreich geändert',
  'auth.reset.doneSub': 'Sie können sich jetzt mit Ihrem neuen Passwort anmelden.',
  'auth.reset.goToLogin': 'Zur Anmeldung',
  'auth.reset.invalidTitle': 'Link ungültig oder abgelaufen',
  'auth.reset.invalidSub':
    'Dieser Link zum Zurücksetzen des Passworts ist nicht mehr gültig. Bitte fordern Sie einen neuen an.',
  'auth.reset.requestNew': 'Neuen Link anfordern',
  'auth.reset.oauthTitle': 'Dieses Konto nutzt {provider}-Anmeldung',
  'auth.reset.oauthSub':
    'Für dieses Konto ist kein Passwort hinterlegt. Bitte melden Sie sich stattdessen mit {provider} an.',

  // Auth — Set Password (LEA-527: branded first-password page for vorab angelegte Konten)
  'auth.setPw.docTitle': 'Passwort festlegen · Leadscraper',
  'auth.setPw.loading': 'Einen Moment …',
  'auth.setPw.greeting': 'Willkommen, {name}!',
  'auth.setPw.title': 'Ihr Konto ist bereit',
  'auth.setPw.sub':
    'Legen Sie Ihr Passwort fest, um loszulegen — Ihre Leads warten bereits in Ihrem Konto.',
  'auth.setPw.pwLabel': 'Passwort*',
  'auth.setPw.pwPlaceholder': 'Mindestens 8 Zeichen',
  'auth.setPw.confirmLabel': 'Passwort bestätigen*',
  'auth.setPw.confirmPlaceholder': 'Passwort erneut eingeben',
  'auth.setPw.submit': 'Passwort festlegen & starten',
  'auth.setPw.saving': 'Konto wird eingerichtet …',
  'auth.setPw.errPwShort': 'Das Passwort muss mindestens 8 Zeichen lang sein.',
  'auth.setPw.errPwWeak':
    'Das Passwort muss Groß- und Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten.',
  'auth.setPw.pwRules':
    'Mindestens 8 Zeichen, mit Groß- und Kleinbuchstaben, einer Zahl und einem Sonderzeichen.',
  'auth.setPw.errPwMismatch': 'Die Passwörter stimmen nicht überein.',
  'auth.setPw.errGeneric': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
  'auth.setPw.doneTitle': 'Alles bereit!',
  'auth.setPw.doneSub': 'Sie werden in Ihr Konto weitergeleitet …',
  'auth.setPw.invalidTitle': 'Link ungültig oder abgelaufen',
  'auth.setPw.invalidSub':
    'Dieser Einrichtungslink ist nicht mehr gültig. Bitte wenden Sie sich an Ihren Ansprechpartner bei Leadscraper.',
  'auth.setPw.backToLogin': 'Zur Anmeldung',
  'auth.setPw.resend': 'Neuen Link senden',
  'auth.setPw.resending': 'Wird gesendet …',
  'auth.setPw.resentTitle': 'Neuer Link gesendet',
  'auth.setPw.resentSub':
    'Wir haben einen frischen Link an Ihre E-Mail-Adresse gesendet — er ist 14 Tage gültig.',
  'auth.setPw.resendErr': 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut.',

  // Auth — Verify Email
  'auth.verify.docTitle': 'E-Mail bestätigen · Leadscraper',
  'auth.verify.title': 'E-Mail bestätigen',
  'auth.verify.verifying': 'E-Mail wird bestätigt …',
  'auth.verify.success': 'Erfolgreich!',
  'auth.verify.error': 'Bestätigung fehlgeschlagen',
  'auth.verify.noToken': 'Bestätigungslink fehlt',
  'auth.verify.verifyingSub': 'Einen Moment bitte.',
  'auth.verify.successSub':
    'Ihre E-Mail-Adresse wurde bestätigt. Sie werden zum Dashboard weitergeleitet …',
  'auth.verify.defaultError': 'Ein Fehler ist aufgetreten.',
  'auth.verify.noTokenSub':
    'Klicken Sie auf den Link in der E-Mail, die wir Ihnen gesendet haben. Falls Sie keine E-Mail erhalten haben, können Sie eine neue anfordern.',
  'auth.verify.goToDashboard': 'Sofort zum Dashboard',
  'auth.verify.resent': 'E-Mail erneut gesendet ✓',
  'auth.verify.resending': 'Wird gesendet …',
  'auth.verify.resendError': 'Neue Bestätigungs-E-Mail anfordern',
  'auth.verify.resendNoToken': 'Bestätigungs-E-Mail erneut senden',
  'auth.verify.toLogin': 'Zur Anmeldung',
  'auth.verify.resendFailed': 'E-Mail konnte nicht erneut gesendet werden.',

  // Auth — Shell
  'auth.shell.nextSlide': 'Nächste Folie',

  // Auth — Slide carousel (LEA-285). Mirrors apps/auth/src/lib/i18n.ts under
  // the auth.* namespace so the AI translate pipeline (LEA-267) fills all 7
  // locales. Source-of-truth for the standalone auth app is still its local
  // i18n.ts until that app migrates to @cortex/i18n. English source copy
  // comes from Janik's standalone HTML design.
  'auth.slides.1.headline':
    'KI-Agenten finden B2B-Unternehmen, die exakt zu deinem Zielkundenprofil passen.',
  'auth.slides.2.headline':
    'Jede Leadliste wird frisch aus öffentlichen Quellen generiert, keine veralteten oder weiterverkauften Daten.',
  'auth.slides.3.headline':
    'Jeder Lead enthält relevante Entscheider, Quell-Links und eine klare Begründung, warum er passt.',
  'auth.slides.aria.region': 'Produkt-Highlights',
  'auth.slides.aria.slide': 'Folie {n} von {total}',
  'auth.slides.aria.goTo': 'Zu Folie {n} springen',

  // --- Login + Registrierung, Revision 19 (Janik-Freigabe 11.09. / 17.09.2026) ---
  // Deutsche Texte 1:1 aus dem Entwurf (Design-Commit 22a435e7). Nicht umformulieren.
  'auth.r19.skip': 'Zum Inhalt',
  'auth.r19.header.haveAccount': 'Schon dabei?',
  'auth.r19.hero.titleLead': 'Finde die',
  'auth.r19.hero.titleGrad': 'Kunden,',
  'auth.r19.hero.titleTail': 'für die dein Angebot gemacht ist.',
  'auth.r19.hero.lead':
    'Beschreib, wen du erreichen möchtest. Leadscraper findet passende Firmen, recherchiert Ansprechpartner und zeigt dir, wo du im Gespräch ansetzen kannst.',
  'auth.r19.demo.caption': 'Deine Recherche. Schritt für Schritt.',
  'auth.r19.demo.play': 'Ablauf abspielen',
  'auth.r19.form.title': 'Starte mit Leadscraper.',
  'auth.r19.form.google': 'Mit Google',
  'auth.r19.form.microsoft': 'Mit Microsoft',
  'auth.r19.form.separator': 'oder mit deiner E-Mail',
  'auth.r19.form.businessEmail': 'Geschäftliche E-Mail',
  'auth.r19.form.emailPlaceholder': 'du@firma.de',
  'auth.r19.form.show': 'Anzeigen',
  'auth.r19.form.hide': 'Verbergen',
  'auth.r19.legal.accept':
    'Mit deiner Registrierung akzeptierst du unsere {terms}. Hinweise zu deinen Daten findest du in der {privacy}.',
  'auth.r19.legal.privacyLink': 'Datenschutzerklärung',
  'auth.r19.proof.founderTitle': 'Persönlich betreut vom Gründer.',
  'auth.r19.proof.founderBody': 'Janik ist dein direkter Ansprechpartner.',
  'auth.r19.confidence.eyebrow': 'Vor deinem ersten Gespräch',
  'auth.r19.confidence.title1': 'Du weißt, wen du ansprichst.',
  'auth.r19.confidence.title2': 'Und warum.',
  'auth.r19.confidence.p1.title': 'Quellen gehören dazu.',
  'auth.r19.confidence.p1.body':
    'Du siehst, worauf die Recherche beruht, und kannst die Angaben selbst prüfen.',
  'auth.r19.confidence.p2.title': 'Offene Punkte bleiben offen.',
  'auth.r19.confidence.p2.body':
    'Fehlt eine Angabe, ist das sichtbar. So entscheidest du, wie du weiter recherchierst.',
  'auth.r19.confidence.p3.title': 'Du bekommst einen Ansatz.',
  'auth.r19.confidence.p3.body':
    'Firmenwissen hilft dir, den ersten Kontakt mit einem konkreten Anlass vorzubereiten.',
  'auth.r19.founder.eyebrow': 'Persönlich an deiner Seite',
  'auth.r19.founder.role': 'Gründer von Leadscraper',
  'auth.r19.founder.photoAlt': 'Janik Deimann, Gründer von Leadscraper',
  'auth.r19.founder.body':
    'Ich helfe dir persönlich bei deiner Suche und deinen Fragen zu Leadscraper.',
  'auth.r19.founder.contact': 'Im Chat fragen',
  'auth.r19.footer.copyright': '© Leadscraper · Deimann Com GmbH',
  'auth.r19.footer.privacy': 'Datenschutz',
  'auth.r19.footer.imprint': 'Impressum',
  // Geprueft 17.09.2026: HTTP 200.
  'auth.r19.footer.imprintUrl': 'https://www.leadscraper.de/impressum',
  'auth.r19.footer.navLabel': 'Rechtliches',

  // ProfileDetail — rejection reasons, learning, decisions, queries, company, etc.
  'pd.rej.wrong_industry': 'Falsche Branche',
  'pd.rej.wrong_role': 'Falsche Rolle',
  'pd.rej.wrong_region': 'Falsche Region',
  'pd.rej.outside_radius': 'Außerhalb Radius',
  'pd.rej.wrong_size': 'Falsche Größe',
  'pd.rej.wrong_company_form': 'Falsche Rechtsform',
  'pd.rej.agency_not_operator': 'Agentur statt Betrieb',
  'pd.rej.consultant_not_operator': 'Berater statt Betrieb',
  'pd.rej.duplicate_previous_session': 'Bereits geliefert',
  'pd.rej.insufficient_data': 'Zu wenig Daten',
  'pd.rej.learned_rejection_pattern': 'Deinem Ablehnungs-Muster entsprochen',
  'pd.rej.low_confidence': 'Zu unsicher',
  'pd.learn.loading': 'Lade Feedback-Lernstand…',
  'pd.learn.loadError': 'Fehler beim Laden',
  'pd.learn.noData': 'Keine Feedback-Daten verfügbar.',
  'pd.learn.emptyTitle': 'Noch kein Feedback gegeben',
  'pd.learn.emptyDesc1': 'Sobald du in der Lead-Liste auf ',
  'pd.learn.emptyFit': 'passt',
  'pd.learn.emptyDesc2': ' oder ',
  'pd.learn.emptyNotFit': 'passt nicht',
  'pd.learn.emptyDesc3':
    ' klickst, lernt Leadscraper deine Vorlieben und zeigt dir hier was es daraus ableitet.',
  'pd.learn.ratingStatus': 'Bewertungs-Stand',
  'pd.learn.lastRating': 'Letzte Bewertung ',
  'pd.learn.noRating': 'Noch keine Bewertung',
  'pd.learn.rated': 'Bewertet',
  'pd.learn.totalSub': '{n} insgesamt',
  'pd.learn.fits': 'Passt',
  'pd.learn.positive': 'positiv',
  'pd.learn.notFits': 'Passt nicht',
  'pd.learn.negative': 'negativ',
  'pd.learn.matchRate': 'Trefferquote',
  'pd.learn.matchRateSub': 'passt / bewertet',
  'pd.learn.stageMature': 'Ausgereift',
  'pd.learn.stageCali': 'Kalibriert',
  'pd.learn.stageEarly': 'Einlernend',
  'pd.learn.stageNext': 'nächste Stufe',
  'pd.learn.morePrefix': 'Noch ',
  'pd.learn.moreSuffix': ' Bewertungen bis Stufe ',
  'pd.learn.coldStartHint':
    'Bewerte mehr Leads damit Leadscraper anfängt deine Muster zu erkennen.',
  'pd.learn.earlyHint': 'Mit jeder weiteren Bewertung wird die Muster-Erkennung präziser.',
  'pd.learn.calibratedHint': 'Leadscraper nimmt deine Muster jetzt aktiv ins Reasoning.',
  'pd.learn.matureMsg':
    'Profil vollständig kalibriert. Leadscraper behandelt deine Muster fast wie Regeln.',
  'pd.learn.topReasons': 'Häufigste Ablehnungsgründe',
  'pd.learn.topReasonsDesc1': 'Aus deinen ',
  'pd.learn.topReasonsDesc2':
    ' Ablehnungen. Leadscraper merkt sich diese Muster und drückt vergleichbare Kandidaten beim nächsten Lauf nach unten.',
  'pd.learn.recentTitle': 'Letzte Bewertungen',
  'pd.learn.narrativeShow': 'Brief an die KI anzeigen',
  'pd.learn.narrativeHide': 'Brief an die KI verbergen',
  'pd.learn.narrativeSub':
    'Genau dieser Text wird beim nächsten Lauf an Leadscraper\u2011KI weitergereicht, wortwörtlich.',
  'pd.time.justNow': 'gerade eben',
  'pd.time.minsAgo': 'vor {n} min',
  'pd.time.hoursAgo': 'vor {n} h',
  'pd.time.daysAgo': 'vor {n} Tagen',
  'pd.decisions.title': 'Leadscraper-Entscheidungen · letzter Lauf',
  'pd.decisions.checked': '{n} Kandidaten geprüft',
  'pd.decisions.checkedSg': '{n} Kandidat geprüft',
  'pd.decisions.delivered': '{n} geliefert',
  'pd.decisions.rejected': '{n} abgelehnt',
  'pd.decisions.showLess': 'Weniger zeigen',
  'pd.decisions.showAll': 'Alle abgelehnten anzeigen',
  'pd.decisions.more': '+ {n} weitere …',
  'pd.decisions.hint':
    'Siehst du hier ein Muster, das falsch ist? Formulier deine Query um. Leadscraper nimmt alle diese Entscheidungen als Lehrbeispiel für den nächsten Lauf mit, sobald du den Zielgruppen-Memory bestätigst.',
  'pd.empty.title': 'Noch keine Zielgruppe angelegt',
  'pd.empty.desc1': 'Eine Zielgruppe ist ',
  'pd.empty.descStrong': 'ein Lern-Container',
  'pd.empty.desc2':
    ': Leadscraper sammelt darin alle Learnings aus deinem Feedback. Lege deine erste Zielgruppe im Dashboard an. Danach findest du hier alle akkumulierten Muster, Annahmen, Ablehnungs-Gründe und Lauf-Historie.',
  'pd.empty.cta': 'Zum Dashboard',
  // V1.28.0 (Janik 2026-05-21): Schwellen 50 → 10 entsprechend Welle 4 Task #53.
  'pd.curve.lockLabel': 'ab 50 Bewertungen',
  'pd.curve.mockTitle': 'Trefferquote über die letzten 10 Bewertungen',
  'pd.curve.mockAxisEnd': '10 Bewertungen',
  'pd.curve.learningActive': 'Leadscraper lernt aktiv',
  'pd.curve.currentRate': 'aktuelle Trefferquote',
  'pd.curve.highPct':
    'Leadscraper trifft mit {n}% sehr scharf. Die Lernkurve zeichnet sich, sobald Verlaufs-Daten über die Zeit eintreffen. ',
  'pd.curve.highPctStrong': 'Alles im Plan.',
  'pd.curve.midPct':
    'Aus deinen {n} Bewertungen baut Leadscraper den Verlauf auf. Lernkurve wird mit jedem weiteren Run sichtbarer.',
  'pd.curve.lowPct':
    'Leadscraper sammelt aus deinen {n} Bewertungen den Verlauf. Mit mehr Daten wird die Trend-Linie scharf.',
  'pd.cortex.comingSoon': 'bald verfügbar',
  'pd.hex.industry': 'Branche',
  'pd.hex.location': 'Standort',
  'pd.hex.ownership': 'Eigentum',
  'pd.hex.bizModel': 'Biz-Modell',
  'pd.hex.role': 'Rolle',
  'pd.hex.size': 'Größe',
  'pd.company.cached': 'Profil aus Cache geladen.',
  'pd.company.analyzed': 'Leadscraper hat dein Unternehmen analysiert (Confidence {n}%).',
  'pd.company.error': 'Analyse fehlgeschlagen. Bitte nochmal probieren.',
  'pd.company.inputTitle': 'Trag deine eigene Website ein',
  'pd.company.inputDesc1':
    'Leadscraper liest deine Firmen-Seite und merkt sich was du verkaufst, an wen du verkaufst, und welche Argumente du nutzt. Bei jedem Lead schreibt Leadscraper dann ',
  'pd.company.inputDescStrong': 'deine maßgeschneiderte Pitch-Strategie',
  'pd.company.inputDesc2': ' statt nur "passt zur Branche".',
  'pd.company.placeholder': 'https://meine-firma.de',
  'pd.company.analyzing': 'Analysiert…',
  'pd.company.analyze': 'Analysieren',
  'pd.company.cancel': 'Abbrechen',
  'pd.company.techDetails': 'Technische Details',
  'pd.company.costHint':
    'Kosten ~$0.015 pro Analyse. Re-Analyse alle 30 Tage automatisch falls sich deine Seite ändert.',
  'pd.company.knownTitle': 'Was Leadscraper über dein Unternehmen weiß',
  'pd.company.confidence': '{n}% sicher',
  'pd.company.change': 'Ändern',
  'pd.company.sellLabel': 'Was du verkaufst',
  'pd.company.targetLabel': 'An wen',
  'pd.company.valueLabel': 'Warum Kunden dich wählen',
  'pd.company.analyzedAt': 'Analysiert am {date}',
  'pd.company.staleAt': 'Re-Analyse fällig {date}',
  'pd.company.reanalyzing': 'Re-Analyse…',
  'pd.company.reanalyze': 'Jetzt re-analysieren',
  'pd.target.title': 'Zielgruppe',
  'pd.target.sub': 'Was Leadscraper bei jeder Suche zugrunde legt.',
  'pd.target.industry': 'Branche',
  'pd.target.region': 'Region',
  'pd.target.size': 'Größe',
  'pd.target.contacts': 'Ansprechpartner',
  'pd.target.excluded': 'Ausgeschlossen',
  'pd.target.queries': 'Suchanfragen',
  'pd.target.leads': 'Leads',
  'pd.target.patterns': 'Muster',
  'pd.queries.title': 'Suchanfragen dieser Zielgruppe',
  'pd.queries.sub': 'Klick öffnet Details, Zeitplan und Verlauf der Suche.',
  'pd.queries.newSearch': 'Neue Suche starten',
  'pd.queries.emptyTitle': 'Noch keine Suche für diese Zielgruppe gestartet.',
  'pd.queries.emptySub': 'Sobald du eine Suche startest, taucht sie hier auf, inklusive Zeitplan.',
  'pd.queries.filterEmpty': 'Keine Queries in diesem Filter.',
  'pd.queries.showAll': 'Alle anzeigen',
  'pd.queries.unnamed': 'Unbenannte Suche',
  'pd.queries.overdue': 'überfällig',
  'pd.queries.inMinutes': 'in {n} Min.',
  'pd.queries.inHours': 'in {n} h',
  'pd.queries.tomorrow': 'morgen',
  'pd.queries.inDays': 'in {n} Tagen',
  'pd.queries.manual': 'Einmalig',
  'pd.queries.hourly': 'Stündlich',
  'pd.queries.everyH': 'Alle {n} h',
  'pd.queries.dailyLegacy': 'Täglich (legacy)',
  'pd.queries.weeklyLegacy': 'Wöchentlich (legacy)',
  'pd.queries.monthlyLegacy': 'Monatlich (legacy)',
  'pd.queries.leadsDelivered': '{n} Leads geliefert',
  'pd.queries.daysAgo': 'vor {n} Tagen gestartet',
  'pd.queries.paused': 'pausiert',

  // W21 Dossier — die Zielgruppen-Seite als selbst-schreibendes Dossier
  // (Claude-Design-Handover 03.07.2026). Fläche 1: Dossier-Karte.
  'dos.eyebrow': 'Deine Zielgruppe · von dir und Leadscraper geschrieben',
  'dos.maturity.coldStart': 'Lernt dich kennen',
  'dos.maturity.early': 'Frühes Bild',
  'dos.maturity.calibrated': 'Kalibriert',
  'dos.maturity.mature': 'Ausgereift',
  'dos.ratings': '{n} Bewertungen',
  'dos.matchRate': '{pct} % Trefferquote',
  'dos.weak': 'schwach',
  'dos.edit.cta': 'Zielgruppe bearbeiten',
  'dos.weave.youSearch': 'Du suchst',
  'dos.weave.vorgabeLabel': 'Deine Vorgabe · aus deinem Briefing',
  'dos.weave.withSize': 'mit {size} Mitarbeitern',
  'dos.weave.sizeValue': '{range} Mitarbeiter',
  'dos.weave.inRegion': 'in {region}',
  'dos.weave.contact': 'Ansprechpartner',
  'dos.weave.prefers': 'bevorzugt',
  'dos.weave.and': 'und',
  'dos.weave.weakHint': 'erster Hinweis:',
  'dos.legend.you': 'deine Vorgabe',
  'dos.legend.learned': 'gelernt, Zahl = Belege, klickbar',
  'dos.legend.weak': 'schwach (1–2 Belege)',
  'dos.emptyLearned':
    'Noch nichts gelernt. Bewerte unten deine ersten Leads, dann schreibt sich dieses Dossier von selbst weiter.',
  'dos.heartbeat.active': 'Lernt aktiv',
  'dos.heartbeat.waiting': 'Wartet auf deine ersten Bewertungen',
  'dos.heartbeat.since': 'seit {date}',
  'dos.heartbeat.next': 'nächste Analyse bei {n} Bewertungen',
  'dos.proof.title': 'Deine {n} angenommenen Firmen',
  'dos.proof.openAll': 'Alle im Board ansehen',
  'dos.error.learn': 'Die Lern-Daten sind gerade nicht erreichbar.',
  'dos.error.retry': 'Erneut laden',
  'dos.details.show': 'Alle {n} Muster im Detail ↓',
  'dos.details.hide': 'Details ausblenden',
  'dos.aside.patterns': 'Muster im Detail',
  'dos.kpi.title': 'Zielgruppe in Zahlen',
  'dos.kpi.match': 'Trefferquote',
  'dos.kpi.reachable': 'Erreichbar',
  'dos.kpi.reachableSub': '{n} von {m} Anfragen',
  'dos.kpi.reachableTeaser': 'Ab der ersten Kontakt-Anfrage',
  'dos.kpi.yield': 'Pro Suche',
  'dos.kpi.yieldSub': '{n} Suchen',
  'dos.kpi.matchTeaser': 'ab {p} Bewertungen',
  'dos.journey.eyebrow': 'So entsteht dein Dossier',
  'dos.journey.s1': 'Zielgruppe beschrieben',
  'dos.journey.s1Sub': 'Sauber erfasst. Leadscraper weiß, wonach es sucht.',
  'dos.journey.s2': 'Erste Leads erhalten',
  'dos.journey.s2Sub':
    'Starte deine erste Suche. In wenigen Minuten liegen die ersten Firmen hier.',
  'dos.journey.s2Done': '{n} Leads liegen bereit.',
  'dos.journey.s2Running': 'Deine Suche läuft. Die ersten Firmen treffen gleich hier ein.',
  'dos.journey.s2RunningBadge': 'Suche läuft · typisch 5–12 min',
  'dos.journey.s3': 'Bewerte die ersten {p} Leads',
  'dos.journey.s3Progress': '{n} von {p} Leads bewertet',
  'dos.journey.s3Sub':
    'Ab {p} Bewertungen schreibt Leadscraper hier seine erste Einschätzung. Ab {a} fließt dein Feedback in jede weitere Suche ein.',
  'dos.voice.preview':
    'Hier schreibt Leadscraper nach deinen ersten {p} Bewertungen seine Einschätzung deiner Zielgruppe.',
  'dos.voice.more': 'Weiterlesen',
  'dos.voice.less': 'Weniger anzeigen',
  'dos.analysis.pending':
    'Leadscraper analysiert deine {n} Bewertungen. Die erste Einschätzung deiner Zielgruppe erscheint hier in Kürze.',
  'dos.heartbeat.analysing': 'Analysiert deine Bewertungen …',
  // Dossier — Beleg-Popover
  'dos.popover.close': 'Schließen',
  'dos.popover.evidence': '{n} Belege',
  'dos.popover.weakChip': 'schwach · {n} Belege',
  'dos.popover.view': 'ansehen ↗',
  'dos.popover.noExamples':
    'Zu diesem Muster sind keine einzelnen Beleg-Leads gespeichert. Die Zahl zählt deine Bewertungen.',
  'dos.popover.weakNote': 'Erst {n} Belege, fließt noch vorsichtig in die Suche ein.',
  // Dossier — Fläche 2: Jetzt bewerten
  'dos.rate.eyebrow': 'Jetzt bewerten',
  'dos.rate.waiting': '{n} Leads warten auf dein Urteil',
  'dos.rate.waitingOne': '1 Lead wartet auf dein Urteil',
  'dos.rate.openBoard': 'Alle im Board öffnen →',
  'dos.rate.sub': 'Jede Bewertung schärft das Dossier, direkt hier, ohne die Seite zu verlassen.',
  'dos.rate.fits': 'Passt zu meiner Zielgruppe',
  'dos.rate.fitsNot': 'Passt nicht',
  'dos.rate.view': 'ansehen',
  'dos.rate.acceptedCheck': '✓ Angenommen',
  'dos.rate.learned': ', das Dossier hat gelernt:',
  'dos.rate.flowsIn': ', fließt in die nächste Analyse ein.',
  'dos.rate.undo': 'Rückgängig',
  'dos.rate.whyQuestion': 'Woran lag es? Ein Tipp genügt. Leadscraper lernt daraus.',
  'dos.rate.noReason': 'Ohne Grund fortfahren',
  'dos.rate.allDone': 'Alles bewertet. Neue Leads erscheinen hier, sobald eine Suche liefert.',
  'dos.rate.rejectedCheck': '✗ Aussortiert',
  'dos.rate.avoidedLearned': ', das Dossier meidet ab jetzt:',
  'dos.reason.industry': 'Falsche Branche',
  'dos.reason.tooBig': 'Zu groß',
  'dos.reason.tooSmall': 'Zu klein',
  'dos.reason.region': 'Falsche Region',
  'dos.reason.role': 'Falsche Rolle',
  'dos.reason.other': 'Anderes',
  // Dossier — Fläche 3: Nächste Suchen
  'dos.sug.eyebrow': 'Aus deinen Mustern abgeleitet',
  'dos.sug.title': 'Deine nächsten Suchen',
  'dos.sug.basis.expansion': 'Ausweitung',
  'dos.sug.basis.crossSell': 'Cross-Sell',
  'dos.sug.basis.zoomOut': 'Zoom-Out',
  'dos.sug.basis.patternHint': 'Muster-Hinweis',
  'dos.sug.basis.salesFit': 'Sales-Fit',
  'dos.sug.tier.veryStrong': 'sehr stark',
  'dos.sug.tier.strong': 'stark',
  'dos.sug.tier.solid': 'solide',
  'dos.sug.tier.hypothesis': 'schwach',
  'dos.sug.fitLabel': 'erwartete Passung',
  'dos.sug.start': 'Suche starten',
  'dos.sug.history': '{n} bisherige Suchen',
  'dos.sug.historyOne': '1 bisherige Suche',
  'dos.sug.showHistory': 'Verlauf ansehen →',

  // LearnedPatterns — Cluster labels & mockups
  'lp.cl.industry': 'Branche',
  'lp.cl.industry.mock': 'Bevorzugt Dienstleister-Sektor (M-N) gegenüber Industrie',
  'lp.cl.size': 'Unternehmensgröße',
  'lp.cl.size.mock': 'Tendenz zu kleineren Operators (10-50 MA)',
  'lp.cl.geo': 'Standort',
  'lp.cl.geo.mock': 'NRW + BaWü stark präferiert, Ostdeutschland eher nicht',
  'lp.cl.role': 'Ansprechpartner',
  'lp.cl.role.mock': 'Geschäftsführer-Level erwartet, Abteilungsleiter zu junior',
  'lp.cl.bizModel': 'Geschäftsmodell',
  'lp.cl.bizModel.mock': 'Operative Anbieter, keine Agenturen oder Vermittler',
  'lp.cl.ownership': 'Eigentümer',
  'lp.cl.ownership.mock': 'Familienunternehmen >> PE-Töchter und Konzerne',
  'lp.cl.buyingSignals': 'Buying-Signale',
  'lp.cl.buyingSignals.mock': 'Aktive Trigger-Events (Wachstum, Hiring) gesucht',
  'lp.cl.techStack': 'Tech-Stack',
  'lp.cl.techStack.mock': 'Bestimmte Technologien werden konsistent gesucht/gemieden',
  'lp.cl.age': 'Firmen-Alter',
  'lp.cl.age.mock': 'Etablierte Firmen mit Gründung vor 2010 bevorzugt',
  'lp.cl.domainBlock': 'Domain-Block',
  'lp.cl.domainBlock.mock': 'Konkurrenten-Domains werden konsistent ausgeschlossen',
  // LearnedPatterns — LockedThresholdPill
  'lp.locked.pill': 'ab {n} Bewertungen',
  // LearnedPatterns — Tone labels
  'lp.tone.drop': 'STARK DROP',
  'lp.tone.softDrop': 'LEICHT DROP',
  'lp.tone.softKeep': 'LEICHT KEEP',
  'lp.tone.keep': 'STARK KEEP',
  // LearnedPatterns — Loading / Error
  'lp.loading': 'Lade Lernstand…',
  'lp.error.load': 'Fehler beim Laden',
  // LearnedPatterns — LearningJourney
  'lp.journey.preview': 'Erstes anlernen',
  'lp.journey.active': 'Aktiv personalisiert',
  'lp.journey.title': '{n} Bewertungen: {accepted} passt · {rejected} passt nicht',
  'lp.journey.matched': 'passten',
  'lp.journey.notMatched': 'passten nicht',
  'lp.journey.matchRate': 'Trefferquote',
  // LearnedPatterns — Stage 0
  'lp.s0.eyebrow': 'Leadscraper lernt mit dir',
  'lp.s0.headline': 'Leadscraper baut deine Zielgruppe auf',
  'lp.s0.body':
    'Bei {preview} bewerteten Leads zeigen wir dir den ersten Eindruck. Bei {active} sucht Leadscraper aktiv für DICH, basierend auf deinen ganz konkreten Mustern.',
  'lp.s0.openOne': '{n} Lead noch unbewertet. Bewerte ihn, um schneller voranzukommen.',
  'lp.s0.openMany': '{n} Leads noch unbewertet. Bewerte sie, um schneller voranzukommen.',
  'lp.cta.count': '{n} Leads bewerten',
  'lp.cta.rate': 'Leads bewerten',
  'lp.cta.open': 'Leads öffnen',
  // LearnedPatterns — Stage 1
  'lp.s1.eyebrow': 'Erster Eindruck',
  'lp.s1.headline': 'Leadscraper sammelt noch Belege',
  'lp.s1.body':
    'Erste Tendenzen sind sichtbar. Bei {n} Bewertungen fließt das aktiv in deine Suchen ein.',
  'lp.s1.strongestLabel': 'Stärkste Tendenz bisher',
  'lp.s1.morePatterns': 'Weitere Muster, werden bei {n} Bewertungen sichtbar',
  // LearnedPatterns — Stage 2
  'lp.s2.pillActive': 'Aktiv personalisiert',
  'lp.s2.pillSharp': 'Zielgruppe sitzt scharf',
  'lp.s2.pillUpdating': 'Aktualisierung läuft',
  'lp.s2.headline': 'Leadscraper sucht für DICH',
  'lp.s2.reanalysisAgo': 'Letzte Re-Analyse: vor {n} Bewertungen · Nächste bei {next}',
  'lp.s2.reanalysisCurrent': 'Re-Analyse aktuell · Nächste bei {n}',
  'lp.s2.weakLabel': 'Schwache Tendenzen, werden mit mehr Daten härter',
  'lp.evidence.one': '{n} Beleg',
  'lp.evidence.many': '{n} Belege',
  'lp.s2.ignoredOne':
    '{n} Bewertung war "kennen wir schon" oder "falsche Daten". Diese fließen bewusst nicht ins Lernen ein.',
  'lp.s2.ignoredMany':
    '{n} Bewertungen waren "kennen wir schon" oder "falsche Daten". Diese fließen bewusst nicht ins Lernen ein.',
  // LearnedPatterns — ProfileSummaryGrid
  'lp.ps.industry.fallback': 'Branchen-offen (keine Eingrenzung)',
  'lp.ps.industry.analyseYes':
    'Leadscraper bestätigt diese Branche durch {n} angenommene Leads. Die Branchen-Eingrenzung sitzt.',
  'lp.ps.industry.analyseNo':
    'Leadscraper sucht systematisch nach Firmen die zu deiner Branchen-Beschreibung passen.',
  // V1.28.0 (Janik 2026-05-21): ehrliches Wording bei "any"-Profil — User
  // hat KEINE Branchen-Eingrenzung gesetzt, Cortex muss aus Bewertungen
  // ableiten welche Branche tatsächlich gewünscht ist.
  'lp.ps.industry.anyBranche':
    'Dein Profil ist branchen-offen. Cortex leitet die tatsächliche Tendenz aus deinen Bewertungen ab. Aktuell {n} angenommene Leads als Anker. Je mehr Bewertungen, desto schärfer wird die abgeleitete Branchen-Tendenz.',
  'lp.ps.size.contentHigh': 'Leadscraper trifft die Größenklasse präzise',
  'lp.ps.size.contentLow': 'Mittelstand-Tendenz aus den bestätigten Leads',
  'lp.ps.size.analyseHigh':
    'Mit {pct}% Trefferquote sieht Leadscraper dass deine Wunsch-Größenklasse stabil getroffen wird, kein Korrektur-Bedarf erkennbar.',
  'lp.ps.size.analyseLow':
    'Leadscraper passt die Mitarbeiter-Spannbreite mit jedem Reject feiner an deine Vorstellung an.',
  'lp.ps.geo.fallback': 'DACH-Raum',
  'lp.ps.geo.analyseYes':
    'Leadscraper hat {n} Firmen aus dieser Region als passend bestätigt. Der geografische Anker sitzt.',
  'lp.ps.geo.analyseNo':
    'Leadscraper priorisiert Treffer aus dieser Region und kuratiert Umkreis-Treffer wenn die Kern-Region dünn wird.',
  'lp.ps.role.fallback': 'Geschäftsführungs-Ebene',
  'lp.ps.role.analyseHigh':
    'Leadscraper schreibt im Reasoning aktiv nach dieser Rolle. Impressum + Karriere-Seiten + LinkedIn werden gezielt darauf gefiltert.',
  'lp.ps.role.analyseLow':
    'Leadscraper sucht im Impressum + auf Karriere-Seiten gezielt nach diesen Rollen, fällt nur auf Geschäftsführer zurück wenn die spezielle Rolle nicht ausgeschrieben ist.',
  'lp.ps.bizModel.content': 'Operative Anbieter (keine reinen Vermittler)',
  'lp.ps.bizModel.analyse':
    'Leadscraper hat den Standard-Filter aktiv. Agenturen, Distributoren und Marketplaces werden im Reasoning automatisch deprioritisiert wenn sie nicht zur Anfrage passen.',
  'lp.ps.ownership.label': 'Eigentümer-Struktur',
  'lp.ps.ownership.contentHigh': 'Inhaber-/Mittelstand-Profil bestätigt',
  'lp.ps.ownership.contentLow': 'Mix aus Inhaber- und kleineren Konzern-Strukturen',
  'lp.ps.ownership.analyseHigh':
    'Leadscraper erkennt aus den bestätigten Leads dass dein Schwerpunkt auf eigentümergeführten Firmen liegt. Konzern-Töchter werden zurückhaltender vorgeschlagen.',
  'lp.ps.ownership.analyseLow':
    'Bewerte konkret eine Konzern-Tochter mit "passt nicht" damit Leadscraper hier ein hartes Eigentümer-Cluster bilden kann.',
  'lp.ps.titleHigh': 'Leadscraper versteht deine Zielgruppe, {pct}% Trefferquote',
  'lp.ps.titleDefault': 'Was Leadscraper aus deinen Bewertungen versteht',
  'lp.ps.bodyHigh':
    'Bei nur {rejected} {rejectWord} kann Leadscraper keine harten Ausschluss-Cluster bilden. Diese Karten zeigen was Leadscraper aus deinem Profil + den {accepted} bestätigten Leads konkret **analysiert** hat. Sobald du gezielter ablehnst, reifen die Cluster zu harten Filtern.',
  'lp.ps.bodyDefault':
    'Diese Karten zeigen was Leadscraper aus deinem Profil + den bestätigten Leads konkret **analysiert** hat. Bewerte gezielter mit Grund damit die Cluster sich verschärfen.',
  'lp.ps.rejectionOne': 'Ablehnung',
  'lp.ps.rejectionMany': 'Ablehnungen',
  'lp.ps.understands': 'Leadscraper versteht',
  // LearnedPatterns — Footer explainer
  'lp.ps.footerTitle': 'Wie das in deine nächsten Suchen einfließt',
  'lp.ps.footerBody':
    'Ab **10 Bewertungen** berücksichtigt Leadscraper bei jeder neuen Suche nicht nur deine Eingabe und das was deine Firma verkauft, sondern auch dein **gelerntes Profil als Tendenz**: Branche, Größenklasse, Standort, Rolle, Eigentümer-Struktur. Nicht als harter Filter, sondern als zusätzliche Gewichtung im Reasoning. Das heißt eine neue Query nach „Steuerberater Hamburg" sucht nicht generisch alle Stb-Kanzleien, sondern bevorzugt automatisch Inhaber-geführte Mittelstands-Kanzleien, analog zu dem Profil-Bild das du hier aufgebaut hast.',
  // LearnedPatterns — CardContent
  'lp.card.hideExamples': 'Beispiele ausblenden',
  'lp.card.showExamplesOne': '{n} Beispiel-Lead anzeigen',
  'lp.card.showExamplesMany': '{n} Beispiel-Leads anzeigen',
  'lp.card.examplesHint': '(Lead-IDs aus deiner Bewertungs-Historie für dieses Cluster)',
  // LearnedPatterns — SuggestedQueries badges
  'lp.sq.badge.expansion': 'Ausweitung',
  'lp.sq.badge.crossSell': 'Cross-Sell',
  'lp.sq.badge.zoomOut': 'Zoom-out',
  'lp.sq.badge.pattern': 'Pattern',
  'lp.sq.badge.salesFit': 'Sales-Fit',
  // LearnedPatterns — SuggestedQueries match tiers
  'lp.sq.tier.veryStrong': 'Sehr stark',
  'lp.sq.tier.strong': 'Stark',
  'lp.sq.tier.solid': 'Solide',
  'lp.sq.tier.hypothesis': 'Test-Hypothese',
  // LearnedPatterns — SuggestedQueries UI
  'lp.sq.launch': 'Suche starten',
  'lp.sq.eyebrow': 'Optimierte Suchanfragen',
  'lp.sq.lockedTitle': 'Leadscraper bereitet konkrete Vorschläge vor',
  'lp.sq.lockedBody':
    'Sobald du {n} Leads bewertet hast, schlägt Leadscraper 3–5 Suchanfragen vor, strukturiert wie deine Eingaben, mit Match-Wahrscheinlichkeit und kurzer Begründung.',
  'lp.sq.mockA.type': 'Mittelständische Maschinenbauer',
  'lp.sq.mockA.region': 'Bayern',
  'lp.sq.mockA.contact': 'Geschäftsführung',
  'lp.sq.mockA.rationale': 'Beispiel-Vorschlag wie Leadscraper Suchen vorschlägt.',
  'lp.sq.mockB.type': 'TGA-Planer Krankenhaus-Sektor',
  'lp.sq.mockB.region': 'DACH',
  'lp.sq.mockB.rationale': 'Beispiel-Vorschlag wie Leadscraper Suchen vorschlägt.',
  'lp.sq.loading': 'Leadscraper rechnet Vorschläge…',
  'lp.sq.emptyBody':
    'Vorschläge werden mit deiner nächsten Pattern-Re-Analyse berechnet (alle {n} Bewertungen).',
  'lp.sq.activeTitle': 'Leadscraper schlägt diese Suchen vor',
  'lp.sq.activeSubS1':
    'Auf Basis deiner ersten {n} Bewertungen, werden mit jedem Re-Analyse-Schritt schärfer.',
  'lp.sq.activeSubS2':
    'Aktualisiert nach {n} Bewertungen · Re-Analyse alle {interval} Bewertungen.',
  // MemoryStatus — Stage tones
  'ms.stage0.eyebrow': 'Lernt mit dir',
  'ms.stage1.eyebrow': 'Erster Eindruck',
  'ms.stage2.eyebrow': 'Aktiv personalisiert',
  // MemoryStatus — Status messages
  'ms.msg.s2active': 'Aktiv personalisiert · {n} Bewertungen',
  'ms.msg.s2reanalysis': 'Wird gerade neu analysiert · {n}',
  'ms.msg.s1': 'Erster Eindruck · {n}/{threshold} bis aktiv',
  'ms.msg.s0': 'Lernt mit dir · {n}/{threshold} bis Vorgeschau',
  'ms.error': 'Fehler',
  // MemoryStatus — Card
  'ms.card.label': 'Leadscraper-Status',
  'ms.card.s2active': '{n} Bewertungen · aktiv im Reasoning',
  'ms.card.s2reanalysis': '{n} Bewertungen · wird neu analysiert',
  'ms.card.ratings': '{n} / {threshold} Bewertungen',
  // MemoryStatus — Cluster verbalize
  'ms.cv.industry': 'Branche: {rule}',
  'ms.cv.size': 'Größe: {rule}',
  'ms.cv.geo': 'Region: {rule}',
  'ms.cv.role': 'Ansprechpartner: {rule}',
  'ms.cv.bizModel': 'Geschäftsmodell: {rule}',
  'ms.cv.ownership': 'Eigentum: {rule}',
  'ms.cv.buyingSignals': 'Buying-Signale: {rule}',
  'ms.cv.techStack': 'Tech-Stack: {rule}',
  'ms.cv.age': 'Firmen-Alter: {rule}',
  'ms.cv.domainBlock': 'Ausschluss: {rule}',
  // MemoryStatus — ProfileFeedbackDonutCard
  'ms.donut.title': 'Bewertungs-Stand',
  'ms.donut.ratings': 'Bewertungen',
  'ms.donut.match': 'passt',
  'ms.donut.noMatch': 'passt nicht',
  'ms.donut.matchRate': 'Trefferquote',
  // MemoryStatus — CortexAudienceCard Stage 0
  'ms.aud.lockedPill': 'ab {n} Bewertungen',
  'ms.aud.lockedEyebrow': 'Zielgruppe in Leadscraper-Worten',
  'ms.aud.lockedMock':
    'Du suchst kleinere Operators in NRW mit aktivem Hiring, GF-Level Kontakte, familiengeführt mit klarer Branche-Tendenz Maschinenbau.',
  // MemoryStatus — CortexAudienceCard computing
  'ms.aud.computingEyebrow': 'Leadscraper analysiert deine Bewertungen',
  'ms.aud.computingTitle': 'Mustererkennung läuft …',
  'ms.aud.computingBody':
    'In ein paar Sekunden beschreibt Leadscraper hier deine Zielgruppe in eigenen Worten.',
  // MemoryStatus — CortexAudienceCard recomputing
  'ms.aud.recomputeEyebrow': 'Leadscraper aktualisiert deine Einschätzung',
  'ms.aud.recomputeTitle':
    'Mit deinen letzten Bewertungen wird die Einschätzung neu durchgerechnet …',
  // MemoryStatus — CortexAudienceCard fallback
  'ms.aud.fallbackEyebrow': 'Erste Einschätzung von Leadscraper',
  'ms.aud.fallbackTitle':
    'Leadscraper aktualisiert die Einschätzung gerade mit deinen letzten {n} Bewertungen.',
  'ms.aud.fallbackBody':
    'Sobald die Re-Analyse durch ist (in wenigen Sekunden), erscheint hier eine konkrete Beschreibung deiner Zielgruppe.',
  // MemoryStatus — CortexAudienceCard main
  'ms.aud.eyebrowS2': 'Aktuelle Einschätzung von Leadscraper',
  'ms.aud.eyebrowS1': 'Erste Einschätzung von Leadscraper',
  'ms.aud.learnedLabel': 'Konkret gelernt',
  'ms.aud.trainS2':
    'Trainiere Leadscraper weiter. **jede Bewertung schärft die Suchen**, die ab jetzt automatisch für dich laufen.',
  'ms.aud.trainS1':
    'Trainiere den Scraper weiter und du wirst **richtig starke Ergebnisse** erhalten. Jede Bewertung macht Leadscraper präziser.',
  'ms.aud.derivedFrom': 'Aus deinen {n} Bewertungen abgeleitet',
  'ms.aud.nextReanalysis': ' · Nächste Re-Analyse bei {n}',

  // ScheduleCard
  'schedCard.freq.hourly': 'Stündlich',
  'schedCard.freq.everyMinute': 'Jede Minute (Test)',
  'schedCard.minuteTestHint':
    'Test-Modus, feuert ~jede Minute, sobald der Scheduler-Tick läuft. Nur Staging.',
  'schedCard.freq.every': 'Alle {n} Stunden',
  'schedCard.freq.hourlyShort': 'jede Stunde',
  'schedCard.freq.everyShort': 'alle {n} h',
  'schedCard.nextRun.overdue': 'überfällig',
  'schedCard.nextRun.min': 'in {n} Min.',
  'schedCard.nextRun.hours': 'in {n} h',
  'schedCard.nextRun.tomorrow': 'morgen',
  'schedCard.nextRun.days': 'in {n} Tagen',
  'schedCard.repeat': 'Diese Suche wiederholen',
  'schedCard.nextLabel': 'nächster Lauf {when}',
  'schedCard.onBody': 'Läuft im Hintergrund. Neue Treffer landen automatisch in deiner Lead-Liste.',
  'schedCard.offBody': 'Einmalig. Du startest selbst, wann du willst.',
  'schedCard.saving': 'Speichere…',
  'schedCard.save': 'Speichern',
  'schedCard.savedToast': 'Zeitplan gespeichert.',
  'schedCard.errorToast': 'Speichern fehlgeschlagen: {err}',
  'schedCard.leadsPerDay': '~{n} Leads / Tag',
  'schedCard.creditsHint':
    'max. {n} Credits / Tag. Sobald keine neuen Leads mehr in deiner Zielgruppe gefunden werden, läuft Leadscraper ohne Verbrauch leer.',
  'schedCard.perWeek': '≈ {n} / Woche',
  'schedCard.noRepeat': 'Keine Wiederholung',

  // RunsTimeline
  'runs.loadError': 'Fehler beim Laden',
  'runs.loadFailed': 'Konnte Verlauf nicht laden: {err}',
  'runs.loading': 'Lade Verlauf…',
  'runs.empty': 'Noch keine Läufe für diese Suche.',
  'runs.running': 'läuft jetzt',
  'runs.failed': 'fehlgeschlagen',
  'runs.unfeasible': 'nicht erfüllbar',
  'runs.noHits': 'keine Treffer',
  'runs.delivered': '{n} Leads geliefert',
  'runs.deliveredOne': '1 Lead geliefert',
  'runs.evaluated': '{n} bewertet',
  'runs.last': 'letzter',
  'runs.harvested.title': 'Zielgruppe vorerst abgegrast',
  'runs.harvested.body':
    'Frühere Suchläufe haben bereits {n} passende Firmen geliefert. Die bekannten Treffer kennt Leadscraper schon. Neue Treffer entstehen, wenn neue Firmen in deiner Zielgruppe online sichtbar werden. Der Schedule pickt sie automatisch auf.',

  // --- NACE full labels (LEA-267 Phase 2) ---
  'nace.A': 'Land- und Forstwirtschaft, Fischerei',
  'nace.B': 'Bergbau und Gewinnung von Steinen und Erden',
  'nace.C': 'Verarbeitendes Gewerbe',
  'nace.D': 'Energieversorgung',
  'nace.E': 'Wasserversorgung; Abwasser- und Abfallentsorgung',
  'nace.F': 'Baugewerbe',
  'nace.G': 'Handel; Instandhaltung und Reparatur von Kraftfahrzeugen',
  'nace.H': 'Verkehr und Lagerei',
  'nace.I': 'Gastgewerbe',
  'nace.J': 'Information und Kommunikation',
  'nace.K': 'Erbringung von Finanz- und Versicherungsdienstleistungen',
  'nace.L': 'Grundstücks- und Wohnungswesen',
  'nace.M': 'Erbringung von freiberuflichen, wissenschaftlichen und technischen Dienstleistungen',
  'nace.N': 'Erbringung von sonstigen wirtschaftlichen Dienstleistungen',
  'nace.O': 'Öffentliche Verwaltung, Verteidigung; Sozialversicherung',
  'nace.P': 'Erziehung und Unterricht',
  'nace.Q': 'Gesundheits- und Sozialwesen',
  'nace.R': 'Kunst, Unterhaltung und Erholung',
  'nace.S': 'Erbringung von sonstigen Dienstleistungen',
  'nace.T': 'Private Haushalte',
  'nace.U': 'Exterritoriale Organisationen und Körperschaften',

  // --- NACE short labels ---
  'naceShort.A': 'Land/Forst',
  'naceShort.B': 'Bergbau',
  'naceShort.C': 'Verarbeit. Gewerbe',
  'naceShort.D': 'Energie',
  'naceShort.E': 'Wasser/Abfall',
  'naceShort.F': 'Bau',
  'naceShort.G': 'Handel',
  'naceShort.H': 'Verkehr/Lagerei',
  'naceShort.I': 'Gastgewerbe',
  'naceShort.J': 'IT/Medien',
  'naceShort.K': 'Finanz/Versich.',
  'naceShort.L': 'Immobilien',
  'naceShort.M': 'Freiberuflich',
  'naceShort.N': 'Sonst. Dienstl.',
  'naceShort.O': 'Öff. Verwaltung',
  'naceShort.P': 'Bildung',
  'naceShort.Q': 'Gesundheit',
  'naceShort.R': 'Kunst/Unterh.',
  'naceShort.S': 'Sonst. Dienstl.',
  'naceShort.T': 'Priv. Haushalte',
  'naceShort.U': 'Exterritorial',

  // --- Reject reasons ---
  'reject.wrongIndustry': 'Falsche Branche',
  'reject.wrongIndustry.hint': 'Leadscraper hat das Geschäftsfeld falsch erkannt',
  'reject.wrongSize': 'Falsche Unternehmensgröße',
  'reject.wrongSize.hint': 'Zu klein, zu groß oder Konzern statt Mittelstand',
  'reject.wrongRegion': 'Falscher Standort',
  'reject.wrongRegion.hint': 'Sitz / Bundesland passt nicht zur Suche',
  'reject.wrongRole': 'Falscher Ansprechpartner',
  'reject.wrongRole.hint': 'Person oder Rolle ist nicht der Entscheider',
  'reject.notOperator': 'Kein Operator',
  'reject.notOperator.hint': 'Agentur, Vermittler oder Bauträger statt operativer Anbieter',
  'reject.wrongOwnership': 'Falsche Eigentümer-Struktur',
  'reject.wrongOwnership.hint':
    'Konzern-Tochter statt Familienunternehmen, falsche Rechtsform o.ä.',
  'reject.noBuyingSignal': 'Kein erkennbarer Bedarf',
  'reject.noBuyingSignal.hint': 'Keine Trigger-Events, keine offenen Stellen, kein Wachstumssignal',
  'reject.alreadyKnown': 'Kennen wir schon',
  'reject.alreadyKnown.hint':
    'Bereits im CRM oder schon kontaktiert, kein Lern-Signal und zählt nicht gegen deine Trefferquote.',
  'reject.badData': 'Falsche Daten',
  'reject.badData.hint': 'Adresse, Name oder Kontaktinfo stimmt nicht',
  'reject.other': 'Anderer Grund',
  'reject.other.hint': 'Schreib unten kurz warum (Freitext)',

  // --- Scheduling relative time ---
  'sched.rel.overdue': 'überfällig',
  'sched.rel.soon': 'bald',
  'sched.rel.tomorrow': 'morgen',
  'sched.rel.inDays': 'in {n} Tagen',

  // --- AI assistant tags ---
  'ai.tag.confirmed': 'bestätigt',
  'ai.tag.uncertain': 'unsicher',
  'ai.tag.unconfirmed': 'unbestätigt',

  // --- Nav ---
  'nav.onboardingRequired': 'Bitte schließ erst die 3 Onboarding-Schritte ab.',

  // --- Common month names ---
  'common.month.jan': 'Januar',
  'common.month.feb': 'Februar',
  'common.month.mar': 'März',
  'common.month.apr': 'April',
  'common.month.may': 'Mai',
  'common.month.jun': 'Juni',
  'common.month.jul': 'Juli',
  'common.month.aug': 'August',
  'common.month.sep': 'September',
  'common.month.oct': 'Oktober',
  'common.month.nov': 'November',
  'common.month.dec': 'Dezember',

  // --- Account billing extras ---
  'acct.bill.methodOnFile': 'Zahlungsmethode hinterlegt',
  'acct.bill.manageViaStripe': 'Verwaltung über Stripe Customer Portal',

  // --- Onboarding (Dashboard) ---
  'onb.step1Done': 'Leadscraper kennt jetzt dein Angebot, siehe Analyse unten',
  'onb.step1Pending':
    'Erzähl Leadscraper kurz von dir. Ein Blick auf deine Website reicht, damit er versteht was du verkaufst',
  'onb.step2Title': 'Erste Zielgruppe anlegen',
  'onb.step2Desc':
    "Beschreibe deine Wunsch-Kunden in 1-2 Sätzen: z.B. 'Steuerberater in NRW, 3-15 Mitarbeiter, Geschäftsführer'. Daraus baut Leadscraper deine Suchabfragen, lernt mit jedem Feedback dazu, und das Profil wird über Wochen schärfer.",
  'onb.step3Done': 'Erster Suchlauf läuft. Leadscraper liefert dir gleich die ersten 10 Leads',
  'onb.step3Pending':
    'Suchlauf für deine Zielgruppe. Leadscraper liefert 10 maßgeschneiderte Leads',
  // G64 (Janik 2026-06-02): Onboarding-Hero war hardcoded DE — jetzt i18n.
  'onb.heroTitle': 'Dein unfairer Wettbewerbsvorteil startet hier',
  'onb.heroDesc':
    'In 3 Schritten zu deinen ersten 10 Leads. Leadscraper lernt dich richtig kennen und liefert dir endlich Leads, die wirklich zu dir passen.',
  'onb.helpCardTitle': 'Neu bei Leadscraper?',
  'onb.helpCardDesc':
    'Unser Schnellstart-Guide bringt dich in wenigen Minuten von Konto und E-Mail bis zur ersten Zielgruppe.',
  'onb.helpCardCta': 'Erste Schritte lesen',
  'onb.helpCardDismissAria': 'Hinweis ausblenden',
  'onb.stepLabel': 'Schritt {n}',
  'onb.b2cLead': 'Leadscraper findet nur Unternehmen, keine Privatkunden.',
  'onb.b2cBody':
    'Deine Website-Analyse hat ergeben dass du an Endkunden verkaufst. Die Vorschläge unten zielen daher auf B2B-Multiplikatoren (z.B. Bauträger, Hausverwaltungen) statt der Privatkunden direkt. Wenn du keinen passenden B2B-Layer hast, ist Leadscraper für dein Geschäft eher nicht das richtige Tool.',
  'onb.step2LabelDone': 'Erste Zielgruppe steht. Leadscraper hat sie gespeichert',
  'onb.step2LabelPending': 'Definiere deine erste Zielgruppe. Wen genau willst du als Kunden?',
  'onb.step2Cta': 'Zielgruppe anlegen',
  'onb.step2Badge': 'Jetzt anlegen',
  'onb.step2Locked': 'Wartet auf Schritt 1',
  'onb.step3Title': 'Erster Suchlauf',
  'onb.step3DescFull':
    'Sobald dein erstes Profil steht, startest du hier den Suchlauf direkt darauf. Leadscraper findet 10 Leads in 30-90 Sekunden, exakt zu der Zielgruppe, die du gerade angelegt hast.',
  'onb.step3Cta': 'Suchlauf starten',
  'onb.step3Badge': 'Jetzt starten',
  'onb.step3Locked': 'Wartet auf Schritt 2',

  // --- API error messages (LEA-267 Phase 2) ---
  'error.demo_read_only': 'In der Demo-Ansicht ist das ausgeschaltet. Hier wird nichts geändert.',
  'error.impersonate_target_not_found':
    'Test-Account nicht gefunden. Die UID existiert nicht in dieser DB-Env (Mini / Staging / Production).',
  'error.unauthenticated':
    'Du bist nicht angemeldet. Bitte lade die Seite neu und melde dich erneut an.',
  'error.account_deleted': 'Dieser Account wurde gelöscht.',
  'error.email_unverified':
    'Bitte verifiziere zuerst deine E-Mail-Adresse (Link in der Anmelde-Mail).',

  // --- Confidence labels ---
  'api.confidence.uncertain': 'unsicher',
  'api.confidence.very_sure': 'sehr sicher',
  'api.confidence.fairly_sure': 'eingeschränkt sicher',
  'api.confidence.cautiously_optimistic': 'vorsichtig optimistisch',

  // --- Run guidance ---
  'run.failed.title': 'Leadscraper ist hängen geblieben',
  'run.failed.body':
    'Technischer Aussetzer beim letzten Suchlauf. Warte 1–2 Minuten und probier es nochmal. Wenn es wieder hängt, sag uns Bescheid.',
  'run.partial_yield.title': '{delivered}/{total} Leads geliefert',
  'run.partial_yield.body':
    'Leadscraper hat weniger als 10 Treffer gefunden. Für mehr Volumen: Beschreibung lockerer formulieren oder breitere Region.',
  'run.no_results.title': 'Zu deiner Query fanden sich keine Treffer im Web',
  'run.no_results.body':
    'Deine Keywords liefern auf Google keine passenden deutschen B2B-Firmen. Versuche alltäglichere Begriffe: z.B. „Schreinerei" statt „Möbelmanufaktur", oder erweitere die Region.',
  'run.too_strict.title': '{reasoned} Kandidaten geprüft. Keiner passte zu deiner Zielgruppe',
  'run.too_strict.body':
    'Leadscraper fand Firmen, aber keine davon matcht deine Zielgruppe sauber. Vielleicht ist deine Beschreibung zu eng. Nimm z.B. eine größere Region, lockere die Mitarbeiterzahl oder lass Details raus.',
  'run.no_leads_delivered': 'Keine passenden Leads geliefert',
  'run.cta.retry': 'Nochmal versuchen',
  'run.cta.edit_query': 'Query anpassen',
  'run.cta.broaden_query': 'Query breiter formulieren',

  // --- App-level toasts + errors (LEA-267 Phase 2) ---
  'error.invalidInput': 'Eingabe ungültig.',
  'error.noProfile': 'Keine Zielgruppe ausgewählt.',
  'error.profileNotRegistered':
    'Zielgruppe noch nicht im Backend registriert. Ich öffne dir den Wizard.',
  'run.complete': 'Suchlauf fertig, {count} Leads geliefert.',
  'run.completeEmpty':
    'Suchlauf fertig, keine passenden Firmen gefunden. Präzisiere deine Zielgruppe oder versuche eine andere Region.',
  'run.searching': 'Leadscraper sucht für dich…',
  'run.startFailed': 'Der Suchlauf konnte nicht gestartet werden. Bitte versuch es erneut.',
  'billing.trialStarted': 'Willkommen im {plan}-Abo. Testphase läuft.',
  'billing.downgradeScheduled':
    'Tarifwechsel geplant: Du wechselst am {date} zu {plan}. Deine Credits bleiben erhalten.',
  'billing.downgradeAlready': 'Der Wechsel zu {plan} ist bereits zum {date} geplant.',

  // --- Billing return page (LEA-267 Phase 2) ---
  'bill.ret.docTitleSuccess': 'Zahlung erfolgreich · Leadscraper',
  'bill.ret.docTitleCancel': 'Vorgang abgebrochen · Leadscraper',
  'bill.ret.verifying': 'Zahlung wird verarbeitet …',
  'bill.ret.verifyingSub': 'Wir aktualisieren dein Konto. Das dauert nur einen Moment.',
  'bill.ret.successTitle': 'Zahlung erfolgreich',
  'bill.ret.successBodySub': 'Dein Abo ist aktiv. Du hast jetzt Zugriff auf deine Leads.',
  'bill.ret.successBodyCredits': 'Deine Credits wurden gutgeschrieben.',
  'bill.ret.rowPlan': 'Plan',
  'bill.ret.rowCredits': 'Credits',
  'bill.ret.rowCreditsAvail': '{n} verfügbar',
  'bill.ret.rowNextRenewal': 'Nächste Abrechnung',
  'bill.ret.cta': 'Zum Dashboard',
  'bill.ret.cancelTitle': 'Vorgang abgebrochen',
  'bill.ret.cancelBody':
    'Es wurde nichts abgebucht. Du kannst den Bezahlvorgang jederzeit erneut starten.',
  'bill.ret.cancelCta': 'Zurück zum Dashboard',
  'bill.ret.errorTitle': 'Status nicht abrufbar',
  'bill.ret.errorBody':
    'Deine Zahlung ist möglicherweise erfolgreich. Wir konnten den Status gerade nicht laden. Bitte schau in deinem Konto unter „Abrechnung" nach.',
  // --- 18f: Prism-Seed-Ankunft nach dem Kauf (ehrliche Zustands-Copy) ---
  'bill.ret.seedWorkingZero':
    'Deine Leads werden gerade angelegt. Die Recherche der Ansprechpartner dauert 10 bis 30 Minuten. Exportiere am besten erst, wenn alle da sind.',
  'bill.ret.seedWorkingCreated':
    'Deine {created} Leads sind angelegt. Die Recherche der Ansprechpartner dauert 10 bis 30 Minuten. Exportiere am besten erst, wenn alle da sind.',
  'bill.ret.seedWorking':
    '{delivered} von {total} Leads sind fertig, der Rest wird gerade angereichert. Insgesamt dauert das 10 bis 30 Minuten.',
  'bill.ret.seedDone': 'Alle {delivered} Leads sind da. Leg los.',
  'bill.ret.seedPartial':
    '{delivered} Leads sind da. Der Rest deines Guthabens bleibt dir für eigene Suchen.',
  'bill.ret.seedCta': 'Zu meinen Leads',

  // --- Boot + billing error modals ---
  'boot.connectionError': 'Verbindungsfehler',
  'boot.connectionErrorDesc': 'Konnte keine Verbindung zum Server herstellen: {msg}',
  'boot.retry': 'Erneut versuchen',
  'boot.reconnecting': 'Verbindung wird wiederhergestellt … (Versuch {n})',
  'billing.disabled': 'Bezahlungen sind aktuell nicht verfügbar. Bitte versuche es später erneut.',
  // LEA-546: der Tarifwechsel wurde serverseitig abgelehnt, weil das Abo
  // gerade nicht änderbar ist (Kündigung vorgemerkt bzw. Zahlung offen).
  'billing.reactivateFirst':
    'Dein Abo ist zur Kündigung vorgemerkt. Reaktiviere es zuerst, dann kannst du den Tarif wechseln.',
  'billing.manageInPortal':
    'Dieses Abo lässt sich gerade nicht wechseln. Öffne das Rechnungsportal, um die Zahlung zu klären.',
  'billing.unknownError': 'Unbekannter Fehler beim Bezahlvorgang.',
  'billing.alreadySubscribed': 'Dieses Abo hast du schon. Deinen aktuellen Tarif siehst du unter Abrechnung.',
  'billing.portalNoCustomer': 'Subscription-Verwaltung ist erst nach dem ersten Kauf verfügbar.',
  'billing.errorTitle': 'Etwas ist schiefgelaufen',
  'billing.errorClose': 'Schließen',
  'billing.errorRetry': 'Erneut versuchen',
  'billing.transientError': 'Vorübergehend nicht erreichbar. Bitte versuche es gleich noch einmal.',

  // ─── Transactional email — shared strings ────────────────────────────────
  // LEA-295: extracted from packages/email-templates/src/templates/*.de.html.
  // Values containing {{var}} mustache placeholders are resolved by
  // packages/email-templates/src/index.ts:interpolate() at render time.
  // Values containing inline HTML (<br>, &middot;) are treated as trusted
  // markup — the templates own them.
  'email.shared.brand.name': 'Leadscraper',
  'email.shared.founder.name': 'Janik Deimann',
  'email.shared.founder.title': 'Gründer, Leadscraper',
  'email.shared.reply_note': 'Fragen? Antworte einfach auf diese Mail.',
  'email.sepa-payment-failed.subject': 'Deine SEPA-Zahlung ist fehlgeschlagen',
  'email.sepa-payment-failed.preheader': 'Die Lastschrift über {{amount_formatted}} kam zurück.',
  'email.sepa-payment-failed.badge': 'Zahlung fehlgeschlagen',
  'email.sepa-payment-failed.hero': 'Deine Lastschrift<br>kam zurück.',
  'email.sepa-payment-failed.greeting': 'Hallo {{first_name}},',
  'email.sepa-payment-failed.intro':
    'die SEPA-Lastschrift für dein Credit-Paket ist bei deiner Bank nicht durchgegangen.',
  'email.sepa-payment-failed.credits_line':
    'Deshalb haben wir {{credits_revoked}} Credits wieder von deinem Account abgezogen.',
  'email.sepa-payment-failed.retry_line':
    'Wenn du die Credits brauchst, kannst du das Paket in deinem Account einfach noch mal kaufen.',
  'email.sepa-payment-failed.button': 'Zu Leadscraper',
  'email.sepa-payment-failed.detail.pack_label': 'Paket',
  'email.sepa-payment-failed.detail.amount_label': 'Betrag',
  'email.shared.footer.transactional':
    'Du erhältst diese E-Mail, weil du dich für einen Leadscraper-Account registriert hast. Diese transaktionale Nachricht ist Bestandteil des Vertragsverhältnisses und kann nicht abbestellt werden.',
  'email.shared.footer.legal':
    'Deimann Com GmbH &middot; Randstraße 75 &middot; 22525 Hamburg &middot; Deutschland<br />Geschäftsführer: Janik Deimann &middot; HRB 164162 (AG Hamburg) &middot; USt-IdNr. DE332747716 &middot; © {{year}}',

  // ─── Transactional email — welcome (LEA-259 design) ──────────────────────
  'email.welcome.subject': 'Willkommen bei Leadscraper, {{first_name}} 👋',
  'email.welcome.title': 'Willkommen bei Leadscraper',
  'email.welcome.preheader': 'Willkommen an Bord, deine ersten Leads in 5 Minuten.',
  'email.welcome.badge': 'Account startklar',
  'email.welcome.hero': 'Schön dass du da bist,<br>{{first_name}}.',
  'email.welcome.subhead':
    "Dein Account wurde erstellt und du hast deine ersten Credits, los geht's.",
  'email.welcome.steps.title': 'So startest du in 5 Schritten',
  'email.welcome.steps.1.title': 'Hinterlege deine Website',
  'email.welcome.steps.1.body':
    'Damit der Agent versteht, in welche Richtung dein Geschäft geht, und worauf er achten soll.',
  'email.welcome.steps.2.title': 'Lege deine Zielgruppe an',
  'email.welcome.steps.2.body':
    'Branche, Region, Firmengröße, Job-Titel. Je präziser, desto besser die Treffer.',
  'email.welcome.steps.3.title': 'Starte deine erste Lead-Anfrage',
  'email.welcome.steps.3.body':
    'Der Agent recherchiert, reichert an und liefert die ersten Firmen direkt ins Dashboard.',
  'email.welcome.steps.4.title': 'Bewerte die Leads',
  'email.welcome.steps.4.body':
    'Daumen hoch oder runter. Der Agent lernt aus jedem Feedback, was für dich passt.',
  'email.welcome.steps.5.title': 'Starte die nächste Anfrage',
  'email.welcome.steps.5.body':
    'Mit jedem Durchlauf werden die Ergebnisse spürbar schärfer, bis sie zu 100 % zu dir passen.',
  'email.welcome.cta.primary': 'Zum Dashboard',
  'email.welcome.signoff.line': 'Fragen? Antworte einfach auf diese Mail. Ich lese mit.',

  // ─── Transactional email — subscription-cancelled (LEA-259 design) ──────
  'email.subscription-cancelled.subject':
    'Schade dass du gehst, {{first_name}}: Kündigung bestätigt',
  'email.subscription-cancelled.title': 'Dein Abo wurde gekündigt',
  'email.subscription-cancelled.preheader': 'Wir haben deine Kündigung erhalten.',
  'email.subscription-cancelled.badge': 'Kündigung bestätigt',
  'email.subscription-cancelled.hero': 'Schade dass du gehst,<br>{{first_name}}.',
  'email.subscription-cancelled.subhead':
    'Wir haben deine Kündigung erhalten. Dein {{plan_name}}-Zugang bleibt bis {{access_until}} aktiv.',
  'email.subscription-cancelled.subhead_trial':
    'Wir haben deine Kündigung erhalten. Dein Test ist damit beendet, es wird nichts abgebucht.',
  'email.subscription-cancelled.note_trial':
    'Wenn du später doch weitermachen willst, kannst du dein Abo in deinem Account wieder aktivieren.',
  'email.subscription-cancelled.summary.plan_label': 'Plan',
  'email.subscription-cancelled.summary.until_label': 'Zugang bis',
  'email.subscription-cancelled.note':
    'Bis dahin behältst du vollen Zugriff. Danach werden deine Daten gemäß unserer Datenschutzrichtlinie gelöscht.',
  'email.subscription-cancelled.signoff.line':
    'Was hätten wir besser machen können? Antworte einfach auf diese Mail. Ich lese mit.',
  'email.subscription-cancelled.cta.primary': 'Zurück ins Produkt &amp; Abo reaktivieren',
  'email.subscription-cancelled.cta.note':
    'Du landest direkt im Dashboard und kannst dort dein Abo wieder aktivieren.',
  'email.subscription-cancelled.footer.transactional':
    'Du erhältst diese E-Mail als Bestätigung deiner Kündigung. Diese transaktionale Nachricht ist Bestandteil des Vertragsverhältnisses und kann nicht abbestellt werden.',

  // LEA-333: Pause-Bestätigung + Pause-läuft-bald-aus.
  'email.subscription-paused.subject': 'Dein Abo ist pausiert',
  'email.subscription-paused.badge': 'Abo pausiert',
  'email.subscription-paused.hero': 'Dein Abo macht<br>jetzt Pause.',
  'email.subscription-paused.detail.plan_label': 'Tarif',
  'email.subscription-paused.detail.until_label': 'Pausiert bis',
  'email.subscription-paused.preheader': 'Keine Abbuchung bis {{pause_ends_at}}.',
  'email.subscription-paused.greeting': 'Hallo {{first_name}},',
  'email.subscription-paused.intro':
    'dein {{plan_name}}-Abo ist jetzt pausiert. Bis {{pause_ends_at}} wird dir nichts berechnet.',
  'email.subscription-paused.access':
    'Dein Zugang und deine restlichen Credits bleiben. Es kommen nur keine neuen monatlichen Credits dazu.',
  'email.subscription-paused.resume_note':
    'Am {{pause_ends_at}} läuft dein Abo automatisch weiter. Du kannst es vorher jederzeit selbst fortsetzen oder kündigen.',
  'email.subscription-paused.button': 'Abo verwalten',
  'email.subscription-paused.signoff': 'Bis bald, dein Leadscraper-Team',

  'email.subscription-pause-ending.subject': 'Dein Abo wird bald fortgesetzt',
  'email.subscription-pause-ending.preheader': 'Deine Pause endet am {{resumes_at}}.',
  'email.subscription-pause-ending.greeting': 'Hallo {{first_name}},',
  'email.subscription-pause-ending.intro':
    'kurze Erinnerung: deine Pause endet am {{resumes_at}}. Dein {{plan_name}}-Abo wird dann automatisch fortgesetzt.',
  'email.subscription-pause-ending.charge_note':
    'Ab dann läuft die Abrechnung wieder normal. Wenn du nicht fortsetzen möchtest, kannst du vorher kündigen.',
  'email.subscription-pause-ending.button': 'Abo verwalten',
  'email.subscription-pause-ending.signoff': 'Dein Leadscraper-Team',

  // ─── Transactional email — payment-failed / dunning (LEA-304 design) ─────
  // "von 3" ist hier bewusst in der Copy verankert (nicht als Variable): die
  // Stripe Smart-Retries-Anzahl ändert sich praktisch nie. Wenn sie sich doch
  // ändert, ist es ein Einzeiler pro Sprache — siehe LEA-304.
  'email.payment-failed.subject': 'Deine Zahlung ist fehlgeschlagen, bitte aktualisieren',
  'email.payment-failed.title': 'Zahlung fehlgeschlagen, bitte aktualisieren',
  'email.payment-failed.preheader':
    'Wir konnten {{amount_formatted}} für deinen {{plan_name}}-Plan nicht einziehen. Bitte aktualisiere deine Zahlungsdaten.',
  'email.payment-failed.badge': 'Zahlung fehlgeschlagen',
  'email.payment-failed.hero': 'Deine Zahlung ist nicht durchgegangen, {{first_name}}.',
  'email.payment-failed.subhead':
    'Wir konnten <strong style="color:#0B0F19;">{{amount_formatted}}</strong> für deinen {{plan_name}}-Plan nicht einziehen. Aktualisiere deine Zahlungsdaten, um eine Unterbrechung deiner Leads zu vermeiden.',
  'email.payment-failed.summary.plan_label': 'Plan',
  'email.payment-failed.summary.amount_label': 'Offener Betrag',
  'email.payment-failed.summary.attempt_label': 'Versuch',
  'email.payment-failed.summary.attempt_value': '{{attempt_count}}. von 3',
  'email.payment-failed.summary.next_label': 'Nächster Versuch',
  'email.payment-failed.cta.primary': 'Zahlungsdaten jetzt aktualisieren',
  'email.payment-failed.reassurance':
    'Dauert keine Minute. Danach läuft alles wie gewohnt weiter. Fragen? Antworte einfach auf diese E-Mail.',
  'email.payment-failed.footer.transactional':
    'Du erhältst diese E-Mail, weil bei deinem Leadscraper-Abo eine Zahlung fehlgeschlagen ist. Diese transaktionale Nachricht ist Bestandteil des Vertragsverhältnisses und kann nicht abbestellt werden.',

  // ─── Transactional email — trial-ending-soon (LEA-295) ─────
  'email.trial-ending-soon.subject': 'Dein Trial endet bald',
  'email.trial-ending-soon.preheader': 'Trial endet {{trial_ends_at}}. Wähl jetzt einen Plan.',
  'email.trial-ending-soon.greeting': 'Hallo {{first_name}},',
  'email.trial-ending-soon.intro':
    'dein {{plan_name}}-Trial endet am {{trial_ends_at}}. Du hast aktuell noch {{credits_remaining}} Credits.',
  'email.trial-ending-soon.why':
    'Sobald der Trial endet, wird dein Account read-only. Du kannst deine bisherigen Leads weiter ansehen, aber keine neuen Suchen starten.',
  'email.trial-ending-soon.cta':
    'Wenn die Ergebnisse für dich passen: Wähle jetzt einen Plan, damit es nahtlos weiterläuft.',
  'email.trial-ending-soon.button': 'Plan auswählen',
  // LEA-556: Kuendigen-Link direkt in der Mail. Die bare URL steht im
  // Fliesstext, weil der Plaintext-Teil per htmlToPlainText abgeleitet wird
  // und ein reiner Anchor dort seinen href verloere.
  'email.trial-ending-soon.cancel_note':
    'Du willst nicht weitermachen? Dann kündige jetzt mit einem Klick — vor der ersten Abbuchung: {{cancel_link}}',
  'email.trial-ending-soon.cancel_link_label': 'Testphase kündigen',
  'email.trial-ending-soon.signoff': 'Janik',

  // LEA-560: Win-back 24 h nach Trial-Sofort-Kuendigung. 30 %/3 Monate
  // (Janik 04.09.), Humanizer-Ton, bare URL im Transparenz-Satz fuer den
  // Plaintext-Teil.
  'email.trial-winback.subject': 'Falls es nur die Angst vor der Abbuchung war …',
  'email.trial-winback.badge': 'Dein Account steht noch',
  'email.trial-winback.hero': '30 % Rabatt, falls du<br>weitermachen willst.',
  'email.trial-winback.preheader': '30 % Rabatt für 3 Monate, dein Account steht noch.',
  'email.trial-winback.greeting': 'Hallo {{first_name}},',
  'email.trial-winback.intro':
    'du hast deinen Test gestern sofort beendet. Völlig okay, genau dafür ist der Knopf da. Falls es dir aber nur darum ging, eine ungewollte Abbuchung zu vermeiden: Dein Account steht noch, mit allem, was du eingerichtet hast.',
  'email.trial-winback.offer':
    'Wenn du weitermachen willst, bekommst du {{plan_name}} drei Monate lang mit 30 % Rabatt. Kein neues Formular, deine Karte ist hinterlegt.',
  'email.trial-winback.button': 'Angebot ansehen',
  'email.trial-winback.transparency':
    'Der Klick bucht nichts ab. Du siehst erst Preis und Abbuchungsdatum und bestätigst dann selbst. Link: {{winback_url}}',
  'email.trial-winback.signoff': 'Janik',
  // LEA-560: In-App-Bestaetigungs-Banner nach dem Mail-Klick.
  'acct.winback.title': 'Dein Willkommen-zurück-Angebot',
  'acct.winback.body':
    '{plan} mit 30 % Rabatt für 3 Monate. Im Checkout siehst du Preis und Abbuchungsdatum, bevor irgendetwas passiert.',
  'acct.winback.cta': 'Zum Checkout',
  'acct.winback.starting': 'Wird geöffnet …',

  // ─── Transactional email — trial-ended (LEA-295) ─────
  'email.trial-ended.subject': 'Dein Test ist vorbei',
  'email.trial-ended.badge': 'Test beendet',
  'email.trial-ended.hero': 'Dein Test<br>ist vorbei.',
  'email.trial-ended.preheader': 'Mit einem Tarif geht es direkt weiter.',
  'email.trial-ended.greeting': 'Hallo {{first_name}},',
  'email.trial-ended.intro':
    'dein {{plan_name}}-Test ist gerade zu Ende gegangen. Dein Account ist jetzt gesperrt, bis du einen Tarif wählst.',
  'email.trial-ended.cta':
    'Deine Daten bleiben erhalten, auch alles, was Leadscraper über deine Zielgruppe gelernt hat. Mit einem Tarif machst du genau da weiter.',
  'email.trial-ended.button': 'Tarif auswählen',
  'email.trial-ended.signoff': 'Bis bald.<br>Janik',

  // ─── Transactional email — verify-email (LEA-295) ─────
  'email.verify-email.subject': 'Bestätige deine E-Mail-Adresse',
  'email.verify-email.badge': 'Fast geschafft',
  'email.verify-email.hero': 'Bestätige kurz<br>deine E-Mail-Adresse.',
  'email.verify-email.preheader': 'Ein Klick, dann kannst du loslegen.',
  'email.verify-email.greeting': 'Hallo {{first_name}},',
  'email.verify-email.body':
    'ein Klick auf den Button, dann ist dein Account aktiv und du kannst loslegen.',
  'email.verify-email.button': 'E-Mail bestätigen',
  'email.verify-email.fallback_note':
    'Der Button geht nicht? Dann kopier diesen Link in den Browser:',
  'email.verify-email.ttl_note': 'Der Link läuft in {{verify_expires_in}} ab.',
  'email.verify-email.ttl_default': '24 Stunden',
  'email.verify-email.ignore_note':
    'Du hast dich nicht bei Leadscraper angemeldet? Dann ignorier diese Mail einfach.',

  // ─── Transactional email — refund-confirmation (LEA-295) ─────
  'email.refund-confirmation.subject': 'Rückerstattung bestätigt',
  'email.refund-confirmation.preheader': 'Refund: {{amount_formatted}}',
  'email.refund-confirmation.greeting': 'Hallo {{first_name}},',
  'email.refund-confirmation.intro': 'wir haben dir {{amount_formatted}} zurückerstattet.',
  'email.refund-confirmation.refunded_line':
    'Buchung am {{refunded_at}} an die ursprüngliche Zahlungsmethode. Die Gutschrift erscheint je nach Bank in 3-10 Werktagen.',
  'email.refund-confirmation.clawback_yes':
    'Da der Refund die zugehörigen Credits storniert, wurden {{credits_clawed_back}} Credits von deinem Account abgezogen.',
  'email.refund-confirmation.clawback_no': 'Deine Credits bleiben unangetastet.',
  'email.refund-confirmation.reason_line': 'Grund: {{reason}}.',
  'email.refund-confirmation.outro': 'Fragen? Antworte einfach auf diese Mail.',
  'email.refund-confirmation.footer':
    'Du erhältst diese Mail, weil eine Rückerstattung für deinen Leadscraper-Account ausgelöst wurde.',

  // ─── Transactional email — password-reset (LEA-259 design) ──────────────
  // Janik on LEA-295: "Password-reset is the one I can't afford to break."
  // Markup is byte-locked by scripts/checkBaseline.ts; copy is mirrored
  // exactly from password-reset.de.html.
  'email.password-reset.subject': 'Passwort zurücksetzen, Link gültig für {{expires_in}}',
  'email.password-reset.title': 'Passwort zurücksetzen',
  'email.password-reset.preheader':
    'Setze dein Passwort sicher zurück. Link läuft in {{expires_in}} ab.',
  'email.password-reset.badge': 'Passwort zurücksetzen',
  'email.password-reset.hero': 'Neues Passwort<br>festlegen.',
  'email.password-reset.body':
    'Jemand hat angefragt, dein Passwort zurückzusetzen. Wenn du das warst, klick einfach auf den Button. Wenn nicht, ignoriere diese E-Mail. Dein Passwort bleibt unverändert.',
  'email.password-reset.expires': 'Der Link läuft in {{expires_in}} ab.',
  'email.password-reset.cta.primary': 'Passwort zurücksetzen',
  'email.password-reset.signoff.line':
    'Fragen zur Account-Sicherheit? Antworte einfach auf diese Mail.',
  'email.password-reset.footer.transactional':
    'Aus Sicherheitsgründen enthält diese E-Mail Informationen über die Anfrage. Teile sie mit niemandem. Diese Sicherheits-Benachrichtigung ist Bestandteil des Vertragsverhältnisses und kann nicht abbestellt werden.',

  // ─── Transactional email — security-alert (LEA-264 design) ──────────────
  // Janik on LEA-295: "Security-alert is the one I can't afford to break."
  // This template uniquely shipped with BOTH .de.html AND .en.html, so EN
  // strings below are mirrored VERBATIM from security-alert.en.html — no
  // creative re-translation — so the EN baseline stays byte-equal.
  'email.security-alert.subject': 'Sicherheitshinweis: {{event}}',
  'email.security-alert.title': 'Sicherheitshinweis',
  'email.security-alert.preheader':
    'Sicherheitshinweis: {{event}}. Falls du das nicht warst: Passwort jetzt zurücksetzen.',
  'email.security-alert.badge': 'Sicherheitshinweis',
  'email.security-alert.hero': 'Auf deinem Account<br>wurde etwas geändert.',
  'email.security-alert.subhead':
    'Hallo {{first_name}}, wir haben gerade eine sicherheitsrelevante Aktion festgestellt: <strong style="color:#0B0F19;">{{event}}</strong>. Wenn du das warst, ist alles in Ordnung. Du kannst diese Mail ignorieren.',
  'email.security-alert.detail.time_label': 'Zeitpunkt',
  'email.security-alert.detail.ip_label': 'IP-Adresse',
  'email.security-alert.detail.browser_label': 'Browser',
  'email.security-alert.warning.line':
    '<strong style="color:#881337;">Das warst nicht du?</strong> Setze dein Passwort sofort zurück und prüfe deine Account-Aktivitäten.',
  'email.security-alert.cta.primary': 'Passwort jetzt ändern',
  'email.security-alert.signoff.line':
    'Fragen zur Account-Sicherheit? Antworte einfach auf diese Mail. Ich lese mit.',
  'email.security-alert.footer.transactional':
    'Aus Sicherheitsgründen enthält diese E-Mail Informationen zur Aktion. Teile sie mit niemandem. Diese Sicherheits-Benachrichtigung ist Bestandteil des Vertragsverhältnisses und kann nicht abbestellt werden.',
  // LEA-295 bug-fix: event labels were previously hardcoded as DE/EN ternaries
  // in apps/api/src/routes/auth.ts; now resolved via tForLang per user.language
  // so FR/ES/IT/NL/PL users see the event in their locale, not silently DE.
  'email.security-alert.event.password_reset': 'Passwort zurückgesetzt',
  'email.security-alert.event.account_deletion_requested':
    'Account-Löschung angefordert (30 Tage Frist)',
  'email.security-alert.event.password_changed': 'Passwort geändert',
  'email.security-alert.firstname_fallback': 'dort',
  // ── Phase-Trigger-UI (Welle G66 i18n — Pricing-v2) ──
  'phase.creditOne': 'Credit',
  'phase.creditMany': 'Credits',
  'phase.retry': 'Erneut versuchen',
  'phase.cancel': 'Abbrechen',
  'phase.confirm': 'Bestätigen',
  'phase.running': 'Läuft …',
  'phase.btn.running': 'läuft …',
  'phase.unknownError': 'Unbekannter Fehler',
  'phase.errorLabel': 'Fehler:',
  'phase.gate.loadingConnect': 'Ansprechpartner werden recherchiert …',
  'phase.gate.loadingPitch': 'Voll-Insights werden generiert …',
  'phase.gate.loadingHint':
    'Das dauert typisch 30-60 Sekunden. Du kannst die Seite verlassen. Wir benachrichtigen dich wenn fertig.',
  'phase.gate.failConnect': 'Recherche fehlgeschlagen',
  'phase.gate.failPitch': 'Insights-Generierung fehlgeschlagen',
  'phase.gate.failHint': 'Bitte erneut versuchen, kein zusätzlicher Credit fällig.',
  'phase.connect.title': 'Ansprechpartner & Direkt-Kontakte freischalten',
  'phase.connect.desc':
    'Wir recherchieren bis zu 3 Decision-Maker mit Direct-E-Mail, Direct-Phone und LinkedIn-URL. Quellen werden mitgeliefert (DSGVO-Audit-Trail).',
  'phase.connect.cta': 'Ansprechpartner finden',
  'phase.connect.runtime': 'Dauer: ~30-60 Sekunden',
  'phase.pitch.title': 'Voll-Insights & Akquise-Plan freischalten',
  'phase.pitch.desc':
    'Personalisierter 6-Sektionen-Akquise-Plan: Was die Firma macht, warum genau dieser Lead, Aktualität (Trigger-Events), Customer-References, Hooks für deine Verkaufsmail.',
  'phase.pitch.cta': 'Voll-Insights generieren',
  'phase.pitch.runtime': 'Dauer: ~20-40 Sekunden',
  'phase.locked.confirmQuestion': 'Bestätigung: {credits} für "{action}" abbuchen?',
  'phase.deepen.title': 'Diesen Lead vertiefen',
  'phase.deepen.descConnectDone':
    'Ansprechpartner sind geladen. Lade jetzt Voll-Insights für Akquise-Plan + Tech-Stack.',
  'phase.deepen.descDefault':
    'Identifiziert. Lade Ansprechpartner oder direkt die Voll-Insights. Pro Klick wird abgerechnet.',
  'phase.deepen.pricingError':
    'Pricing-Catalog konnte nicht geladen werden, Fallback auf Standard-Preise.',
  'phase.deepen.directPitch': 'Voll-Insights direkt laden (ohne Ansprechpartner)',
  'phase.btn.connect': '+ Ansprechpartner finden ({credits})',
  'phase.btn.pitch': '+ Voll-Insights ({credits})',
  'phase.toast.connectLoading': 'Ansprechpartner werden geladen.',
  'phase.toast.pitchLoading': 'Voll-Insights werden geladen.',
  'phase.toast.noCredits': 'Keine Credits mehr. Bitte nachladen oder Plan upgraden.',
  'phase.toast.connectSoon':
    'Ansprechpartner-Suche kommt bald, wird mit Welle F2.2 freigeschaltet.',
  'phase.toast.pitchSoon': 'Voll-Insights kommen bald, wird mit Welle F2.3 freigeschaltet.',
  'phase.toast.error': 'Fehler: {msg}',
  'phase.toast.unexpected': 'Unerwarteter Fehler. Bitte erneut versuchen.',
  'phase.dialog.connectTitle': 'Ansprechpartner finden?',
  'phase.dialog.pitchTitle': 'Voll-Insights laden?',
  'phase.dialog.connectDesc':
    'Wir recherchieren Decision-Maker (Email, Phone, LinkedIn) für diesen Lead. Ergebnis ist meist binnen 1-2 Minuten verfügbar.',
  'phase.dialog.pitchDesc':
    'Wir generieren Akquise-Plan, Tech-Stack, Trigger-Phrasen und Sparkle-Felder für diesen Lead. Ergebnis ist meist binnen 1-2 Minuten verfügbar.',
  'phase.dialog.close': 'Dialog schließen',
  'phase.dialog.costNote':
    'Diese Aktion kostet {credits}. Credit verbraucht = Credit verbraucht (keine automatische Rückerstattung).',
  'phase.dialog.confirmDeduct': 'Ja, {credits} abbuchen',
  // ── LeadDetail Rest-Strings (Welle G66.2 i18n) ──
  'det.src.impressum': 'Impressum',
  'det.src.handelsregister': 'Handelsregister',
  'det.src.subPage': 'Team-Seite',
  'det.src.dorkEnrich': 'Web-Recherche',
  'det.src.geminiGrounding': 'KI-Recherche',
  'det.confReason.deepResearchConfirmed': 'via Recherche bestätigt',
  'det.confReason.handelsregisterOnly': 'nur Handelsregister',
  'det.confReason.nameMatch': 'Name-Abgleich',
  'det.confReason.multiSource': 'mehrere Quellen',
  'det.confReason.rankFallback': 'Discovery-Ranking (Deep-Research übersprungen)',
  'det.confReason.rankFallbackLowConf': 'Discovery-Ranking (Deep-Research ohne Treffer)',
  'det.trust.authoritative': 'Aus offizieller Quelle verifiziert (Impressum/Handelsregister)',
  'det.trust.semiAuth': 'Von eigener Firmen-Seite (z.B. /team)',
  'det.trust.llm': 'Per KI aus Website-Inhalt extrahiert',
  'det.trust.derived': 'Aus anderen Daten abgeleitet (niedrige Sicherheit)',
  'det.trust.sourceGeneric': 'Quelle: {source}',
  'det.trust.confidence': 'Confidence',
  'det.pReject.duplicate': 'Doppelt',
  'det.pReject.duplicateHint':
    'Person ist bereits in der Liste oder Name-Mismatch ("Werner Weber Kurt Richter")',
  'det.pReject.wrongRole': 'Falsche Rolle',
  'det.pReject.wrongRoleHint': 'Person hat nicht die Entscheidungsbefugnis die wir suchen',
  'det.pReject.inactive': 'Nicht mehr aktiv',
  'det.pReject.inactiveHint': 'Person ist gewechselt, in Rente o.ä.',
  'det.pReject.wrongData': 'Daten unkorrekt',
  'det.pReject.wrongDataHint': 'Email/Phone falsch oder nicht erreichbar',
  'det.pReject.betterContact': 'Andere Person besser',
  'det.pReject.betterContactHint': 'Es gibt einen passenderen Kontakt in dieser Firma',
  'det.pReject.private': 'Nicht ansprechen',
  'det.pReject.privateHint': 'Möchte diese Person nicht kontaktieren (kein Learning)',
  'det.toast.personFeedbackRealOnly': 'Person-Feedback nur für echte Leads verfügbar.',
  'det.toast.removeFailed': 'Konnte nicht entfernen. Versuche es nochmal.',
  'det.toast.backendUnavailable': 'Backend nicht verfügbar. Bitte App neu laden.',
  'det.toast.planRegenerating': 'Akquiseplan wird mit aktuellem Briefing neu generiert …',
  'det.toast.phaseAlreadyRunning': '{phase} läuft schon, einen Moment Geduld.',
  'det.available': 'verfügbar',
  'det.unavailable': 'nicht verfügbar',
  'det.primary': 'Primär',
  'det.sourcePrefix': 'Quelle:',
  'det.dataViaWebResearch': 'Daten via öffentliche Web-Recherche',
  'det.openLink': '{label} öffnen',
  'det.openLinkedin': 'LinkedIn-Profil von {name} öffnen',
  'det.openXing': 'XING-Profil von {name} öffnen',
  // ── LeadsTable Rest-Strings (Welle G66.3 i18n) ──
  'lt.trigErr.noContacts':
    'Wir konnten keine Ansprechpartner identifizieren. Kein Credit verbraucht.',
  'lt.trigErr.insufficientCredits': 'Nicht genug Credits. Bitte aufladen.',
  'lt.trigErr.phaseRunning': 'Diese Phase läuft schon. Bitte warten.',
  'lt.trigErr.phaseCompleted': 'Diese Phase ist bereits abgeschlossen.',
  'lt.trigErr.triggerFailed': 'Trigger fehlgeschlagen: {msg}',
  'lt.cta.findContacts': 'Ansprechpartner finden · 1 Credit',
  'lt.cta.createPlan': 'Akquiseplan erstellen · 1 Credit',
  'lt.cta.openOutreach': 'Anschreiben öffnen',
  'lt.verifyStuck': 'Verifikation hängt. Bitte Seite neu laden und erneut probieren.',
  'lt.verifyFailed': 'Ansprechpartner-Verifikation fehlgeschlagen.',
  'lt.planFailed': 'Akquise-Plan konnte nicht erstellt werden.',
  'lt.softKeepAria': 'Möglich, Klick für Details',
  'lt.manual.toast.backendUnavailable': 'Backend nicht verfügbar. Bitte später erneut versuchen.',
  'lt.manual.toast.added': '{name} hinzugefügt',
  'lt.manual.toast.alreadyExists': '{name} ist schon angelegt. Öffne sie für dich.',
  'lt.manual.toast.switchProfile': 'Wechsle ggf. die Zielgruppe. Der Lead liegt evtl. woanders.',
  'lt.manual.toast.addFailed': 'Anlegen fehlgeschlagen.',
  'lt.manual.companyFallback': 'Unternehmen',
  // ── Dashboard Rest-Strings (Welle G66.4 i18n) ──
  'dash.cancel.requested': 'Abbruch angefordert, wird beim nächsten Checkpoint greifen.',
  'dash.cancel.failed': 'Abbruch fehlgeschlagen',
  'dash.cancel.titleNoRun': 'Run-ID noch nicht verfügbar',
  'dash.cancel.titleCancel': 'Suchlauf abbrechen',
  'dash.cancel.inFlight': 'Wird abgebrochen …',
  'dash.cancel.confirm': 'Wirklich abbrechen?',
  'dash.refreshing': 'Aktualisiere …',
  'dash.run.noCredits': 'Keine Credits. Bitte Abo abschließen.',
  'dash.run.startSub': 'Abo starten',
  'dash.sugg.region': 'Region:',
  'dash.sugg.contact': 'Ansprechpartner:',
  'dash.sugg.extra': 'Zusatz:',
  'dash.sugg.why': 'Warum:',
  // ── Bestandskunden-Exclude (A1, 2026-06-02) ──
  'acct.exclude.title': 'Bestandskunden ausschließen',
  'acct.exclude.desc':
    'Hinterlege hier Domains, die du bereits kennst (z.B. dein CRM-Export). Sie werden aus den Ergebnissen ALLER Suchen herausgefiltert, eine Domain pro Zeile.',
  'acct.exclude.placeholder': 'firma.de\nbeispiel-gmbh.de\nkunde.com',
  'acct.exclude.count': '{n} Domains werden aus allen Suchen ausgeschlossen',
  'acct.exclude.save': 'Liste speichern',
  'acct.exclude.saved': 'Ausschluss-Liste gespeichert ({n} Domains)',
  // LEA-498: CRM/CSV-Import der Bestandskunden-Liste (füttert dieselbe Discovery-
  // Ausschluss-Liste wie die manuelle Eingabe oben, nur als Datei-Upload).
  'acct.seedimport.title': 'Bestandskunden-Liste importieren',
  'acct.seedimport.desc':
    'Lade eine CSV- oder Textdatei mit deinen Bestandskunden hoch — eine Domain oder URL pro Zeile (oder eine Spalte mit Domains). Diese Firmen werden auf ALLEN Zielgruppen nie als neuer Lead geliefert.',
  'acct.seedimport.hint': 'CSV oder .txt · max. 5 MB',
  'acct.seedimport.cta': 'CSV hochladen',
  'acct.seedimport.uploading': 'Wird importiert …',
  'acct.seedimport.report':
    '{rows} Zeilen · {resolved} Domains erkannt · {added} neu · {total} in deiner Liste',
  'acct.seedimport.unresolved': '{n} Zeilen ohne erkennbare Domain übersprungen',
  'acct.seedimport.capped': 'Import-Limit erreicht — nicht alle Domains übernommen.',
  'acct.seedimport.failed': 'Import fehlgeschlagen. Prüfe die Datei und versuche es erneut.',
  // ── Agent-Chat / Cockpit (LEA-435 Wave B) ──
  'agent.nav': 'Assistent',
  'agent.tab.chat': 'Chat',
  'agent.tab.workspace': 'Arbeitsfläche',
  'agent.boot': 'Einen Moment — dein Assistent startet …',
  'agent.thinking': 'Denkt nach …',
  'agent.turnError': 'Das hat gerade nicht geklappt — bitte versuch es gleich noch einmal.',
  'agent.budgetExhausted':
    'Für heute ist das Chat-Guthaben deines Accounts aufgebraucht. Morgen geht es automatisch weiter — deine Credits und Leads sind davon nicht betroffen.',
  'agent.artifact.eyebrow': 'Zielgruppe',
  'agent.artifact.draftBadge': 'Entwurf',
  'agent.artifact.createdBadge': 'Neu angelegt',
  'agent.artifact.industry': 'Branche',
  'agent.artifact.region': 'Region',
  'agent.artifact.size': 'Größe',
  'agent.artifact.exclusions': 'Ausschlüsse',
  'agent.artifact.any': 'egal',
  'agent.bootError': 'Der Assistent ist gerade nicht erreichbar. Bitte lade die Seite neu.',
  'agent.empty.title': '{greeting} — womit kann ich dir helfen?',
  'agent.greet.morning': 'Guten Morgen',
  'agent.greet.day': 'Hallo',
  'agent.greet.evening': 'Guten Abend',
  'agent.empty.sub':
    'Beschreib mir einfach, wen du als Kunden suchst — ich baue daraus die Suche, hole deine Freigabe ein und wir besprechen die Ergebnisse gemeinsam.',
  'agent.starter.find': 'Ich suche neue Kunden — hilf mir, meine Zielgruppe zu definieren',
  'agent.starter.describe': 'Analysiere meine Website und schlag mir passende Zielgruppen vor',
  'agent.starter.review': 'Zeig mir meine letzten Leads und lass sie uns durchgehen',
  'agent.composer.placeholder': 'Nachricht an deinen Assistenten …',
  'agent.composer.send': 'Senden',
  'agent.composer.stop': 'Stopp',
  'agent.composer.hint': 'Enter zum Senden · Shift+Enter für eine neue Zeile',
  'agent.scroll.end': 'Zum Ende springen',
  'agent.confirm.title': 'Freigabe: {action}',
  'agent.confirm.approve': 'Freigeben',
  'agent.confirm.deny': 'Ablehnen',
  'agent.tool.analyze': 'Website analysieren',
  'agent.tool.analyzeReference': 'Referenz-Website ansehen',
  'agent.tool.draft': 'Zielgruppen-Entwurf',
  'agent.tool.createProfile': 'Profil anlegen',
  'agent.tool.startRun': 'Suche starten',
  'agent.tool.runStatus': 'Suchstatus',
  'agent.tool.listLeads': 'Leads laden',
  'agent.tool.getLead': 'Lead-Details',
  'agent.tool.connect': 'Ansprechpartner finden',
  'agent.tool.pitch': 'Akquiseplan erstellen',
  'agent.tool.feedback': 'Feedback verbuchen',
  'agent.tool.credits': 'Credit-Stand',
  'agent.tool.exclude': 'Firmen ausschließen',
  'agent.tool.cancelApproval': 'Freigabe zurückziehen',
  'agent.tool.cancelPlan': 'Suchplan stoppen',
  'agent.support.open': 'Support',
  'agent.support.title': 'Support-Chat öffnen — es antwortet ein Mensch',
  'agent.ws.title': 'Deine Zielgruppen',
  'agent.ws.new': 'Neu',
  'agent.ws.empty': 'Hier erscheinen die Zielgruppen-Profile, die wir im Chat gemeinsam anlegen.',
  'agent.ws.openLeads': 'Leads ansehen',
  // Kopieren / Umbenennen / Datei-Anhang (LEA-435 Usability-Welle)
  'agent.msg.copy': 'Kopieren',
  'agent.msg.copied': 'Kopiert',
  'agent.sessions.rename': 'Doppelklick zum Umbenennen',
  'agent.composer.attach': 'Kundenliste anhängen (CSV/XLSX)',
  'agent.attach.none': 'In der Datei waren keine Firmen-Domains erkennbar.',
  'agent.attach.xlsxFailed':
    'Die Excel-Datei konnte nicht gelesen werden. Versuch es bitte mit einer CSV-Datei.',
  'agent.attach.saved':
    'Ich habe meine Kundenliste hochgeladen: {n} Firmen-Domains sind jetzt aus allen künftigen Suchen ausgeschlossen (z. B. {examples}).',
  'agent.attach.saveFailed':
    'Ich habe meine Kundenliste hochgeladen ({n} Firmen-Domains), aber das Speichern als Ausschlussliste ist fehlgeschlagen.',
  // Session-Verlauf + Relativzeit (LEA-435 Multi-Session)
  'agent.sessions.new': 'Neuer Chat',
  'agent.sessions.empty': 'Noch keine Unterhaltungen.',
  'agent.sessions.untitled': 'Neue Unterhaltung',
  'agent.sessions.delete': 'Löschen',
  // LEA-448 — Löschbestätigung (#7), Umkreis-Feld (P2-5), Firmen-Kontakt-Hinweis
  // (P2-1b), „hängt"-Failsafe (#8).
  'agent.sessions.deleteConfirm':
    'Diese Unterhaltung löschen? Das lässt sich nicht rückgängig machen.',
  'agent.artifact.radius': 'Umkreis {n} km',
  'agent.leads.companyContactHint':
    'Firmen-Kontakt aus dem Impressum — kein persönlicher Ansprechpartner.',
  'agent.run.stalled': 'Dauert länger als üblich…',
  'agent.run.recheck': 'Erneut prüfen',
  // LEA-448 round-4 — Freigabe-Karten-Kosten, lokalisiert (vorher hartkodiert DE).
  'agent.cost.startRun':
    'bis zu {n} Credits — nur tatsächlich gelieferte Firmen zählen, aussortierte werden nie berechnet',
  'agent.cost.startRunRescue':
    'zweiter Versuch nach magerem Ergebnis — zählt nicht als weitere Suche; berechnet werden wie immer nur gelieferte Firmen (bis zu {n} Credits)',
  'agent.cost.connect':
    '{n} Credit — Ansprechpartner (Name, Rolle, E-Mail, Telefon) für diese Firma aus öffentlichen Quellen',
  'agent.cost.pitch':
    '{n} Credit — Akquiseplan (Recherche + kopierfertiges Erstanschreiben) für diese Firma',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'agent.cost.startRunReveal':
    'kostenlos — Suchen kostet nichts, bezahlt wird erst das Freischalten eines Ansprechpartners',
  'agent.cost.scheduleReveal':
    'kostenlos — jeder Lauf · {cadence} · pausiert von selbst nach {k} Läufen in Folge ohne neue Firmen oder wenn das Guthaben leer ist · jederzeit stoppbar',
  'agent.cost.connectReveal':
    'kostenlos — Ansprechpartner werden recherchiert und sind nach dem Freischalten sichtbar',
  'agent.cost.pitchReveal': 'kostenlos — der Akquiseplan ist im Freischalten enthalten',
  'agent.cost.startRunPlan':
    '{runs} Suchen nacheinander, je bis zu {per} Credits — zusammen bis zu {n} Credits für bis zu {leads} Firmen; nur tatsächlich gelieferte Firmen zählen, der Plan stoppt nach einem mageren Ergebnis',
  'agent.cost.connectBatch':
    'bis zu {n} Credits — Ansprechpartner (Name, Rolle, E-Mail, Telefon) für {count} Firmen aus öffentlichen Quellen; ohne erreichbaren Kontakt wird für die Firma nichts berechnet',
  'agent.cost.pitchBatch':
    'bis zu {n} Credits — Akquisepläne (Recherche + kopierfertiges Erstanschreiben) für {count} Firmen',
  'agent.sessions.history': 'Verlauf',
  'agent.sessions.close': 'Schließen',
  'agent.time.now': 'gerade eben',
  'agent.time.min': 'vor {n} Min',
  'agent.time.hour': 'vor {n} Std',
  'agent.time.day': 'vor {n} T',
  // ── Live-Fortschrittskarte (LEA-435) ──
  'agent.run.running': 'Suche läuft',
  'agent.run.finalizing': 'Feinschliff läuft — gleich fertig …',
  'agent.run.preparing': 'Suche wird vorbereitet …',
  'agent.run.done': 'Suche abgeschlossen',
  'agent.run.failed': 'Suche fehlgeschlagen',
  'agent.run.interrupted': '{n} Firmen geliefert — Suche vorzeitig beendet',
  'agent.run.qualifierDown':
    'Unsere Prüf-Stufe war kurz nicht erreichbar — das lag an uns, nicht an deinen Kriterien. Ein neuer Lauf lohnt sich.',
  'agent.run.cancelled': 'Suche abgebrochen',
  'agent.run.delivered': '{n} / {total} Firmen geliefert',
  'agent.run.reviewCta': 'Leads durchgehen',
  'agent.run.dismiss': 'Ausblenden',
  'agent.run.step.planning': 'Planung',
  'agent.run.step.discovery': 'Entdeckung',
  'agent.run.step.hydration': 'Anreicherung',
  'agent.run.step.reasoning': 'Bewertung',
  'agent.run.step.delivery': 'Lieferung',
  'agent.run.won': '{n} frische Leads für dich!',
  // LEA-504: Zero-Result-Rettung im Chat (services/runRescue.ts + RescueCard)
  'agent.run.empty': 'Keine passenden Firmen gefunden',
  'agent.rescue.head.zero': 'Diese Suche hat keine passenden Firmen gefunden.',
  'agent.rescue.head.lowOne':
    'Diese Suche hat nur 1 passende Firma gefunden — die kannst du dir schon ansehen.',
  'agent.rescue.head.low':
    'Diese Suche hat nur {n} passende Firmen gefunden — die kannst du dir schon ansehen.',
  'agent.rescue.cause.ours':
    'Das lag an uns, nicht an deiner Zielgruppe: Die Suche ist technisch nicht sauber durchgelaufen.',
  'agent.rescue.cause.oursQualifier':
    'Das lag an uns, nicht an deiner Zielgruppe: Unsere Prüf-Stufe war während der Suche nicht erreichbar, die gefundenen Firmen wurden gar nicht bewertet.',
  'agent.rescue.cause.fewFound':
    'Im Suchgebiet ({area}) haben wir nur wenige Firmen gefunden, die zu deiner Beschreibung passen. Das sagt mehr über unsere Reichweite dort als über deinen Markt.',
  'agent.rescue.cause.harvested':
    'Die Firmen, die wir gefunden haben, kennst du schon: Sie wurden dir bei früheren Suchen geliefert oder stehen auf deiner Liste bekannter Firmen.',
  'agent.rescue.cause.harvestedLow':
    'Die übrigen Firmen, die wir gefunden haben, kennst du schon: Sie wurden dir bei früheren Suchen geliefert oder stehen auf deiner Liste bekannter Firmen.',
  'agent.rescue.cause.tooBroad':
    'Deine Zielgruppe nennt keine konkrete Branche. Ohne Branche weiß die Recherche nicht, welche Firmen sie prüfen soll.',
  'agent.rescue.cause.filtered':
    'Wir haben Firmen gefunden, aber keine hat deine Kriterien erfüllt (Branche, Größe oder Region).',
  'agent.rescue.cause.filteredLow':
    'Die übrigen Firmen, die wir gefunden haben, haben deine Kriterien nicht erfüllt (Branche, Größe oder Region).',
  'agent.rescue.cause.unknown': 'Woran es genau lag, konnten wir nicht sicher feststellen.',
  'agent.rescue.freeRule':
    'Fehlgeschlagene Suchen kosten nie etwas: Ohne gelieferte Firma wird nichts berechnet. Und der neue Versuch zählt nicht als weitere Suche.',
  'agent.rescue.pick': 'Mein Vorschlag — ein Klick startet die neue Suche:',
  'agent.rescue.noOption.tooBroad':
    'Nenn mir eine konkrete Branche oder ein Gewerk, dann schärfen wir die Zielgruppe gemeinsam nach.',
  'agent.rescue.noOption.wide':
    'Das Suchgebiet ist schon so weit, wie es sinnvoll geht — ein weiterer Versuch mit denselben Kriterien brächte voraussichtlich nichts Neues.',
  'agent.rescue.thin.zero':
    'Auch der zweite Versuch hat keine passenden Firmen gebracht. Das spricht dafür, dass es für diese Kombination nur sehr wenige öffentlich auffindbare Firmen gibt — ein weiterer Versuch mit denselben Kriterien würde daran nichts ändern.',
  'agent.rescue.thin.low':
    'Auch der zweite Versuch hat kaum passende Firmen gebracht ({n} geliefert). Das spricht dafür, dass es für diese Kombination nur wenige öffentlich auffindbare Firmen gibt — ein weiterer Versuch mit denselben Kriterien würde daran nichts ändern.',
  'agent.rescue.thin.next':
    'Sinnvoller ist ein anderer Winkel — zum Beispiel eine Nachbarbranche oder eine andere Region.',
  'agent.rescue.opt.same': 'Gleiche Suche neu starten',
  'agent.rescue.opt.widen': 'Suchgebiet erweitern: {area} (statt nur {from})',
  'agent.rescue.opt.dach': 'Suchgebiet erweitern: Deutschland, Österreich und Schweiz',
  'agent.rescue.opt.dachFrom':
    'Suchgebiet erweitern: Deutschland, Österreich und Schweiz (statt nur {from})',
  'agent.rescue.opt.industry': 'Mit Branche „{industry}“ neu suchen',
  'agent.rescue.chip.market': 'Lass uns „{market}“ als Zielgruppe probieren',
  'agent.rescue.chip.rethink': 'Hilf mir, die Zielgruppe neu zu denken',
  'agent.rescue.unavailable': 'Dieser zweite Versuch ist nicht mehr verfügbar',
  'agent.rescue.card.note':
    'Zählt nicht als weitere Suche — wie immer werden nur gelieferte Firmen berechnet',
  'agent.rescue.card.noteFree': 'Kostenloser zweiter Versuch — zählt nicht als weitere Suche',
  'agent.rescue.oursRetryLater':
    'Versuch es in ein paar Minuten noch einmal — nicht gelieferte Firmen werden nie berechnet.',
  'agent.rescue.card.used': 'Gestartet',
  'agent.rescue.card.aria': 'Vorschläge für einen zweiten Versuch',
  'agent.rescue.preparing': 'Ich schaue, woran es lag …',
  // ── Momentum-Leiste (LEA-435) ──
  'agent.momentum.label': 'Dein Lauf',
  'agent.momentum.audiences': 'Zielgruppen',
  'agent.momentum.searches': 'Suchen',
  'agent.momentum.leads': 'Leads',
  'agent.momentum.contacts': 'Entscheider',
  'agent.momentum.pitches': 'Anschreiben',
  // ── Lead-Bewert-Deck (LEA-435) ──
  'agent.leads.title': 'Deine Leads — welche passen?',
  'agent.leads.rated': '{done}/{total} bewertet',
  'agent.leads.accept': 'Passt',
  'agent.leads.reject': 'Passt nicht',
  'agent.leads.accepted': 'Passt',
  'agent.leads.rejected': 'Passt nicht',
  'agent.leads.contacts': '{n} Kontakte',
  'agent.leads.openAll': 'Alle im Detail',
  'agent.leads.done': 'Stark — alle bewertet! Das schärft die nächste Suche.',
  'agent.leads.chainConnect': '→ Entscheider für {n} Treffer finden',
  'agent.leads.chainMsg': 'Finde bitte die Ansprechpartner für: {names}. (leadIds: {ids})',
  // ── Erfolgs-Puls (LEA-435) ──
  'agent.pulse.hitRate': 'Trefferquote {pct}%',
  'agent.pulse.rising': 'steigt',
  'agent.pulse.detail': '{accepted} von {rated} Leads passen · {profiles} Zielgruppen',
  'agent.pulse.nudge':
    'Bewerte deine Leads mit 👍/👎 — dann lerne ich deine Trefferquote und werde mit jeder Suche besser.',
  // ── Aktions-Chips (LEA-435) ──
  'agent.chip.confirmDraft': 'Ja, so anlegen',
  'agent.chip.adjustDraft': 'Anders eingrenzen',
  'agent.chip.startRun': 'Suche starten',
  'agent.chip.reviewLeads': 'Leads durchgehen',
  'agent.chip.msg.confirmDraft': 'Ja, leg das Profil genau so an.',
  'agent.chip.msg.adjustDraft': 'Ich möchte die Zielgruppe noch anpassen.',
  'agent.chip.msg.startRun': 'Starte jetzt die Suche für dieses Profil.',
  'agent.chip.msg.startRunNamed': 'Starte jetzt die Suche für die Zielgruppe „{name}“.',
  'agent.chip.msg.reviewLeads': 'Lass uns die gelieferten Leads durchgehen.',
  // ── Editierbare Firmen-Karte (#122, 2026-06-02) ──
  'common.remove': 'Entfernen',
  'dash.cortex.editHint':
    'Lösche Chips mit × oder ergänze passende. So trifft Leadscraper dein Angebot exakter (max. 8 pro Spalte).',
  'dash.cortex.descLabel': 'Beschreibung',
  'dash.cortex.changeUrl': 'Andere Website analysieren',
  'dash.cortex.editSaved': 'Firmen-Profil aktualisiert',
  'dash.cortex.addPlaceholder': 'hinzufügen…',
  'dash.cortex.capReached': 'Max. 8 erreicht',
  'pd.target.edit': 'Neu beschreiben',
  'pd.target.editHint':
    'Beschreib deine Wunschkunden in 1–2 Sätzen. Leadscraper leitet Branche, Region & Ansprechpartner daraus neu ab.',
  'pd.target.editPlaceholder':
    'z.B. Verpackungshersteller in NRW, 50–250 Mitarbeiter, Geschäftsführung',
  'pd.target.reparsing': 'Leadscraper denkt nach …',
  'pd.target.saved': 'Zielgruppe aktualisiert',
  'pd.target.saveError': 'Konnte nicht aktualisieren. Bitte nochmal versuchen.',
  'common.close': 'Schließen',
  'common.selected': 'Ausgewählt',
  'credit.balanceTitle': 'Dein Credit-Stand',
  'credit.available': 'verfügbar',
  'det.trigger.cat.serviceRadius': 'Service-Region',
  'det.trigger.cat.specialization': 'Spezialisierung',
  'det.trigger.cat.capacity': 'Kapazität',
  'det.trigger.cat.history': 'Historie',
  'det.trigger.cat.partnership': 'Partnerschaft',
  'det.trigger.cat.certification': 'Zertifizierung',
  'det.trigger.cat.other': 'Sonstiges',
  'lead.removeContactTitle': 'Warum entfernen?',
  'lead.actionNeedPlan': 'Erst Akquiseplan generieren',
  'lead.actionNoEmail': 'Keine E-Mail-Adresse für den priorisierten Ansprechpartner',

  // ─── scraper run experience (LEA-302) ────────────────────────────────────
  // Live activity stream + run-quality summary + memory pills, rendered
  // server-side per user.language via tForLang('scraper.*'). DE values are
  // byte-identical to the original orchestrator/guidance/reflector literals.
  'scraper.act.loadProfile': 'Lade dein Profil + bisherige Bewertungen …',
  'scraper.act.firstFeedbacks':
    'Erste Bewertungen sammeln. Ab 10 lernt Cortex deine Anti-/Akzeptanz-Muster.',
  'scraper.act.feedbacksCollected':
    '{seen} Bewertungen gesammelt. Personalisierung wird ab {activeAt} Bewertungen pro Profil aktiv. Dieser Suchlauf nutzt die Personalisierung noch nicht.',
  'scraper.act.patternsActive':
    '{seen} Bewertungen · {accepted} Akzeptanz-Muster · {rejected} Ablehnungs-Muster aktiv im Reasoning',
  'scraper.act.planning':
    'Plane Suchstrategie: welche Such-Quellen + Queries decken deine Anfrage am besten ab?',
  'scraper.act.aiSearchTempError':
    'KI-Suche hatte ein temporäres Problem (Netzwerk/Timeout). Bitte erneut versuchen.',
  'scraper.act.aiSearchUnavailable':
    'KI-Suche aktuell nicht verfügbar (Konfigurationsproblem). Support kontaktieren.',
  'scraper.act.aiSearchBadFormat': 'KI-Suche lieferte ungültiges Format. Bitte erneut versuchen.',
  'scraper.act.aiSearchFailed': 'KI-Suche fehlgeschlagen ({reason}). Bitte erneut versuchen.',
  'scraper.act.reasonUnknown': 'unbekannt',
  'scraper.act.researcherAnalyzing': 'KI-Researcher analysiert deine Suchanfrage…',
  'scraper.act.researcherFound': 'KI-Researcher: {n} verifizierte Firmen identifiziert',
  'scraper.act.goal': 'Ziel: {goal}',
  'scraper.act.strategy': 'Strategie: {strategy}',
  'scraper.act.reasoning': 'Überlegung: {reasoning}',
  'scraper.act.srcCurated': '⭐ Kuratierte Quelle',
  'scraper.act.srcOwn': '💡 Eigener Vorschlag',
  'scraper.act.srcKindRegister': 'Register',
  'scraper.act.srcKindDirectory': 'Verzeichnis',
  'scraper.act.srcKindPortal': 'Portal',
  'scraper.act.source': '{tag}: {label} [{kind}]',
  'scraper.act.googleSearch': 'Google-Suche: „{q}"',
  'scraper.act.googleMaps': 'Google Maps: „{q}"{location}',
  'scraper.act.googleNews': 'Google News: „{q}"',
  'scraper.act.researcherEnough':
    'KI-Researcher reicht ({n} Firmen), überspringe zusätzliche Google-Suchen',
  'scraper.act.researcherIdentified':
    'KI-Researcher identifizierte {n} Firmen, überspringe Google-Suchen',
  'scraper.act.researcherNone':
    'KI-Researcher fand keine passenden Firmen. Suchanfrage ist sehr nischig. Versuche es mit breiterem Profil oder weniger spezifischer Region.',
  'scraper.act.placesTopUp':
    'KI-Researcher fand erst {have}/{target}, ergänze über lokale Google-Maps-Suche…',
  'scraper.act.placesToppedUp': '{n} Firmen über Google Maps ergänzt (jetzt {total})',
  'scraper.act.placesFitReason':
    'Über lokale Google-Maps-Suche als {businessType}-Treffer gefunden',
  'scraper.act.companyIdentified': 'Firma identifiziert: {name} ({i}/{total})',
  'scraper.act.enrichBasics':
    'Reichere {n} Firmen mit Grunddaten an (Adresse, Größe, Tech-Stack)...',
  'scraper.act.enrichCompany': 'Reichere Firma {idx}/{total} an: {domain}',
  'scraper.act.phase1Light':
    'Phase-1-Light: {n} Firmen identifiziert in {secs}s. Adresse/Größe/Details werden bei Bedarf nachgescraped.',
  'scraper.act.serperExhausted':
    '⚠ Serper-Credits aufgebraucht, Discovery limited. Auf serper.dev/dashboard nachladen.',
  'scraper.act.mapsHits': '{n} Maps-Treffer für „{query}"',
  'scraper.act.searchHitsCollected': '{n} Treffer aus Google-Suche eingesammelt',
  'scraper.act.directoriesFound':
    '{n} Branchenverzeichnisse gefunden, extrahiere gelistete Firmen …',
  'scraper.act.searchingPortal': 'Durchsuche {host} nach gelisteten Firmen …',
  'scraper.act.minedCompanies': '{n} Firmen aus {portal} extrahiert',
  'scraper.act.onlyPortals': 'Keine operativen Firmen identifiziert. Alle Treffer waren Portale',
  'scraper.act.queryInfeasible': 'Cortex hält die Query für nicht machbar: {reason}',
  'scraper.act.rethinking': 'Cortex denkt nochmal nach (Runde {round}): {reason}',
  'scraper.act.searchingPortalNew': 'Durchsuche {host} (neuer Plan-Schritt) …',
  'scraper.act.minedPortalRound': '{n} Firmen aus {host} (Reflektor-Runde {round})',
  'scraper.act.backlogResumed': '{n} Backlog-Kandidaten aus früheren Runs wieder aufgenommen',
  'scraper.act.companiesIdentifiedAgg':
    '{n} Unternehmen identifiziert, {rescued}/{attempted} aus Aggregator-Portalen gerettet, starte Tiefenanalyse',
  'scraper.act.companiesIdentified': '{n} Unternehmen identifiziert, starte Tiefenanalyse',
  'scraper.act.handelsregisterChecked': 'Handelsregister-Auszug geprüft: {hrb}',
  'scraper.act.scanningWebsite': 'Durchleuchte Website: {domain}',
  'scraper.act.relatedPages': '{n} weitere Seiten analysiert: {domain}',
  'scraper.act.deepAnalysis': 'Tiefgehende Unternehmensanalyse: {name}',
  'scraper.act.pipelineStarted':
    'Pipeline gestartet. {n} Kandidaten gehen parallel durch Hydration + Bewertung',
  'scraper.act.allDroppedPrefilter':
    'Alle {n} gefundenen Firmen wurden als nicht-passend verworfen (Branche/Region). Präzisiere deine Zielgruppe oder versuche eine andere Region.',
  'scraper.act.noCompaniesFound':
    'Discovery hat keine Firmen für diese Suche gefunden. Präzisiere deine Zielgruppe.',
  'scraper.act.phase1OnlyRun':
    'Phase-1-only-Run: {n} Leads identifiziert. Phase 2 + 3 wurden übersprungen.',
  'scraper.act.leadsDeliveredEnriching':
    '{n} Leads geliefert. Cortex enriched noch (Akquiseplan, Scores, Tiefen-Recherche)',
  'scraper.act.deeperResearch': 'Tiefere Recherche: {name}, {findings} aus {sources} Quellen',
  'scraper.act.coldStart': 'Cold-Start (keine vorherigen Runs)',
  'scraper.act.runHistory':
    '{runs} vorherige Runs · {delivered} bereits geliefert · {dropped} bereits gedroppt',
  'scraper.act.buyerProfile': 'Käufer-Profil: {narrative} (Confidence: {confidence})',
  'scraper.act.confHigh': 'hoch',
  'scraper.act.confMid': 'mittel',
  'scraper.act.confLow': 'niedrig',
  'scraper.act.subsidiary':
    'DACH-Niederlassung erkannt: {domain} ({src}), wird für Ansprechpartner-Suche genutzt.',
  'scraper.act.subsidiarySrcDirect': 'direkt geprüft',
  'scraper.act.subsidiarySrcGoogle': 'via Google-Recherche',
  // run-quality summary — empty-run paths
  'scraper.rq.harvestedMsg':
    'Zielgruppe vorerst abgegrast. Frühere Suchläufe haben bereits {prior} passende Firmen geliefert.',
  'scraper.rq.harvestedRec':
    'Cortex hat die bekannten Firmen schon gefunden. Neue Treffer entstehen, wenn neue Firmen in deiner Zielgruppe online sichtbar werden. Der Schedule pickt sie automatisch auf.',
  'scraper.rq.noMarketMsg':
    'Nur {n} Firmen im gesamten Web zur Suche gefunden. Diese Zielgruppe scheint nicht öffentlich auffindbar zu sein, vielleicht zu speziell oder interne Firmendaten.',
  'scraper.rq.noMarketRec':
    'Versuche breiter zu formulieren oder kombiniere mit Look-alike-Branchen. Schedule lohnt sich für diese Query nicht.',
  'scraper.rq.tooNicheMsg':
    'Nur {n} potenzielle Firmen im Markt. Deine Zielgruppe ist sehr nische.',
  'scraper.rq.tooNicheRec':
    'Schedule lohnt sich nur bei Zielgruppen mit 50+ Unternehmen. Erwäge breitere Region oder mehr Branchen-Varianten.',
  'scraper.rq.qualifierDownMsg':
    'Die KI-Bewertung war während dieses Laufs nicht erreichbar. Die {n} gefundenen Firmen konnten deshalb nicht geprüft werden — ein technisches Problem auf unserer Seite, kein Urteil über deinen Markt.',
  'scraper.rq.qualifierDownRec':
    'Starte die Suche in ein paar Minuten neu. Deine Kriterien musst du nicht anpassen — diesmal wurde keine einzige Firma tatsächlich bewertet.',
  'scraper.rq.unmatchedMsg':
    '{n} Firmen analysiert. Keine entsprach deinen Kriterien (Branche, Größe, Region).',
  'scraper.rq.unmatchedRec':
    'Beschreibung prüfen: zu strenge Kriterien? Look-alike-Akzeptanz hilft nicht weil keine Look-alikes plausibel waren.',
  // run-quality summary — final delivery paths
  'scraper.sum.delivered':
    '{n} Leads geliefert ({hard} sicher{softFrag}) aus {total} analysierten Firmen.',
  'scraper.sum.softFragment': ', {soft} möglicherweise relevant',
  'scraper.sum.deliveredNiche':
    '{n}/10 Leads geliefert. Die Zielgruppe ist nische (nur {total} Firmen im Markt identifiziert).',
  'scraper.sum.nicheRec':
    'Bei wiederkehrendem Schedule normal. Neue Treffer entstehen über Zeit. Wenn du mehr Volumen brauchst: erwäge breitere Region oder verwandte Branchen.',
  'scraper.sum.recallUnverified':
    '{n}/10 Leads geliefert. Der KI-Researcher reichte aus, daher wurde die breite Websuche übersprungen. Der Markt könnte deutlich größer sein als die {total} bisher gefundenen Firmen.',
  'scraper.sum.recallUnverifiedRec':
    'Das ist kein dünner Markt, sondern eine übersprungene Suche. Wir weiten die Discovery aus, um die echte Marktgröße zu erfassen.',
  // LEA-461: honest low-yield framing — discovery under-reached, but we have NO breadth signal proving the market is thin.
  'scraper.sum.lowYield':
    '{n}/10 Leads geliefert. Wir haben bisher {total} Firmen zu deiner Suche gefunden — das spiegelt unsere aktuelle Recherche-Reichweite wider, nicht die tatsächliche Marktgröße.',
  'scraper.sum.lowYieldRec':
    'Kein dünner Markt — die Discovery hat ihn nur nicht ausgeschöpft. Für mehr Volumen: breitere Region oder die Suche in spezifischere Teil-Anfragen aufteilen.',
  'scraper.rq.lowYield':
    '{n} Firmen bisher gefunden. Das spiegelt unsere Recherche-Reichweite wider, nicht die Marktgröße — der Markt ist wahrscheinlich größer.',
  // LEA-474: 0-Run auf einer Suche ohne Branche ("Mittelständler") → ehrliche Zu-breit-Diagnose statt too_niche.
  'scraper.rq.tooBroadMsg':
    'Deine Suchanfrage nennt keine konkrete Branche — „{type}" beschreibt nur Art oder Größe von Unternehmen. Daraus lässt sich kein klares Zielprofil ableiten, deshalb kam keine passende Firma durch.',
  'scraper.rq.tooBroadRec':
    'Nenne eine konkrete Branche oder ein Gewerk (z.B. „Maschinenbau-Betriebe in NRW" statt „Mittelständler") — Region und Größe kannst du zusätzlich eingrenzen.',
  // LEA-479: die Zielgruppe nennt GAR keine Branche, nur ein Merkmal/Signal (businessType 'any',
  // z.B. "Firmen mit veralteter Website"). Ein Merkmal ist ein Prüfkriterium, kein Sucheinstieg.
  'scraper.sum.attrOnly':
    '{n}/10 Leads geliefert. Deine Suche nennt keine Branche, sondern nur ein Merkmal (z.B. „veraltete Website"). Ein Merkmal ist ein Prüfkriterium, kein Suchbegriff — die Recherche weiß nicht, WEN sie prüfen soll, deshalb kamen kaum passende Firmen durch.',
  'scraper.rq.attrOnly':
    'Deine Suche nennt keine Branche, sondern nur ein Merkmal (z.B. „veraltete Website"). Ein Merkmal ist ein Prüfkriterium, kein Suchbegriff — ohne Branche weiß die Recherche nicht, WEN sie prüfen soll.',
  'scraper.sum.attrOnlyRec':
    'Nenne eine Branche oder ein Segment (z.B. „Zahnarztpraxen in NRW") und behalte das Merkmal als Zusatzkriterium — so prüft die Recherche gezielt die richtigen Firmen auf dein Signal.',
  'scraper.sum.supplyExhausted':
    '{n}/10 Leads geliefert. {dropped} weitere Treffer hattest du bei früheren Suchen schon erhalten und wurden als Duplikate herausgefiltert. Der Markt ist nicht dünn, du hast nur den Großteil der bisher auffindbaren Firmen bereits.',
  'scraper.sum.supplyExhaustedRec':
    'Bei wiederkehrenden Suchen normal. Neue Firmen kommen über Zeit dazu. Für mehr frisches Volumen: breitere Region oder verwandte Branchen wählen.',
  'scraper.sum.deliveredDropped':
    '{n}/10 Leads geliefert. Cortex hat {dropped} weitere Kandidaten als nicht passend verworfen.',
  'scraper.sum.droppedRec':
    'Wenn du mehr Volumen willst: Beschreibung lockerer formulieren oder Look-alikes/Soft-Keeps akzeptieren.',
  'scraper.sum.deliveredMixed': '{n}/10 Leads geliefert, gemischter Yield aus {total} Firmen.',
  // LEA-494: honest low-contact floor — a run can deliver 10 leads yet mostly nameless companies.
  'scraper.sum.lowContactRec':
    'Nur {withContact} von {n} Leads tragen einen Ansprechpartner. Bei den übrigen liefern wir die Firma — den Kontakt findest du per Connect.',
  'scraper.sum.mixedRec':
    'Bei wiederkehrendem Schedule normal. Cortex sammelt mit der Zeit weitere Treffer.',
  'scraper.sum.noneMatched': '{total} Firmen analysiert. Keine entsprach deinen Kriterien.',
  'scraper.sum.noneMatchedRec':
    'Beschreibung prüfen: zu strenge Kriterien oder andere Region versuchen.',
  // memory status pills
  'scraper.mem.active': 'Aktiv personalisiert · {n} Bewertungen',
  'scraper.mem.analyzing': 'Wird gerade neu analysiert · {n} Bewertungen',
  'scraper.mem.firstImpression': 'Erster Eindruck · {n}/{active} bis aktiv',
  'scraper.mem.learning': 'Lernt mit dir · {n}/{preview} bis Vorgeschau',
  // reflector fallback (re-plan unavailable)
  'scraper.reflector.fallback':
    'Reflektor nicht verfügbar, Query als nicht-machbar gemeldet damit User nicht endlos wartet.',

  // ─── API error/validation messages (LEA-302, Cluster 3) ───────────────────
  // Returned as { error, message } from apps/api routes; localized server-side
  // via tForLang('apierr.*', user.language). DE values byte-identical.
  // LEA-543: Zielgruppe sind Privatpersonen — Leadscraper findet nur Unternehmen.
  // Server-seitig lokalisiert via tForLang, zusammen unter 240 Zeichen (die
  // Fehler-Antwort wird im Client bei 300 Zeichen abgeschnitten).
  'apierr.b2cOnly':
    'Leadscraper findet Unternehmen und die Entscheider darin — Privatpersonen liefern wir nicht.',
  'apierr.b2cPivot': 'Möglich wäre stattdessen: {pivot}',
  'apierr.junkQuery':
    'Bitte beschreibe konkret WEN du suchst: z.B. "Bäckereien in Hamburg" oder "Steuerberater NRW 5-50 MA". Generische Begriffe wie "B2B", "Test", "Profil" oder Tippfehler-Texte werden nicht akzeptiert.',
  'apierr.invalidWebsite': 'Bitte gib eine gültige Webseite ein (z.B. meine-firma.de)',
  'apierr.noUserCompanyStep1': 'Erst Website analysieren (Schritt 1).',
  'apierr.noUserCompany': 'Erst Website analysieren.',
  'apierr.insufficientPhase': 'Du brauchst {cost} Credit(s) für diese Phase. Aktuell: {credits}.',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'apierr.pitchRequiresReveal':
    'Schalte zuerst die Kontakte dieser Firma frei – der Akquiseplan ist darin enthalten',
  'apierr.planGenFailed': 'Akquise-Plan konnte nicht generiert werden. Kein Credit verbraucht.',
  'apierr.urlParse': 'URL konnte nicht geparst werden.',
  'apierr.intentParseTimeout': "Unsere KI hat zu lange gebraucht, um deine Beschreibung zu lesen — bitte versuche es gleich noch einmal.",
  'apierr.urlIncomplete': 'Bitte vollständige URL angeben.',
  'apierr.dupCompany': 'Dieses Unternehmen hast du bereits angelegt{nameSuffix}.',
  'apierr.dupCompanySuffix': ' ({name})',
  'apierr.manualUnreachable':
    'Webseite war beim Anlegen nicht erreichbar. Daten konnten nicht abgerufen werden.',
  'apierr.manualPhase1Failed':
    'Phase 1 fehlgeschlagen (Webseite unreachable). Erneut versuchen über "Daten aktualisieren".',
  'apierr.cancelRequested': 'Abbruch angefordert. Wird beim nächsten Checkpoint greifen.',
  'apierr.noCredits': 'Keine Credits verfügbar. Bitte Abo abschließen oder Credits nachkaufen.',
  'apierr.rescueNotAvailable':
    'Der kostenlose zweite Versuch für diese Suche ist nicht (mehr) verfügbar.',
  // LEA-475: distinct from noCredits — der Zugang ist beendet, nicht bloss das
  // Wallet leer. Vorhandene Credits bleiben erhalten (eingefroren).
  'apierr.subscriptionEnded':
    'Dein Abo ist beendet. Reaktiviere es, um weiter zu suchen — deine vorhandenen Credits bleiben erhalten.',
  // LEA-475: forced "expired" gate copy (features/pricing/ExpiredGate).
  'expired.title': 'Dein Abo ist beendet',
  'expired.body':
    'Dein Zugang ist pausiert. Reaktiviere dein Abo, um wieder Leads zu suchen und deine Zielgruppen laufen zu lassen.',
  'expired.readOnly':
    'Deine Leads kannst du weiter ansehen und exportieren. Neue Suchen und Kontakt-Recherchen brauchen ein aktives Abo.',
  // Bewusst Gegenwartsform ("eingefroren, nicht gelöscht") statt einer Zusage,
  // dass die exakte Zahl die Reaktivierung überlebt: bei reinen Trial-Konten
  // werden Nicht-Pack-Credits beim ersten bezahlten Zyklus ge-void't (LEA-278).
  'expired.creditsKept': 'Deine {credits} Credits sind eingefroren, nicht gelöscht.',
  'expired.cta': 'Abo reaktivieren',
  'expired.ctaLoading': 'Wird geladen…',
  // LEA-704: Willkommen-zurück-Screen für abgelaufene Konten im Reveal-Modell.
  'revealMigration.title': 'Willkommen zurück',
  'revealMigration.subtitle': 'Leadscraper rechnet jetzt pro Kontakt ab',
  'revealMigration.free': 'Suchen und Kontakt-Recherche sind kostenlos',
  'revealMigration.payPerContact': 'Du bezahlst nur, wenn du einen Ansprechpartner freischaltest',
  'revealMigration.units': 'Dein Guthaben bleibt: {n} Kontakte zum Freischalten',
  'revealMigration.unitsOne': 'Dein Guthaben bleibt: 1 Kontakt zum Freischalten',
  'revealMigration.unitsNone': 'Kontakte kaufst du im Paket, wenn du sie brauchst',
  'revealMigration.cta': 'Weiter',
  'revealMigration.ctaLoading': 'Einen Moment…',
  'revealMigration.error': 'Das hat nicht geklappt – bitte versuch es noch einmal',
  'apierr.intentParse':
    'Konnte aus deiner Beschreibung "{desc}" keine konkrete Branche extrahieren. Bitte präzisiere: z.B. statt "Hamburg" → "Bäckereien in Hamburg" oder "Steuerberater in Hamburg".',
  // i18n localization batch (LeadDetail / acquisition plan)
  'det.acquisitionPlan': 'Akquiseplan',
  'det.creatingPlan': 'Cortex erstellt deinen Akquiseplan…',
  'det.planLoadTime': 'In der Regel 30-60 Sekunden, kein Reload nötig, erscheint automatisch',
  'det.planUncertaintyWarning': 'Hinweis: Plan-Text enthält Unsicherheiten',
  'det.companyClassification': 'Unternehmens-Einordnung',
  'det.opportunities': 'Chancen',
  'det.risksAndDealbreakers': 'Risiken / Dealbreaker',
  'det.channelMix': 'Kanal-Mix · 7-Tage-Sequenz',
  'ld.sparkle.sampleMessageLabel': 'Beispiel-Message für Erstkontakt',
  'ld.sparkle.sampleMessageCopied': 'Beispiel-Message kopiert.',
  'common.copy': 'kopieren',
  'ld.sparkle.messageSubject': 'Betreff: ',
  'ld.lean.urteil': 'Warum dieser Lead',
  'ld.lean.winkel': 'Dein Winkel',
  'ld.lean.kontakte': 'Wen zuerst',
  'ld.lean.nachricht': 'Erstkontakt, fertig zum Senden',
  'ld.lean.nachrichtShort': 'Erstkontakt-Entwurf',
  'ld.lean.telefon': 'Telefon-Einstieg',
  'ld.lean.check': 'Vor dem Senden',
  'ld.lean.copyAI': 'Für KI kopieren',
  'ld.lean.copyAITitle':
    'Kopiert Plan, öffentlich recherchierte Firmen- & Kontaktdaten und dein Angebots-Profil als Handover für ChatGPT, Claude & Co.',
  'ld.lean.copiedAI': 'Handover kopiert. Füge ihn in dein KI-Tool ein',
  'ld.lean.varMain': 'Empfohlen',
  'ld.lean.sendMail': 'Als E-Mail senden',
  'ld.lean.sendMailTitle': 'Öffnet dein E-Mail-Programm mit {addr}, Betreff und Text vorbefüllt',
  'ld.lean.zentrale': 'Zentrale',
  'ld.lean.nameNotPublic': 'Name nicht öffentlich',
  'ld.lean.verifiziert': 'verifiziert',
  'ld.lean.chEmail': 'E-Mail',
  'ld.lean.chTelefon': 'Telefon',
  'ld.lean.chLinkedIn': 'LinkedIn',
  'ld.lean.chXing': 'Xing',
  'ld.ai.instructions':
    'Du bist mein Vertriebs-Copilot für genau diesen einen Lead. Unten stehen alle Daten, die mein Tool (Leadscraper) öffentlich recherchiert und als Akquiseplan aufbereitet hat. Nutze sie direkt, frag nicht erst danach.\n\nKennzeichnung: ✓ = öffentlich belegt (Website, Impressum, LinkedIn, Register), ~ = Annahme ohne harte Quelle. Halte diese Unterscheidung durch und erfinde nichts über Firma oder Kontaktperson hinzu.\n\nDu kannst mir helfen, die Erstkontakt-Nachricht zu verfeinern, ein Anruf-Skript zu bauen, Einwände durchzuspielen oder das Follow-up vorzubereiten.',
  'ld.ai.secLead': 'Lead',
  'ld.ai.secData': 'Datenlage',
  'ld.ai.secContacts': 'Kontakte',
  'ld.ai.secCompany': 'Mein Unternehmen',
  'ld.ai.secPlan': 'Akquiseplan',
  'ld.ai.secUncertain': 'Unsicherheiten & Verifizieren',
  'ld.ai.secTask': 'Was ich von dir brauche',
  'ld.ai.taskBody':
    'Starte direkt: Verfeinere die Erstkontakt-Nachricht oben in meinem Ton und schlage EINE konkrete Verbesserung vor, die meine Antwortchance erhöht.',
  'ld.ai.company': 'Firma',
  'ld.ai.industry': 'Branche',
  'ld.ai.size': 'Größe',
  'ld.ai.region': 'Region',
  'ld.ai.dataAsOf': 'Datenstand: recherchiert am {date}',
  'det.recommendedNextStep': 'Empfohlener nächster Schritt',
  'det.botProtectionWarning':
    'Diese Website hatte Bot-Schutz aktiv. Wir konnten Impressum/Kontaktseite nicht direkt scrapen. Die hier gezeigten Daten haben wir aus öffentlichen Quellen (Google, Branchenverzeichnisse) zusammengetragen und können ungenauer sein als 1:1-Impressum-Daten.',
  'det.possibleNotVerified': 'Möglich, nicht zu 100 % verifizierbar',
  'det.noJustificationYet':
    'Noch keine Begründung. Bei diesem Lead konnte das Buyer-Matching nicht ausgeführt werden (User-Profil unvollständig oder Webseite war nicht erreichbar). Phase 2/3 starten holt mehr Daten.',
  'det.offering': 'Angebot',
  'det.nicheSignals': 'Nischen-Signale',
  'det.niche.signalsOne': '1 Signal',
  'det.niche.signalsMany': '{n} Signale',
  'det.vatId': 'USt-ID: ',
  'det.revenue': 'Umsatz ',
  'det.agency': 'Agentur',
  'det.distributor': 'Distributor',
  'det.stack': 'Stack:',
  'det.webDesign': 'Webdesign:',
  'det.masteryBusiness': 'Meisterbetrieb',
  'det.guild': 'Innung: ',
  'det.imprintVerified': '✓ Impressum verifiziert',
  'det.sealsOfQuality': 'Gütesiegel:',
  'det.social': 'Social:',
  'det.verifyingContacts': 'Verifiziere Ansprechpartner…',
  'det.inferringPattern': 'Pattern wird inferiert…',
  'det.emailPatternPlaceholder': '{vorname}.{nachname}@firma.de',
  'det.emailPatternExampleTag': 'Beispiel',
  'det.emailPatternLockedHint':
    'Wird beim Verifizieren der Ansprechpartner für diese Firma bestimmt.',
  'det.sales': 'Vertrieb',
  'det.marketing': 'Marketing',
  'det.engineering': 'Technik',
  'det.finance': 'Finanzen',
  'det.management': 'Geschäftsleitung',
  'det.procurist': 'Prokurist',
  'det.contactRemoved': 'entfernt, wird nicht mehr ausgeliefert.',
  'det.percentSure': '% sicher',
  'det.foundIn': 'gefunden in:',
  'det.email.verified': 'verifiziert',
  'det.email.unverified': 'nicht verifiziert',
  'det.recommendedChannel': 'Empfohlener Kanal',
  'det.linkedinProfile': 'LinkedIn-Profil',
  'det.xingProfile': 'Xing-Profil',
  'det.tier1': 'Direkt erreichbar',
  'det.tier2': 'Über LinkedIn/Xing',
  'det.tier3': 'Über die Zentrale',
  'det.tier4': 'Backup-Kontakt',
  'det.tier5': 'Nur Firmen-Kontakt',
  'det.inferred': '⚠ vermutet',
  'det.companyCentral': '(Firmen-Zentrale)',
  'det.quality.title': 'Lead-Qualität',
  'det.quality.company': 'Firma',
  'det.quality.contact': 'Kontakt',
  'det.quality.noContacts':
    'Für diese Firma sind keine Entscheider öffentlich belegbar. Leadscraper erfindet keine Kontakte.',
  'det.quality.companyFitPlain': 'Branche, Region und Größe passen zu deiner Suche.',
  'det.quality.companyFitSoft':
    'Branche und Region passen, bei einzelnen Kriterien noch nicht ganz eindeutig.',
  'det.quality.noContactsCentral': 'Erreichbar bleibt sie über die Zentrale (siehe Kontakt).',
  'det.quality.outreach': 'Outreach',
  'det.quality.lockedContactVerify': 'Erst Ansprechpartner verifizieren',
  'det.quality.lockedPlanCreate': 'Erst Akquiseplan erstellen',
  'ld.sparkle.conversationOpener': 'Gesprächs-Opener',
  'ld.sparkle.openerCopied': 'Opener kopiert.',
  'lt.next.contactVerificationStarted': 'Ansprechpartner-Verifikation gestartet …',
  'lt.next.contactVerificationLabel': 'Ansprechpartner-Verifikation',
  'lt.next.planGenerationStarted': 'Akquiseplan-Generierung gestartet …',
  'lt.next.planGenerationLabel': 'Akquiseplan-Generierung',
  'lt.next.verifiedNoContacts': 'Verifiziert, keine Kontakte gefunden',
  'det.size.employees': 'Mitarbeiter',
  'det.since': 'seit ',

  // ── Prism-Funnel (Stage C i18n-Extraktion, /dev/prism-demo) ──────────────
  // Allgemein / Kicker
  'prism.kicker.account': 'Account erstellt',
  'prism.kicker.waiting': 'Deine ersten Kunden warten',
  'prism.audienceFallback': 'deiner Zielgruppe',
  // LEA-379 i18n#4 (Om QA): Stripe checkout line-item, localized per session lang
  // (was a static German name frozen on the Stripe Product → German on FR pages).
  'billing.tripwire.lineItem.name': 'Leadscraper: 50 Leads Startpaket',
  'billing.tripwire.lineItem.desc': '50 verifizierte Leads, startklar zum Anschreiben.',
  'prism.a11y.close': 'Schließen',
  // Schritt 1 — Zielgruppe
  'prism.target.eyebrow': 'Schritt 1 von 3 · Zielgruppe',
  'prism.target.title': 'Wen willst du erreichen?',
  'prism.target.titleGrad': 'Wir finden sie sofort.',
  'prism.target.sub':
    'Beschreibe deine Zielgruppe in einem Satz. Deine Live-Suche richtet sich exakt danach aus.',
  'prism.target.label': 'Deine Zielgruppe',
  'prism.target.placeholder': 'z. B. Geschäftsführer von Steuerkanzleien in Bayern',
  'prism.target.chip.steuer': 'Steuerkanzleien in Bayern',
  'prism.target.chip.agentur': 'Marketing-Agenturen in NRW',
  'prism.target.chip.handwerk': 'Handwerksbetriebe in Hamburg',
  'prism.target.chipQuery.steuer': 'Geschäftsführer von Steuerkanzleien in Bayern',
  'prism.target.chipQuery.agentur': 'Inhaber von Marketing-Agenturen in NRW',
  'prism.target.chipQuery.handwerk': 'Handwerksbetriebe in Hamburg',
  'prism.target.tip':
    '💡 Am stärksten: Branche + Region, z. B. „Zahnärzte in Köln". Auch Rollen wie „Geschäftsführer im Mittelstand" verstehen wir.',
  'prism.target.suggestion': 'Meinst du z. B. »{suggestion}«?',
  'prism.target.validating': 'Prüfe deine Zielgruppe …',
  'prism.target.cta': 'Zielgruppe finden',
  'prism.target.foot': 'Kostenlos · noch keine Zahlungsdaten nötig',
  'prism.target.errFallback': 'Das sieht noch nicht nach einer Zielgruppe aus.',
  // Schritt 2 — Website
  'prism.website.eyebrow': 'Schritt 2 von 3 · Website',
  'prism.website.title': 'Deine Website:',
  'prism.website.titleGrad': 'damit die KI dich versteht',
  'prism.website.sub':
    'Deine eigene Firmen-Website, damit wir verstehen, was du verkaufst und wer als Kunde zu dir passt.',
  'prism.website.label': 'Website-URL',
  'prism.website.placeholder': 'https://deine-firma.de',
  'prism.website.hint':
    'Noch keine eigene Website? Dann überspring diesen Schritt. Die Suche läuft dann nur mit deiner Zielgruppe.',
  'prism.website.errInvalid':
    'Das sieht noch nicht nach einer Web-Adresse aus: z. B. „deine-firma.de".',
  'prism.website.cta': 'Website analysieren',
  'prism.website.foot': 'Wird nur analysiert · nichts wird veröffentlicht',
  // Analyse-Phase
  'prism.analyzing.reading': 'Die KI liest deine Website …',
  'prism.analyzing.wait': 'Deine Zielgruppe wird geschärft …',
  'prism.analyze.step1': 'Website live geladen & ausgelesen',
  'prism.analyze.step2': 'Geschäftsmodell erkannt',
  'prism.analyze.step3': 'Angebot & Nutzenversprechen analysiert',
  'prism.analyze.step4': 'Ideale Zielgruppe abgeleitet',
  // Schritt 3 — Fragen
  'prism.questions.eyebrow': 'Letzter Schritt · Feinschliff',
  'prism.questions.back': '← Zurück',
  'prism.questions.title': 'Kurz bestätigen:',
  'prism.questions.titleGrad': 'Frage {num} von {total}',
  // Mock-Fragen (Demo-Fallback) — kurze Frage + Antwort-Chips, die die Frage
  // wörtlich beantworten (Janik 03.07.: kein generisches Ja/Nein auf
  // Entweder-oder-Fragen; Entscheidungen müssen in 1 Sekunde fallen).
  'prism.questions.q1': 'Wie groß sollen die Firmen sein?',
  'prism.questions.q1o1': 'Bis 50 Mitarbeiter',
  'prism.questions.q1o2': 'Mehr als 50',
  'prism.questions.q1o3': 'Egal',
  'prism.questions.q2': 'Sollen die Firmen spezialisiert sein?',
  'prism.questions.q2o1': 'Ja, auf ein Segment',
  'prism.questions.q2o2': 'Breit aufgestellt',
  'prism.questions.q2o3': 'Egal',
  'prism.questions.q3': 'Wo sollen die Firmen sitzen?',
  'prism.questions.q3o1': 'Nur in meiner Region',
  'prism.questions.q3o2': 'Landesweit',
  'prism.questions.q3o3': 'Egal',
  'prism.questions.yes': 'Ja, genau',
  'prism.questions.no': 'Eher nicht',
  'prism.questions.foot': 'Je genauer deine Antwort, desto passgenauer deine ersten Leads.',
  // Such-Phase
  'prism.searching.label': 'Firmen in deiner Zielgruppe gefunden …',
  // #2 (Welle 2): konkreter/prozesshaft, damit die endlose Rotation nicht wie
  // „festgehängt" wirkt — 6 WAHRE Prozess-Schritte statt 4.
  'prism.searching.wait1': 'Treffer werden auf Passung geprüft …',
  'prism.searching.wait2': 'Schwache Treffer werden aussortiert …',
  'prism.searching.wait3': 'Duplikate werden abgeglichen …',
  'prism.searching.wait4': 'Websites werden auf Erreichbarkeit geprüft …',
  'prism.searching.wait5': 'Standorte werden abgeglichen …',
  'prism.searching.wait6': 'Firmenprofile werden zusammengeführt …',
  'prism.search.step1': 'Suchanfragen für deine Zielgruppe geplant',
  'prism.search.step2': 'Firmen über Web- und Kartensuche gesammelt',
  'prism.search.step3': 'Portale, Verzeichnisse und Dubletten aussortiert',
  'prism.search.step4': 'Passung der besten Treffer zu deiner Zielgruppe bewertet',
  'prism.search.step5': 'Websites der stärksten Treffer live geprüft',
  'prism.search.step6': 'Region und Firmentyp der stärksten Treffer gegengeprüft',
  'prism.search.step7': 'Schwache Treffer aussortiert',
  'prism.search.step8': 'Ergebnis auf Plausibilität geprüft',
  'prism.search.step9': 'Stärkste Treffer zusammengestellt',
  'prism.search.n.companies': '{count} Firmen',
  'prism.search.n.ap': '{count} AP',
  'prism.search.n.valid': '{count} gültig',
  'prism.search.n.revenue': '~{count} Mio €',
  'prism.search.n.top': 'Top 50',
  // Fit-Score-Labels
  'prism.score.perfect': 'Perfekter Fit',
  'prism.score.outstanding': 'Herausragender Fit',
  'prism.score.veryStrong': 'Sehr starker Fit',
  'prism.score.good': 'Guter Fit',
  'prism.score.titleAttr': 'Fit-Score {score}/100',
  // Refine-Screen (Engine schwach)
  'prism.refine.title': 'Noch nicht genug Treffer. Lass uns kurz schärfen.',
  'prism.refine.body': 'Zu {audience} haben wir noch keine überzeugenden Firmen gefunden.',
  'prism.refine.hint1': 'Präzisier deine Zielgruppe, am besten',
  'prism.refine.hintStrong': 'Branche + Region',
  'prism.refine.hint2':
    '(z. B. „Steuerkanzleien in Bayern", „Zahnarztpraxen in Hamburg", „Bauunternehmen in Sachsen"). Je konkreter, desto sicherer treffen wir echte Firmen für dich.',
  'prism.refine.try': 'Diese Zielgruppen kennen wir schon. 1 Klick genügt:',
  // F9: 429-Screen — Tages-Kontingent, ehrlich benannt (kein Qualitäts-Refine).
  'prism.rateLimit.title': 'Dein Tages-Kontingent für Live-Suchen ist erreicht.',
  'prism.rateLimit.body':
    'Das hat nichts mit deiner Zielgruppe zu tun — wir begrenzen die kostenlosen Live-Suchen pro Tag. Deine Zielgruppe und Website bleiben gespeichert.',
  'prism.rateLimit.reset': 'Dein Kontingent setzt sich um {time} Uhr zurück.',
  'prism.rateLimit.cta': 'Zurück zum Start',
  // D2 (LEA-430): „Willkommen zurück"-Resume + ehrliche Timer-Alternative.
  'prism.resume.title': 'Willkommen zurück!',
  'prism.resume.body': 'Deine Suche zu {audience} ist fertig — dein Ergebnis ist gespeichert.',
  'prism.resume.cta': 'Ergebnis ansehen',
  'prism.resume.dismiss': 'Neue Suche starten',
  'prism.resume.saved': 'Deine Auswahl ist gespeichert — kein Zeitdruck.',
  // Post-Kauf-Delivery-Banner (Dashboard, LEA-379)
  // Unternehmens-Verständnis-Karte (Such-Phase)
  'prism.understood.title': 'Dein Unternehmen verstanden',
  'prism.understood.opps': 'Chancen',
  // #1 (Welle 2): Label vor der hervorgehobenen „Warum jetzt"-Zeile.
  'prism.understood.momentumLabel': 'Warum jetzt:',
  // DEPRECATED (Welle 2): „Zu beachten" wird nicht mehr gerendert (Alt-Bundles).
  'prism.understood.risks': 'Zu beachten',
  // Nur Demo-Route (/dev/prism-demo) — echter Flow nutzt die Engine
  'prism.understood.demoModel':
    'B2B-Dienstleister, der Mittelständler bei der Neukundengewinnung unterstützt.',
  'prism.understood.demoOpp1': 'Klar umrissene Nische mit hohem Auftragswert',
  'prism.understood.demoOpp2': 'Wenig spezialisierter Wettbewerb in der Region',
  'prism.understood.demoOpp3': 'Entscheider direkt erreichbar (kleine Teams)',
  'prism.understood.demoRisk1': 'Lange Entscheidungswege im Mittelstand',
  'prism.understood.demoRisk2': 'Erstansprache braucht konkreten Aufhänger',
  'prism.seed.badge': 'Startpaket',
  'prism.seed.working': '{delivered}/{total} Leads geliefert',
  'prism.seed.workingSub':
    'Das dauert 10 bis 30 Minuten. Neue Leads erscheinen automatisch. Exportiere am besten erst, wenn alle da sind.',
  'prism.seed.creditsNote':
    'Deine {total} Start-Credits werden dabei eingelöst, 1 Credit je fertigem Lead.',
  'prism.seed.done': 'Alle {delivered} Leads sind in deinem Konto.',
  'prism.seed.donePartial': '{delivered} Leads geliefert. Übrige Credits bleiben dir als Guthaben.',
  'prism.refine.cta': 'Zielgruppe jetzt schärfen',
  // Ergebnis (Aha)
  // #6 (Welle 2): echte kept-Zahl trägt die Headline.
  'prism.results.foundSuffix': 'Firmen in deiner Zielgruppe gefunden',
  // #4 (Quickwins): personalisierte Headline-Variante — {audience} kommt als
  // fertiges »Zitat« aus dem Client (nie flektieren, Gate im Client).
  'prism.results.foundSuffixAud': 'Firmen zu {audience} gefunden',
  // DEPRECATED (#13, Janik 10.07.): „nur X passen" macht die Engine klein und
  // die 50er-Freischaltung unlogisch — ersetzt durch topLine (Fülle + Auswahl).
  'prism.results.matched': '{count} passen zu deiner Zielgruppe',
  // #13: Story = wir zeigen die stärksten, der Markt hat mehr davon.
  'prism.results.topLine': 'Unten: deine stärksten Treffer nach Passung.',
  // #3 (Welle 2): Label-Crossfade-Ziel des Zahlen-Morphs (reserviert; die
  // „live geprüft"-Rahmung trägt aktuell foundSuffix).
  'prism.results.checkedLabel': 'davon live geprüft, deine stärksten',
  // DEPRECATED (Welle 2): durch prism.results.matched ersetzt.
  'prism.results.checked': '{count} davon haben wir bereits live geprüft',
  'prism.results.unlockHint': 'Schalte deine ersten',
  'prism.results.unlockOffer': '{n} passenden Firmen für 49 € frei',
  'prism.results.disclaimer':
    'Marktpotenzial-Schätzung auf Basis deiner Live-Analyse. Genau diese Firmen finden wir für dich.',
  'prism.results.stat.checked': 'Firmen gefunden',
  // #11 (Welle 2): neue echte Stat-Labels. stat.onTarget DEPRECATED (#13).
  'prism.results.stat.onTarget': 'passen zu deiner Zielgruppe',
  // #13: Markt-Fülle-Kachel (echte Engine-Schätzung projected_range_dach).
  'prism.results.stat.market': 'Firmen in deinem Markt (Schätzung)',
  'prism.results.stat.avgFit': 'Ø Fit-Score deiner Top-Treffer',
  // DEPRECATED (Welle 2): synthetische Kacheln — nicht mehr gerendert.
  'prism.results.stat.contacts': 'Ansprechpartner findbar',
  'prism.results.stat.revenue': 'Umsatzpotenzial Zielgruppe',
  'prism.results.chart.sizeTitle': 'Firmen nach Größe',
  'prism.results.chart.sizeMuted': 'in deiner Zielgruppe',
  'prism.results.chart.emp1': '1–9 MA',
  'prism.results.chart.emp2': '10–49 MA',
  'prism.results.chart.emp3': '50–199 MA',
  'prism.results.chart.emp4': '200+ MA',
  'prism.results.chart.qualityTitle': 'Datenqualität deiner Leads',
  'prism.results.chart.qualityMuted': 'heute geprüft',
  'prism.results.chart.mail': 'Verif. Mail',
  'prism.results.chart.dial': 'Direktwahl',
  'prism.results.chart.decider': 'Entscheider',
  'prism.results.insights.title': 'Potenzial & Timing deiner Zielgruppe',
  'prism.results.insights.openRate': 'Ø Öffnungsrate verifizierter B2B-Mails',
  'prism.results.insights.bestTimeValue': 'Di–Do · 9–11 Uhr',
  'prism.results.insights.bestTime': 'Beste Ansprechzeit in dieser Branche',
  'prism.results.insights.dealValue': 'Ø Auftragswert pro gewonnenem Kunden',
  'prism.results.insights.competitionValue': 'niedrig',
  'prism.results.insights.competition': 'Kaltakquise-Wettbewerb in deiner Region',
  'prism.results.why.title': 'Gutes Timing:',
  'prism.results.why.p1': 'In deiner Zielgruppe wurden zuletzt',
  'prism.results.why.strong': '18 % mehr neue Entscheider:innen',
  'prism.results.why.p2':
    'aktiv, ideale Phase für die Erstansprache, bevor der Wettbewerb nachzieht.',
  'prism.results.timing.title': 'Warum genau jetzt der richtige Zeitpunkt ist',
  'prism.results.timing.legend': 'Beste Ansprechphase in deiner Zielgruppe, jetzt',
  'prism.timing.text':
    'Im {month} ist die Erreichbarkeit bei {who} erfahrungsgemäß am höchsten. Budgets fürs kommende Quartal werden gerade verplant und Entscheider gehen ans Telefon. Wer jetzt den ersten Kontakt setzt, ist da, bevor der Wettbewerb im {next} nachzieht.',
  // Monate (Saisonalitäts-Chart + Timing-Text)
  'prism.month.now': 'Jetzt',
  'prism.month.short.1': 'Jan',
  'prism.month.short.2': 'Feb',
  'prism.month.short.3': 'Mär',
  'prism.month.short.4': 'Apr',
  'prism.month.short.5': 'Mai',
  'prism.month.short.6': 'Jun',
  'prism.month.short.7': 'Jul',
  'prism.month.short.8': 'Aug',
  'prism.month.short.9': 'Sep',
  'prism.month.short.10': 'Okt',
  'prism.month.short.11': 'Nov',
  'prism.month.short.12': 'Dez',
  'prism.month.long.1': 'Januar',
  'prism.month.long.2': 'Februar',
  'prism.month.long.3': 'März',
  'prism.month.long.4': 'April',
  'prism.month.long.5': 'Mai',
  'prism.month.long.6': 'Juni',
  'prism.month.long.7': 'Juli',
  'prism.month.long.8': 'August',
  'prism.month.long.9': 'September',
  'prism.month.long.10': 'Oktober',
  'prism.month.long.11': 'November',
  'prism.month.long.12': 'Dezember',
  // Frei-Lead
  'prism.freelead.tag': 'Dein erster Lead, geht auf uns',
  'prism.freelead.verified': 'verifiziert',
  'prism.freelead.lockedChip': '🔒 Ansprechpartner & Kontaktdaten nach dem Freischalten',
  'prism.freelead.note1': 'So sieht',
  'prism.freelead.noteStrong': 'jede',
  'prism.freelead.note2':
    'deiner {n} passenden Firmen aus: echter Ansprechpartner mit E-Mail oder Telefon. Die übrigen {rest} schaltest du im nächsten Schritt frei.',
  'prism.freelead.alt1': 'Diese Firma passt zu deiner Zielgruppe. Bei Freischaltung reichern wir',
  'prism.freelead.altStrong': 'echte Ansprechpartner mit E-Mail oder Telefon',
  'prism.freelead.alt2': 'an, für alle {n}.',
  // Lead-Zeilen
  'prism.lead.ap': 'Ansprechpartner',
  'prism.lead.inclDeciders': 'nach Freischaltung',
  'prism.results.moreStrong': '≈{count} weitere',
  'prism.results.moreRest': 'Firmen gefunden. Kontakte recherchieren wir nach dem Freischalten.',
  'prism.results.planTitle': 'Dein Start-Akquiseplan:',
  'prism.results.planBody':
    'die {n} stärksten Firmen zuerst, Ansprechpartner mit E-Mail oder Telefon, als CSV oder Excel exportierbar.',
  'prism.results.cta': 'Meine {n} passenden Firmen freischalten',
  'prism.results.detailsLink': 'Was genau ist enthalten?',
  'prism.results.foot': '49 € heute · {n} passende Firmen · ab Tag 4: 290 €/Monat, jederzeit kündbar',
  // Paywall
  'prism.paywall.step2': 'Freischalten',
  'prism.paywall.step3': 'Loslegen',
  'prism.paywall.resPrefix': 'Deine',
  'prism.paywall.resStrong': '50 Leads',
  'prism.paywall.resSuffix': 'sind für dich reserviert',
  'prism.paywall.resExpired': 'Reservierung abgelaufen. Wir halten deine Suche noch kurz für dich.',
  'prism.paywall.eyebrow': '{count} Firmen gefunden, bereit zum Freischalten',
  'prism.paywall.title1': 'Schalte deine ersten',
  'prism.paywall.titleGrad': '{n} passenden Firmen',
  'prism.paywall.title2': 'jetzt frei.',
  // #4 (Quickwins): personalisierte H1-Variante ({audience} = fertiges »Zitat«).
  'prism.paywall.title2Aud': 'zu {audience} frei.',
  'prism.paywall.sub1': 'Wir haben',
  'prism.paywall.subStrong1': '{count} Firmen',
  'prism.paywall.sub2': 'zu {audience} gefunden. Die',
  'prism.paywall.subStrong2': '{n} stärksten',
  'prism.paywall.sub3':
    'warten auf dich. Ansprechpartner und Kontaktdaten recherchieren wir nach dem Freischalten.',
  // Lead-Tresor
  'prism.vault.title': 'Deine {n} stärksten Firmen stehen bereit',
  // #6 (Welle 2): 3-Stufen-Story aus echten Zahlen — {count}=discovery.kept
  // (live geprüft), {onTarget}=quality.onTargetCount (passen zur Zielgruppe),
  // {audience}=getippte Zielgruppe. Die 6 Fremdsprachen (noch {count}+{audience})
  // laufen weiter sauber, bis der i18n-Folge-Agent zieht.
  // #13: kein „passen X genau" mehr (widersprach „50 stärkste" und machte den
  // Markt klein) — {onTarget} bleibt als ungenutzter Platzhalter kompatibel.
  'prism.vault.sub':
    'Aus {count} gefundenen Firmen zu {audience}: hier deine {n} stärksten. Ansprechpartner und Kontaktdaten recherchieren wir nach dem Freischalten.',
  'prism.vault.locked': 'gesperrt',
  'prism.vault.blurEmail': 'kontakt@firma.de',
  // #6 (Welle 2): echte Restmenge des gescorten Pools statt statischem „+45".
  'prism.vault.more': '+ {count} weitere gefundene Firmen, gesperrt',
  'prism.vault.cta': 'Alle {n} freischalten: 49 €',
  'prism.vault.reassure': '49 € heute · ab Tag 4: 290 €/Monat · jederzeit kündbar',
  // Gründer-Karte + Video
  'prism.founder.head': 'Eine persönliche Nachricht vom Gründer',
  'prism.founder.quote':
    '„Hey, ich bin Janik. Während deiner gesamten Testphase betreue ich dich persönlich, und den Einstieg gibt\'s bewusst günstig, damit du Leadscraper in Ruhe ausprobieren kannst. Gib uns die Chance: Ich bin sicher, wir passen zu dir."',
  'prism.founder.role': 'Gründer · Leadscraper',
  'prism.video.playAria': 'Demo-Video abspielen',
  'prism.video.chip': 'Live-Demo · 10:04',
  'prism.video.title': 'Sieh dir an, wie Janik deine ersten Leads findet',
  'prism.video.cta': 'Demo ansehen, echte Suche, echtes Dashboard',
  'prism.video.iframeTitle': 'Live-Demo · Leadscraper',
  // Timeline (So läuft dein Test)
  'prism.timeline.title': 'So läuft dein 3-Tage-Test',
  'prism.timeline.today': 'Heute',
  'prism.timeline.todayStrong': '49 € heute',
  'prism.timeline.todayRest': ': {n} passende Firmen freigeschaltet, in 10 bis 30 Minuten in deinem Konto.',
  'prism.timeline.days13': 'Tag 1–3',
  'prism.timeline.testP1': 'Du testest mit echten Leads.',
  'prism.timeline.testStrong': '3 Tage Zeit',
  'prism.timeline.testP2': '. Passt es nicht, kündigst du mit 1 Klick, kein weiterer Cent.',
  'prism.timeline.day4': 'Ab Tag 4',
  'prism.timeline.aboP1': 'Danach läuft dein Plan mit',
  'prism.timeline.aboStrong': '250 Credits für 290 €/Monat',
  'prism.timeline.aboP2': ' weiter — jederzeit kündbar.',
  // Versus-Block
  'prism.versus.title': 'Warum Leadscraper, und nicht der übliche Weg',
  'prism.versus.oldTitle': 'Der übliche Weg',
  'prism.versus.old1': 'Stunden manuell googeln oder veraltete Listen kaufen',
  'prism.versus.old2': 'Hohe Bounce-Rate, DSGVO-Graubereich',
  'prism.versus.old3': 'Ansprechpartner mühsam selbst zusammensuchen',
  'prism.versus.old4': '1.000–1.500 €/Monat + Jahresvertrag (Cognism, Dealfront)',
  'prism.versus.old5': 'Wochen bis zur ersten Antwort',
  'prism.versus.newTitle': 'Mit Leadscraper',
  'prism.versus.new1': '{n} passende Firmen in 10 bis 30 Minuten, zugeschnitten auf deine Zielgruppe',
  'prism.versus.new2': 'E-Mail-Adressen technisch geprüft, Telefon wo verfügbar',
  'prism.versus.new3': 'Ansprechpartner direkt mitgeliefert',
  'prism.versus.new4': '49 € testen · monatlich kündbar · kein Jahresvertrag',
  'prism.versus.new5': 'Heute exportieren, morgen anschreiben',
  'prism.versus.foot1': 'Dieselbe Arbeit, für die andere',
  'prism.versus.footStrong1': 'Wochen',
  'prism.versus.foot2': 'und',
  'prism.versus.footStrong2': 'über 1.000 €/Monat',
  'prism.versus.foot3': 'zahlen, bei dir heute, zum Test für',
  'prism.versus.footStrong3': '49 €',
  // ROI-Panel
  'prism.roi.title': 'Was deine {n} passenden Firmen dir bringen',
  'prism.roi.row1': 'Leads mit Ansprechpartner, in 10 bis 30 Minuten bereit',
  'prism.roi.row2': 'Dein Einsatz heute',
  'prism.roi.row3': 'Schon 1 gewonnener Kunde bringt',
  'prism.roi.row3v': 'ein Vielfaches zurück',
  'prism.roi.hl1': 'Ein',
  'prism.roi.hlStrong': 'einziger',
  'prism.roi.hl2':
    'Kunde aus deinen ersten {n} passenden Firmen spielt die 49 € um ein Vielfaches wieder rein. Alles danach ist Vorsprung.',
  'prism.roi.perLead': 'pro fertigem Lead',
  'prism.roi.stat2v': '10–30 Min.',
  'prism.roi.stat2': 'statt Wochen Recherche',
  'prism.roi.stat3v': '3 Tage',
  'prism.roi.stat3': 'Testzeit vor Abo-Start',
  // Plan-Karte
  'prism.plan.badge': 'Einstiegsangebot · 3 Tage testen',
  'prism.plan.leadsUnit': 'passende Firmen · Ansprechpartner in 10 bis 30 Minuten',
  'prism.plan.anchor': 'Selbst recherchiert: ~10 Std. Handarbeit',
  'prism.plan.priceSuffix': 'heute',
  'prism.price.netVat': 'zzgl. USt.',
  'prism.plan.perLeadStrong': 'unter 1 €',
  'prism.plan.f1': 'E-Mail-Adressen technisch geprüft, Telefon wo verfügbar',
  'prism.plan.f2': 'Ansprechpartner je Firma, soweit öffentlich auffindbar',
  'prism.plan.f3': 'Export als CSV oder Excel, CRM-Anbindung möglich',
  'prism.plan.cta': 'Jetzt freischalten: 49 €',
  'prism.plan.secure': 'Sichere Zahlung über Stripe · SSL-verschlüsselt',
  'prism.plan.subnote': 'Kündigung jederzeit mit 1 Klick im Konto.',
  'prism.plan.gbCondition': 'Garantie-Bedingungen: siehe § 7 der',
  'prism.guarantee.title': 'Geld-zurück-Garantie',
  'prism.guarantee.sub':
    'Innerhalb der 3 Testtage erstatten wir dir die 49 €: Schreib an support@leadscraper.eu, fülle unser kurzes Feedback-Formular aus, wir beenden dein Abo mit der Erstattung. Nur für dieses Einstiegsangebot.',
  'prism.legal.agb': 'AGB',
  'prism.legal.agbUrl': 'https://www.leadscraper.de/agb',
  'prism.legal.privacyUrl': 'https://www.leadscraper.de/datenschutz',
  'prism.legal.privacy': 'Datenschutzhinweise',
  // Reviews-Band (Überschriften — Kunden-Zitate/Namen bleiben bewusst unübersetzt)
  'prism.reviews.title': 'Vertriebsteams, die schon umgestiegen sind',
  // Trust-Bar
  'prism.trust.payStrong': '49 € heute',
  'prism.trust.payRest': '· Karte, PayPal, Apple & Google Pay, sicher über Stripe',
  'prism.trust.cancelStrong': 'Jederzeit kündbar',
  'prism.trust.cancelRest': '· mit 1 Klick im Konto, keine Frist, keine Rückfragen',
  'prism.trust.dataStrong': 'Nur öffentliche Daten',
  'prism.trust.dataRest': '· DSGVO by design · Server in der EU',
  // FAQ
  'prism.faq.title': 'Häufige Fragen',
  'prism.faq.q1': 'Was passiert nach den 3 Tagen?',
  'prism.faq.a1':
    'Ab Tag 4 läuft dein Plan mit 250 Credits für 290 €/Monat weiter, jederzeit mit einem Klick kündbar. Du entscheidest also in Ruhe während der 3 Tage.',
  'prism.faq.q2': 'Kann ich jederzeit kündigen?',
  'prism.faq.a2':
    'Ja, monatlich: Ein Klick im Konto genügt, ohne Frist und ohne Rückfragen. Kündigst du in den 3 Testtagen, zahlst du nur die 49 €. Später läuft dein Zugang bis zum Ende des bezahlten Monats.',
  'prism.faq.q3': 'Woher kommen die Leads? Ist das DSGVO-konform?',
  'prism.faq.a3':
    'Ausschließlich aus öffentlich verfügbaren Firmendaten. DSGVO by design, Verarbeitung und Server ausschließlich in der EU.',
  'prism.faq.q4': 'Was, wenn die Leads nicht passen?',
  'prism.faq.a4':
    'Innerhalb der 3 Testtage erstatten wir dir die 49 €, wenn du unser kurzes Feedback-Formular ausfüllst (AGB § 7). Schreib uns dazu an support@leadscraper.eu; mit der Erstattung beenden wir dein Abo. Danach ist keine Erstattung mehr möglich; das Abo kannst du aber jederzeit kündigen.',
  'prism.faq.q5': 'Bekomme ich echte Ansprechpartner?',
  'prism.faq.a5':
    'Ja, pro Firma recherchierte Ansprechpartner mit E-Mail-Adresse oder Telefonnummer. Die E-Mail-Adressen werden technisch geprüft; dass jedes Postfach existiert, können wir nicht garantieren. Findet sich für eine Firma kein erreichbarer Kontakt, wird dafür nichts berechnet.',
  // Gründer-Zeile
  'prism.founderline.strong': 'Inhabergeführt aus Hamburg',
  'prism.founderline.rest': '· Janik Deimann, Gründer',
  'prism.founderline.sub':
    'Deimann Com GmbH · Du erreichst bei uns Menschen, keine Ticket-Warteschlange.',
  'prism.founderline.ask':
    'Noch unsicher? Schreib uns: support@leadscraper.eu. Es antwortet ein Mensch.',
  // Fixe Kauf-Leiste
  'prism.sticky.leads': '{n} passende Firmen ·',
  'prism.sticky.today': 'heute · ab Tag 4: 290 €/Monat',
  'prism.sticky.cta': 'Jetzt freischalten',
  // Inline-Checkout
  'prism.checkout.eyebrow': 'Einstiegsangebot · 49 € heute',
  'prism.checkout.title': '{n} passende Firmen · jetzt freischalten',
  'prism.checkout.sumPrice': '49 € heute',
  'prism.checkout.sumDesc': '{n} passende Firmen freigeschaltet, 3 Tage testen',
  'prism.checkout.after': 'ab Tag 4',
  'prism.checkout.monthly': '290 € / Monat',
  'prism.checkout.reassure3d':
    'Kündigst du innerhalb der 3 Tage, zahlst du nur die 49 €. Deine Leads bleiben dir: Du kannst sie auch danach ansehen und exportieren.',
  'prism.checkout.deliverNote':
    'Aus dieser Suche liegen {count} passende Firmen bereit. Ein Credit zählt nur, wenn wir einen Ansprechpartner finden; den Rest deiner 50 Credits nutzt du für weitere Suchen.',
  'prism.checkout.cancelNote': 'Abo jederzeit mit 1 Klick kündbar.',
  'prism.checkout.invite':
    'Wir laden dich ein: 50 Leads einmalig zum Selbstkostenpreis, nur zum Einstieg, damit du Leadscraper risikofrei testen kannst.',
  'prism.checkout.or': 'oder mit Karte',
  'prism.checkout.tabCard': 'Karte',
  'prism.checkout.tabSepa': 'SEPA-Lastschrift',
  'prism.checkout.cardholder': 'Karteninhaber',
  'prism.checkout.cardholderPh': 'Max Mustermann',
  'prism.checkout.cardNumber': 'Kartennummer',
  'prism.checkout.expiry': 'Ablauf',
  'prism.checkout.expiryPh': 'MM / JJ',
  'prism.checkout.country': 'Land',
  'prism.checkout.countryDe': 'Deutschland',
  'prism.checkout.countryAt': 'Österreich',
  'prism.checkout.countryCh': 'Schweiz',
  'prism.checkout.paying': 'Aktiviere …',
  'prism.checkout.embedLoading': 'Sichere Zahlung wird geladen …',
  'prism.checkout.payCta': '{n} passende Firmen freischalten: 49 €',
  'prism.checkout.securePrefix': 'Sichere Zahlung über',
  'prism.checkout.secureSuffix': '· SSL-verschlüsselt',
  // #9 (Welle 2): generischer Button-Bezug — der Live-CTA des PaymentElement
  // (Sperrzone) heißt „Weiter zur Zahlung", nicht „50 Leads freischalten".
  'prism.checkout.fine1': 'Mit dem Klick auf den Button oben akzeptierst du die',
  'prism.checkout.fine2':
    'sowie die automatische Verlängerung als Starter-Abo (250 Credits / 290 € pro Monat) ab Tag 4, jederzeit mit einem Klick kündbar. Dieses Angebot richtet sich ausschließlich an Unternehmer:innen und Gewerbetreibende (B2B, § 14 BGB). Alle Preise netto zzgl. gesetzlicher USt. Geld-zurück-Garantie: nur für dieses Einstiegsangebot, nur innerhalb der 3 Testtage und mit ausgefülltem Feedback-Formular (AGB § 7).',
  // Success-Screen
  'prism.success.title': '{n} passende Firmen freigeschaltet',
  'prism.success.body':
    'Deine {n} passenden Firmen sind freigeschaltet. Die Ansprechpartner kommen in 10 bis 30 Minuten dazu, exportierbar als CSV/CRM. Ab Tag 4 läuft dein Starter-Abo (250 Credits/Monat), monatlich kündbar.',
  'prism.success.cta': "Los geht's",

  // --- Autopilot-Modus (Port aus feat/autopilot-setup-experience) ---
  'autopilot.mode.search': 'Standard',
  'autopilot.mode.lockedHint': 'Autopilot ist ein Zusatzmodul – mehr erfahren',
  'autopilot.res.title': 'Was zieht',
  'autopilot.res.intro':
    'Woher Antworten kommen — und worauf niemand reagiert. Deine Engine misst jede Ansprache und zieht daraus die Konsequenzen.',
  'autopilot.res.learnedTitle': 'Was deine Engine daraus macht',
  'autopilot.res.segments': 'Segmente',
  'autopilot.res.segmentsHint': 'Welche Branchen und Rollen antworten.',
  'autopilot.res.subjects': 'Betreffzeilen',
  'autopilot.res.subjectsHint': 'Was geöffnet und beantwortet wird.',
  'autopilot.res.angles': 'Aufhänger',
  'autopilot.res.anglesHint': 'Mit welchem Einstieg wir ins Gespräch kommen.',
  'autopilot.res.thin': 'zu wenig Daten',
  'autopilot.res.footnote':
    'Quoten erst ab 30 angeschriebenen Unternehmen — darunter wäre eine Prozentzahl Zufall.',
  'autopilot.res.emptyTitle': 'Noch keine Resonanz',
  'autopilot.res.emptyHint':
    'Sobald deine Kampagne läuft und die ersten Antworten da sind, steht hier, was zieht und was nicht.',
  'autopilot.mode.autopilot': 'Autopilot',
  'autopilot.nav.overview': 'Dashboard',
  'autopilot.nav.warmup': 'Warmup',
  'autopilot.nav.replies': 'Antworten',
  'autopilot.status.offer': 'In Vorbereitung',
  'autopilot.status.contract': 'Vertrag unterschrieben',
  'autopilot.status.setup': 'Einrichtung',
  'autopilot.status.warmup': 'Warmup',
  'autopilot.status.awaiting': 'Wartet auf Freigabe',
  'autopilot.status.active': 'Aktiv',
  'autopilot.status.paused': 'Pausiert',
  'autopilot.status.ended': 'Beendet',
  'autopilot.ov.offerTitle': 'Dein Autopilot wird vorbereitet',
  'autopilot.ov.offerHint':
    'Sobald der Vertrag steht, beginnen wir mit der Einrichtung deiner Engine.',
  'autopilot.ov.setupTitle': 'Wir bauen deine Engine',
  'autopilot.ov.setupHint':
    'Domain, Authentifizierung und Postfächer werden eingerichtet — komplett von uns. Du musst nichts tun; wir melden uns, sobald deine ersten Freigaben bereitliegen.',
  'autopilot.ov.warmupTitle': 'Warmup läuft',
  'autopilot.ov.warmupHint':
    'Deine Postfächer werden behutsam aufgewärmt, damit deine Mails im Posteingang landen — nicht im Spam. In dieser Zeit kannst du deine Freigaben erledigen.',
  'autopilot.ov.warmupDay': 'Warmup · Tag {d} von {total}',
  'autopilot.ov.awaitTitle': 'Deine Engine ist startklar',
  'autopilot.ov.awaitHint': 'Es fehlen nur noch deine Freigaben — danach starten wir den Versand.',
  'autopilot.ov.awaitCta': 'Zu den Freigaben',
  'autopilot.ov.activeTitle': 'Deine Engine arbeitet',
  'autopilot.ov.pausedTitle': 'Versand pausiert',
  'autopilot.ov.pausedHint':
    'Es wird nichts versendet. Melde dich bei deinem Ansprechpartner, um fortzusetzen.',
  'autopilot.ov.endedTitle': 'Autopilot beendet',
  'autopilot.infra.title': 'Deine Infrastruktur',
  'autopilot.infra.domain': 'Sende-Domain registriert — auf deinen Namen',
  'autopilot.infra.verify': 'Domain verifiziert & für den Versand freigeschaltet',
  'autopilot.infra.dns': 'E-Mail-Authentifizierung eingerichtet (SPF · DKIM · DMARC)',
  'autopilot.infra.mailboxes': 'Postfächer eingerichtet',
  'autopilot.infra.yourTask': 'Deine Aufgabe',
  'autopilot.setup.title': 'Deine Engine entsteht',
  'autopilot.setup.intro': 'Was wir gerade für dich aufbauen — jeder Schritt dokumentiert.',
  'autopilot.setup.ev.domain_registered':
    'Sende-Domain {domain} registriert — eingetragen auf deine Firma, du bist Inhaber.',
  'autopilot.setup.ev.dns_shield':
    'DNS-Sicherheitsnetz für {domain} gespannt: Absender-Authentifizierung (SPF · DKIM · DMARC) und Anti-Spoofing-Schutz aktiv.',
  'autopilot.setup.ev.redirect_live':
    '{domain} führt Besucher jetzt direkt auf {target} — volle Transparenz für jeden Empfänger.',
  'autopilot.setup.ev.mailboxes_created':
    '{n} Postfächer auf {domain} eingerichtet, abgesichert und verschlüsselt.',
  'autopilot.setup.ev.warmup_started':
    'Anwärm-Netzwerk gestartet: {n} Postfächer bauen ab jetzt Tag für Tag Zustell-Reputation auf.',
  'autopilot.setup.ev.warmup_progress':
    'Anwärmphase Tag {day} von {total} — {rate} % Posteingangsquote im Netzwerk.',
  'autopilot.setup.ev.blacklist_clean':
    'Reputations-Check: {n} Sperrlisten geprüft — alles sauber.',
  'autopilot.kpi.contacted': 'Angeschrieben',
  'autopilot.kpi.delivered': 'Zugestellt',
  'autopilot.kpi.replies': 'Antworten',
  'autopilot.kpi.handovers': 'Übergaben',
  'autopilot.kpi.won': 'Gewonnen',
  'autopilot.appr.title': 'Deine Freigaben',
  'autopilot.appr.intro':
    'Du gibst frei, wir setzen um. Jede Freigabe wird dokumentiert — du behältst die Kontrolle über Zielgruppe, Inhalt und Start.',
  'autopilot.appr.icp': 'Zielgruppe & Segment',
  'autopilot.appr.icpHint': 'Wen deine Engine anspricht — Branchen, Regionen, Entscheider.',
  'autopilot.appr.copy': 'Anschreiben & Sequenz',
  'autopilot.appr.copyHint':
    'Deine Mails, fertig formuliert — die Variablen füllt die Engine pro Firma individuell aus.',
  'autopilot.appr.playbook': 'Antwort-Playbook',
  'autopilot.appr.playbookHint':
    'Wie wir Rückfragen in deinem Namen beantworten, bevor wir übergeben.',
  'autopilot.appr.launch': 'Kampagnen-Start',
  'autopilot.appr.launchHint':
    'Deine finale Freigabe — erst danach verlässt die erste Mail das Haus.',
  'autopilot.appr.pending': 'Wartet auf dich',
  'autopilot.appr.preparingShort': 'In Vorbereitung',
  'autopilot.appr.preparing':
    'Inhalt wird gerade vorbereitet — du wirst benachrichtigt, sobald du freigeben kannst.',
  'autopilot.appr.given': 'Freigegeben am {date}',
  'autopilot.appr.locked': 'Wird frei, sobald die anderen Freigaben vorliegen',
  'autopilot.appr.action': 'Freigeben',
  'autopilot.appr.givenShort': 'Freigegeben',
  'autopilot.appr.opsShort': 'Von uns freigegeben',
  'autopilot.appr.opsFeedback':
    'Das haben wir geprüft und freigegeben, du musst nichts tun. Wenn es für dich passt, kannst du es hier bestätigen. Änderungswünsche gern direkt an deinen Ansprechpartner.',
  'autopilot.appr.opsNoAction':
    'Das haben wir geprüft und freigegeben, du musst nichts tun. Änderungswünsche gern direkt an deinen Ansprechpartner.',
  'autopilot.appr.opsChanged':
    'Die Inhalte haben sich seit deiner Rückmeldung vom {date} geändert. Die aktuelle Fassung haben wir geprüft und freigegeben.',
  'autopilot.appr.opsConfirm': 'Passt für mich',
  'autopilot.appr.opsConfirmAsk': 'Rückmeldung speichern?',
  'autopilot.appr.opsDone': 'Danke, deine Rückmeldung ist gespeichert.',
  'autopilot.appr.opsAllDone':
    'Alles freigegeben. Wenn dir etwas auffällt, sag uns einfach Bescheid.',
  'autopilot.appr.launchHintOps':
    'Den Start geben wir frei, sobald Zielgruppe, Anschreiben und Antwortablauf geprüft sind.',
  'autopilot.camp.readonlyOps':
    'Du möchtest etwas ändern? Sag deinem Ansprechpartner Bescheid, wir passen es an.',
  'autopilot.appr.pvShow': 'Ansehen',
  'autopilot.appr.pvHide': 'Einklappen',
  'autopilot.appr.pvShowFirst': 'Erst ansehen, was du freigibst',
  'autopilot.appr.pvHeading': 'Das gibst du frei',
  'autopilot.appr.pvSampleTitle': 'Auszug der Zielfirmen',
  'autopilot.appr.pvSampleFoot':
    'Stichprobe aus deiner Zielgruppe — die vollständige Liste siehst du unter Zielfirmen.',
  'autopilot.appr.pvEmpty': 'Inhalt wird gerade für dich vorbereitet.',
  'autopilot.appr.pvFirms': '{n} Firmen',
  'autopilot.appr.pvPace': '{n}/Tag',
  'autopilot.appr.pvStart': 'Sofort',
  'autopilot.appr.pvWait': '+{d} Tage',
  'autopilot.appr.pvSubject': 'Betreff:',
  'autopilot.appr.variantA': 'Variante A',
  'autopilot.appr.variantB': 'Variante B',
  'autopilot.appr.subject': 'Betreff:',
  'autopilot.seq.variantA': 'Variante A',
  'autopilot.seq.variantB': 'Variante B',
  'autopilot.seq.subject': 'Betreff:',
  'autopilot.appr.staleCopy':
    'Die Texte haben sich seit deiner Freigabe vom {date} geändert. Bitte prüfe sie und gib sie erneut frei.',
  'autopilot.appr.stale':
    'Die Inhalte oder Voraussetzungen haben sich seit deiner Freigabe vom {date} geändert. Bitte prüfe sie und gib sie erneut frei.',
  'autopilot.appr.pvAb': 'A/B-Variante:',
  'autopilot.appr.pvLaunchReady':
    'Alle Inhalte sind freigegeben — mit dem Start verlässt die erste Mail das Haus.',
  'autopilot.appr.pvLaunchWait':
    'Der Start wird frei, sobald die drei Freigaben darüber vorliegen.',
  'autopilot.appr.soon': 'Inhalt wird gerade für dich vorbereitet',
  'autopilot.pause.title': 'Not-Aus',
  'autopilot.pause.hint':
    'Stoppt den Versand sofort und vollständig. Dein Ansprechpartner meldet sich danach persönlich.',
  'autopilot.pause.hintContact':
    'Den Versand stoppt dein Ansprechpartner für dich — melde dich kurz, es geht sofort.',
  'autopilot.pause.action': 'Versand pausieren',
  'autopilot.pause.confirm': 'Wirklich stoppen?',
  'autopilot.pause.done': 'Versand pausiert — dein Ansprechpartner meldet sich persönlich.',
  'autopilot.pause.error':
    'Pausieren hat nicht geklappt — melde dich bitte direkt bei deinem Ansprechpartner.',
  'autopilot.pause.pausedHint':
    'Der Versand ist pausiert. Dein Ansprechpartner meldet sich persönlich, bevor es weitergeht.',
  'autopilot.rep.title': 'Antworten',
  'autopilot.rep.viewThread': 'Verlauf ansehen ({n})',
  'autopilot.rep.threadEmpty': 'Für diese Konversation liegt noch kein Verlauf vor.',
  'autopilot.rep.threadSent': 'Gesendet · {step}',
  'autopilot.rep.threadSentPlain': 'Von dir gesendet',
  'autopilot.rep.threadFoot':
    'Versendet in deinem Namen. Änderungen laufen über deinen Ansprechpartner.',
  'autopilot.rep.cls.interested': 'Interesse',
  'autopilot.rep.cls.later': 'Später',
  'autopilot.rep.cls.noNeed': 'Kein Bedarf',
  'autopilot.rep.cls.referral': 'Zuständige Person genannt',
  'autopilot.rep.cls.question': 'Rückfrage',
  'autopilot.rep.cls.outOfOffice': 'Abwesenheit',
  'autopilot.rep.cls.unsubscribed': 'Abmeldung',
  'autopilot.rep.intro': 'Echte Gespräche mit vollem Verlauf. Wir klären, du telefonierst.',
  'autopilot.rep.gateTitle': 'Von uns vorgeprüft.',
  'autopilot.rep.gateHint':
    'Jede eingehende Antwort wird gelesen und klassifiziert — hier landet nur, was ein echtes Gespräch werden kann. Alles andere fließt still in die Statistik.',
  'autopilot.rep.gateStats':
    '{total} Antworten insgesamt · {interested} interessiert · {later} später · {noNeed} kein Bedarf',
  'autopilot.rep.emptyTitle': 'Noch keine Antworten',
  'autopilot.rep.emptyHint':
    'Sobald deine Kampagne läuft, erscheinen hier die Antworten deiner angeschriebenen Firmen — mit vollem Verlauf und unserer Einschätzung.',
  'autopilot.rep.call': 'Jetzt anrufen',
  'autopilot.stage.new': 'Neu',
  'autopilot.stage.clarify': 'In Klärung',
  'autopilot.stage.handover': 'Übergeben',
  'autopilot.stage.won': 'Gewonnen',
  'autopilot.stage.lost': 'Verloren',
  'autopilot.notActive.title': 'Autopilot ist für dieses Konto nicht aktiv',
  'autopilot.notActive.hint': 'Wenn du Autopilot nutzen möchtest, sprich uns an.',
  'autopilot.step.setup': 'Einrichtung',
  'autopilot.step.warmup': 'Warmup',
  'autopilot.step.approvals': 'Startfreigabe',
  'autopilot.step.live': 'Live',
  'autopilot.ov.engineTitle': 'Deine Engine',
  'autopilot.mb.title': 'Postfächer & Warmup',
  'autopilot.mb.count': '{active} von {total} aktiv',
  'autopilot.mb.scoreLabel': 'Zustell-Score',
  'autopilot.mb.sent': '{n} Kampagnen-Mails über dieses Postfach versendet',
  'autopilot.mb.hint':
    'Warmup läuft dauerhaft — auch im Live-Betrieb hält ein niedriger Sockel die Zustellbarkeit hoch.',
  'autopilot.mb.score': 'Zustellbarkeit',
  'autopilot.mb.perDay': '{n} Mails/Tag',
  'autopilot.mb.st.connecting': 'wird verbunden',
  'autopilot.mb.st.warmup': 'Warmup · Tag {d}/{total}',
  'autopilot.mb.st.ready': 'bereit',
  'autopilot.mb.st.sending': 'aktiv · Erhaltungs-Warmup',
  'autopilot.mb.empty': 'Deine Postfächer werden gerade eingerichtet.',
  'autopilot.mb.place.title': 'Wo deine Anwärm-Mails landen',
  'autopilot.mb.place.hint': 'Anwärm-Mails im Posteingang und Spam über alle deine Postfächer.',
  'autopilot.mb.place.sent': 'Gesendet',
  'autopilot.mb.place.inbox': 'Posteingang',
  'autopilot.mb.place.spam': 'Spam',
  'autopilot.mb.place.rate': '{pct} % Posteingangsquote',
  'autopilot.mb.place.sentLine': 'Gesendet (Rampe)',
  'autopilot.mb.place.ratePct': '% Posteingangsquote',
  'autopilot.mb.sum.score': 'Ø Zustell-Score {n}',
  'autopilot.mb.sum.cta': 'Zum Warmup',
  'autopilot.warm.introTitle': 'Deine Anwärmphase',
  'autopilot.warm.introLead':
    'Bevor die erste echte Mail rausgeht, bauen deine Postfächer Sende-Reputation auf — mit echtem, täglich wachsendem Mailverkehr. Das ist die unsichtbare Arbeit, die später über Posteingang oder Spam entscheidet.',
  'autopilot.warm.p1t': 'Echter Mailverkehr',
  'autopilot.warm.p1':
    'Deine Postfächer schreiben täglich mit einem Netzwerk gepflegter Postfächer — inklusive Antworten, wie echte Konversationen. Kein Simulieren, echter Verkehr.',
  'autopilot.warm.p2t': 'Ruf entsteht',
  'autopilot.warm.p2':
    'Die großen Mail-Anbieter beobachten neue Absender genau. Sauberer, natürlicher Verkehr stuft deine Domains als vertrauenswürdig ein — das entscheidet mit, ob deine Mails später ankommen.',
  'autopilot.warm.p3t': 'Rund 4 Wochen Handwerk',
  'autopilot.warm.p3':
    'Das Volumen steigt behutsam, Tag für Tag. Abkürzen würde den Ruf beschädigen — deshalb läuft ein niedriger Sockel auch im Live-Betrieb weiter.',
  'autopilot.warm.traffic.title': 'Anwärmverkehr deiner Postfächer',
  'autopilot.warm.traffic.hint':
    'Ausgehende und im Posteingang erfasste Anwärm-Mails über alle deine Postfächer.',
  'autopilot.warm.traffic.out': 'rausgegangen',
  'autopilot.warm.traffic.in': 'reingekommen',
  'autopilot.ov.ring.day': 'Tag',
  'autopilot.ov.ring.warm': 'Deine Postfächer wärmen auf',
  'autopilot.ov.ring.building': 'Deine Engine wird gebaut',
  'autopilot.ov.ring.ready': 'Startklar — deine Freigaben fehlen',
  'autopilot.ov.ring.launch': 'Erster Versand ~{date}',
  'autopilot.ov.ring.rateLabel': 'Posteingang',
  'autopilot.ov.ring.daySub': 'Tag {d} von {total}',
  'autopilot.ov.today.recent': 'Zuletzt passiert',
  'autopilot.ov.hero.warmLine':
    'Deine Postfächer bauen gerade Vertrauen bei den großen Mail-Anbietern auf — damit deine Mails später ankommen.',
  'autopilot.ov.hero.buildLine':
    'Wir bauen gerade deine Sende-Infrastruktur: Domains, Postfächer, Schutzschilde.',
  'autopilot.ov.hero.startLabel': 'Start deiner Kampagne',
  'autopilot.ov.hero.phase1Label': 'Erste Aussendungen ab',
  'autopilot.ov.hero.phase1Sub': 'geringes Volumen · volle Rampe ~{date}',
  'autopilot.warm.traffic.weekend': 'Wochenende — das Anwärm-Netzwerk fährt planmäßig herunter',
  'autopilot.warm.traffic.pause': 'Ruhetag im Anwärm-Netzwerk',
  'autopilot.warm.traffic.weekendShort': 'WE',
  'autopilot.warm.traffic.pauseShort': 'Pause',
  'autopilot.ov.hero.rampLabel': 'Volle Rampe ab',
  'autopilot.ov.hero.phase2Sub': 'erste Aussendungen laufen — das Volumen steigt schrittweise',
  'autopilot.appr.zf.loading': 'Zielfirmen werden geladen …',
  'autopilot.appr.zf.passt': 'Passt',
  'autopilot.appr.zf.raus': 'Aussortieren',
  'autopilot.appr.zf.raus2': 'Aussortiert',
  'autopilot.appr.zf.alle': 'Alle {n} Firmen anzeigen',
  'autopilot.appr.zf.weniger': 'Weniger anzeigen',
  'autopilot.appr.zf.stand': '{rated} von {n} bewertet',
  'autopilot.appr.zf.chipLetter': '✉ Brief',
  'autopilot.appr.zf.title': 'Deine Zielfirmen',
  'autopilot.appr.zf.dabei': '{n} dabei · {raus} aussortiert',
  'autopilot.appr.zf.lead':
    'Angeschrieben wird jede Firma, die du nicht aussortierst. Ein Haken ist optional und hilft uns, deinen Geschmack zu treffen.',
  'autopilot.appr.zf.f.alle': 'Alle {n}',
  'autopilot.appr.zf.f.dabei': 'Dabei {n}',
  'autopilot.appr.zf.f.raus': 'Aussortiert {n}',
  'autopilot.appr.zf.f.ohneKontakt': 'Ohne Kontakt {n}',
  'autopilot.camp.offenN': '{n} Freigaben offen: {liste}',
  'autopilot.camp.offen1': 'Eine Freigabe offen: {liste}',
  'autopilot.appr.zf.neuTitle': 'Neu seit deinem letzten Besuch',
  'autopilot.appr.zf.neuChip': '{n} neu',
  'autopilot.appr.zf.th.firma': 'Firma',
  'autopilot.appr.zf.th.ort': 'Ort',
  'autopilot.appr.zf.th.kontakt': 'Ansprechpartner',
  'autopilot.appr.zf.th.grund': 'Warum diese Firma',
  'autopilot.appr.zf.kontaktFolgt': 'wird ermittelt',
  'autopilot.appr.zf.wieder': 'Wieder aufnehmen',
  'autopilot.appr.zf.passtTitle':
    'Optional: bestätigt den Treffer und hilft der Engine beim Lernen',
  'autopilot.appr.zf.suche': 'Suchen …',
  'autopilot.appr.kampagne': 'Kampagne',
  'autopilot.appr.sammel.titel': 'Alle {n} Vorbereitungs-Freigaben auf einmal',
  'autopilot.appr.sammel.hint':
    'Der Kampagnen-Start bleibt ein eigener Schritt. Jede Freigabe wird einzeln protokolliert.',
  'autopilot.appr.sammel.btn': 'Alle {n} freigeben',
  'autopilot.appr.sammel.confirm': 'Verbindlich {n} Freigaben erteilen?',
  'autopilot.appr.sammel.cancel': 'Abbrechen',
  'autopilot.appr.zf.st.dabei': 'Dabei',
  'autopilot.appr.zf.st.neu': 'Neu',
  'autopilot.appr.zf.alleSeite': 'Alle noch offenen auf dieser Seite auswählen',
  'autopilot.appr.zf.gewaehlt': '{n} ausgewählt',
  'autopilot.appr.zf.bulkPasst': 'Passt',
  'autopilot.appr.zf.bulkLaeuft': 'Speichere {fertig} von {gesamt} …',
  'autopilot.appr.zf.bulkFehler': '{n} konnten nicht gespeichert werden — bitte nochmal',
  'autopilot.appr.zf.bereich': '{von}–{bis} von {gesamt}',
  'autopilot.appr.zf.grundFrage': 'Warum passt diese Firma nicht?',
  'autopilot.appr.zf.grundFrageN': 'Warum passen diese {n} Firmen nicht?',
  'autopilot.appr.zf.grundSkip': 'Ohne Grund aussortieren',
  'autopilot.appr.zf.g.branche': 'Falsche Branche',
  'autopilot.appr.zf.g.groesse': 'Falsche Größe',
  'autopilot.appr.zf.g.region': 'Falsche Region',
  'autopilot.appr.zf.g.bekannt': 'Kennen wir schon',
  'autopilot.appr.zf.g.kontakt': 'Kontakt stimmt nicht',
  'autopilot.appr.zf.g.fit': 'Passt inhaltlich nicht',
  'autopilot.appr.zf.g.sonst': 'Anderer Grund',
  'autopilot.appr.zf.g.bekanntHinweis':
    '„Kennen wir schon“ nimmt die Firma dauerhaft aus deinen Vorschlägen, auch in künftigen Kampagnen.',
  'autopilot.appr.zf.st.raus': 'Aussortiert',
  'autopilot.camp.brief.title': 'Kampagnen-Plan',
  'autopilot.camp.brief.hint':
    'Das Vorhaben hinter dieser Kampagne — wen wir ansprechen, mit welchem Angebot, und was wir dabei vergleichen.',
  'autopilot.camp.brief.ziel': 'Ziel',
  'autopilot.camp.brief.zielfirmen': 'Ideale Unternehmen',
  'autopilot.camp.brief.ausschluss': 'Zunächst ausgeschlossen',
  'autopilot.camp.brief.ap': 'Ansprechpartner',
  'autopilot.camp.brief.prio.primaer': 'Primär',
  'autopilot.camp.brief.prio.sekundaer': 'Sekundär',
  'autopilot.camp.brief.prio.alternativ': 'Alternative',
  'autopilot.camp.brief.aufhaenger': 'Aufhänger',
  'autopilot.camp.brief.kern': 'Kernbotschaft',
  'autopilot.camp.brief.angebot': 'Das Angebot',
  'autopilot.camp.brief.cta': 'Erster Schritt',
  'autopilot.camp.brief.abtest': 'Was wir vergleichen (A/B)',
  'autopilot.camp.st.plan': 'Plan',
  'autopilot.camp.st.start': 'Start',
  'autopilot.camp.st.zielfirmen': 'Zielfirmen',
  'autopilot.camp.st.versand': 'Nächster Versand',
  'autopilot.camp.st.ergebnisse': 'Ergebnisse & Sequenz',
  'autopilot.camp.st.planLeer':
    'Der Kampagnen-Plan wird gerade ausgearbeitet — sobald er steht, siehst du ihn hier.',
  'autopilot.camp.vs.geprueft': '{n} bestätigt',
  'autopilot.camp.vs.ungeprueft': '{n} nicht bestätigt',
  'autopilot.camp.vs.zust.ok': 'Adresse bestätigt',
  'autopilot.camp.vs.zust.ungeprueft': 'Adresse nicht bestätigt',
  'autopilot.camp.vs.erkl.geprueft':
    'Wir prüfen jede Adresse vor dem Versand technisch. Bestätigt heißt, der Mailserver hat die Adresse zugesagt. Nicht bestätigt heißt meist Catch-all, der Server antwortet dort für jede Adresse gleich.',
  'autopilot.camp.vs.absender': 'Absender',
  'autopilot.camp.vs.takt': 'Takt',
  'autopilot.camp.vs.taktWert': '{n} Mails pro Tag',
  'autopilot.camp.vs.naechster': 'nächster Versand {when}',
  'autopilot.camp.vs.keinAbsender':
    'Für diese Kampagne ist noch kein Postfach als Absender hinterlegt. Wir richten das vor dem Start ein.',
  'autopilot.camp.vs.title': 'Nächster Versand',
  'autopilot.camp.vs.bereit': '{n} versandbereit',
  'autopilot.camp.vs.wartet': '{n} warten auf Ansprechpartner',
  'autopilot.camp.vs.hint':
    'So geht die Mail raus. Grün unterstrichen ist aus unserer Recherche eingesetzt, gestrichelt wird beim Versand pro Person gefüllt.',
  'autopilot.camp.vs.keine':
    'Noch keine versandbereiten Empfänger — sobald Ansprechpartner mit E-Mail-Adresse recherchiert sind, siehst du hier jede Mail fertig ausgefüllt.',
  'autopilot.camp.vs.step': 'Schritt {n}',
  'autopilot.camp.vs.nurBrief':
    'Diese Kampagne hat nur Brief-Schritte — die Brief-Vorschau kommt aus der Druckstrecke.',
  'autopilot.camp.vs.post': '{n} per Post',
  'autopilot.appr.zf.th.aktion': 'Aktion',
  'autopilot.nav.approvalsBadgeTitle': 'Offene Freigaben — warten auf deine Bestätigung',
  'autopilot.appr.zf.hint':
    'Angeschrieben wird jede Firma, die hier NICHT aussortiert ist. ✓ ist optional und hilft uns, deinen Geschmack zu treffen.',
  'autopilot.ov.health.mailOne': 'Mail heute getauscht',
  'autopilot.ov.health.mailsDay': 'Mails am {day} getauscht',
  'autopilot.ov.health.mailOneDay': 'Mail am {day} getauscht',
  'autopilot.ov.health.arrive': 'kommen im Posteingang an',
  'autopilot.ov.health.mails': 'Mails heute getauscht',
  'autopilot.ov.health.checksOk': 'Alle Prüfungen bestanden',
  'autopilot.ov.health.checksPart': '{clean} von {total} Prüfungen ok',
  'autopilot.ov.recent.title': 'Zuletzt für dich erledigt',
  'autopilot.fun.title': 'Dein Funnel',
  'autopilot.fun.hint': 'seit Kampagnenstart',
  'autopilot.fun.contacted': 'Angeschrieben',
  'autopilot.fun.delivered': 'Zugestellt',
  'autopilot.fun.replies': 'Geantwortet',
  'autopilot.fun.interested': 'Interessiert',
  'autopilot.fun.handovers': 'An dich übergeben',
  'autopilot.fun.won': 'Gewonnen',
  'autopilot.ov.today.title': 'Heute für dich',
  'autopilot.ov.today.stand': 'Stand {time}',
  'autopilot.ov.today.moved': '{n} Anwärm-Mails bewegt',
  'autopilot.ov.today.lMoved': 'Anwärm-Mails bewegt',
  'autopilot.ov.today.lScore': 'Ø Zustell-Score',
  'autopilot.ov.today.lBl': 'Sperrlisten sauber',
  'autopilot.ov.today.blClean': '{n} Sperrlisten geprüft — alles sauber',
  'autopilot.ov.today.blPart': '{clean} von {total} Sperrlisten sauber',
  'autopilot.ov.today.empty': 'Die Maschine richtet sich gerade ein — Zahlen folgen täglich.',
  'autopilot.ov.today.foot': 'Läuft automatisch, jeden Tag — auch am Wochenende.',
  'autopilot.ov.next.title': 'Dein nächster Schritt',
  'autopilot.ov.next.none': 'Alles bei uns — du musst gerade nichts tun.',
  'autopilot.ov.next.msSetup': 'Als Nächstes von uns: Postfächer ans Anwärm-Netzwerk anschließen.',
  'autopilot.ov.next.msWarmup': 'Als Nächstes von uns: deine Sequenz-Texte zur Freigabe.',
  'autopilot.ov.next.msLive': 'Die Engine arbeitet — Übergaben erscheinen hier zuerst.',
  'autopilot.ov.next.more': '+{n} weitere Übergaben ansehen',
  'autopilot.ov.outlook.title': 'So geht es weiter',
  'autopilot.ov.outlook.approvals': 'Deine Freigaben',
  'autopilot.ov.outlook.open': '{n} offen',
  'autopilot.ov.outlook.start': 'Kampagnenstart',
  'autopilot.ov.outlook.replies': 'Erste Antworten',
  'autopilot.ov.outlook.repliesVal': 'typisch Woche 2–3',
  'autopilot.ov.trust.bl': '{n} Sperrlisten sauber',
  'autopilot.ov.trust.write': 'Schreiben',
  'autopilot.ov.trust.report': 'Report am {date}',
  'autopilot.kpi.lockedHint': 'Zahlen erscheinen, sobald deine Kampagne läuft.',
  'autopilot.rep.noFit': 'Passt nicht',
  'autopilot.rep.noFitSet': 'Als „passt nicht" markiert — deine Engine lernt daraus.',
  'autopilot.rep.noFitWhy': 'Kurz: Warum passt es nicht?',
  'autopilot.rep.noFitR.industry': 'Falsche Branche',
  'autopilot.rep.noFitR.size': 'Falsche Firmengröße',
  'autopilot.rep.noFitR.role': 'Falsche Ansprechperson',
  'autopilot.rep.noFitR.other': 'Anderer Grund',
  'autopilot.tasks.title': 'Deine Aufgaben',
  'autopilot.tasks.none': 'Nichts zu tun — die Engine arbeitet für dich.',
  'autopilot.tasks.calls': '{n} warme Übergaben warten auf deinen Anruf',
  'autopilot.tasks.approvals': '{n} Freigaben warten auf dich',
  'autopilot.tasks.approvalsOne': 'Eine Freigabe wartet auf dich',
  'autopilot.ho.title': 'Warme Übergaben',
  'autopilot.ho.none': 'Keine offenen Übergaben — die Engine arbeitet.',
  'autopilot.pulse.title': 'Die Engine gerade jetzt',
  'autopilot.pulse.researched': '{n} recherchiert',
  'autopilot.pulse.checked': '{n} KI-geprüft',
  'autopilot.pulse.sent': '{n} heute versendet',
  'autopilot.pulse.queue': '{n} im Vorrat',
  'autopilot.pulse.next': 'Nächster Versand {when}',
  'autopilot.spark.title': 'Sende-Aktivität (4 Wochen)',
  'autopilot.spark.empty': 'Erscheint, sobald der Versand startet.',
  'autopilot.rcls.title': 'Antworten nach Einordnung',
  'autopilot.rc.interested': 'Interesse',
  'autopilot.rc.later': 'Später',
  'autopilot.rc.noNeed': 'Kein Bedarf',
  'autopilot.rc.ooo': 'Abwesenheit',
  'autopilot.rc.unsub': 'Abmeldung',
  'autopilot.health.title': 'System-Gesundheit',
  'autopilot.health.green': 'Alle Systeme grün',
  'autopilot.health.amber': 'Wird beobachtet',
  'autopilot.health.red': 'Wir kümmern uns darum',
  'autopilot.health.bounce': 'Bounce-Rate {n}%',
  'autopilot.health.blacklistOk': 'Blacklists sauber',
  'autopilot.health.suppressed': '{n} Abmeldungen respektiert, kampagnenübergreifend gesperrt',
  'autopilot.quota.title': 'Kontingent diesen Monat',
  'autopilot.quota.progress': '{used} von ~{target} Firmen',
  'autopilot.act.title': 'Zuletzt passiert',
  'autopilot.tasks.call1': 'Eine warme Übergabe wartet auf deinen Anruf',
  'autopilot.exp.title': 'Experimente',
  'autopilot.exp.empty':
    'Sobald deine Engine Test-Hypothesen fährt, siehst du hier, was getestet wird — und warum.',
  'autopilot.exp.since': 'seit {date}',
  'autopilot.report.title': 'Monatsreport',
  'autopilot.report.first':
    'Dein nächster Report kommt am {date} — versendet, zugestellt, Antworten, Übergaben. Keine Schönfärberei.',
  'autopilot.contact.title': 'Dein Ansprechpartner',
  'autopilot.contact.write': 'Nachricht schreiben',
  'autopilot.contact.hint':
    'Direkter Draht, kein Ticketsystem. Der Not-Aus liegt in der Kampagne unter „Start".',
  'autopilot.nav.tech': 'Technik',
  'autopilot.tech.title': 'Technik & Zustellbarkeit',
  'autopilot.tech.inArbeit': 'Einrichtung läuft · {bereit} von {gesamt} Postfächern bereit',
  'autopilot.tech.allGreen': 'Alles betriebsbereit',
  'autopilot.tech.intro':
    'Deine komplette Sende-Infrastruktur auf einen Blick — Domains, DNS-Authentifizierung, Postfächer, Monitoring. Wir richten alles ein und halten es grün; du musst nichts davon anfassen.',
  'autopilot.tech.pending':
    'Deine Infrastruktur wird gerade eingerichtet — hier erscheint bald dein vollständiger Kontrollraum.',
  'autopilot.tech.domains': 'Sende-Domains',
  'autopilot.tech.registrar': 'Registrar: {name}',
  'autopilot.tech.owner': 'Inhaber: du',
  'autopilot.tech.nis2': 'Domain bestätigt',
  'autopilot.tech.ssl': 'TLS/SSL',
  'autopilot.tech.mailboxes': 'Postfächer & Authentifizierung',
  'autopilot.tech.warmup': 'Warmup',
  'autopilot.tech.rep': 'Reputation {n}',
  'autopilot.tech.score': 'Zustell-Score {n}',
  'autopilot.tech.placementLive': 'Posteingangs-Quote im Anwärm-Netz (7 Tage): {n} %',
  'autopilot.tech.blacklists': 'Blacklist-Überwachung',
  'autopilot.tech.clean': 'sauber',
  'autopilot.tech.reputation': 'Reputation & Zustell-Monitoring',
  'autopilot.tech.dmarcReports': 'DMARC-Aggregat-Reports aktiv',
  'autopilot.tech.placement': 'Letzter Placement-Test: {n}% Posteingang',
  'autopilot.tech.auto': 'Läuft automatisch',
  'autopilot.tech.autoHint':
    'Diese Wartungsaufgaben laufen im Hintergrund — ohne dass du je einen Finger rühren musst.',
  'autopilot.tech.pipeline': 'Die KI-Pipeline',
  'autopilot.tech.pipelineHint':
    'Jede einzelne Mail durchläuft diese unabhängigen Prüfungen, bevor sie versandbereit ist.',
  'autopilot.tech.replyLogic': 'Antwort-Intelligenz',
  'autopilot.tech.integrations': 'Angebundene Systeme',
  'autopilot.nav.history': 'Kampagnen',
  'autopilot.hist.title': 'Kampagnen',
  'autopilot.hist.intro':
    'Was gerade läuft, was gelaufen ist — und was deine Engine dabei gelernt hat. Zum Ansehen und Durchklicken. Änderungen stimmst du mit deinem Ansprechpartner ab.',
  'autopilot.hist.campaigns': 'Abgeschlossen',
  'autopilot.hist.tests': 'Abgeschlossene Tests',
  'autopilot.hist.running': 'läuft',
  'autopilot.hist.completed': 'abgeschlossen',
  'autopilot.hist.ongoing': 'läuft',
  'autopilot.hist.steps': '{n} Sequenz-Stufen',
  'autopilot.hist.vs': 'gegen',
  'autopilot.hist.tie': 'Gleichstand',
  'autopilot.hist.emptyTitle': 'Noch kein Verlauf',
  'autopilot.hist.emptyHint':
    'Sobald deine erste Kampagne läuft, sammeln sich hier Kampagnen-Bilanzen und die Ergebnisse abgeschlossener Tests.',
  'autopilot.rep.contacted': 'Als übernommen markieren',
  'autopilot.rep.contactedShort': 'Übernommen',
  'autopilot.rep.contactedDone': 'Übernommen am {date}',
  'autopilot.rep.contactedSet': 'Als übernommen markiert — danke, das hilft uns.',
  'autopilot.rep.actionFailed': 'Aktion fehlgeschlagen — bitte erneut versuchen.',
  'autopilot.talk.title': 'Gerade im Gespräch',
  'autopilot.talk.empty':
    'Sobald deine Kampagne live ist, siehst du hier, mit wem die Engine gerade spricht.',
  'autopilot.talk.emptyLive':
    'Gerade keine offenen Gespräche — bei der nächsten Antwort erscheint die Firma hier.',
  'autopilot.talk.all': 'Alle ansehen',
  'autopilot.pulse.quiet':
    'Noch kein Versand — die Engine ist im Aufbau. Sobald es losgeht, siehst du hier den Tagespuls.',
  'autopilot.foot.quota': 'Kontingent {used}/{target}',
  'autopilot.foot.details': 'Details in Technik',
  'autopilot.end.testing': 'Gerade im Test: {label}',
  'autopilot.camp.sectionRunning': 'Läuft gerade',
  'autopilot.camp.sectionPlanned': 'Geplant — startet nach deiner Freigabe',
  'autopilot.camp.statsAfterStart':
    'Versand- und Antwortzahlen erscheinen, sobald die Kampagne läuft.',
  'autopilot.seq.letterChip': 'Brief · per Post',
  'autopilot.camp.showLetter': 'Brief ansehen',
  'autopilot.camp.hideLetter': 'Brief einklappen',
  'autopilot.rep.gateSource': 'Quelle: {label}.',
  'autopilot.ch.letter.one': '1 Brief',
  'autopilot.ch.letter.many': '{n} Briefe',
  'autopilot.ch.mail.one': '1 E-Mail',
  'autopilot.ch.mail.many': '{n} E-Mails',
  'autopilot.ch.legendLetter': 'Brief',
  'autopilot.ch.legendMail': 'E-Mail',
  'autopilot.ov.kamp.vonFirmen': 'von {n} Firmen',
  'autopilot.ov.mod.post': 'Postfächer',
  'autopilot.ov.mod.briefe': 'Briefpost',
  'autopilot.ov.briefe.zeile': 'Briefe verschickt · {r} Antworten',
  'autopilot.ov.briefe.zeileOne': 'Briefe verschickt · 1 Antwort',
  'autopilot.ov.kpi.rateFoot': '{p} % Antwortrate',
  'autopilot.ov.kpi.repliesFootLeer': 'Die Rate erscheint mit dem ersten Versand',
  'autopilot.ov.kpi.handoverFoot': '{p} % der Antworten',
  'autopilot.ov.kpi.handoverFootLeer': 'Passende Antworten reichen wir an dich weiter',
  'autopilot.ov.kpi.wonFoot': '{v} Auftragswert',
  'autopilot.ov.kpi.wonFootLeer': 'Der Wert erscheint mit deinem ersten Abschluss',
  'autopilot.ov.kamp.zielfirmen': 'Zielfirmen',
  'autopilot.ov.post.anzahl': 'Postfächer',
  'autopilot.ov.mod.betreuung': 'Deine Betreuung',
  'autopilot.ov.kpi.seitStart': 'seit Kampagnenstart',
  'autopilot.ov.kpi.proGespraech': '{v} pro Gespräch',
  'autopilot.ov.kpi.proPositiv': 'Kosten je positiver Antwort: {v}',
  'autopilot.ov.kpi.positivLabel': 'Positive Antworten',
  'autopilot.ov.kpi.positivFoot': '{p} % der Antworten sind positiv',
  'autopilot.ov.zu.title': 'Im Posteingang',
  'autopilot.ov.zu.sub': 'aus {n} Anwärm-Mails der letzten 7 Tage',
  'autopilot.ov.betrieb.post': '{n} Postfächer senden',
  'autopilot.ov.betrieb.laeuft': 'Kampagne läuft',
  'autopilot.ov.betrieb.briefe': '{n} Briefe unterwegs',
  'autopilot.ov.betrieb.kontakt': '{name} ist dein direkter Draht',
  'autopilot.ov.auf.uebergabe': '{firma} wartet auf deinen Anruf',
  'autopilot.ov.auf.freigabeHint': 'Ohne deine Freigabe geht nichts raus.',
  'autopilot.ov.post.sendend': '{n} senden gerade',
  'autopilot.ov.post.schwach': 'Schwächstes Postfach: {n} — wir kümmern uns',
  'autopilot.fun.deliveredFoot':
    '{n} Mails zugestellt — mehr als angeschriebene Firmen, weil Nachfass-Mails mitzählen.',
  'autopilot.appr.zf.ls.preparing': 'Brief in Vorbereitung',
  'autopilot.appr.zf.ls.printed': 'Brief gedruckt',
  'autopilot.appr.zf.ls.mailed': 'Brief unterwegs',
  'autopilot.appr.zf.ls.replied': 'Antwort erhalten',
  'autopilot.camp.sendTbd': 'Takt und Versandfenster legen wir mit deiner Start-Freigabe fest.',
  'autopilot.camp.chip.running': 'Läuft',
  'autopilot.camp.chip.scheduled': 'Geplant',
  'autopilot.camp.chip.paused': 'Pausiert',
  'autopilot.camp.open': 'Ansehen',
  'autopilot.camp.progress': '{done} von {total} Firmen angeschrieben',
  'autopilot.camp.sReplies': '{n} Antworten',
  'autopilot.camp.sSent': '{n} versendet',
  'autopilot.camp.nextSend': 'Nächster Versand {when}',
  'autopilot.camp.startsAt': 'Startet {when}',
  'autopilot.camp.approvedShort': 'Freigegeben — Start folgt',
  'autopilot.camp.awaitApproval': 'Wartet auf deine Launch-Freigabe',
  'autopilot.camp.audienceN': '{n} Firmen im Segment',
  'autopilot.camp.back': 'Alle Kampagnen',
  'autopilot.camp.approvedAt': 'Von dir freigegeben am {date}',
  'autopilot.camp.runningSince': 'läuft seit {date}',
  'autopilot.camp.audience': 'Zielgruppe',
  'autopilot.camp.sending': 'Versand',
  'autopilot.camp.pace': 'bis zu {n} Mails/Tag über deine Postfächer',
  'autopilot.camp.queue': '{n} geprüfte Firmen im Vorrat',
  'autopilot.camp.sequence': 'Die Sequenz',
  'autopilot.camp.sequenceHint':
    'Jede Mail ist ein Unikat: Anrede, Name und Firma setzt die Engine je Kontakt ein. Markiert sind Beispielwerte (Frau Muster, Musterbetrieb GmbH).',
  'autopilot.camp.stepStart': 'Start der Sequenz',
  'autopilot.camp.stepWait': '+{n} Tage danach',
  'autopilot.camp.subject': 'Betreff',
  'autopilot.camp.showMail': 'Mail ansehen',
  'autopilot.camp.hideMail': 'Einklappen',
  'autopilot.camp.readonly':
    'Du möchtest etwas ändern? Sag deinem Ansprechpartner Bescheid. Jede Änderung geht erst nach deiner Freigabe live.',
  'autopilot.appr.confirmAsk': 'Verbindlich freigeben?',
  'autopilot.appr.done': 'Freigabe protokolliert — mit Zeitstempel und Prüfsumme.',
  'autopilot.appr.error': 'Freigabe fehlgeschlagen — bitte erneut versuchen.',
  'autopilot.appr.allDone':
    'Alles freigegeben — wir starten deine Kampagne und melden uns, sobald sie läuft.',
  'autopilot.appr.logTitle': 'Freigabe-Protokoll',
  'autopilot.appr.logIntro':
    'Jede Freigabe wird mit Zeitstempel festgehalten; der freigegebene Inhalt wird eingefroren und per Prüfsumme verankert.',
  'autopilot.appr.hash': 'Prüfsumme',
  'autopilot.rep.wonSet': 'Gewonnen — stark! Der Auftragswert fließt in deine Bilanz.',
  'autopilot.rep.wonNoValue': 'Gewonnen',
  'autopilot.rep.dealPlaceholder': 'Auftragswert',
  'autopilot.rep.lostPlaceholder': 'Grund (optional)',
  'autopilot.rep.saveClose': 'Speichern',
  'autopilot.kpi.wonValueLabel': 'Auftragswert gewonnen',
  'autopilot.kpi.modulePrice': 'Modul: {price}/Monat',
  'autopilot.ov.hero.warmOffen':
    'Deine Postfächer wärmen noch auf (Tag {d} von {total}). Gib jetzt frei, dann starten wir, sobald sie bereit sind.',
  'autopilot.ov.hero.warmFrei':
    'Alles freigegeben. Deine Postfächer wärmen noch auf (Tag {d} von {total}), dann geht die erste Mail raus.',
  'autopilot.ov.hero.fertigOffen':
    'Deine Postfächer sind aufgewärmt. Der Start wartet nur noch auf deine Freigaben.',
  'autopilot.ov.hero.fertigFrei':
    'Aufgewärmt und freigegeben. Wir bereiten die erste Aussendung vor.',
  'autopilot.ov.hero.startNachFreigabe': 'sobald du freigegeben hast',
  'autopilot.ov.hero.startInVorbereitung': 'in Vorbereitung',
  'autopilot.mb.st.fertig': 'Aufgewärmt',
  'autopilot.camp.offenDanach': ', danach {label}',
  'autopilot.ov.ring.bereit': 'bereit',
  'autopilot.ov.hero.bereitOffen':
    'Startbereit: alle {n} Postfächer liegen bei mindestens {s} im Zustell-Score. Es fehlen nur noch deine Freigaben.',
  'autopilot.ov.hero.bereitFrei':
    'Startbereit und freigegeben. Alle {n} Postfächer liegen bei mindestens {s} im Zustell-Score, wir bereiten die erste Aussendung vor.',
  'autopilot.ov.hero.teilOffen':
    '{bereit} von {n} Postfächern sind startbereit (Zustell-Score ab {s}). Gib jetzt frei, dann starten wir, sobald alle so weit sind.',
  'autopilot.ov.hero.teilFrei':
    '{bereit} von {n} Postfächern sind startbereit (Zustell-Score ab {s}). Wir starten, sobald alle so weit sind.',
  'autopilot.ov.hero.scoreRegel': 'Zustell-Score je Postfach · startbereit ab {s}',
  'autopilot.mb.st.bereit': 'Startbereit',
  'autopilot.mb.st.bereitTeil': '{bereit} von {n} startbereit',
  'autopilot.mb.st.mbBereit': 'startbereit · Tag {d}/{total}',
  'autopilot.warm.regel':
    'Startbereit ist ein Postfach ab Zustell-Score {s}. Die {total} Tage sind der Richtwert, nicht die Bedingung.',
  'autopilot.camp.vs.wartetTitel':
    'Firmen ohne recherchierte Mailadresse. Sie rücken automatisch nach, sobald ein Ansprechpartner mit Adresse gefunden ist.',
  'autopilot.camp.vs.empfaenger': 'Empfänger',
  'autopilot.camp.vs.vorschauFuer': 'Vorschau für',
  'autopilot.camp.vs.an': 'An',
  'autopilot.camp.vs.platzhalter': 'wird beim Versand pro Person gefüllt',
  'autopilot.erkl.aria': 'Wie wird das gerechnet?',
  'autopilot.erkl.quelle': 'Quelle: {q}',
  'autopilot.warm.scoreChart.title': 'Zustell-Score je Postfach',
  'autopilot.warm.scoreChart.hint':
    'Das Band zeigt die Spanne aller Postfächer, die Linie das schwächste. Startbereit ist es ab {s}.',
  'autopilot.warm.scoreChart.perBox': 'je Postfach',
  'autopilot.warm.scoreChart.perDomain': 'je Domain',
  'autopilot.warm.scoreChart.schwelle': 'startbereit ab {s}',
  'autopilot.warm.scoreChart.xHinweis':
    'Jeder Punkt ist eine gespeicherte Score-Änderung, rechts siehst du den aktuellen Stand.',
  'autopilot.warm.scoreChart.messpunkt': 'Messpunkt {n}',
  'autopilot.warm.chart.gesendet': 'Gesendet',
  'autopilot.warm.scoreChart.titleDomain': 'Zustell-Score je Domain',
  'autopilot.warm.scoreChart.hintDomain':
    'Das Band zeigt die Spanne deiner Domains, die Linie die schwächste. Startbereit ist ein Postfach ab {s}.',
  'autopilot.warm.erkl.traffic':
    'Hier siehst du Anwärm-Mails im lemwarm-Netzwerk. Die Zahlen enthalten auch eingehenden Netzwerkverkehr und zeigen keinen Kampagnenversand.',
  'autopilot.warm.erkl.placement':
    'Die Werte zeigen, wo deine Anwärm-Mails landen, einschließlich eingehender Mails aus dem Netzwerk. Für die Posteingangsquote teilen wir Posteingang durch die Summe aus Posteingang und Spam.',
  'autopilot.warm.erkl.tage':
    'Die Tage sind ein Richtwert für deine Anwärmphase, die Bedingung ist ein Zustell-Score ab {s} je Postfach.',
  'autopilot.warm.traffic.nochKeineKampagne':
    'Hier siehst du Verkehr im Anwärm-Netzwerk, noch keine Kampagnen-Mails.',
  'autopilot.warm.placement.vorwoche':
    'Posteingangsquote der letzten 7 erfassten Tage gegenüber den 7 Tagen davor.',
  'autopilot.camp.vs.absenderKonto':
    'Diese Postfächer gehören zu deinem Konto. Welches davon diese Kampagne verschickt, legen wir vor dem Start fest.',
  'autopilot.camp.vs.quellePruefung': 'E-Mail-Prüfung',
  'autopilot.appr.zf.unvollstaendig':
    'Wir zeigen die neuesten Firmen bis zur Anzeigegrenze. Ältere sind hier nicht dabei.',
  'autopilot.appr.zf.ladeFehler':
    'Ein Teil deiner Firmen konnte gerade nicht geladen werden. Lade die Seite neu, dann versuchen wir es erneut.',
  'autopilot.warm.scoreChart.schwelleKurz': 'startbereit',
  'autopilot.warm.scoreChart.alle': 'Alle',
  'autopilot.warm.scoreChart.hintEines': 'Verlauf von {adresse}. Startbereit ist es ab {s}.',
  // LEA-505 — Ein-Klick-Nachkauf von Kontakt-Paketen (Bestätigungskarte + Checkout-Einwilligung)
  'refill.checkoutConsent':
    'Deine Karte wird für spätere Nachkäufe mit einem Klick gespeichert. Abgebucht wird nur, wenn du einen Nachkauf mit dem angezeigten Betrag ausdrücklich bestätigst — kein Abo, keine automatische Aufladung. Entfernen kannst du die Karte jederzeit im Kundenportal.',
  'refill.title': 'Kontakte nachkaufen',
  'refill.subtitle': 'Mit deiner gespeicherten Karte — ohne Umweg über den Checkout.',
  'refill.choose': 'Paket wählen',
  'refill.pack': '{n} Kontakte',
  'refill.net': '{amount} netto',
  'refill.total': 'Gesamt',
  'refill.inclTax': 'inkl. {tax} MwSt.',
  'refill.reverseCharge':
    'Ohne MwSt. — Steuerschuldnerschaft des Leistungsempfängers (Reverse Charge).',
  'refill.cardLabel': 'Bezahlt mit {brand} •••• {last4}',
  'refill.cta': '{amount} jetzt bezahlen',
  'refill.quoting': 'Betrag wird berechnet …',
  'refill.paying': 'Zahlung läuft …',
  'refill.terms': 'Einmalige Zahlung, kein Abo. Deine Kontakte verfallen nicht.',
  // LEA-518 — first contact-pack purchase (Checkout) for reveal customers
  'packs.first.title': 'Kontakte kaufen',
  'packs.first.subtitle': 'Wähle ein Paket – damit schaltest du danach Kontakte frei',
  'packs.first.balance': 'Verfügbare Kontakte: {n}',
  'packs.first.popular': 'Beliebt',
  'packs.first.cta': 'Weiter zur Zahlung',
  'packs.first.redirecting': 'Weiterleitung zu Stripe …',
  'packs.first.checkoutNote':
    'Du bezahlst im nächsten Schritt sicher über Stripe – dort siehst du den Endbetrag mit Umsatzsteuer',
  'packs.first.error': 'Die Zahlung konnte nicht gestartet werden – bitte versuch es noch einmal',
  'packs.first.loadError': 'Die Pakete konnten gerade nicht geladen werden',
  'packs.first.retry': 'Erneut laden',
  'refill.success': '{n} Kontakte gutgeschrieben. Neuer Stand: {balance}.',
  'refill.again': 'Weiteres Paket kaufen',
  'refill.amountChanged': 'Der Betrag hat sich geändert. Bitte bestätige den neuen Betrag.',
  'refill.inProgress': 'Ein Nachkauf läuft bereits. Einen Moment …',
  'refill.processing':
    'Die Zahlung wird noch verarbeitet. Wir prüfen den Stand gleich noch einmal.',
  'refill.failedDeclined': 'Deine Bank hat die Zahlung abgelehnt. Es wurde nichts abgebucht.',
  'refill.failedAuth':
    'Die Bestätigung bei deiner Bank wurde nicht abgeschlossen. Es wurde nichts abgebucht.',
  'refill.failed': 'Die Zahlung wurde nicht ausgeführt. Es wurde nichts abgebucht.',
  'refill.error': 'Das hat nicht geklappt. Bitte versuche es gleich noch einmal.',
  'refill.checking': 'Wir prüfen den Stand deiner Zahlung …',
  'refill.unknown':
    'Wir konnten die Zahlung noch nicht bestätigen. Prüfe dein Guthaben, bevor du erneut kaufst.',
  'refill.retryQuote': 'Betrag erneut laden',
  'refill.checkStatus': 'Zahlungsstatus prüfen',

  'auth.register.errPwPolicy':
    'Das Passwort ist zu schwach. Mindestens 8 Zeichen mit Groß- und Kleinbuchstaben, einer Zahl und einem Sonderzeichen.',
  'auth.err.emailTaken': 'Diese E-Mail-Adresse ist bereits registriert. Bitte melde dich an.',
  'auth.err.rateLimited':
    'Zu viele Versuche von dieser Verbindung. Bitte versuche es spätestens in {minutes} Minuten erneut.',
  'auth.err.rateLimitedLater':
    'Zu viele Versuche von dieser Verbindung. Bitte versuche es später erneut.',
  'auth.err.network': 'Verbindung zum Server fehlgeschlagen. Bitte prüfe deine Internetverbindung.',
  'auth.err.busy': 'Der Server ist gerade ausgelastet. Bitte versuche es in einem Moment erneut.',
  'auth.err.signupFailed':
    'Registrierung fehlgeschlagen. Bitte versuche es in einem Moment erneut.',
  'auth.err.invalidInput': 'Bitte überprüfe deine Eingaben.',
  'auth.err.turnstileFailed':
    'Die Bot-Prüfung ist fehlgeschlagen oder abgelaufen. Bitte lade die Seite neu und versuche es erneut.',
  'auth.err.turnstileBlocked':
    'Die Sicherheitsprüfung konnte nicht laufen. Ein Werbe- oder Tracking-Blocker kann sie sperren: Erlaube challenges.cloudflare.com für diese Seite oder versuche einen anderen Browser.',
  'auth.err.popupBlocked':
    'Das Login-Fenster wurde blockiert. Bitte erlaube Pop-ups für diese Seite und versuche es erneut.',
  'auth.err.popupClosed':
    'Das Login-Fenster wurde geschlossen, bevor die Anmeldung abgeschlossen war.',
  'auth.err.otherProvider':
    'Es existiert bereits ein Konto mit dieser E-Mail. Bitte melde dich mit {provider} an.',
  'auth.err.otherMethod':
    'Es existiert bereits ein Konto mit dieser E-Mail. Bitte melde dich so an, wie du dich registriert hast (Google, Microsoft oder E-Mail und Passwort).',
  'auth.err.providerPassword': 'E-Mail und Passwort',
  'auth.err.firstName': 'Bitte gib deinen Vornamen ein.',
  'auth.err.lastName': 'Bitte gib deinen Nachnamen ein.',
  'auth.err.pwLong': 'Das Passwort ist zu lang.',
  'auth.err.oauthFailed':
    'Anmeldung mit dem Identitätsanbieter fehlgeschlagen. Bitte versuche es erneut.',
  'auth.err.noEmailFromProvider':
    'Wir haben keine E-Mail-Adresse von deinem Anbieter erhalten. Bitte versuche einen anderen Login-Weg.',
  'auth.err.ssoUnavailable':
    'Der Login mit Google oder Microsoft ist gerade nicht verfügbar. Bitte verwende E-Mail und Passwort.',
  'auth.err.accountGone': 'Dieses Konto wurde gelöscht oder ist deaktiviert.',
  'auth.err.sessionFailed': 'Die Sitzung konnte nicht erstellt werden. Bitte versuche es erneut.',
  'auth.register.next.prism':
    'Nächster Schritt: Zielgruppe eingeben und echte Firmen sehen. Bezahlt wird erst, wenn du Leads freischaltest.',
  'auth.register.next.noCard':
    'Nach der Registrierung kannst du direkt loslegen. Keine Zahlungsdaten nötig.',
  'auth.register.next.trial':
    'Nächster Schritt: Paket wählen und 3 Tage testen. Karte nötig, heute 0 €; danach läuft das Paket weiter, wenn du nicht vor Ende des Tests kündigst.',
  'auth.register.next.plan':
    'Nächster Schritt: Paket wählen. Die Zahlung per Karte ist sofort fällig.',
  'auth.register.busyHint': 'Dein Konto wird angelegt. Das dauert einige Sekunden.',
  'auth.login.legalSso':
    'Neu hier? Mit Google oder Microsoft legst du automatisch ein Konto an und akzeptierst unsere {terms}. Hinweise zu deinen Daten findest du in der {privacy}.',
  'auth.r19.form.pw.title': 'Passwort-Anforderungen',
  'auth.r19.form.pw.len': 'Mindestens 8 Zeichen',
  'auth.r19.form.pw.case': 'Groß- und Kleinbuchstaben',
  'auth.r19.form.pw.digit': 'Eine Zahl',
  'auth.r19.form.pw.special': 'Ein Sonderzeichen',
  'auth.r19.form.pw.met': 'erfüllt',
  'auth.r19.form.pw.open': 'offen',
  'auth.r19.chat.greeting':
    'Schreib uns hier deine Frage. Wenn du deine E-Mail-Adresse dazuschreibst, können wir dir auch später antworten.',
  'auth.r19.chat.failed': 'Der Chat lässt sich gerade nicht öffnen. Schreib uns stattdessen an',

  'prism.rail.label': 'Fortschritt',
  'prism.rail.audience': 'Zielgruppe',
  'prism.rail.website': 'Website',
  'prism.rail.refine': 'Feinschliff',
  'prism.rail.result': 'Ergebnis',
  'prism.rail.done': 'erledigt',
  'prism.steps.earlier': 'Davor erledigt: {n} Schritte',
  'prism.target.errEmpty': 'Sag uns zuerst, wen du erreichen willst — z. B. „Zahnärzte in Köln“.',
  'prism.score.possible': 'Möglicher Fit',
  'prism.rateLimited.title': 'Tageslimit erreicht',
  'prism.rateLimited.body':
    'Du hast deine Suchen für heute aufgebraucht. Morgen geht es weiter — deine Eingaben bleiben erhalten.',
  'prism.results.queriesLabel': 'So haben wir gesucht:',
  'prism.results.queriesMore': '+{count} weitere',
  'prism.freelead.tagTop': 'Deine stärkste Firma',
  'prism.lead.evidenceTag': 'Auf ihrer Website:',
  'prism.abandon.q': 'Kurze Frage: Was hält dich gerade ab?',
  'prism.abandon.freeText': 'Oder schreib es in einem Satz …',
  'prism.abandon.price': 'Der Preis',
  'prism.abandon.fit': 'Die Firmen passen nicht',
  'prism.abandon.later': 'Schaue ich später an',
  'prism.abandon.fitQ': 'Welche Firmen hättest du erwartet?',
  'prism.abandon.send': 'Senden',
  'prism.abandon.skip': 'Überspringen',
  'prism.abandon.thanks': 'Danke — das hilft uns wirklich weiter.',
  'prism.plan.termsStrong': 'Ab Tag 4: 290 €/Monat.',
  'prism.plan.termsBody':
    'Nach den 3 Testtagen geht dein Zugang automatisch ins Starter-Abo über (250 Credits/Monat). Kündigst du vorher im Konto, zahlst du nur die 49 €.',
  'prism.checkout.autoNote':
    'Wird automatisch zum Starter-Abo (250 Credits/Monat), wenn du nicht innerhalb der 3 Testtage kündigst.',
  // Prism-Umsatzpaket (16.10.2026): Abo-Satz, Entscheider vor dem Kauf, Hinweise.
  'prism.abo.line':
    '49 € heute · ab Tag 4: 290 €/Monat · monatlich mit einem Klick kündbar',
  'prism.abo.afterDelivery':
    'Jede Woche ~{n} neue Firmen. Zu jeder suchen wir den Entscheider, du zahlst nur, wenn wir ihn finden.',
  'prism.abo.afterCredits':
    'Danach jeden Monat {credits} Credits für neue Firmen und Ansprechpartner.',
  'prism.teaser.tag':
    'Entscheider gratis vorab',
  'prism.teaser.running':
    'Wir suchen gerade den Entscheider bei {company} …',
  'prism.teaser.foundShort':
    'Entscheider gefunden: {name}',
  'prism.teaser.noneShort':
    'Kein Entscheider mit Beleg gefunden',
  'prism.teaser.failedShort':
    'Recherche gerade nicht möglich',
  'prism.teaser.open':
    'Ansehen',
  'prism.teaser.close':
    'Zuklappen',
  'prism.teaser.role':
    'Rolle',
  'prism.teaser.source':
    'Beleg',
  'prism.teaser.email':
    'E-Mail',
  'prism.teaser.src.impressum':
    'Impressum von {domain}',
  'prism.teaser.src.handelsregister':
    'Handelsregister',
  'prism.teaser.src.website':
    'Website von {domain}',
  'prism.teaser.mail.verified':
    'beim Mailserver geprüft',
  'prism.teaser.mail.probable':
    'sehr wahrscheinlich zustellbar',
  'prism.teaser.mail.found':
    'steht so auf ihrer Website',
  'prism.teaser.mail.none':
    'keine persönliche E-Mail gefunden',
  'prism.teaser.foundNote':
    'So recherchieren wir jede deiner {n} passenden Firmen. Die volle E-Mail siehst du nach dem Freischalten, Telefon, wo verfügbar.',
  'prism.teaser.noneBody':
    'Für {company} haben wir keinen Entscheider mit Beleg gefunden (Impressum, Handelsregister oder eigene Website). Bevor wir etwas erfinden, zeigen wir dir lieber nichts.',
  'prism.teaser.noneNote':
    'Nach dem Freischalten zählt ein Credit nur, wenn wir einen Ansprechpartner finden.',
  'prism.teaser.failedBody':
    'Die Recherche hat gerade nicht geklappt. Nach dem Freischalten läuft sie für alle {n} Firmen.',
  'prism.teaser.cta':
    'Alle {n} freischalten',
  'prism.cardHint.body':
    'Den Entscheider bei {company} recherchieren wir nach dem Freischalten: Name und Rolle, dazu E-Mail oder Telefon, soweit öffentlich auffindbar.',
  'prism.cardHint.example':
    'Ein Beispiel siehst du oben bei {top}.',
  'prism.cardHint.cta':
    'Freischalten',
  'prism.website.skip':
    'Ohne Website weiter',
  'prism.website.issue.own_product':
    'Das ist unsere Seite, nicht deine. Trag hier die Website deiner eigenen Firma ein, damit wir verstehen, was du verkaufst.',
  'prism.website.issue.ai_chat':
    'Das ist ein Link zu einem KI-Chat. Wir brauchen die Website deiner eigenen Firma, z. B. „deine-firma.de“.',
  'prism.website.issue.social':
    'Ein Social-Media-Profil verrät uns zu wenig über dein Angebot. Hast du eine eigene Website? Sonst überspring den Schritt einfach.',
  'prism.website.issue.redirect':
    'Das ist ein Kurz- oder Weiterleitungslink. Trag bitte direkt die Adresse deiner Website ein, z. B. „deine-firma.de“.',
  'prism.notice.title':
    'Kurz zur Datenlage',
  'prism.notice.local_b2c':
    'Kleine Läden für Privatkunden (z. B. Friseure oder Imbisse) nennen online oft nur Telefon und Inhaber. Geprüfte E-Mails von Entscheidern finden wir dort seltener als bei Firmen, die an Unternehmen verkaufen.',
  'prism.notice.outside_dach':
    'Am vollständigsten sind unsere Daten in Deutschland, Österreich und der Schweiz. Außerhalb davon fehlen Impressum und Handelsregister oft, dort finden wir weniger Entscheider.',
  'prism.notice.continue':
    'Suchen kannst du trotzdem.',
  // Gratis-Leads vor dem Kauf + Hinweise für die übrige Liste (16.10.2026).
  'prism.free.tag':
    'Deine {n} Gratis-Leads, sofort nutzbar',
  'prism.free.tagRunning':
    'Wir suchen gerade deine {n} Gratis-Leads',
  'prism.free.tagOne':
    'Dein Gratis-Lead, sofort nutzbar',
  'prism.free.tagNone':
    'Gratis-Leads: diesmal keine mit Beleg',
  'prism.free.tagSlow':
    'Deine Gratis-Leads brauchen etwas länger',
  'prism.free.slowBody':
    'Die Recherche dauert diesmal länger als üblich. Wir zeigen dir deine Gratis-Leads hier, sobald sie da sind, auch wenn du später wiederkommst.',
  'prism.free.running':
    'Wir recherchieren gerade die Entscheider deiner stärksten Firmen … ({found} von {n})',
  'prism.free.noneBody':
    'Für deine stärksten Firmen haben wir keinen Entscheider mit Beleg und E-Mail gefunden (Impressum, Handelsregister oder eigene Website). Bevor wir etwas erfinden, zeigen wir dir lieber nichts. Nach dem Freischalten zählt ein Credit nur, wenn wir einen Ansprechpartner finden.',
  'prism.free.fewer':
    'Belegbar waren {found} von {n}. Bei den anderen Top-Firmen fehlte ein Beleg, dort zeigen wir dir lieber nichts.',
  'prism.free.yours':
    'Kopier oder exportier sie, sie gehören dir.',
  'prism.free.export':
    'Als CSV exportieren',
  'prism.free.copy':
    'Kopieren',
  'prism.free.copied':
    'Kopiert',
  'prism.free.cta':
    'Alle {n} freischalten',
  'prism.free.usedNote':
    'Gratis-Leads gibt es einmal je Konto und Firma. Diesen Entscheider siehst du hier als Vorschau.',
  'prism.free.csv.company':
    'Firma',
  'prism.free.csv.domain':
    'Domain',
  'prism.free.csv.name':
    'Name',
  'prism.free.csv.role':
    'Rolle',
  'prism.free.csv.email':
    'E-Mail',
  'prism.free.csv.phone':
    'Telefon',
  'prism.free.csv.source':
    'Beleg',
  'prism.pattern.first':
    'vorname',
  'prism.pattern.last':
    'nachname',
  'prism.pattern.f':
    'v',
  'prism.hint.freeAbove':
    'Gratis freigeschaltet, siehe oben',
  'prism.hint.dmsOne':
    '1 Entscheider: {roles}',
  'prism.hint.dmsMany':
    '{count} Entscheider: {roles}',
  'prism.hint.dmsNoRole':
    '{count} Entscheider belegt',
  'prism.hint.pattern':
    'E-Mail-Muster erkannt:',
  'prism.hint.src.impressum':
    'Impressum',
  'prism.hint.src.handelsregister':
    'Handelsregister',
  'prism.hint.src.website':
    'Website',
  'prism.hint.unlock':
    'Ansprechpartner',
  'prism.hint.unlockSub':
    'freischalten',
  // LEA-595: Setup-Lieferungen freischalten (für jedes Offer).
  'ld.reveal.title': 'Ansprechpartner gefunden, noch gesperrt',
  'ld.reveal.hint':
    'Name, E-Mail und Telefon siehst du nach dem Freischalten. Ein Freischalten öffnet alle Kontakte dieser Firma.',
  'ld.reveal.cta': 'Kontakte freischalten',
  'ld.reveal.confirm':
    'Dafür wird 1 Credit abgebucht. Danach siehst du die Kontakte dieser Firma vollständig, und der Akquiseplan kostet nichts extra.',
  'ld.reveal.confirmCta': 'Für 1 Credit freischalten',
  'ld.reveal.busy': 'Wird freigeschaltet…',
  'ld.reveal.done': 'Kontakte freigeschaltet, 1 Credit abgebucht.',
  'ld.reveal.already': 'Schon freigeschaltet, es wurde nichts erneut abgebucht.',
  'ld.reveal.notEligible':
    'Kein erreichbarer Ansprechpartner: Hier gibt es nichts freizuschalten, und es wird nichts abgebucht.',
  'ld.reveal.verificationPending':
    'Die Kontakte werden noch geprüft. Versuch es in einer Minute noch einmal, es wurde nichts abgebucht.',
  'ld.reveal.researchRunning':
    'Die Kontaktsuche läuft noch. Freischalten geht, sobald sie fertig ist.',
  'ld.reveal.failed':
    'Freischalten hat nicht geklappt. Versuch es noch einmal, doppelt abgebucht wird nie.',
  'ld.reveal.noCredits': 'Zum Freischalten fehlt dir 1 Credit.',
  'ld.reveal.buyContacts': 'Dein Guthaben ist leer – hier kannst du Kontakte nachkaufen',
  'ld.reveal.planLocked': 'Erst die Kontakte freischalten',
  'ld.reveal.planNoContact': 'Kein erreichbarer Ansprechpartner, daher kein Akquiseplan',
  'ld.contact.lockedEmailPhone': 'E-Mail und Telefon nach dem Freischalten',
  'ld.contact.lockedEmail': 'E-Mail nach dem Freischalten',
  'ld.contact.lockedPhone': 'Telefon nach dem Freischalten',
  // Wöchentliche Lieferung, Etappe B (16.10.2026) — Kundenseite + Assistant.
  'delivery.card.title': 'Wöchentliche Lieferung',
  'delivery.card.badgeNew': 'Neu da',
  'delivery.card.forAudience': 'für {name}',
  'delivery.card.amount': 'Jede Woche ~{n} neue Firmen. Zu jeder suchen wir den Entscheider, du zahlst nur, wenn wir ihn finden.',
  'delivery.card.credits': 'Bis zu {credits} Credits je Lieferung: 1 je Firma, 1 je gefundenem Entscheider',
  'delivery.card.switchLabel': 'Wöchentliche Lieferung ein- oder ausschalten',
  'delivery.card.on': 'An',
  'delivery.card.off': 'Aus',
  'delivery.card.offHint': 'Schalte sie ein, dann startet die erste Lieferung direkt.',
  'delivery.card.next.label': 'Nächste Lieferung',
  'delivery.card.next.afterRating': 'sobald du die aktuelle bewertet hast, spätestens {date}',
  'delivery.card.next.soon': 'startet gleich',
  'delivery.card.running': 'Lieferung {no} läuft: {delivered} von {target} Firmen',
  'delivery.card.runningConnect': 'Lieferung {no}: {delivered} Firmen da, jetzt kommen die Entscheider',
  'delivery.card.lowCredits': 'Du hast {credits} Credits, eine volle Lieferung braucht {need}.',
  'delivery.card.topUp': 'Credits aufladen',
  'delivery.card.loadFailed': 'Die Lieferung konnte nicht geladen werden.',
  'delivery.pause.out_of_credits.title': 'Pausiert: keine Credits mehr',
  'delivery.pause.out_of_credits.body': 'Mit neuen Credits geht die Lieferung von selbst weiter.',
  'delivery.pause.niche_exhausted.title': 'Pausiert: deine Zielgruppe ist ausgeschöpft',
  'delivery.pause.niche_exhausted.body': 'Hier finden wir keine neuen Firmen mehr. Erweitere sie mit einem Klick:',
  'delivery.pause.subscription_ended.title': 'Pausiert: dein Abo ist beendet',
  'delivery.pause.subscription_ended.body': 'Mit einem aktiven Paket geht die Lieferung weiter.',
  'delivery.pause.subscription_ended.cta': 'Paket wählen',
  'delivery.pause.subscription_paused.title': 'Pausiert: dein Abo ruht',
  'delivery.pause.subscription_paused.body': 'Sobald dein Abo wieder läuft, geht die Lieferung weiter.',
  'delivery.pause.payment_issue.title': 'Pausiert: Zahlung offen',
  'delivery.pause.payment_issue.body': 'Aktualisiere deine Zahlungsart, dann geht die Lieferung weiter.',
  'delivery.pause.payment_issue.cta': 'Zahlung aktualisieren',
  'delivery.pause.other.title': 'Pausiert',
  'delivery.pause.other.body': 'Schreib uns kurz, dann schauen wir es uns an.',
  'delivery.expand.hint': 'Das ändert deine Zielgruppe, auch für deine manuellen Suchen.',
  'delivery.pause.profile_missing.title': 'Pausiert: die Zielgruppe gibt es nicht mehr',
  'delivery.pause.profile_missing.body': 'Leg eine neue Zielgruppe an und schalte die Lieferung dort ein.',
  'delivery.pause.profile_missing.cta': 'Zielgruppe neu anlegen',
  'delivery.pause.not_self_service.title': 'Pausiert: dein Konto betreut unser Team',
  'delivery.pause.not_self_service.body': 'Deine Firmen bekommst du über den Autopilot.',
  'delivery.pause.account_closed.title': 'Pausiert: Löschung beantragt',
  'delivery.pause.account_closed.body': 'Für ein Konto in Löschung liefern wir nicht mehr.',
  'delivery.pause.unsupported_model.title': 'Pausiert: in deinem Paket nicht enthalten',
  'delivery.pause.unsupported_model.body': 'Die Lieferung gibt es in Basic, Starter und Growth.',
  'delivery.short.title': 'Letzte Lieferung: {delivered} von {target} Firmen',
  'delivery.short.body': 'Mehr gibt deine Zielgruppe gerade nicht her. Erweitere sie mit einem Klick:',
  'delivery.expand.loading': 'Vorschläge werden geprüft …',
  'delivery.expand.none': 'Beschreib deine Zielgruppe breiter, dann geht es weiter.',
  'delivery.expand.edit': 'Zielgruppe bearbeiten',
  'delivery.expand.applied': 'Zielgruppe erweitert. Die nächste Lieferung startet gleich.',
  'delivery.expand.opt.area': 'Auf ganz {area} statt {from} erweitern und Lieferung starten',
  'delivery.expand.opt.dach': 'Auf Deutschland, Österreich und Schweiz erweitern und Lieferung starten',
  'delivery.expand.opt.industry': 'Zielgruppe um {industry} erweitern und Lieferung starten',
  'delivery.expand.opt.size': 'Alle Firmengrößen statt {from} Mitarbeitende zulassen und Lieferung starten',
  'delivery.toast.on': 'Lieferung ist an. Die erste startet gleich.',
  'delivery.toast.off': 'Lieferung ist aus.',
  'delivery.toast.failed': 'Das hat nicht geklappt. Versuch es noch einmal.',
  'delivery.toast.planRequired': 'Für die Lieferung brauchst du ein aktives Paket.',
  'delivery.history.title': 'Bisherige Lieferungen',
  'delivery.history.cycle': 'Lieferung {no}',
  'delivery.history.companies': '{n} Firmen',
  'delivery.history.withContact': '{n} mit Entscheider',
  'delivery.history.acceptRate': '{pct} % Passt',
  'delivery.history.noRating': 'noch nicht bewertet',
  'delivery.history.review': 'Jetzt bewerten ({n} offen)',
  'delivery.history.show': 'Ansehen',
  'delivery.history.empty': 'Deine erste Lieferung erscheint hier.',
  'delivery.history.more': 'Alle anzeigen',
  'delivery.history.less': 'Weniger anzeigen',
  'delivery.filter.prefix': 'Gefiltert auf:',
  'delivery.notif.ready.title': 'Deine Lieferung ist da: {n} Firmen',
  'delivery.notif.ready.body': '{connected} davon mit Entscheider, für {name}. Bewerte sie, dann kommt die nächste.',
  'delivery.notif.paused.out_of_credits.title': 'Lieferung pausiert: keine Credits',
  'delivery.notif.paused.out_of_credits.body': 'Mit neuen Credits geht sie von selbst weiter.',
  'delivery.notif.paused.niche_exhausted.title': 'Lieferung pausiert: Zielgruppe ausgeschöpft',
  'delivery.notif.paused.niche_exhausted.body': 'Erweitere {name} mit einem Klick, dann geht es weiter.',
  'agent.delivery.tool.status': 'Lieferung prüfen',
  'agent.delivery.tool.set': 'Wöchentliche Lieferung',
  'agent.delivery.cost.enable': 'Bis zu {credits} Credits je Lieferung: jede Woche ~{n} neue Firmen, zu jeder suchen wir den Entscheider. Den Credit dafür zahlst du nur, wenn wir ihn finden. Ausschalten geht jederzeit.',
} as const;

export default de;
